
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ko4Vl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eh1Vk")).VersionDetailSpa);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $eh1Vk = parcelRequire("eh1Vk");

});
parcelRegister("eh1Vk", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSpa", () => $f340b311cb6806c4$export$4232c14770c47725);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $dpXKE = parcelRequire("dpXKE");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $buJlM = parcelRequire("buJlM");

var $llMVF = parcelRequire("llMVF");

var $2oUjd = parcelRequire("2oUjd");

var $aO4C9 = parcelRequire("aO4C9");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $lB25E = parcelRequire("lB25E");

var $c2vP4 = parcelRequire("c2vP4");

var $6Xjm5 = parcelRequire("6Xjm5");
const $f340b311cb6806c4$export$4232c14770c47725 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const projectKey = match.params.projectKey ?? '';
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const onExperienceFail = (0, $2oUjd.useViewVersionDetailsPageExperienceFail)();
    const { queryReference: queryReference } = (0, $buJlM.useRelayResource)((0, $llMVF.versionDetailsRelayResourceCustom));
    const releasesHomeUrl = `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`;
    // Note: "the no Software license" case is handled by a redirect within `VersionDetailPage`
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oUjd.VersionDetailsPageExperienceStart), {
        experienceId: projectKey
    }), queryReference === null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSpaAppsSoftwareReleasesVersionDetails",
        teamName: "fusion-solaris",
        extraEventData: {
            isSimplifiedProject: projectContext?.simplified ?? false
        },
        onError: (location, error)=>{
            onExperienceFail(location, error, {
                isNetworkError: (0, $6Xjm5.isNetworkError)(error)
            });
        },
        attributes: (error)=>({
                isNetworkError: (0, $6Xjm5.isNetworkError)(error),
                isSimplifiedProject: projectContext?.simplified ?? false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectContext?.projectName ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $c2vP4.default).releases),
            href: releasesHomeUrl
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO4C9.VersionDetail), {
        queryReference: queryReference
    }))))));
};

});
parcelRegister("2oUjd", function(module, exports) {

$parcel$export(module.exports, "VersionDetailsPageExperienceStart", () => $ec97b0bda39ef210$export$87a9bc4e7a50039a);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $ec97b0bda39ef210$export$f9fb921f60393679);
$parcel$export(module.exports, "ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker", () => $ec97b0bda39ef210$export$c2bfafdc422ffc0a);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");

var $11icP = parcelRequire("11icP");
const $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $ec97b0bda39ef210$export$87a9bc4e7a50039a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $ec97b0bda39ef210$export$f9fb921f60393679 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $ec97b0bda39ef210$export$1a84e8ad118354e4 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $ec97b0bda39ef210$export$c2bfafdc422ffc0a = ({ reason: reason })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            reason: reason
        }
    });
const $ec97b0bda39ef210$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $11icP.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $ec97b0bda39ef210$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("11icP", function(module, exports) {

$parcel$export(module.exports, "useProjectContextResource", () => $ec4330da9adacb0d$export$a3138047c831fa4e);
$parcel$export(module.exports, "useProjectContext", () => $ec4330da9adacb0d$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $ec4330da9adacb0d$export$b6a91b2d78273787);

var $ciulY = parcelRequire("ciulY");

var $ixwgj = parcelRequire("ixwgj");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $ec4330da9adacb0d$export$a3138047c831fa4e = (0, $ciulY.withSuspense)(()=>(0, $lB25E.useResource)((0, $ixwgj.projectContextResource)));
const $ec4330da9adacb0d$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $ec4330da9adacb0d$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $6vrw7.toProjectKey)(data.projectKey),
        projectId: (0, $6vrw7.toProjectId)(data.projectId.toString())
    };
};
const $ec4330da9adacb0d$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $ec4330da9adacb0d$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});
parcelRegister("ciulY", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $47280a1aa92c9d77$export$a3bce93d4fb4eda6);
const $47280a1aa92c9d77$var$isDataEmpty = (data)=>data == null;
function $47280a1aa92c9d77$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $47280a1aa92c9d77$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});



parcelRegister("aO4C9", function(module, exports) {

$parcel$export(module.exports, "VersionDetail", () => $b57ac67d5658db24$export$7ef104a5ca9287b8);

var $cos6r = parcelRequire("cos6r");

var $g5E9O = parcelRequire("g5E9O");

var $bMW5V = parcelRequire("bMW5V");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $c9TLT = parcelRequire("c9TLT");

var $bEZRh = parcelRequire("bEZRh");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4bMJ9 = parcelRequire("4bMJ9");

var $gGtKh = parcelRequire("gGtKh");

var $huI7r = parcelRequire("huI7r");

var $2jdHI = parcelRequire("2jdHI");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $dIEey = parcelRequire("dIEey");

var $3GsbF = parcelRequire("3GsbF");

var $10dcg = parcelRequire("10dcg");

var $yyqSx = parcelRequire("yyqSx");

var $6Ye5d = parcelRequire("6Ye5d");

var $9t9g0 = parcelRequire("9t9g0");

var $FLXe7 = parcelRequire("FLXe7");

var $gJ1u9 = parcelRequire("gJ1u9");

var $a5QNi = parcelRequire("a5QNi");

var $75bi0 = parcelRequire("75bi0");

var $jPZ7t = parcelRequire("jPZ7t");

var $erKV3 = parcelRequire("erKV3");

var $ephMr = parcelRequire("ephMr");

var $hUZx2 = parcelRequire("hUZx2");

var $lpokX = parcelRequire("lpokX");

var $hG7ij = parcelRequire("hG7ij");

var $9hVW3 = parcelRequire("9hVW3");

var $3AmM5 = parcelRequire("3AmM5");

var $4mRwo = parcelRequire("4mRwo");

var $dWLk9 = parcelRequire("dWLk9");

var $1byaX = parcelRequire("1byaX");

var $j1rVF = parcelRequire("j1rVF");

var $eb8av = parcelRequire("eb8av");

var $lB25E = parcelRequire("lB25E");

var $hUb8I = parcelRequire("hUb8I");

var $czzq4 = parcelRequire("czzq4");

var $h3FKF = parcelRequire("h3FKF");

var $2oUjd = parcelRequire("2oUjd");

var $11icP = parcelRequire("11icP");

var $aFKQh = parcelRequire("aFKQh");

var $gOcNK = parcelRequire("gOcNK");

var $6nw99 = parcelRequire("6nw99");

var $dQQNC = parcelRequire("dQQNC");

var $bDFkL = parcelRequire("bDFkL");
const $b57ac67d5658db24$var$getVersionIdState = (versionId)=>{
    const correctedVersionId = versionId.replace(/\D/g, ''); // non-numeric version id is invalid
    if (correctedVersionId.length === 0) return {
        state: 'INVALID'
    };
     // numeric version id that has been pruned of non-numeric characters
    if (correctedVersionId.length !== versionId.length) return {
        state: 'CORRECTED',
        correctedVersionId: correctedVersionId
    };
    return {
        state: 'VALID'
    };
};
const $b57ac67d5658db24$export$d5910e6123a77411 = ({ jiraVersion: jiraVersion, devOps: devOps })=>{
    const [state] = (0, $a5QNi.useSidebarStore)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [designQueryRef, loadDesignQuery] = (0, $iWLL0.useQueryLoader)((0, $3GsbF.default));
    const [relatedWorkQueryRef, loadRelatedWorkQuery] = (0, $iWLL0.useQueryLoader)((0, $dIEey.default));
    const onViewRelatedWorkExperienceFail = (0, $hG7ij.useViewVersionRelatedWorkExperienceFail)();
    const onLaunchCardExperienceFail = (0, $jPZ7t.useLaunchCardExperienceFail)();
    const onVersionApproversCardExperienceFail = (0, $FLXe7.useVersionApproversCardExperienceFail)();
    const onIssueAssociatedDesignsExperienceFail = (0, $1byaX.useIssueAssociatedDesignsExperienceFail)();
    const { currentTabId: currentTabId } = (0, $h3FKF.useCurrentTab)();
    const devOpsData = (0, $iWLL0.useFragment)((0, $bMW5V.default), devOps);
    const [version, refetch] = (0, $iWLL0.useRefetchableFragment)((0, $g5E9O.default), jiraVersion);
    const designProviderLength = (devOpsData?.providers?.designProviders ?? []).length; // Designs and its associated issues query is expensive, so we load it lazily not as a part of initial query.
    (0, $eUqFw.useEffect)(()=>{
        if (designProviderLength > 0 && designQueryRef == null) {
            loadDesignQuery({
                versionAri: version.id,
                cloudAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                })
            });
            loadRelatedWorkQuery({
                versionAri: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)()
            });
        }
    }, [
        cloudId,
        designProviderLength,
        designQueryRef,
        loadDesignQuery,
        loadRelatedWorkQuery,
        version.id
    ]);
    const { filters: filters, sortBy: sortBy } = (0, $ephMr.useVersionIssuesGraphQLVariables)();
    const [suspenselessRefetch, isRefetchLoading] = (0, $4bMJ9.useSuspenselessRefetch)((0, $10dcg.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const [debouncedRefetchVersion] = (0, $2jdHI.default)(()=>{
        suspenselessRefetch({
            id: version.id,
            isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
            isIssueSummarisedDeploymentsMigratedToAgs: (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
            ...(0, $czzq4.convertTabToQueryVariables)(currentTabId),
            filters: filters,
            sortBy: sortBy
        });
    }, 500);
    const isIssueClosed = state.status === 'CLOSED';
    const isIssueSectionCollapsed = (version.collapsedUis ?? []).includes('ISSUES');
    const issueListFooterRef = (0, $eUqFw.useRef)(null);
    const [isIssueListFooterPinned, setIsIssueListFooterPinned] = (0, $eUqFw.useState)(false);
    const handleScroll = ()=>{
        const issueListFooter = issueListFooterRef.current;
        if (issueListFooter) {
            const footerRect = issueListFooter.getBoundingClientRect();
            setIsIssueListFooterPinned(footerRect.top + footerRect.height >= window.innerHeight);
        }
    };
    const issueListContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$IssueListMinHeightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUZx2.IssueListWithHeaderWithErrorBoundary), {
        jiraVersion: version
    }), !isIssueSectionCollapsed && version?.canAddAndRemoveIssues && version?.allIssues?.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "addIssuesToVersion"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$IssueListFooterContentWrapper, {
        isPinned: isIssueListFooterPinned,
        ref: issueListFooterRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t9g0.AddIssuesToVersion), {
        appearance: "subtle",
        isIssueListFooterButton: true,
        jiraVersion: version,
        showIcon: true
    }))) : null);
    const shouldRenderDesignSection = !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && designProviderLength > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$VersionDetailsWrapper, {
        isIssueClosed: isIssueClosed,
        onScroll: handleScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lpokX.RefetchContext).Provider, {
        value: {
            isLoading: isRefetchLoading,
            refetch: debouncedRefetchVersion
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPZ7t.LaunchCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$ContainerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$MainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nw99.Header), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "richTextSection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4mRwo.AsyncVersionRichTextSection), {
        jiraVersion: version
    })), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "relatedWork",
        onError: onViewRelatedWorkExperienceFail
    }, relatedWorkQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3AmM5.RelatedWorkLoadingSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-releases-version-details-related-work",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3AmM5.RelatedWorkLoadingSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hVW3.RelatedWork), {
        queryRef: relatedWorkQueryRef
    }))), shouldRenderDesignSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueAssociatedDesigns",
        onError: onIssueAssociatedDesignsExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1byaX.IssueAssociatedDesignsExperienceStart), null), designQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1rVF.DesignSectionSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-releases-version-details-designs",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1rVF.DesignSectionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1rVF.IssueAssociatedDesigns), {
        queryRef: designQueryRef
    }))), issueListContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDFkL.RightSidebar), {
        jiraVersion: version
    }, isIssueClosed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "launchCard",
        onError: onLaunchCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $erKV3.LaunchCard), {
        jiraVersion: version
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "approversCard",
        onError: onVersionApproversCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $FLXe7.VersionApproversCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJ1u9.Approvers), {
        jiraVersion: version
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "progressCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eb8av.VersionProgress), {
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueSidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75bi0.IssueSidebar), null))))));
};
const $b57ac67d5658db24$export$7ef104a5ca9287b8 = ({ queryReference: queryReference })=>{
    const hasFiredErrorAnalytics = (0, $eUqFw.useRef)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: projectContext } = (0, $11icP.useProjectContextResource)();
    const { jira: jira, devOps: devOps } = (0, $iWLL0.usePreloadedQuery)((0, $cos6r.default), queryReference);
    const [versionId, setVersionId] = (0, $lB25E.usePathParam)('versionId'); // replaces invalid non-numeric version ids from the url params.
    // the query data is still valid as the same regex is applied in the versionDetailsResource.
    // if the version id is invalid then fire off an error analytic.
    (0, $eUqFw.useEffect)(()=>{
        if (versionId != null) {
            const versionIdState = $b57ac67d5658db24$var$getVersionIdState(versionId);
            if (versionIdState.state === 'CORRECTED') setVersionId(versionIdState.correctedVersionId, 'replace');
            if (versionIdState.state === 'INVALID' && !hasFiredErrorAnalytics.current) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'jira.releases.version.detail.invalid.version.id',
                        packageName: 'jiraSoftwareReleasesVersionDetail',
                        teamName: 'fusion-solaris'
                    },
                    error: Error(`Invalid version id in path param. Version id: ${String(versionId)}`),
                    sendToPrivacyUnsafeSplunk: true
                });
                hasFiredErrorAnalytics.current = true;
            }
        }
    }, [
        setVersionId,
        versionId
    ]); // missing project context means invalid project key in path param
    if (projectContext == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oUjd.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Project found"
    }));
     // missing jira value due to invalid non-digit version id in path param
    // causing relay to skip query to avoid invalid ari error in AGG
    if (!jira && versionId != null && $b57ac67d5658db24$var$getVersionIdState(versionId).state === 'INVALID') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oUjd.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
     // unknown error
    if (!jira) throw Error("Relay: Missing @required value at path 'jira' in 'uiVersionDetailsQuery'"); // mimics the Relay @required directive
    const { version: version } = jira; // received query error graphql type
    // e.g. permissions error or version not found error
    if (version.__typename !== 'JiraVersion') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oUjd.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
    const { simplified: simplified, isProjectAdmin: isProjectAdmin, projectId: projectId, projectKey: projectKey, projectName: projectName } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gOcNK.AccessCheck), {
        jiraVersion: version
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            simplified: simplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId,
            versionStatus: version.status
        },
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "versionDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFKQh.PerformanceTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hG7ij.VersionRelatedWorkExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ye5d.ViewFeatureFlagsEmptyStateExperienceExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b57ac67d5658db24$export$d5910e6123a77411, {
        jiraVersion: version,
        devOps: devOps ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $dQQNC.default).browserTitle, {
            projectName: projectName,
            versionName: version.name
        })
    })));
};
const $b57ac67d5658db24$var$ISSUE_HEADER_AND_FILTERS_SECTION_OFFSET = (0, $c9TLT.gridSize) * 14.75;
const $b57ac67d5658db24$var$LEFT_CONTAINER_MIN_WIDTH = 496; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b57ac67d5658db24$var$ContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _c71l1osq _4t3i1osq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b57ac67d5658db24$var$MainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91dft _19bvzwfg _u5f31tcg _1reo15vq _18m91wug _16jlkb7n _1o9zkb7n _i0dl1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b57ac67d5658db24$var$IssueListMinHeightContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1aj4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b57ac67d5658db24$var$VersionDetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1osq _4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.isIssueClosed ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b57ac67d5658db24$var$SidebarCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19iti1qc _2rko1l7b",
            __cmplp.className
        ])
    });
});
const $b57ac67d5658db24$var$IssueListFooterContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPinned: isPinned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q75w2r _94n5idpf _1e0c1txw _2lx21bp4 _4t3it9kd _1bah1h6o _kqsw1if8 _1bsb1osq",
            __cmplp.isPinned ? "_x3do1l7n" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cos6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e804c99683d4bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18f23f15ebc43286f3105a52e0eb4a39>>
 * @relayHash 54a305f918a787589a77e8d5c898026b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 444e6048d20cdfb98399a3b985e5a9a989d8407910b31465971b237984ad5f35

var $cNy9K = parcelRequire("cNy9K");
const $92e804c99683d4bc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v14 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v15 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v21 = {
        "kind": "ScalarField",
        "name": "description"
    }, v22 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "count"
    }, v24 = {
        "kind": "ScalarField",
        "name": "state"
    }, v25 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v24 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v26 = [
        v23 /*: any*/ 
    ], v27 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "title"
    }, v29 = [
        v23 /*: any*/ ,
        v12 /*: any*/ 
    ], v30 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v29 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v32 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v36 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v8 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "accessCheck_softwareReleasesVersionDetail"
                                                        }
                                                    ],
                                                    "type": "JiraVersion"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.version"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "cloudAri"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "providerTypes",
                                            "value": [
                                                "DESIGN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDesignProvider",
                                            "kind": "LinkedField",
                                            "name": "designProviders",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canAddAndRemoveIssues"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        v14 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cloudId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionDriverResult",
                                                    "kind": "LinkedField",
                                                    "name": "driverData",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "driver",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "queryError",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                                    "kind": "LinkedField",
                                                    "name": "connectAddonIframeData",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moduleKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "location"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "options"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "doneIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "DONE"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                },
                                                {
                                                    "alias": "inProgressIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "IN_PROGRESS"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                },
                                                {
                                                    "alias": "todoIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "TODO"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "warningsCount"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewDevTools"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionIssueTableHiddenColumns"
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "priority",
                                                                                        "summary",
                                                                                        "assignee",
                                                                                        "status",
                                                                                        "issuetype"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fieldId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "statusCategoryId"
                                                                                                                        },
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                v12 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devOpsSummarisedEntities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "category"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "deploymentState"
                                                                                                },
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summarisedDeployments",
                                                                                                    "plural": false,
                                                                                                    "selections": v26 /*: any*/ 
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummaryCache",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "devSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "pullrequest",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v24 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "branch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v26 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "review",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "lastUpdated"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "stateCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryByProvider",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "providerId"
                                                                                                                },
                                                                                                                v10 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commit",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v26 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "build",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "failedBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "successfulBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "unknownBuildCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironments",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "topEnvironments",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v30 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v25 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": v29 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedFeatureFlags",
                                                                                    "plural": false,
                                                                                    "selections": v16 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v22 /*: any*/ ,
                                                    "filters": [
                                                        "filter",
                                                        "sortBy",
                                                        "filters"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ListVersion_issuesForList",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                },
                                                {
                                                    "alias": "allIssuesRedesignTemp",
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                },
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "concreteType": "JiraVersionApproverConnection",
                                                    "kind": "LinkedField",
                                                    "name": "approvers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApproverEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionApprover",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v19 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "declineReason"
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ],
                                                    "storageKey": "approvers(first:100)"
                                                },
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_approvers",
                                                    "kind": "LinkedHandle",
                                                    "name": "approvers"
                                                },
                                                {
                                                    "concreteType": "JiraVersionRichTextSection",
                                                    "kind": "LinkedField",
                                                    "name": "richTextSection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraADF",
                                                            "kind": "LinkedField",
                                                            "name": "content",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "json"
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewVersionDetailsPage"
                                                },
                                                {
                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasReleaseNote"
                                                        },
                                                        {
                                                            "concreteType": "JiraVersionContributorConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributors",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionContributorEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                            "kind": "LinkedField",
                                                            "name": "relatedWorkV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v36 /*: any*/ ,
                                                                                    "type": "JiraVersionRelatedWorkGenericLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v36 /*: any*/ ,
                                                                                    "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "storageKey": "relatedWorkV2(first:100)"
                                                        },
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "version_relatedWorkV2",
                                                            "kind": "LinkedHandle",
                                                            "name": "relatedWorkV2"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedEntities",
                                                            "kind": "LinkedField",
                                                            "name": "devOpsSummarisedEntities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsProviders",
                                                                    "kind": "LinkedField",
                                                                    "name": "providers",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "featureFlagProviders",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "444e6048d20cdfb98399a3b985e5a9a989d8407910b31465971b237984ad5f35",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$92e804c99683d4bc$var$node.hash = "bd9f49cde5ae44cf7400b66e88a88e94";
(0, $cNy9K.PreloadableQueryRegistry).set($92e804c99683d4bc$var$node.params.id, $92e804c99683d4bc$var$node);
var $92e804c99683d4bc$export$2e2bcd8739ae039 = $92e804c99683d4bc$var$node;

});

parcelRegister("g5E9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e7b35bfa096bddc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46b02226c84565aab29d6978425758f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $10dcg = parcelRequire("10dcg");
const $3e7b35bfa096bddc$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        },
        {
            "kind": "RootArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        },
        {
            "kind": "RootArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $10dcg.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "alias": "allIssues",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "ALL"
                }
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issues",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ],
            "storageKey": "issues(filter:\"ALL\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesLaunchCard_LaunchCard"
        },
        {
            "kind": "FragmentSpread",
            "name": "header_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_versionProgress_VersionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesApprovers_Approvers"
        },
        {
            "kind": "FragmentSpread",
            "name": "rightSidebar_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$3e7b35bfa096bddc$var$node.hash = "0e068654bcbac5a53b80708d6abf77a8";
var $3e7b35bfa096bddc$export$2e2bcd8739ae039 = $3e7b35bfa096bddc$var$node;

});
parcelRegister("10dcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9048129016c72be6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d71bc4941df06b95c21ac688aefb5e3>>
 * @relayHash 61388f78aef4cdc49e2956adb1249090
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808bb6a1b2ad88b19353b2a5771138ef3c4b4ea7f74293b5581c947dc7937992
const $9048129016c72be6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v10 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v11 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v14 = {
        "kind": "ScalarField",
        "name": "status"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v19 = {
        "kind": "ScalarField",
        "name": "description"
    }, v20 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "count"
    }, v22 = {
        "kind": "ScalarField",
        "name": "state"
    }, v23 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v22 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v24 = [
        v21 /*: any*/ 
    ], v25 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "title"
    }, v27 = [
        v21 /*: any*/ ,
        v8 /*: any*/ 
    ], v28 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v29 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v30 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v31 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v33 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v34 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                v9 /*: any*/ ,
                                {
                                    "alias": "allIssues",
                                    "args": [
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": "issues(filter:\"ALL\")"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "releaseDate"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cloudId"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionDriverResult",
                                    "kind": "LinkedField",
                                    "name": "driverData",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "driver",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "queryError",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v19 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                    "kind": "LinkedField",
                                    "name": "connectAddonIframeData",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "appKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "appName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "options"
                                        }
                                    ]
                                },
                                {
                                    "alias": "doneIssuesRedesignTemp",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "filters",
                                            "value": {
                                                "statusCategories": [
                                                    "DONE"
                                                ]
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                },
                                {
                                    "alias": "inProgressIssuesRedesignTemp",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "filters",
                                            "value": {
                                                "statusCategories": [
                                                    "IN_PROGRESS"
                                                ]
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                },
                                {
                                    "alias": "todoIssuesRedesignTemp",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "filters",
                                            "value": {
                                                "statusCategories": [
                                                    "TODO"
                                                ]
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "warningsCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v8 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v7 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        v7 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": v24 /*: any*/ 
                                                                                },
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v22 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v24 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v17 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v24 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v27 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v30 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "alias": "allIssuesRedesignTemp",
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "args": v31 /*: any*/ ,
                                    "concreteType": "JiraVersionApproverConnection",
                                    "kind": "LinkedField",
                                    "name": "approvers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionApproverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApprover",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "declineReason"
                                                        },
                                                        v19 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v30 /*: any*/ 
                                    ],
                                    "storageKey": "approvers(first:100)"
                                },
                                {
                                    "args": v31 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "version_approvers",
                                    "kind": "LinkedHandle",
                                    "name": "approvers"
                                },
                                {
                                    "concreteType": "JiraVersionRichTextSection",
                                    "kind": "LinkedField",
                                    "name": "richTextSection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasReleaseNote"
                                        },
                                        {
                                            "concreteType": "JiraVersionContributorConnection",
                                            "kind": "LinkedField",
                                            "name": "contributors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionContributorEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v31 /*: any*/ ,
                                            "concreteType": "JiraVersionRelatedWorkV2Connection",
                                            "kind": "LinkedField",
                                            "name": "relatedWorkV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v34 /*: any*/ ,
                                                                    "type": "JiraVersionRelatedWorkGenericLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v34 /*: any*/ ,
                                                                    "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                }
                                                            ]
                                                        },
                                                        v29 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ],
                                            "storageKey": "relatedWorkV2(first:100)"
                                        },
                                        {
                                            "args": v31 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_relatedWorkV2",
                                            "kind": "LinkedHandle",
                                            "name": "relatedWorkV2"
                                        },
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v33 /*: any*/ 
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "808bb6a1b2ad88b19353b2a5771138ef3c4b4ea7f74293b5581c947dc7937992",
            "metadata": {},
            "name": "versionDetailPageRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9048129016c72be6$var$node.hash = "0e068654bcbac5a53b80708d6abf77a8";
var $9048129016c72be6$export$2e2bcd8739ae039 = $9048129016c72be6$var$node;

});


parcelRegister("bMW5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $c07bf64ae4fe84a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<575aa0ac902f70ccf49448d3df147e43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c07bf64ae4fe84a1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudAri"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "DESIGN"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsDesignProvider",
                            "kind": "LinkedField",
                            "name": "designProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "DevOps"
};
$c07bf64ae4fe84a1$var$node.hash = "72d5936bbd25e3ba21b829d9fbc1ac05";
var $c07bf64ae4fe84a1$export$2e2bcd8739ae039 = $c07bf64ae4fe84a1$var$node;

});

parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("4bMJ9", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetch", () => $93417f2cf15e39ef$export$c7ce5f64dc007896);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $3koWU = parcelRequire("3koWU");
const $93417f2cf15e39ef$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eUqFw.useRef)([]);
    return (0, $eUqFw.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $93417f2cf15e39ef$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const isMounted = (0, $3koWU.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $93417f2cf15e39ef$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    return (0, $eUqFw.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $iWLL0.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    setLastFetchError?.(null);
                    onRequestFinish(variables, ()=>refetch(variables, {
                            fetchPolicy: 'store-only'
                        }));
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError
    ]);
};
const $93417f2cf15e39ef$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eUqFw.useState)(null);
    const refetchFunction = $93417f2cf15e39ef$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dIEey", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01c019737d76db3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a502a521dfb278c60a140a47696ab44e>>
 * @relayHash 46005dd1e90285de41063db46b4c78fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e539d2431a455c6471d76a9f70475650b3bb0955bd96adf4240b9e4d5f3be156
const $e01c019737d76db3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "relatedWorkId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "assignee",
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "statusCategoryId"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    },
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    v3 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "picture"
                                                    },
                                                    v10 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                    },
                                    v5 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isSaving"
            }
        ]
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ 
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkV2",
        "abstractKey": "__isJiraVersionRelatedWorkV2"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "category"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEditRelatedWork"
                                                },
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": "ALL"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "collapsedUis"
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e539d2431a455c6471d76a9f70475650b3bb0955bd96adf4240b9e4d5f3be156",
            "metadata": {},
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e01c019737d76db3$var$node.hash = "d8d66158505126260b0811b2a2af5336";
var $e01c019737d76db3$export$2e2bcd8739ae039 = $e01c019737d76db3$var$node;

});

parcelRegister("3GsbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1db43a21d0556225$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ae3efdf5ff1633f61a5fb1f56aa7df2>>
 * @relayHash b89922858b2af773f5745e807572963f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c
const $1db43a21d0556225$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 6
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCarousel_versionIssueAssociatedDesigns"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v3 /*: any*/ ,
                                                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issueAssociatedDesigns",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.issueAssociatedDesigns.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.issueAssociatedDesigns"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsedUis"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdated"
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "id",
                                                                                    "variableName": "cloudAri"
                                                                                }
                                                                            ],
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 2
                                                                                }
                                                                            ],
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "associatedIssues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "key"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "summary"
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ignoreMissingFields",
                                                                                                                    "value": true
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v2 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "name"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "xsmall"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v5 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v5 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v2 /*: any*/ ,
                                                                                                v6 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "associatedIssues(first:2)"
                                                                        }
                                                                    ],
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "filters": [
                                                "sort"
                                            ],
                                            "handle": "connection",
                                            "key": "DesignSlider_issueAssociatedDesigns",
                                            "kind": "LinkedHandle",
                                            "name": "issueAssociatedDesigns"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c",
            "metadata": {},
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1db43a21d0556225$var$node.hash = "6385dc34956a666103b9e7e3b549a2e3";
var $1db43a21d0556225$export$2e2bcd8739ae039 = $1db43a21d0556225$var$node;

});

parcelRegister("6Ye5d", function(module, exports) {

$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceStart", () => $dfa40d4cf50bdb64$export$dba6cce392699a2b);
$parcel$export(module.exports, "useViewFeatureFlagsEmptyStateExperienceExperienceFail", () => $dfa40d4cf50bdb64$export$b0017a8c5a092f54);
$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker", () => $dfa40d4cf50bdb64$export$c49eaa8e4e389a94);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $bNe1g = parcelRequire("bNe1g");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $dfa40d4cf50bdb64$var$EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';
const $dfa40d4cf50bdb64$export$dba6cce392699a2b = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $dfa40d4cf50bdb64$var$EXPERIENCE_NAME,
        analyticsSource: "featureFlagsEmptyStateExperience",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $dfa40d4cf50bdb64$export$b0017a8c5a092f54 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $dfa40d4cf50bdb64$var$EXPERIENCE_NAME
    });
const $dfa40d4cf50bdb64$export$c49eaa8e4e389a94 = ()=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $dfa40d4cf50bdb64$var$EXPERIENCE_NAME,
        attributes: projectContext != null ? {
            projectId: projectContext.projectId,
            isProjectAdmin: projectContext.isProjectAdmin,
            simplified: projectContext.simplified
        } : undefined
    });
};

});

parcelRegister("9t9g0", function(module, exports) {

$parcel$export(module.exports, "AddIssuesToVersion", () => $a2f6d1b1c98fddfd$export$bae9d11b7896e3f7);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $e6qJT = parcelRequire("e6qJT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a2f6d1b1c98fddfd$var$LazyAddIssuesToVersion = (0, $7rh0R.lazy)(()=>(parcelRequire("hcRc5")).then((module)=>module.AddIssuesToVersion), {
    moduleId: "./src/packages/releases/add-issues-to-version/src/ui/index.tsx"
});
const $a2f6d1b1c98fddfd$export$bae9d11b7896e3f7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const PlaceholderButton = props.isIssueListFooterButton ? $a2f6d1b1c98fddfd$var$IssueListFooterButton : (0, $7u4fN.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-issues-to-version",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PlaceholderButton, {
            onClick: undefined,
            appearance: props.appearance,
            type: "button",
            iconBefore: props.showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: "",
                size: "small"
            }) : undefined
        }, formatMessage((0, $e6qJT.default).addButton))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2f6d1b1c98fddfd$var$LazyAddIssuesToVersion, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2f6d1b1c98fddfd$var$IssueListFooterButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kba1h6o _btpd1osq _1n7d1ylp _14741e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e6qJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ff9686771dad87$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c3ff9686771dad87$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addButton: {
        "id": "software-releases-add-issues-to-version.add-button",
        "defaultMessage": "Add issues"
    },
    errorFlagTitle: {
        "id": "software-releases-add-issues-to-version.error-flag-title",
        "defaultMessage": "Can't add {totalCount, plural, one {issue} other {# issues}} to version"
    },
    errorFlagDescription: {
        "id": "software-releases-add-issues-to-version.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    successFlagDescription: {
        "id": "software-releases-add-issues-to-version.success-flag-description",
        "defaultMessage": "{issueCount, plural, one {# issue has been added} other {# issues have been added}}."
    },
    partialIssueFailureFlagTitle: {
        "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title",
        "defaultMessage": "{failedIssueCount} out of {totalCount} issues not added to version."
    },
    singleIssueMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so it wasn't added."
    },
    singleIssueMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so it wasn't added."
    },
    singleIssueMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so it wasn't added."
    },
    twoIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    multipleIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    }
});

});

parcelRegister("hcRc5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3fzV5").then(()=>parcelRequire('b422H'));

});


parcelRegister("FLXe7", function(module, exports) {

$parcel$export(module.exports, "VersionApproversCardExperienceStart", () => $585fa5c41b8d2ee5$export$e45410483a7f75f3);
$parcel$export(module.exports, "VersionApproversCardExperienceSuccess", () => $585fa5c41b8d2ee5$export$664bc979971dec26);
$parcel$export(module.exports, "useVersionApproversCardExperienceFail", () => $585fa5c41b8d2ee5$export$3edb8e7637e1d4cc);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $585fa5c41b8d2ee5$export$52919046b94109dc = 'jiraVersionApproversCard';
const $585fa5c41b8d2ee5$var$ANALYTICS_SOURCE = 'versionDetails';
const $585fa5c41b8d2ee5$export$e45410483a7f75f3 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $585fa5c41b8d2ee5$export$52919046b94109dc,
        analyticsSource: $585fa5c41b8d2ee5$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $585fa5c41b8d2ee5$export$664bc979971dec26 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $585fa5c41b8d2ee5$export$52919046b94109dc
    });
const $585fa5c41b8d2ee5$export$3edb8e7637e1d4cc = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $585fa5c41b8d2ee5$export$52919046b94109dc
    });

});

parcelRegister("gJ1u9", function(module, exports) {

$parcel$export(module.exports, "Approvers", () => $5396a7428d0750ff$export$52f716ccfb37fc43);

var $6jsbe = parcelRequire("6jsbe");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $aVkzK = parcelRequire("aVkzK");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");


var $75j3A = parcelRequire("75j3A");

var $jkhfg = parcelRequire("jkhfg");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5396a7428d0750ff$var$LazyApprovers = (0, $7rh0R.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("jkhfg"))).then((module)=>module.Approvers), {
    ssr: false,
    moduleId: "./src/packages/releases/approvers/src/ui/index.tsx"
});
const $5396a7428d0750ff$export$52f716ccfb37fc43 = ({ jiraVersion: jiraVersion })=>{
    const { startNextPhase: startNextPhase } = (0, $7rh0R.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $iWLL0.useFragment)((0, $6jsbe.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const numberOfApproversToShow = (0, $fd4473419e7fd62e$export$ab69ec32c8e056d0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "releases-approvers",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkhfg.ApproversCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkhfg.Header), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkhfg.ApproversTitle), null, formatMessage((0, $75j3A.default).approversTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                size: "small",
                label: ""
            }),
            appearance: "subtle"
        })), [
            ...Array(numberOfApproversToShow).keys()
        ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
                key: i,
                isShimmering: true,
                hasAvatar: true
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5396a7428d0750ff$var$LazyApprovers, {
        jiraVersion: version
    }));
};

});
parcelRegister("6jsbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a4297865f3769d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9002c0d697d345d76c64fe0f6d5cbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80a4297865f3769d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesApprovers_Approvers",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesApprovers_Approvers"
        }
    ],
    "type": "JiraVersion"
};
$80a4297865f3769d$var$node.hash = "b54447a983203e9751ad03d69a14f12e";
var $80a4297865f3769d$export$2e2bcd8739ae039 = $80a4297865f3769d$var$node;

});

const $fd4473419e7fd62e$export$ab69ec32c8e056d0 = 5;

parcelRegister("75j3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0fda7f05eadcdc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3b0fda7f05eadcdc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    approversTitle: {
        "id": "software-releases-approvers.approvers-title",
        "defaultMessage": "Approvers"
    },
    noApproversMessage: {
        "id": "software-releases-approvers.no-approvers-message",
        "defaultMessage": "No approvers have been added"
    },
    showMore: {
        "id": "software-releases-approvers.show-more",
        "defaultMessage": "Show all approvers"
    },
    showLess: {
        "id": "software-releases-approvers.show-less",
        "defaultMessage": "Show less"
    }
});

});

parcelRegister("jkhfg", function(module, exports) {

$parcel$export(module.exports, "Approvers", () => $45144f84b9369a7b$export$52f716ccfb37fc43);
$parcel$export(module.exports, "ApproversCardWrapper", () => $45144f84b9369a7b$export$8a998394e67d0203);
$parcel$export(module.exports, "Header", () => $45144f84b9369a7b$export$8b251419efc915eb);
$parcel$export(module.exports, "ApproversTitle", () => $45144f84b9369a7b$export$390d4754e91af8cc);

var $96YIL = parcelRequire("96YIL");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $h0grN = parcelRequire("h0grN");

var $3MV1G = parcelRequire("3MV1G");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5mz4o = parcelRequire("5mz4o");

var $4REJK = parcelRequire("4REJK");

var $FLXe7 = parcelRequire("FLXe7");

var $k2mZG = parcelRequire("k2mZG");


var $75j3A = parcelRequire("75j3A");

var $6PysW = parcelRequire("6PysW");
const $45144f84b9369a7b$export$52f716ccfb37fc43 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isShowingAllApprovers, setIsShowingAllApprovers] = (0, $eUqFw.useState)(false);
    const version = (0, $iWLL0.useFragment)((0, $96YIL.default), jiraVersion);
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(false);
    const allApprovers = version.approvers.edges.map((edge)=>edge?.node).filter(Boolean);
    const collapsedApproversList = allApprovers.slice(0, (0, $fd4473419e7fd62e$export$ab69ec32c8e056d0));
    const moreApproversCount = allApprovers.length - (0, $fd4473419e7fd62e$export$ab69ec32c8e056d0);
    const moreApproversCountLabel = `+${moreApproversCount}`;
    const canShowMoreApprovers = allApprovers.length > (0, $fd4473419e7fd62e$export$ab69ec32c8e056d0);
    const showMoreMessage = isShowingAllApprovers ? formatMessage((0, $75j3A.default).showLess) : formatMessage((0, $75j3A.default).showMore);
    const popupContent = allApprovers.length >= 100 && version.canAddAndRemoveIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mz4o.LimitReachedError), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4REJK.NoPermissionError), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$export$8a998394e67d0203, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $FLXe7.VersionApproversCardExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$export$8b251419efc915eb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$export$390d4754e91af8cc, null, formatMessage((0, $75j3A.default).approversTitle)), version.canAddAndRemoveIssues && allApprovers.length < 100 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k2mZG.ApproverSelector), {
        jiraVersion: version,
        numberOfApprovers: allApprovers.length
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        content: ()=>popupContent,
        isOpen: isPopupOpen,
        autoFocus: false,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-end",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                onClick: ()=>setIsPopupOpen(true),
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                    size: "small",
                    label: ""
                })
            })
    })), allApprovers.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$var$EmptyStateMessage, null, formatMessage((0, $75j3A.default).noApproversMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$var$List, null, (allApprovers.length < (0, $fd4473419e7fd62e$export$ab69ec32c8e056d0) || isShowingAllApprovers ? allApprovers : collapsedApproversList).map((node)=>node == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PysW.TaskApprover), {
            key: node.id,
            jiraVersionApprover: node,
            jiraVersion: version
        }))), canShowMoreApprovers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$var$ExpandableListButton, {
        onClick: ()=>setIsShowingAllApprovers(!isShowingAllApprovers)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$var$ExpandableListLozenge, null, isShowingAllApprovers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h0grN))), {
        size: "small",
        label: ""
    }) : moreApproversCountLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45144f84b9369a7b$var$ExpandableListText, null, showMoreMessage)));
};
const $45144f84b9369a7b$var$BORDER_SIZE = 1;
const $45144f84b9369a7b$var$PADDING_SIZE = (0, $c9TLT.gridSize) * 3;
const $45144f84b9369a7b$var$WIDTH_OFFSET = ($45144f84b9369a7b$var$PADDING_SIZE + $45144f84b9369a7b$var$BORDER_SIZE) * 2; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $45144f84b9369a7b$export$8a998394e67d0203 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zulppxbi _p12fpjzf _c71l842n _1reo1wug _18m91wug _1yt41ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $45144f84b9369a7b$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $45144f84b9369a7b$export$390d4754e91af8cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1wybdlk8 _k48pni7l _syaz14xw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45144f84b9369a7b$var$EmptyStateMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz1be1 _1wybdlk8 _ca0qu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45144f84b9369a7b$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45144f84b9369a7b$var$ExpandableListText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz14xw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45144f84b9369a7b$var$ExpandableListLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1tcg _bfhkiw92 _1bsbzwfg _4t3izwfg _syaz14xw _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45144f84b9369a7b$var$ExpandableListButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7glyw _19itglyw _1yt4u2gc _80omtlke _1e0c1txw _zulppxbi _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("96YIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4933100b3314f26b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eeda6d651a2b214293767fe20f183f3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4933100b3314f26b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "approvers"
                ]
            }
        ]
    },
    "name": "ui_softwareReleasesApprovers_Approvers",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "approverSelector_softwareReleasesApprovers"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "approvers",
                "concreteType": "JiraVersionApproverConnection",
                "kind": "LinkedField",
                "name": "__version_approvers_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraVersionApproverEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionApprover",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "approvers.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "approvers"
        },
        {
            "kind": "FragmentSpread",
            "name": "taskApprover_softwareReleasesApprovers_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$4933100b3314f26b$var$node.hash = "6bdf5e27e22a0c4638dba83dd47602fd";
var $4933100b3314f26b$export$2e2bcd8739ae039 = $4933100b3314f26b$var$node;

});

parcelRegister("5mz4o", function(module, exports) {

$parcel$export(module.exports, "LimitReachedError", () => $0632cd29264d86f5$export$94e0e4128489f457);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $43Lxe = parcelRequire("43Lxe");

var $feTYk = parcelRequire("feTYk");

var $1du3b = parcelRequire("1du3b");
const $0632cd29264d86f5$export$94e0e4128489f457 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43Lxe.ErrorView), {
        title: formatMessage((0, $1du3b.default).title),
        description: formatMessage((0, $1du3b.default).description),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($feTYk))),
            width: 80,
            height: 105,
            alt: ""
        }),
        testId: "software-releases-approvers.common.ui.limit-reached-error.error-view"
    });
};

});
parcelRegister("43Lxe", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $64c379437bd826df$export$8c68b6013ae44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $64c379437bd826df$export$8c68b6013ae44ca6 = ({ image: image, title: title, description: description, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64c379437bd826df$var$Container, {
        "data-testid": testId
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64c379437bd826df$var$Description, null, description));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64c379437bd826df$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1yt41ejb _ca0q1jfw _1bsb1k99",
            __cmplp.className
        ])
    });
});
const $64c379437bd826df$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zu5n _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("feTYk", function(module, exports) {
module.exports = new URL("error-generic.82a0f101.svg", import.meta.url).toString();

});

parcelRegister("1du3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc3a68b176bdfd7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $adc3a68b176bdfd7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-releases-approvers.common.limit-reached-error.title",
        "defaultMessage": "You can't add any more approvers"
    },
    description: {
        "id": "software-releases-approvers.common.limit-reached-error.description",
        "defaultMessage": "You've reached the maximum limit of 100 approvers for this version - whoa! Please remove some approvers if you want to add more."
    }
});

});


parcelRegister("4REJK", function(module, exports) {

$parcel$export(module.exports, "NoPermissionError", () => $7328c618efac4b3f$export$f0cacbf7abab6c86);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $43Lxe = parcelRequire("43Lxe");

var $1POUe = parcelRequire("1POUe");

var $eQqVb = parcelRequire("eQqVb");
const $7328c618efac4b3f$export$f0cacbf7abab6c86 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43Lxe.ErrorView), {
        title: formatMessage((0, $eQqVb.default).title),
        description: formatMessage((0, $eQqVb.default).description),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1POUe))),
            width: 80,
            height: 105,
            alt: ""
        }),
        testId: "software-releases-approvers.common.ui.no-permission-error.error-view"
    });
};

});
parcelRegister("1POUe", function(module, exports) {
module.exports = new URL("lock-closed.13d6083b.svg", import.meta.url).toString();

});

parcelRegister("eQqVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3adf3a3d6ec886c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c3adf3a3d6ec886c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-releases-approvers.common.no-permission-error.title",
        "defaultMessage": "Can't add approvers"
    },
    description: {
        "id": "software-releases-approvers.common.no-permission-error.description",
        "defaultMessage": "You don't have permission to add approvers to this version."
    }
});

});


parcelRegister("k2mZG", function(module, exports) {

$parcel$export(module.exports, "ApproverSelector", () => $fa07c1c1c0c7d005$export$d226c73d87e91324);

var $aKjI9 = parcelRequire("aKjI9");

var $8DLqm = parcelRequire("8DLqm");

var $3IbI5 = parcelRequire("3IbI5");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $1wNw5 = parcelRequire("1wNw5");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $etAFk = parcelRequire("etAFk");

var $2oNBl = parcelRequire("2oNBl");
const $fa07c1c1c0c7d005$var$isOptionData = (val)=>val != null && typeof val.name === 'string' && typeof val.id === 'string';
const $fa07c1c1c0c7d005$var$createLoadQueryFunc = (environment, versionAri)=>(searchText)=>(0, $iWLL0.fetchQuery)(environment, (0, $3IbI5.default), {
            versionAri: versionAri,
            searchText: searchText
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise().then(// @ts-expect-error - TS2345 - Argument of type '(response: Response) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
        (response)=>{
            const edges = response?.jira?.version?.project?.suggestedApproversForJiraVersion?.edges ?? [];
            return edges.filter(Boolean).map((edge)=>edge?.node).map((user)=>user == null ? null : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    avatarUrl: user.picture,
                    name: user.name,
                    id: user.accountId,
                    byline: user?.extendedProfile?.jobTitle ?? '',
                    type: 'user'
                }).filter($fa07c1c1c0c7d005$var$isOptionData);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'approverSelectorQuery',
                    packageName: 'jiraSoftwareReleasesApprovers'
                },
                error: error
            }); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
        });
const $fa07c1c1c0c7d005$export$d226c73d87e91324 = ({ numberOfApprovers: numberOfApprovers, jiraVersion: jiraVersion })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const experienceStart = (0, $etAFk.useAddVersionApproversExperienceStart)();
    const experienceFail = (0, $etAFk.useAddVersionApproversExperienceFail)();
    const experienceSuccess = (0, $etAFk.useAddVersionApproversExperienceSuccess)();
    const version = (0, $iWLL0.useFragment)((0, $8DLqm.default), jiraVersion);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'selected',
        actionSubject: 'versionApprover'
    });
    const [addJiraVersionApprover] = (0, $iWLL0.useMutation)((0, $aKjI9.default));
    const connectionId = (0, $iWLL0.ConnectionHandler).getConnectionID(version.__id, 'version_approvers');
    const onMutationError = (error)=>{
        experienceFail('graphql error', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.approvers.approver-selector',
                packageName: 'jiraSoftwareReleasesApprovers',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: formatMessage((0, $2oNBl.default).genericErrorFlagTitle),
            description: formatMessage((0, $2oNBl.default).genericErrorFlagDescription),
            type: 'error'
        });
    };
    const versionAri = version.id;
    const loadOptions = $fa07c1c1c0c7d005$var$createLoadQueryFunc(environment, versionAri);
    const addApproverToVersion = (newApprover)=>{
        addJiraVersionApprover({
            variables: {
                input: {
                    versionId: versionAri,
                    approverAccountId: newApprover?.id
                },
                connections: [
                    connectionId
                ]
            },
            onCompleted: (data)=>{
                if (data.jira?.addJiraVersionApprover?.success !== true) {
                    const responseErrors = data?.jira?.addJiraVersionApprover?.errors;
                    const errorMessage = responseErrors?.[0]?.message ?? 'addVersionApprover graphql mutation failed';
                    onMutationError(new Error(errorMessage));
                }
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionApprover added', {
                    isApproverSet: Boolean(newApprover?.id)
                });
                experienceSuccess();
            },
            onError: (error)=>{
                onMutationError(error);
            }
        });
        return newApprover;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa07c1c1c0c7d005$var$PlacholderStyleOverrider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wNw5.PopupUserPicker), {
        fieldId: "jiraVersionApprovers",
        width: 320,
        placeholder: formatMessage((0, $2oNBl.default).findUserLabel),
        onChange: (value)=>{
            if (Array.isArray(value)) return;
            value == null || addApproverToVersion(value);
        },
        target: ({ ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...targetProps,
                appearance: "subtle",
                isDisabled: numberOfApprovers >= 100,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                    size: "small",
                    label: formatMessage((0, $2oNBl.default).addApproverLabel)
                })
            }),
        loadOptions: loadOptions,
        placement: "bottom-end",
        onFocus: ()=>experienceStart()
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa07c1c1c0c7d005$var$PlacholderStyleOverrider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0196n _1owr16oo _1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw _v98tu2gc _djrp1mxx _hfmuglyw _16daglyw _wadh1otk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aKjI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fd6a98a4e20a99f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b309734cf04b0cb666486c981e7f13a>>
 * @relayHash 47e8af21a1b55b6170b6b8c6d263a139
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 542e4a4137c33de1980ae75d67a35693680f429d9b801fe3e8d834f57d2dbab9
const $0fd6a98a4e20a99f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "connections"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "approverSelector_addApproverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionAddApproverPayload",
                            "kind": "LinkedField",
                            "name": "addJiraVersionApprover",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersionApproverEdge",
                                    "kind": "LinkedField",
                                    "name": "approverEdge",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionApprover",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "approverSelector_addApproverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionAddApproverPayload",
                            "kind": "LinkedField",
                            "name": "addJiraVersionApprover",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersionApproverEdge",
                                    "kind": "LinkedField",
                                    "name": "approverEdge",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionApprover",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                    "kind": "LinkedField",
                                                                    "name": "extendedProfile",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jobTitle"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "AtlassianAccountUser"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "declineReason"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "handle": "prependEdge",
                                    "key": "",
                                    "kind": "LinkedHandle",
                                    "name": "approverEdge",
                                    "handleArgs": [
                                        {
                                            "kind": "Variable",
                                            "name": "connections",
                                            "variableName": "connections"
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "542e4a4137c33de1980ae75d67a35693680f429d9b801fe3e8d834f57d2dbab9",
            "metadata": {},
            "name": "approverSelector_addApproverMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0fd6a98a4e20a99f$var$node.hash = "fbbec1648cd00fbc1991cee1a778d936";
var $0fd6a98a4e20a99f$export$2e2bcd8739ae039 = $0fd6a98a4e20a99f$var$node;

});

parcelRegister("8DLqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2814ee664795fa8e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec079cce1e9b9d06e85d18b627ced680>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2814ee664795fa8e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "approverSelector_softwareReleasesApprovers",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$2814ee664795fa8e$var$node.hash = "eb08f554f17d908a61adf9079c7b4066";
var $2814ee664795fa8e$export$2e2bcd8739ae039 = $2814ee664795fa8e$var$node;

});

parcelRegister("3IbI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $339431fd4f5da86d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc7a5b39dc58a6e08a0bf3eba0717dbd>>
 * @relayHash 44e0520fbe7c9312855d33dc878efa15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05a59679b028a14828cd049a892942950bfcc88e314b92df19350712d643be4
const $339431fd4f5da86d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludedAccountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchText"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "excludedAccountIds",
            "variableName": "excludedAccountIds"
        },
        {
            "kind": "Variable",
            "name": "searchText",
            "variableName": "searchText"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "approverSelector_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "args": v4 /*: any*/ ,
                                                                "concreteType": "JiraVersionSuggestedApproverConnection",
                                                                "kind": "LinkedField",
                                                                "name": "suggestedApproversForJiraVersion",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionSuggestedApproverEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v5 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node.accountId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v6 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node.name"
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.project"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "approverSelector_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraVersionSuggestedApproverConnection",
                                                    "kind": "LinkedField",
                                                    "name": "suggestedApproversForJiraVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionSuggestedApproverEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v10 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e05a59679b028a14828cd049a892942950bfcc88e314b92df19350712d643be4",
            "metadata": {},
            "name": "approverSelector_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$339431fd4f5da86d$var$node.hash = "ecf6916313ab62b01f6ac39409f8349e";
var $339431fd4f5da86d$export$2e2bcd8739ae039 = $339431fd4f5da86d$var$node;

});

parcelRegister("1wNw5", function(module, exports) {

$parcel$export(module.exports, "PopupUserPicker", () => $f79353c7780256cc$export$3687c7ed123b6b2b);

var $2jDha = parcelRequire("2jDha");

var $l44HT = parcelRequire("l44HT");

var $eUqFw = parcelRequire("eUqFw");

var $4dR1n = parcelRequire("4dR1n");

var $dTS4n = parcelRequire("dTS4n");

var $74dT9 = parcelRequire("74dT9");

var $3IZWd = parcelRequire("3IZWd");
class $f79353c7780256cc$export$c87d8f24e24a8ae2 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            boundariesElement: 'viewport',
            width: 300,
            isMulti: false,
            offset: [
                0,
                0
            ],
            placement: 'auto',
            rootBoundary: 'viewport',
            shouldFlip: true
        };
    }
    render() {
        const { target: target, popupTitle: popupTitle, boundariesElement: boundariesElement, isMulti: isMulti, offset: offset, placement: placement, rootBoundary: rootBoundary, shouldFlip: shouldFlip, styles: styles } = this.props;
        const width = this.props.width;
        const selectStyles = (0, $dTS4n.getPopupStyles)(width, isMulti, styles);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3IZWd.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            SelectComponent: (0, $l44HT.default),
            width: width,
            styles: selectStyles,
            components: (0, $4dR1n.getPopupComponents)(!!popupTitle),
            pickerProps: (0, $74dT9.getPopupProps)(width, target, this.handleFlipStyle, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle)
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            flipped: false
        };
        this.handleFlipStyle = (data)=>{
            const { flipped: flipped, styles: { transform: transform }, popper: { height: height } } = data;
            this.setState({
                flipped: flipped
            });
            if (!flipped) return data;
            data.styles.transform = transform + `translate(0, ${height}px) translate(0, -100%)`;
            return data;
        };
    }
}
const $f79353c7780256cc$export$3687c7ed123b6b2b = (0, $2jDha.default)()($f79353c7780256cc$export$c87d8f24e24a8ae2);

});
parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $asNSH = parcelRequire("asNSH");

var $XHGTv = parcelRequire("XHGTv");


var $5wCDk = parcelRequire("5wCDk");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");

var $7ldaw = parcelRequire("7ldaw");
/**
 * Are we rendering on the client or server?
 */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$FocusLock = (0, $XHGTv.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $XHGTv.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $lT14u.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $lT14u.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $lT14u.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId,
                    ref: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hcvt0 = parcelRequire("hcvt0");


var $lcnyw = parcelRequire("lcnyw");

var $lkPEe = parcelRequire("lkPEe");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hcvt0))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).IndicatorSeparator, props);
const $e208c4fdfb4dbbc3$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, props);
const $e208c4fdfb4dbbc3$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu,
    IndicatorSeparator: $e208c4fdfb4dbbc3$var$IndicatorSeparator,
    ClearIndicator: $e208c4fdfb4dbbc3$var$ClearIndicator,
    MultiValueRemove: $e208c4fdfb4dbbc3$var$MultiValueRemove
};

});
parcelRegister("hcvt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85bf750af932d50$var$_react = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c85bf750af932d50$var$_search = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("9IsWp")));

var $c85bf750af932d50$var$_search2 = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("bPZtE")));
function $c85bf750af932d50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c85bf750af932d50$var$SearchIcon = (props)=>/*#__PURE__*/ $c85bf750af932d50$var$_react.default.createElement($c85bf750af932d50$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c85bf750af932d50$var$_search2.default
    }, props));
$c85bf750af932d50$var$SearchIcon.Name = 'SearchIconMigration';
var $c85bf750af932d50$var$_default = module.exports.default = $c85bf750af932d50$var$SearchIcon;

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});




parcelRegister("4dR1n", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $a3dbd76a262a50b0$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $a3dbd76a262a50b0$export$19205fd341a6bb08);

var $5iWql = parcelRequire("5iWql");

var $bEfg9 = parcelRequire("bEfg9");

var $y5ydU = parcelRequire("y5ydU");

var $3oEge = parcelRequire("3oEge");

var $g5mgF = parcelRequire("g5mgF");

var $lftfg = parcelRequire("lftfg");

var $aRUd7 = parcelRequire("aRUd7");

var $cRDmG = parcelRequire("cRDmG");

var $5Hu7b = parcelRequire("5Hu7b");

var $6BfkR = parcelRequire("6BfkR");

var $bP6rt = parcelRequire("bP6rt");
const $a3dbd76a262a50b0$export$4e811121b221213b = (0, $5iWql.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $g5mgF.Option
    };
    else return {
        MultiValue: $y5ydU.MultiValue,
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: multi ? null : (0, $bEfg9.ClearIndicator),
        Option: $g5mgF.Option,
        ValueContainer: multi ? (0, $3oEge.MultiValueContainer) : (0, $cRDmG.SingleValueContainer),
        Input: $aRUd7.Input,
        Menu: $bP6rt.Menu
    };
});
const $a3dbd76a262a50b0$export$19205fd341a6bb08 = (0, $5iWql.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: $bEfg9.ClearIndicator,
        Option: $g5mgF.Option,
        ValueContainer: (0, $cRDmG.SingleValueContainer),
        Input: (0, $5Hu7b.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6BfkR.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("bEfg9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $29bd55272a291249$export$ecf9cf59142dd54a);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

const $29bd55272a291249$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kZKuG")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $29bd55272a291249$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29bd55272a291249$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("kZKuG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d9TBY").then(()=>parcelRequire('fxbL4'));

});


parcelRegister("y5ydU", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $af295f744665a83e$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $6CQF2 = parcelRequire("6CQF2");

var $fWEEw = parcelRequire("fWEEw");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $f0Noz = parcelRequire("f0Noz");
function $af295f744665a83e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af295f744665a83e$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $af295f744665a83e$var$groupTagContainer = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $af295f744665a83e$var$nameWrapper = {
    name: "6urmvo",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $af295f744665a83e$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.getElemBefore = ()=>{
            const { data: { data: data }, selectProps: selectProps } = this.props;
            if ((0, $cHYJ6.isEmail)(data)) return selectProps.emailLabel ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                isLozenge: true,
                label: selectProps.emailLabel
            }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $hAQEH.messages).addEmail, (label)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                    isLozenge: true,
                    label: label
                }));
            if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
                xcss: $af295f744665a83e$var$groupTagContainer
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f0Noz))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "group-icon",
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "multi",
                src: (0, $cHYJ6.getAvatarUrl)(data)
            });
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $af295f744665a83e$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $af295f744665a83e$var$nameWrapper
        }, children));
    }
}

});
parcelRegister("6CQF2", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $9d5e4069310b8c35$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9UAhx = parcelRequire("9UAhx");


var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");
const $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $9d5e4069310b8c35$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9UAhx))), {
        label: label,
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("9UAhx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e7305b7a80dd81883f747fbed5a39fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73757cd51f353c0b$var$_react = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73757cd51f353c0b$var$_email = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8qa3H")));

var $73757cd51f353c0b$var$_email2 = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8IVhP")));
function $73757cd51f353c0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73757cd51f353c0b$var$EmailIcon = (props)=>/*#__PURE__*/ $73757cd51f353c0b$var$_react.default.createElement($73757cd51f353c0b$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $73757cd51f353c0b$var$_email2.default
    }, props));
$73757cd51f353c0b$var$EmailIcon.Name = 'EmailIconMigration';
var $73757cd51f353c0b$var$_default = module.exports.default = $73757cd51f353c0b$var$EmailIcon;

});
parcelRegister("8qa3H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01c9d10de58aecafc412cf2587bb6df9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62188de139005924$var$_react = $62188de139005924$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $62188de139005924$var$_UNSAFE_baseNew = $62188de139005924$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $62188de139005924$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62188de139005924$var$EmailIcon = (props)=>/*#__PURE__*/ $62188de139005924$var$_react.default.createElement($62188de139005924$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$62188de139005924$var$EmailIcon.displayName = 'EmailIcon';
var $62188de139005924$var$_default = module.exports.default = $62188de139005924$var$EmailIcon;

});

parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $659edeb603307d4b$var$_email = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("8qa3H")));
function $659edeb603307d4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $659edeb603307d4b$var$_email.default
    }));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = module.exports.default = $659edeb603307d4b$var$EmailIcon;

});



parcelRegister("fWEEw", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $c352fe32cb3aa4c8$export$44d81a88129649da);

var $iJlfe = parcelRequire("iJlfe");

var $3Dk5Z = parcelRequire("3Dk5Z");

var $eUqFw = parcelRequire("eUqFw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $c352fe32cb3aa4c8$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $cHYJ6.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dk5Z.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), props);
    }
}

});
parcelRegister("3Dk5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1869a65c00213d53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");


var $eJ2Jf = parcelRequire("eJ2Jf");
const $1869a65c00213d53$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $1869a65c00213d53$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
function $1869a65c00213d53$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, (innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ2Jf.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            ...innerProps
        }));
}

});
parcelRegister("eJ2Jf", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $3fb7f58cf3c7f578$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $4nce6 = parcelRequire("4nce6");

function $3fb7f58cf3c7f578$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3fb7f58cf3c7f578$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $3fb7f58cf3c7f578$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $3fb7f58cf3c7f578$var$ICON_PADDING = 4;
const $3fb7f58cf3c7f578$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $3fb7f58cf3c7f578$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $3fb7f58cf3c7f578$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $3fb7f58cf3c7f578$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3fb7f58cf3c7f578$var$avatarDefaultIconStyles,
            $3fb7f58cf3c7f578$var$nestedAvatarStyles[size]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: alt,
        primaryColor: $3fb7f58cf3c7f578$var$ICON_BACKGROUND,
        secondaryColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
        testId: testId && `${testId}--team`
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", rest, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $3fb7f58cf3c7f578$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $32f2cb577afb3a41$var$_peopleGroup = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("dd6Uq")));
function $32f2cb577afb3a41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $32f2cb577afb3a41$var$_peopleGroup.default
    }));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});



parcelRegister("cHYJ6", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $76b83dfd34bdcdb2$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $76b83dfd34bdcdb2$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $76b83dfd34bdcdb2$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $76b83dfd34bdcdb2$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $76b83dfd34bdcdb2$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $76b83dfd34bdcdb2$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $76b83dfd34bdcdb2$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $76b83dfd34bdcdb2$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $76b83dfd34bdcdb2$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $76b83dfd34bdcdb2$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $76b83dfd34bdcdb2$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $76b83dfd34bdcdb2$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $76b83dfd34bdcdb2$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $76b83dfd34bdcdb2$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $76b83dfd34bdcdb2$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $76b83dfd34bdcdb2$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $76b83dfd34bdcdb2$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $76b83dfd34bdcdb2$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $l44HT = parcelRequire("l44HT");
const $76b83dfd34bdcdb2$export$f6058dbcb5980cb = (option)=>option.type === (0, $0b440fae145c26fc$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $76b83dfd34bdcdb2$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $0b440fae145c26fc$export$8436e53e45ffe15b);
const $76b83dfd34bdcdb2$export$f8c4277cb588611f = (option)=>option.type === (0, $0b440fae145c26fc$export$26bc40b960693765);
const $76b83dfd34bdcdb2$export$d7976824e9f55785 = (option)=>option.type === (0, $0b440fae145c26fc$export$d460f747b73abb10);
const $76b83dfd34bdcdb2$export$7fbbfbca30081d0 = (option)=>option.type === (0, $0b440fae145c26fc$export$6662b3461398ef8c);
const $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $0b440fae145c26fc$export$eafd0979afa5b224);
const $76b83dfd34bdcdb2$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $76b83dfd34bdcdb2$var$isOptionData = (option)=>option.name !== undefined;
const $76b83dfd34bdcdb2$export$3f993c492bd6c728 = (option)=>{
    if ($76b83dfd34bdcdb2$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $76b83dfd34bdcdb2$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $76b83dfd34bdcdb2$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $76b83dfd34bdcdb2$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($76b83dfd34bdcdb2$export$3f993c492bd6c728));
const $76b83dfd34bdcdb2$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($76b83dfd34bdcdb2$export$3f993c492bd6c728);
    return $76b83dfd34bdcdb2$export$3f993c492bd6c728(defaultValue);
});
const $76b83dfd34bdcdb2$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $76b83dfd34bdcdb2$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $76b83dfd34bdcdb2$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $76b83dfd34bdcdb2$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $76b83dfd34bdcdb2$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $76b83dfd34bdcdb2$export$b4f8f1f54acec99b = (optionData)=>{
    if ($76b83dfd34bdcdb2$export$2e44165f1da65304(optionData) || $76b83dfd34bdcdb2$export$f8c4277cb588611f(optionData) || $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $76b83dfd34bdcdb2$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $l44HT.default);
const $76b83dfd34bdcdb2$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $76b83dfd34bdcdb2$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $0b440fae145c26fc$export$8436e53e45ffe15b = 'user';
const $0b440fae145c26fc$export$50042ec1d2e00e63 = 'external_user';
const $0b440fae145c26fc$export$26bc40b960693765 = 'team';
const $0b440fae145c26fc$export$d460f747b73abb10 = 'group';
const $0b440fae145c26fc$export$6662b3461398ef8c = 'email';
const $0b440fae145c26fc$export$eafd0979afa5b224 = 'custom';



parcelRegister("hAQEH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0166325e684f6a54$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0166325e684f6a54$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("f0Noz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca6de88f6e16cefe07cae368c9c27484>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aedd2bf6f30653ba$var$_react = $aedd2bf6f30653ba$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $aedd2bf6f30653ba$var$_peopleGroup = $aedd2bf6f30653ba$var$_interopRequireDefault((parcelRequire("dd6Uq")));

var $aedd2bf6f30653ba$var$_people = $aedd2bf6f30653ba$var$_interopRequireDefault((parcelRequire("4nce6")));
function $aedd2bf6f30653ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aedd2bf6f30653ba$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $aedd2bf6f30653ba$var$_react.default.createElement($aedd2bf6f30653ba$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $aedd2bf6f30653ba$var$_people.default
    }, props));
$aedd2bf6f30653ba$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $aedd2bf6f30653ba$var$_default = module.exports.default = $aedd2bf6f30653ba$var$PeopleGroupIcon;

});


parcelRegister("3oEge", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c);

var $jQxSL = parcelRequire("jQxSL");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8uD7Y = parcelRequire("8uD7Y");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $8fe8e = parcelRequire("8fe8e");
class $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props);
        this.timeoutId = null;
        this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        };
        this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        };
        this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(this.props.children, (child)=>(0, $cHYJ6.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
        };
        this.renderChildren = ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props, this.renderChildren()));
    }
}

});
parcelRegister("8fe8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d958d4fcf0f18b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $b2d958d4fcf0f18b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $b2d958d4fcf0f18b$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $b2d958d4fcf0f18b$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b2d958d4fcf0f18b$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $b2d958d4fcf0f18b$export$2e2bcd8739ae039 = $b2d958d4fcf0f18b$var$ValueContainerWrapper;

});


parcelRegister("g5mgF", function(module, exports) {

$parcel$export(module.exports, "Option", () => $69e114acf80b738d$export$36d18380658d5d20);

var $b5IAe = parcelRequire("b5IAe");

var $jQxSL = parcelRequire("jQxSL");

var $2eG9N = parcelRequire("2eG9N");

var $eUqFw = parcelRequire("eUqFw");

var $geaMl = parcelRequire("geaMl");

var $eV39A = parcelRequire("eV39A");

var $dqj52 = parcelRequire("dqj52");

var $diO51 = parcelRequire("diO51");

var $4jmtC = parcelRequire("4jmtC");

var $19gl5 = parcelRequire("19gl5");

var $cHYJ6 = parcelRequire("cHYJ6");

var $eL5KE = parcelRequire("eL5KE");
const $69e114acf80b738d$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $69e114acf80b738d$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $cHYJ6.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV39A.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jmtC.default), {
        email: data,
        emailValidity: (0, $eL5KE.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $cHYJ6.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqj52.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diO51.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19gl5.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $69e114acf80b738d$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, $69e114acf80b738d$var$dataOption(props)));
    return $69e114acf80b738d$var$dataOption(props);
};
const $69e114acf80b738d$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: $69e114acf80b738d$var$defaultOption(props)
    }, $69e114acf80b738d$var$dataOptionWithTooltip(props)));

});
parcelRegister("geaMl", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $a2ecfda802f63071$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7cBHL = parcelRequire("7cBHL");

var $decpf = parcelRequire("decpf");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $a2ecfda802f63071$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7cBHL.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $cHYJ6.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "big",
                src: avatarUrl,
                presence: status
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("7cBHL", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $da888a92b8218389$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $da888a92b8218389$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cHYJ6 = parcelRequire("cHYJ6");
function $da888a92b8218389$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $da888a92b8218389$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kZKuG")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $da888a92b8218389$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $da888a92b8218389$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $da888a92b8218389$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        fontSize: '0.85em'
    } : {};
    return /*#__PURE__*/ (0, $byn9U.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $da888a92b8218389$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $da888a92b8218389$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $byn9U.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $da888a92b8218389$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $cHYJ6.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
                fallback: /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $byn9U.jsx)($da888a92b8218389$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $da888a92b8218389$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$optionWrapper
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("decpf", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $394febfe0c687d04$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");
class $394febfe0c687d04$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}

});


parcelRegister("eV39A", function(module, exports) {

$parcel$export(module.exports, "default", () => $876fe813f4c1c632$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $876fe813f4c1c632$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("jTQuA")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $876fe813f4c1c632$export$2e2bcd8739ae039 = $876fe813f4c1c632$var$AsyncExternalUserOption;

});
parcelRegister("jTQuA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("d3tcO")
]).then(()=>parcelRequire('ipFJ8'));

});


parcelRegister("dqj52", function(module, exports) {

$parcel$export(module.exports, "default", () => $99124d670f0cce21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $99124d670f0cce21$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("1icV4")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $99124d670f0cce21$export$2e2bcd8739ae039 = $99124d670f0cce21$var$AsyncTeamOption;

});
parcelRegister("1icV4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kS5MT").then(()=>parcelRequire('h6N8Y'));

});


parcelRegister("diO51", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca6f28ecfe324c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $1ca6f28ecfe324c4$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("6MXJu")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $1ca6f28ecfe324c4$export$2e2bcd8739ae039 = $1ca6f28ecfe324c4$var$AsyncGroupOption;

});
parcelRegister("6MXJu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cupcD").then(()=>parcelRequire('67Bgx'));

});


parcelRegister("4jmtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a8ac55002f9ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $c70a8ac55002f9ee$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("6TnIL")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $c70a8ac55002f9ee$export$2e2bcd8739ae039 = $c70a8ac55002f9ee$var$AsyncEmailOption;

});
parcelRegister("6TnIL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jHxNy").then(()=>parcelRequire('fGM7m'));

});


parcelRegister("19gl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $939b3c40c1c8ea24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $939b3c40c1c8ea24$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("bN1xj")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $939b3c40c1c8ea24$export$2e2bcd8739ae039 = $939b3c40c1c8ea24$var$AsyncCustomOption;

});
parcelRegister("bN1xj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jiY6F").then(()=>parcelRequire('70iAn'));

});


parcelRegister("eL5KE", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $74079603909b5140$export$371e338370561054);
const $74079603909b5140$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $74079603909b5140$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $74079603909b5140$export$371e338370561054 = (inputText)=>{
    if (inputText.match($74079603909b5140$var$validRegex)) return 'VALID';
    if (inputText.match($74079603909b5140$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("lftfg", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $b0efde321d2f82a0$export$1949dac661ba6e3a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $6R0C9 = parcelRequire("6R0C9");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
const $b0efde321d2f82a0$var$avatarItemComponent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    border: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-0, 0px)"} !important`,
    width: 'auto',
    overflow: 'hidden',
    minWidth: '100px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        boxSizing: 'border-box'
    },
    '&:hover': {
        width: 'auto',
        padding: 0,
        border: 'none'
    }
});
const $b0efde321d2f82a0$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6R0C9.default), {
        backgroundColor: "transparent",
        avatar: /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
            src: (0, $cHYJ6.getAvatarUrl)(data),
            appearance: appearance
        }),
        primaryText: label
    }, ({ ref: ref, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b0efde321d2f82a0$var$avatarItemComponent,
            ...props
        }))) : null;
};

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");


var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});


parcelRegister("aRUd7", function(module, exports) {

$parcel$export(module.exports, "Input", () => $a6afe550849f2f63$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
class $a6afe550849f2f63$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args);
        // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("cRDmG", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $9a44acf63722ec21$export$afa5f855316c6a48);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $fWEEw = parcelRequire("fWEEw");

var $dTS4n = parcelRequire("dTS4n");

var $8fe8e = parcelRequire("8fe8e");
function $9a44acf63722ec21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9a44acf63722ec21$var$placeholderIconContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $dTS4n.BORDER_PADDING),
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $9a44acf63722ec21$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $9a44acf63722ec21$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $9a44acf63722ec21$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $9a44acf63722ec21$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        this.renderAvatar = ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $9a44acf63722ec21$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $9a44acf63722ec21$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});
parcelRegister("dTS4n", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $c46738fef3a1a380$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $c46738fef3a1a380$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $c46738fef3a1a380$export$4e983f376ad8a3af);


var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $c46738fef3a1a380$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $c46738fef3a1a380$export$53937c04f7dfc2ae = 6;
const $c46738fef3a1a380$export$2c62ba763e976c54 = 39;
const $c46738fef3a1a380$export$ffd58b7f6f099a57 = (0, $5iWql.default)((width, isMulti, isCompact, overrideStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingLeft: isMulti ? $c46738fef3a1a380$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                fontSize: '100%',
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$c46738fef3a1a380$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>({
                ...css,
                overflow: 'hidden'
            }),
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $cEc3i.m)(styles, overrideStyles) : styles;
});
const $c46738fef3a1a380$export$4e983f376ad8a3af = (0, $5iWql.default)((width, isMulti, overrideStyles)=>({
        ...$c46738fef3a1a380$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
    }));

});


parcelRegister("5Hu7b", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $af7bd16282155901$export$d8edbfd510a7db82);

var $eUqFw = parcelRequire("eUqFw");

var $aRUd7 = parcelRequire("aRUd7");
class $af7bd16282155901$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRUd7.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6BfkR", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $2db2d66d3748ae86$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

const $2db2d66d3748ae86$var$spacing = 8;
const $2db2d66d3748ae86$var$fontSize = 12;
const $2db2d66d3748ae86$var$innerHeight = $2db2d66d3748ae86$var$spacing * 2; // 16px
const $2db2d66d3748ae86$var$lineHeight = $2db2d66d3748ae86$var$innerHeight / $2db2d66d3748ae86$var$fontSize;
const $2db2d66d3748ae86$var$controlWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $2db2d66d3748ae86$var$getLabelStyle = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
        fontSize: `${$2db2d66d3748ae86$var$fontSize}px`,
        fontWeight: 600,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${$2db2d66d3748ae86$var$lineHeight}`,
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-0, 0px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });
class $2db2d66d3748ae86$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$controlWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$getLabelStyle()
        }, popupTitle), /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, this.props));
    }
}

});

parcelRegister("bP6rt", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $f6008453f5d5b3f2$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");
const $f6008453f5d5b3f2$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $f6008453f5d5b3f2$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f6008453f5d5b3f2$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("74dT9", function(module, exports) {

$parcel$export(module.exports, "getPopupProps", () => $e5b4705a3d2cf738$export$4adcaee797a284b3);

var $5iWql = parcelRequire("5iWql");
const $e5b4705a3d2cf738$export$4adcaee797a284b3 = (0, $5iWql.default)((width, target, onFlip, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle)=>({
        searchThreshold: -1,
        controlShouldRenderValue: true,
        minMenuWidth: width,
        maxMenuWidth: width,
        autoFocus: false,
        target: target,
        popupTitle: popupTitle,
        popperProps: {
            placement: placement || 'auto',
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: offset
                    }
                },
                {
                    name: 'handleFlipStyle',
                    enabled: true,
                    order: 910,
                    fn: (data)=>onFlip(data)
                },
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: rootBoundary,
                        boundary: boundariesElement
                    }
                },
                {
                    name: 'flip',
                    enabled: shouldFlip
                }
            ]
        }
    }));

});

parcelRegister("3IZWd", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $f8b053239afa9fd6$export$b4ff48c8d43b18c3);

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hompL = parcelRequire("hompL");

var $bjvv3 = parcelRequire("bjvv3");

var $b9ITu = parcelRequire("b9ITu");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $a1Z9P = parcelRequire("a1Z9P");
const $f8b053239afa9fd6$var$loadingMessage = ()=>null;
const $f8b053239afa9fd6$var$classNamePrefix = 'fabric-user-picker';
class $f8b053239afa9fd6$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).errorMessage),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.value);
        else if ((0, $cHYJ6.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props);
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $cHYJ6.callCallback)(onChange, (0, $cHYJ6.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $cHYJ6.callCallback)(onSelection, (0, $cHYJ6.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $bjvv3.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $bjvv3.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $cHYJ6.callCallback)(onClear);
                    this.fireEvent((0, $bjvv3.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $bjvv3.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $bjvv3.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $b9ITu.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $bjvv3.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                const inflightRequest = previousRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $cHYJ6.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                return {
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                };
            });
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $uMitL.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $cHYJ6.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $cHYJ6.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $cHYJ6.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleBlur = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $cHYJ6.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleOpen = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleClose = ()=>{
            this.resetInputState();
            (0, $cHYJ6.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $cHYJ6.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $bjvv3.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $bjvv3.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $bjvv3.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $cHYJ6.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $a1Z9P.userPickerOptionsShownUfoExperience).getInstance((0, $hompL.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $bjvv3.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $bjvv3.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $uMitL.UFOExperienceState).STARTED.id,
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $f8b053239afa9fd6$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).placeholder),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $f8b053239afa9fd6$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $f8b053239afa9fd6$export$d099ade7b4f4d2a4 = (0, $2jDha.default)()($f8b053239afa9fd6$export$b4ff48c8d43b18c3);

});
parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("bjvv3", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $72125c7ae0a2c4a6$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $72125c7ae0a2c4a6$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $72125c7ae0a2c4a6$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $72125c7ae0a2c4a6$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $72125c7ae0a2c4a6$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $72125c7ae0a2c4a6$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $72125c7ae0a2c4a6$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $72125c7ae0a2c4a6$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $72125c7ae0a2c4a6$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $72125c7ae0a2c4a6$export$f541f04954b0c11e);

var $hM7RE = parcelRequire("hM7RE");

var $hompL = parcelRequire("hompL");

var $cHYJ6 = parcelRequire("cHYJ6");
const $72125c7ae0a2c4a6$var$packageName = "platform-pkg";
const $72125c7ae0a2c4a6$var$packageVersion = "0.0.0-use.local";
const $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $72125c7ae0a2c4a6$export$c0d84948cecf78d8 = ()=>({
        id: (0, $hompL.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $72125c7ae0a2c4a6$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $72125c7ae0a2c4a6$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $72125c7ae0a2c4a6$var$packageName,
            packageVersion: $72125c7ae0a2c4a6$var$packageVersion,
            ...attributes
        }
    });
const $72125c7ae0a2c4a6$var$checkValidId = (id)=>{
    return $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $72125c7ae0a2c4a6$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $72125c7ae0a2c4a6$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $cHYJ6.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $cHYJ6.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $72125c7ae0a2c4a6$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$72125c7ae0a2c4a6$var$optionData2Analytics(data));
    }
    return [];
};
const $72125c7ae0a2c4a6$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        pickerType: $72125c7ae0a2c4a6$var$pickerType(props),
        journeyId: journeyId
    });
const $72125c7ae0a2c4a6$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'focused', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $72125c7ae0a2c4a6$var$buildValueForAnalytics(state.value)
    });
const $72125c7ae0a2c4a6$export$7b5800e732182efb = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $72125c7ae0a2c4a6$var$values(state)
    });
const $72125c7ae0a2c4a6$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        journeyId: journeyId,
        value: $72125c7ae0a2c4a6$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $72125c7ae0a2c4a6$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(args[0]),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(args[0]),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session)
    });
const $72125c7ae0a2c4a6$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $72125c7ae0a2c4a6$var$createEvent('ui', $72125c7ae0a2c4a6$var$selectEventType(session), 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        position: $72125c7ae0a2c4a6$var$position(state, args[0]),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(state),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session),
        result: $72125c7ae0a2c4a6$var$result(args[0]),
        numberOfResults: $72125c7ae0a2c4a6$var$numberOfResults(state)
    });
};
const $72125c7ae0a2c4a6$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $72125c7ae0a2c4a6$var$results(state);
    return $72125c7ae0a2c4a6$var$createEvent('operational', 'searched', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        durationSinceInputChange: $72125c7ae0a2c4a6$var$durationSinceInputChange(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        isLoading: $72125c7ae0a2c4a6$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $72125c7ae0a2c4a6$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('operational', 'failed', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $72125c7ae0a2c4a6$export$f541f04954b0c11e = (sources, accountId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $72125c7ae0a2c4a6$var$checkValidId(accountId) ? accountId : null
    });
function $72125c7ae0a2c4a6$var$queryLength(state) {
    return state.inputValue.length;
}
function $72125c7ae0a2c4a6$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $72125c7ae0a2c4a6$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $72125c7ae0a2c4a6$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $72125c7ae0a2c4a6$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $72125c7ae0a2c4a6$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $72125c7ae0a2c4a6$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $72125c7ae0a2c4a6$var$sessionId(session) {
    return session && session.id;
}
function $72125c7ae0a2c4a6$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $72125c7ae0a2c4a6$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $72125c7ae0a2c4a6$var$result(option) {
    return option ? $72125c7ae0a2c4a6$var$optionData2Analytics(option.data) : null;
}
function $72125c7ae0a2c4a6$var$results(state) {
    return (state.options || []).map($72125c7ae0a2c4a6$var$optionData2Analytics);
}
function $72125c7ae0a2c4a6$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $72125c7ae0a2c4a6$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$72125c7ae0a2c4a6$var$optionData2Analytics(option.data)) : [
        $72125c7ae0a2c4a6$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $72125c7ae0a2c4a6$var$numberOfResults(state) {
    return (state.options || []).length;
}

});

parcelRegister("b9ITu", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $6fd848c9243cf2a4$export$da86c38211c1c0a8);
function $6fd848c9243cf2a4$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("a1Z9P", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $542454000b8812af$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $542454000b8812af$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $542454000b8812af$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $uMitL = parcelRequire("uMitL");
const $542454000b8812af$export$b49757166e1acfc2 = new (0, $2kFUE.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
const $542454000b8812af$export$135a264e0da507ae = new (0, $2kFUE.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
});
class $542454000b8812af$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        const instance = $542454000b8812af$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $uMitL.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});







parcelRegister("etAFk", function(module, exports) {

$parcel$export(module.exports, "useAddVersionApproversExperienceStart", () => $4cd36c3e2ed24967$export$110cabd162b99bb5);
$parcel$export(module.exports, "useAddVersionApproversExperienceFail", () => $4cd36c3e2ed24967$export$a03e71dc31014452);
$parcel$export(module.exports, "useAddVersionApproversExperienceSuccess", () => $4cd36c3e2ed24967$export$9c0e9ed456b1aee7);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $4cd36c3e2ed24967$var$EXPERIENCE_NAME = 'addVersionApprover';
const $4cd36c3e2ed24967$var$SOURCE = 'versionDetails';
const $4cd36c3e2ed24967$export$110cabd162b99bb5 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $4cd36c3e2ed24967$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $4cd36c3e2ed24967$var$SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $4cd36c3e2ed24967$export$a03e71dc31014452 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $4cd36c3e2ed24967$var$EXPERIENCE_NAME
    });
const $4cd36c3e2ed24967$export$9c0e9ed456b1aee7 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $4cd36c3e2ed24967$var$EXPERIENCE_NAME
    });

});

parcelRegister("2oNBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9351475e1a5409c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e9351475e1a5409c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addApproverLabel: {
        "id": "software-releases-approvers.approver-selector.add-approver-label",
        "defaultMessage": "Add approver"
    },
    findUserLabel: {
        "id": "software-releases-approvers.approver-selector.find-user-label",
        "defaultMessage": "Find user"
    },
    genericErrorFlagTitle: {
        "id": "software-releases-approvers.approver-selector.generic-error-flag-title",
        "defaultMessage": "We couldn't add the version approver."
    },
    genericErrorFlagDescription: {
        "id": "software-releases-approvers.approver-selector.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("6PysW", function(module, exports) {

$parcel$export(module.exports, "TaskApprover", () => $a59674c417acf18a$export$f02de85c4814213b);

var $gfV5c = parcelRequire("gfV5c");

var $jlWYX = parcelRequire("jlWYX");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");


var $5JgJ2 = parcelRequire("5JgJ2");

var $ieQ6k = parcelRequire("ieQ6k");

var $xozIx = parcelRequire("xozIx");

var $mYqiC = parcelRequire("mYqiC");

var $hGwrO = parcelRequire("hGwrO");
const $a59674c417acf18a$export$f02de85c4814213b = ({ jiraVersionApprover: jiraVersionApprover, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const approver = (0, $iWLL0.useFragment)((0, $jlWYX.default), jiraVersionApprover);
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $gfV5c.default), jiraVersion);
    const { picture: picture, name: name } = approver.user;
    const role = approver?.user?.extendedProfile?.jobTitle;
    const onWrapperClick = (e)=>{
        const isOriginDeclineButton = e.target instanceof Element && e.target.closest((0, $ieQ6k.getDeclineButtonSelector)()) != null;
        const isOriginIgnoreMouseEventTarget = e.target instanceof Element && e.target.closest((0, $ieQ6k.getIgnoreMouseEventTargetSelector)()) != null;
        if (isOriginDeclineButton) {
            setIsOpen(true);
            return;
        }
        if (isOriginIgnoreMouseEventTarget) return;
        setIsOpen(!isOpen);
    };
    const handleKeyDown = (e)=>{
        if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onWrapperClick(e);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xozIx.ApprovalDrawer), {
                jiraVersionApprover: approver,
                jiraVersion: jiraVersionData
            }),
        isOpen: isOpen,
        // to make the width of the popup content responsive to the trigger width.
        shouldRenderToParent: true,
        autoFocus: true,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a59674c417acf18a$var$BaseWrapper, {
                isOpen: isOpen,
                onClick: onWrapperClick,
                onKeyDown: handleKeyDown,
                tabIndex: 0,
                role: "button",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                src: picture,
                size: "medium"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a59674c417acf18a$var$ApproverWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a59674c417acf18a$var$ApproverName, {
                isOpen: isOpen
            }, " ", name, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a59674c417acf18a$var$ApproverRole, {
                isOpen: isOpen
            }, role)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a59674c417acf18a$var$RightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mYqiC.ApprovalStatus), {
                jiraVersionApprover: approver
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                primaryColor: isOpen ? `var(--ds-icon-selected, ${(0, $73a5c9d720aa66e1$exports).B400})` : undefined,
                label: formatMessage((0, $hGwrO.default).openApproverIcon)
            }))))
    }));
};
const $a59674c417acf18a$var$BaseWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulppxbi _4cvr1h6o _1yt4wue8 _80omtlke",
            !__cmplp.isOpen ? "_irr34mfv" : "_irr329zg",
            !!__cmplp.isOpen && "_syaz17uj",
            !__cmplp.isOpen ? "_bfhk18uv" : "_bfhk29zg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a59674c417acf18a$var$ApproverWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ijo _1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a59674c417acf18a$var$ApproverName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _vwz4v47k _11c81oud",
            !__cmplp.isOpen ? "_syaz14xw" : "_syaz17uj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a59674c417acf18a$var$ApproverRole = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4v47k _11c81vlj",
            !__cmplp.isOpen ? "_syaz1wmz" : "_syaz17uj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a59674c417acf18a$var$RightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gfV5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f087764a6a8be3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9dd3de8f982dc218b25c85e651586f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f087764a6a8be3c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "taskApprover_softwareReleasesApprovers_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "approvalDrawer_softwareReleasesApprovers_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$7f087764a6a8be3c$var$node.hash = "70db2f75a58a67028506d4a771e78c7c";
var $7f087764a6a8be3c$export$2e2bcd8739ae039 = $7f087764a6a8be3c$var$node;

});

parcelRegister("jlWYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ecb993a5a474fc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4becf6527068dcd0582e0e649d5bbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ecb993a5a474fc3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "user.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "jobTitle"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    }
                ]
            },
            "action": "THROW",
            "path": "user"
        },
        {
            "kind": "FragmentSpread",
            "name": "approvalDrawer_softwareReleasesApprovers_jiraVersionApprover"
        },
        {
            "kind": "FragmentSpread",
            "name": "approvalStatus_softwareReleasesApprovers"
        }
    ],
    "type": "JiraVersionApprover"
};
$6ecb993a5a474fc3$var$node.hash = "2f386310c911f628d06832824656bc52";
var $6ecb993a5a474fc3$export$2e2bcd8739ae039 = $6ecb993a5a474fc3$var$node;

});

parcelRegister("ieQ6k", function(module, exports) {

$parcel$export(module.exports, "STATUS_DECLINED_BUTTON_CLICK_IGNORE_TARGET", () => $234ab07992f2e1b6$export$d87f7e993942a72c);
$parcel$export(module.exports, "STATUS_PENDING_BUTTON_CLICK_IGNORE_TARGET", () => $234ab07992f2e1b6$export$6ead830879fb0044);
$parcel$export(module.exports, "STATUS_APPROVED_BUTTON_CLICK_IGNORE_TARGET", () => $234ab07992f2e1b6$export$e9bf00b3bf376085);
$parcel$export(module.exports, "STATUS_POPUP_TRIGGER_CLICK_IGNORE_TARGET", () => $234ab07992f2e1b6$export$54bcf36aa4799d32);
$parcel$export(module.exports, "getIgnoreMouseEventTargetSelector", () => $234ab07992f2e1b6$export$8b8b3f420a17741c);
$parcel$export(module.exports, "getDeclineButtonSelector", () => $234ab07992f2e1b6$export$ed01a0bfe3932b44);
// These are utility data-ignore-target attributes to control approval drawer opening and closing when actionable items are clicked in the status popup
// Should prevent default to prevent the whole approver not to be clicked
const $234ab07992f2e1b6$export$d87f7e993942a72c = 'software-releases-approvers.ui.task-approver.approval-status.declined-button';
const $234ab07992f2e1b6$export$6ead830879fb0044 = 'software-releases-approvers.ui.task-approver.approval-status.pending-button';
const $234ab07992f2e1b6$export$e9bf00b3bf376085 = 'software-releases-approvers.ui.task-approver.approval-status.approved-button';
const $234ab07992f2e1b6$export$54bcf36aa4799d32 = 'software-releases-approvers.ui.task-approver.approval-status.status-popup-trigger';
const $234ab07992f2e1b6$export$8b8b3f420a17741c = ()=>`[data-ignore-target="${$234ab07992f2e1b6$export$d87f7e993942a72c}"],
[data-ignore-target="${$234ab07992f2e1b6$export$6ead830879fb0044}"],
[data-ignore-target="${$234ab07992f2e1b6$export$e9bf00b3bf376085}"],
[data-ignore-target="${$234ab07992f2e1b6$export$54bcf36aa4799d32}"]`;
const $234ab07992f2e1b6$export$ed01a0bfe3932b44 = ()=>`[data-ignore-target="${$234ab07992f2e1b6$export$d87f7e993942a72c}"]`;

});

parcelRegister("xozIx", function(module, exports) {

$parcel$export(module.exports, "ApprovalDrawer", () => $1f303d4fe4677d06$export$90304aade9f8c992);

var $kK21b = parcelRequire("kK21b");

var $gZqY4 = parcelRequire("gZqY4");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jPTIc = parcelRequire("jPTIc");

var $7alWX = parcelRequire("7alWX");

var $8zb8w = parcelRequire("8zb8w");
const $1f303d4fe4677d06$export$90304aade9f8c992 = ({ jiraVersionApprover: jiraVersionApprover, jiraVersion: jiraVersion })=>{
    const approver = (0, $iWLL0.useFragment)((0, $gZqY4.default), jiraVersionApprover);
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $kK21b.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f303d4fe4677d06$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f303d4fe4677d06$var$TopWrapper, null, approver.status === 'DECLINED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1f303d4fe4677d06$var$declineReasonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7alWX.DeclineReason), {
        jiraVersionApprover: approver
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPTIc.ApprovalDescription), {
        jiraVersionApprover: approver
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zb8w.RemoveApprover), {
        jiraVersionApprover: approver,
        jiraVersion: jiraVersionData
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f303d4fe4677d06$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1x6q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f303d4fe4677d06$var$TopWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _vchhusvi _1yt4pxbi _n7zlh6cr",
            __cmplp.className
        ])
    });
});
const $1f303d4fe4677d06$var$declineReasonWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("kK21b", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ff52d9b3be6980$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45171f46c50aa773456ca94a51e3974f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c8ff52d9b3be6980$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "approvalDrawer_softwareReleasesApprovers_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "removeApprover_softwareReleasesApprovers_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$c8ff52d9b3be6980$var$node.hash = "6da0d1cd4c994248c69b351953b6d2d6";
var $c8ff52d9b3be6980$export$2e2bcd8739ae039 = $c8ff52d9b3be6980$var$node;

});

parcelRegister("gZqY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b54880ccd66422f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c40ed07cbf814859fcd1d8d861886a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b54880ccd66422f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "approvalDrawer_softwareReleasesApprovers_jiraVersionApprover",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "FragmentSpread",
            "name": "declineReason_softwareReleasesApprovers"
        },
        {
            "kind": "FragmentSpread",
            "name": "approvalDescription_softwareReleasesApprovers"
        },
        {
            "kind": "FragmentSpread",
            "name": "removeApprover_softwareReleasesApprovers_jiraVersionApprover"
        }
    ],
    "type": "JiraVersionApprover"
};
$5b54880ccd66422f$var$node.hash = "9a8c096db46dae97f3dee130dd9f5252";
var $5b54880ccd66422f$export$2e2bcd8739ae039 = $5b54880ccd66422f$var$node;

});

parcelRegister("jPTIc", function(module, exports) {

$parcel$export(module.exports, "ApprovalDescription", () => $f5c6a64e698e2361$export$887db792032d5003);

var $49m9f = parcelRequire("49m9f");

var $3fb9B = parcelRequire("3fb9B");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $7Y3W2 = parcelRequire("7Y3W2");

var $k1Nmg = parcelRequire("k1Nmg");
const $f5c6a64e698e2361$export$887db792032d5003 = ({ jiraVersionApprover: jiraVersionApprover })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { description: description, id: approverAri } = (0, $iWLL0.useFragment)((0, $3fb9B.default), jiraVersionApprover);
    const [updateDescription] = (0, $iWLL0.useMutation)((0, $49m9f.default));
    const onError = ()=>{
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.version-detail.approver.update-description',
                packageName: 'jiraSoftwareReleasesApprovers',
                teamName: 'fusion-solaris'
            },
            error: Error('Unable to update description'),
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: (0, $k1Nmg.default).updateDescriptionFailed,
            type: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y3W2.TextAreaInput), {
        onConfirm: (newString)=>{
            const newValue = newString === '' ? null : newString;
            updateDescription({
                variables: {
                    input: {
                        approverId: approverAri,
                        description: newValue
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.updateJiraVersionApproverDescription?.success) onError();
                },
                onError: onError,
                optimisticResponse: {
                    jira: {
                        updateJiraVersionApproverDescription: {
                            success: true,
                            errors: null,
                            approver: {
                                id: approverAri,
                                description: newValue
                            }
                        }
                    }
                }
            });
        },
        title: (0, $k1Nmg.default).descriptionLabel,
        placeholderText: (0, $k1Nmg.default).noDescriptionPlaceholder,
        confirmButtonAriaLabel: (0, $k1Nmg.default).descriptionEditConfirmLabel,
        cancelButtonAriaLabel: (0, $k1Nmg.default).descriptionEditCancelLabel,
        textAreaFocusAriaLabel: (0, $k1Nmg.default).descriptionAriaLabel,
        editIconAriaLabel: (0, $k1Nmg.default).descriptionAriaLabel,
        defaultValue: description ?? ''
    });
};

});
parcelRegister("49m9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $38fa0dc09a78efaa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92b973d936036156d5856f358bdd784a>>
 * @relayHash ccc2fbd0a3839f1ff09007af98d695a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be5bea6aea08c11bce374ca854555fd7e14aef36a2086e6c6dc917350319a138
const $38fa0dc09a78efaa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraVersionUpdateApproverDescriptionPayload",
                    "kind": "LinkedField",
                    "name": "updateJiraVersionApproverDescription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraVersionApprover",
                            "kind": "LinkedField",
                            "name": "approver",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "approvalDescription_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "approvalDescription_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "be5bea6aea08c11bce374ca854555fd7e14aef36a2086e6c6dc917350319a138",
            "metadata": {},
            "name": "approvalDescription_softwareReleasesApproversMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$38fa0dc09a78efaa$var$node.hash = "3552fa1fc260ed118615ad832c35b8ff";
var $38fa0dc09a78efaa$export$2e2bcd8739ae039 = $38fa0dc09a78efaa$var$node;

});

parcelRegister("3fb9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0bf268e912035bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b5fd4c21fbf20f0897e04719b2b144a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0bf268e912035bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "approvalDescription_softwareReleasesApprovers",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        }
    ],
    "type": "JiraVersionApprover"
};
$b0bf268e912035bd$var$node.hash = "c421fe945502a3b4d88465ed8f62bb82";
var $b0bf268e912035bd$export$2e2bcd8739ae039 = $b0bf268e912035bd$var$node;

});

parcelRegister("7Y3W2", function(module, exports) {

$parcel$export(module.exports, "TextAreaInput", () => $caecf5bde94ede00$export$ce9b1cc0c34506d0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");

var $89sIt = parcelRequire("89sIt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $xeS7R = parcelRequire("xeS7R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $arxBE = parcelRequire("arxBE");
const $caecf5bde94ede00$export$ce9b1cc0c34506d0 = ({ onConfirm: onConfirm, title: title, placeholderText: placeholderText, confirmButtonAriaLabel: confirmButtonAriaLabel, cancelButtonAriaLabel: cancelButtonAriaLabel, textAreaFocusAriaLabel: textAreaFocusAriaLabel, editIconAriaLabel: editIconAriaLabel, defaultValue: defaultValue, isReadOnlyMode: isReadOnlyMode = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isWriteMode, setIsWriteMode] = (0, $eUqFw.useState)(false);
    const textAreaRef = (0, $eUqFw.useRef)(null);
    const [text, setText] = (0, $eUqFw.useState)(defaultValue);
    const onEnterWriteMode = ()=>{
        if (isReadOnlyMode) return;
        setIsWriteMode(true); // In order to focus, it should do it in the next frame, as textArea is `display: none` in the current frame
        setTimeout(()=>{
            if (textAreaRef.current != null) textAreaRef.current.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $caecf5bde94ede00$var$descriptionEditableAreaWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$HeadingUpperCase, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100",
        as: "h4"
    }, formatMessage(title))), text.trim() !== defaultValue.trim() && !isWriteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $caecf5bde94ede00$var$draftIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100",
        as: "h4"
    }, `\u{2022} ${formatMessage((0, $arxBE.default).unsavedChanges)}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$EditModeWrapper, {
        isWriteMode: isWriteMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        defaultValue: defaultValue,
        value: text,
        ref: textAreaRef,
        onBlur: ()=>{
            setIsWriteMode(false);
        },
        minimumRows: 4,
        onChange: (e)=>{
            setText(e.target.value);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: ()=>{
            onConfirm(text.trim());
            setIsWriteMode(false);
        },
        isDisabled: text.trim() === defaultValue.trim(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            label: formatMessage(confirmButtonAriaLabel)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>{
            setIsWriteMode(false);
            setText(defaultValue);
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage(cancelButtonAriaLabel)
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$ReadModeWrapper, {
        isWriteMode: isWriteMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$DescriptionReadOnly, {
        isPlaceHolder: defaultValue === '',
        onClick: ()=>{
            onEnterWriteMode();
        },
        isReadOnlyMode: isReadOnlyMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage(textAreaFocusAriaLabel),
        appearance: "subtle",
        spacing: "none",
        onClick: ()=>{
            onEnterWriteMode();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caecf5bde94ede00$var$ReadOnlyText, null, defaultValue === '' ? formatMessage(placeholderText) : defaultValue), !isReadOnlyMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89sIt))), {
        size: "small",
        label: formatMessage(editIconAriaLabel)
    }))));
};
const $caecf5bde94ede00$var$descriptionEditableAreaWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050',
    width: '100%'
});
const $caecf5bde94ede00$var$EditModeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWriteMode: isWriteMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.isWriteMode ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $caecf5bde94ede00$var$ReadModeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWriteMode: isWriteMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.isWriteMode ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $caecf5bde94ede00$var$HeadingUpperCase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $caecf5bde94ede00$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _zulpu2gc _19pku2gc",
            __cmplp.className
        ])
    });
});
const $caecf5bde94ede00$var$DescriptionReadOnly = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadOnlyMode: isReadOnlyMode, isPlaceHolder: isPlaceHolder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _v564pypm _1yt41b66 _18u0r5cr _1e0c1txw _4cvr1h6o _158uidpf _hxt6idpf _cs56kb7n _1yp3f1ug _11owyh40 _1guj194a _pbhanqa1 _1kygkb7n _v1pk1r31 _11uuglyw _dxpzidpf _1vm2kb7n",
            __cmplp.isReadOnlyMode ? "_80om1wug" : "_80omtlke",
            __cmplp.isReadOnlyMode ? "_irr318uv" : "_irr3ex3k",
            __cmplp.isPlaceHolder ? "_zg8l1m30" : "_zg8l4jg8",
            __cmplp.isPlaceHolder && "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $caecf5bde94ede00$var$ReadOnlyText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $caecf5bde94ede00$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $caecf5bde94ede00$var$draftIndicatorStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("89sIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef570750d61ee3c$var$_react = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5ef570750d61ee3c$var$_edit = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $5ef570750d61ee3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5ef570750d61ee3c$var$EditFilledIcon = (props)=>/*#__PURE__*/ $5ef570750d61ee3c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $5ef570750d61ee3c$var$_edit.default
    }));
$5ef570750d61ee3c$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $5ef570750d61ee3c$var$_default = module.exports.default = $5ef570750d61ee3c$var$EditFilledIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});


parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("arxBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd606ad76bb6c7bb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd606ad76bb6c7bb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unsavedChanges: {
        "id": "software-releases-approvers.common.textarea-input.unsaved-changes",
        "defaultMessage": "Unsaved changes"
    }
});

});


parcelRegister("k1Nmg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7a6898f56b821e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4b7a6898f56b821e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.description-label",
        "defaultMessage": "Description"
    },
    descriptionAriaLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.description-aria-label",
        "defaultMessage": "Edit description"
    },
    descriptionEditConfirmLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.description-edit-confirm-label",
        "defaultMessage": "Save description change"
    },
    descriptionEditCancelLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.description-edit-cancel-label",
        "defaultMessage": "Cancel description change"
    },
    noDescriptionPlaceholder: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.no-description-placeholder",
        "defaultMessage": "No description added"
    },
    updateDescriptionFailed: {
        "id": "software-releases-approvers.task-approver.approval-drawer.approval-description.update-description-failed",
        "defaultMessage": "Failed to update the reason. Please re-try."
    }
});

});


parcelRegister("7alWX", function(module, exports) {

$parcel$export(module.exports, "DeclineReason", () => $b65fee0513fd4d60$export$bb30404b5132672c);

var $46OUl = parcelRequire("46OUl");

var $3yncc = parcelRequire("3yncc");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $cWiVr = parcelRequire("cWiVr");

var $7Y3W2 = parcelRequire("7Y3W2");

var $avMgL = parcelRequire("avMgL");
const $b65fee0513fd4d60$export$bb30404b5132672c = ({ jiraVersionApprover: jiraVersionApprover })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { declineReason: declineReason, id: approverAri, user: { accountId: accountId } } = (0, $iWLL0.useFragment)((0, $3yncc.default), jiraVersionApprover);
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const canChangeDeclineReason = user.accountId === accountId;
    const [updateDeclineReason] = (0, $iWLL0.useMutation)((0, $46OUl.default));
    const onError = ()=>{
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.version-detail.approver.update-decline-reason',
                packageName: 'jiraSoftwareReleasesApprovers',
                teamName: 'fusion-solaris'
            },
            error: Error('Unable to update decline reason'),
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: (0, $avMgL.default).updateDeclineReasonFailed,
            type: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y3W2.TextAreaInput), {
        isReadOnlyMode: !canChangeDeclineReason,
        onConfirm: (newString)=>{
            const newValue = newString === '' ? null : newString;
            updateDeclineReason({
                variables: {
                    input: {
                        approverId: approverAri,
                        reason: newValue
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.updateJiraVersionApproverDeclineReason?.success) onError();
                },
                onError: onError,
                optimisticResponse: {
                    jira: {
                        updateJiraVersionApproverDeclineReason: {
                            success: true,
                            errors: null,
                            approver: {
                                id: approverAri,
                                declineReason: newValue
                            }
                        }
                    }
                }
            });
        },
        title: (0, $avMgL.default).declineLabel,
        placeholderText: (0, $avMgL.default).noDeclinePlaceholder,
        confirmButtonAriaLabel: (0, $avMgL.default).declineEditConfirmLabel,
        cancelButtonAriaLabel: (0, $avMgL.default).declineEditCancelLabel,
        textAreaFocusAriaLabel: (0, $avMgL.default).declineAriaLabel,
        editIconAriaLabel: (0, $avMgL.default).declineAriaLabel,
        defaultValue: declineReason ?? ''
    });
};

});
parcelRegister("46OUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b34408e3120e50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1903c656c21e96e8ded0d62825d9d7ad>>
 * @relayHash 338f28b041520a3caa75f9f8aad90e3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eaeb766594d01e4f6ecd688b983d57cf252776b7f80ee703dad9ca8f1e81c958
const $50b34408e3120e50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraVersionUpdateApproverDeclineReasonPayload",
                    "kind": "LinkedField",
                    "name": "updateJiraVersionApproverDeclineReason",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraVersionApprover",
                            "kind": "LinkedField",
                            "name": "approver",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "declineReason"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "declineReason_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "declineReason_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "eaeb766594d01e4f6ecd688b983d57cf252776b7f80ee703dad9ca8f1e81c958",
            "metadata": {},
            "name": "declineReason_softwareReleasesApproversMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$50b34408e3120e50$var$node.hash = "8a8bd7229f8a09992db859a1ce22ddb1";
var $50b34408e3120e50$export$2e2bcd8739ae039 = $50b34408e3120e50$var$node;

});

parcelRegister("3yncc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e03e947239afdf13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c2afe7dcb2588adba9405090f76575c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e03e947239afdf13$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "declineReason_softwareReleasesApprovers",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "declineReason"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        "action": "THROW",
                        "path": "user.accountId"
                    }
                ]
            },
            "action": "THROW",
            "path": "user"
        }
    ],
    "type": "JiraVersionApprover"
};
$e03e947239afdf13$var$node.hash = "9a9ae7f6ce65233c8a8a317185c80c40";
var $e03e947239afdf13$export$2e2bcd8739ae039 = $e03e947239afdf13$var$node;

});

parcelRegister("avMgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e946447177a95ab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5e946447177a95ab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    declineLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.decline-label",
        "defaultMessage": "Decline reason"
    },
    declineAriaLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.decline-aria-label",
        "defaultMessage": "Edit reason"
    },
    declineEditConfirmLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.decline-edit-confirm-label",
        "defaultMessage": "Save reason change"
    },
    declineEditCancelLabel: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.decline-edit-cancel-label",
        "defaultMessage": "Cancel reason change"
    },
    noDeclinePlaceholder: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.no-decline-placeholder",
        "defaultMessage": "No reason provided"
    },
    updateDeclineReasonFailed: {
        "id": "software-releases-approvers.task-approver.approval-drawer.decline-reason.update-decline-reason-failed",
        "defaultMessage": "Failed to update the reason. Please re-try."
    }
});

});


parcelRegister("8zb8w", function(module, exports) {

$parcel$export(module.exports, "RemoveApprover", () => $36f23ff9098ca0e7$export$e500a6e4fcf7b99e);

var $9dVIY = parcelRequire("9dVIY");

var $iPUBM = parcelRequire("iPUBM");

var $lTtVy = parcelRequire("lTtVy");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bm4Iv = parcelRequire("bm4Iv");

var $9ArRu = parcelRequire("9ArRu");
const $36f23ff9098ca0e7$export$e500a6e4fcf7b99e = ({ jiraVersionApprover: jiraVersionApprover, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { id: approverAri, __id: approverStoreId } = (0, $iWLL0.useFragment)((0, $lTtVy.default), jiraVersionApprover);
    const version = (0, $iWLL0.useFragment)((0, $iPUBM.default), jiraVersion);
    const connectionId = (0, $cNy9K.ConnectionHandler).getConnectionID(version.__id, 'version_approvers');
    const experienceStart = (0, $bm4Iv.useRemoveVersionApproversExperienceStart)();
    const experienceSuccess = (0, $bm4Iv.useRemoveVersionApproversExperienceSuccess)();
    const experienceFail = (0, $bm4Iv.useRemoveVersionApproversExperienceFail)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const [removeApprover] = (0, $iWLL0.useMutation)((0, $9dVIY.default));
    const onError = ()=>{
        const error = Error('Unable to remove approver');
        experienceFail('graphql error', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.version-detail.approver.remove-approver',
                packageName: 'jiraSoftwareReleasesApprovers',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: (0, $9ArRu.default).removeApproverFailed,
            type: 'error'
        });
    };
    const onDeleteNode = (store)=>{
        const connectionRecord = store.get(connectionId);
        if (connectionRecord == null) return;
        (0, $cNy9K.ConnectionHandler).deleteNode(connectionRecord, approverStoreId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($36f23ff9098ca0e7$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'removeApproverFromVersion');
            experienceStart();
            removeApprover({
                variables: {
                    approverAri: approverAri
                },
                onCompleted: (data)=>{
                    if (!data.jira?.deleteJiraVersionApprover?.success) {
                        onError();
                        return;
                    }
                    experienceSuccess();
                },
                onError: onError,
                optimisticUpdater: onDeleteNode,
                updater: onDeleteNode
            });
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "small",
            label: formatMessage((0, $9ArRu.default).removeApprover)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($36f23ff9098ca0e7$var$Inline, null, formatMessage((0, $9ArRu.default).removeApprover))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36f23ff9098ca0e7$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36f23ff9098ca0e7$var$Inline = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9dVIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7f1bce1fbef6661$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<685324005536c0de7faf47b1342079bf>>
 * @relayHash bc7b99240d9187d11ae7b905f77c6810
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd5c5052a127803b509014898bc3c9365eb873b77c1d9bddd5e2aba3dabd6f09
const $a7f1bce1fbef6661$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "approverAri"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "approverAri"
                        }
                    ],
                    "concreteType": "JiraVersionDeleteApproverPayload",
                    "kind": "LinkedField",
                    "name": "deleteJiraVersionApprover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "deletedApproverId"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "removeApprover_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "removeApprover_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dd5c5052a127803b509014898bc3c9365eb873b77c1d9bddd5e2aba3dabd6f09",
            "metadata": {},
            "name": "removeApprover_softwareReleasesApproversMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a7f1bce1fbef6661$var$node.hash = "c4ddb7a4c6fdd0197fc36106f5bdabcb";
var $a7f1bce1fbef6661$export$2e2bcd8739ae039 = $a7f1bce1fbef6661$var$node;

});

parcelRegister("iPUBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a7c520605a2618d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13c58fef270502f858af557e11e38680>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a7c520605a2618d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "removeApprover_softwareReleasesApprovers_jiraVersion",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$7a7c520605a2618d$var$node.hash = "15af9d43789b08db6dabb0770ed8710d";
var $7a7c520605a2618d$export$2e2bcd8739ae039 = $7a7c520605a2618d$var$node;

});

parcelRegister("lTtVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea3f8abb44c242a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<669570516113064080a80e203300f536>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cea3f8abb44c242a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "removeApprover_softwareReleasesApprovers_jiraVersionApprover",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraVersionApprover"
};
$cea3f8abb44c242a$var$node.hash = "20e18f6c71fb765cb93bd4418c0f9640";
var $cea3f8abb44c242a$export$2e2bcd8739ae039 = $cea3f8abb44c242a$var$node;

});

parcelRegister("bm4Iv", function(module, exports) {

$parcel$export(module.exports, "useRemoveVersionApproversExperienceStart", () => $13e872e3bbea6642$export$f5536e84f6531099);
$parcel$export(module.exports, "useRemoveVersionApproversExperienceFail", () => $13e872e3bbea6642$export$1a348aeea836ccda);
$parcel$export(module.exports, "useRemoveVersionApproversExperienceSuccess", () => $13e872e3bbea6642$export$3e9cc4ccfd38cd03);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $13e872e3bbea6642$var$EXPERIENCE_NAME = 'removeVersionApprover';
const $13e872e3bbea6642$var$SOURCE = 'versionDetails';
const $13e872e3bbea6642$export$f5536e84f6531099 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $13e872e3bbea6642$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $13e872e3bbea6642$var$SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $13e872e3bbea6642$export$1a348aeea836ccda = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $13e872e3bbea6642$var$EXPERIENCE_NAME
    });
const $13e872e3bbea6642$export$3e9cc4ccfd38cd03 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $13e872e3bbea6642$var$EXPERIENCE_NAME
    });

});

parcelRegister("9ArRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $53cbf22e041e9d84$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $53cbf22e041e9d84$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeApprover: {
        "id": "software-releases-approvers.task-approver.approval-drawer.remove-approver.remove-approver",
        "defaultMessage": "Remove approver"
    },
    removeApproverFailed: {
        "id": "software-releases-approvers.task-approver.approval-drawer.remove-approver.remove-approver-failed",
        "defaultMessage": "Failed to remove the approver. Please re-try."
    }
});

});



parcelRegister("mYqiC", function(module, exports) {

$parcel$export(module.exports, "ApprovalStatus", () => $06d70052bb72bd42$export$c624813ee5873aa);

var $l34xp = parcelRequire("l34xp");

var $3W9pY = parcelRequire("3W9pY");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $ffiyv = parcelRequire("ffiyv");

var $bULPy = parcelRequire("bULPy");

var $3MV1G = parcelRequire("3MV1G");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cWiVr = parcelRequire("cWiVr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ieQ6k = parcelRequire("ieQ6k");

var $rti3k = parcelRequire("rti3k");

var $kTfkq = parcelRequire("kTfkq");
const $06d70052bb72bd42$export$c624813ee5873aa = ({ jiraVersionApprover: jiraVersionApprover })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isStatusOpen, setIsStatusOpen] = (0, $eUqFw.useState)(false);
    const experienceStart = (0, $rti3k.useChangeVersionApproversStatusStart)();
    const experienceFail = (0, $rti3k.useChangeVersionApproversStatusFail)();
    const experienceSuccess = (0, $rti3k.useChangeVersionApproversStatusSuccess)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const approver = (0, $iWLL0.useFragment)((0, $3W9pY.default), jiraVersionApprover);
    const approverAri = approver.id;
    const canChangeStatus = user.accountId === approver.user.accountId;
    const isApproved = approver.status === 'APPROVED';
    const isDeclined = approver.status === 'DECLINED';
    const mapApprovalStateToLozengeAppearance = (state)=>{
        switch(state){
            case 'APPROVED':
                return 'success';
            case 'DECLINED':
                return 'removed';
            default:
                return 'default';
        }
    };
    const [updateApproverStatus] = (0, $iWLL0.useMutation)((0, $l34xp.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const handleClick = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionApproverStatusPopup');
        if (!canChangeStatus) return;
        setIsStatusOpen(!isStatusOpen);
    };
    const onMutationError = (error)=>{
        experienceFail('graphql error', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.approvers.task-approver.approver-status',
                packageName: 'jiraSoftwareReleasesApprovers',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: formatMessage((0, $kTfkq.default).genericUpdateFailedFlagTitle),
            description: formatMessage((0, $kTfkq.default).statusFailedFlagDescription),
            type: 'error'
        });
    };
    const handleChange = (option)=>{
        updateApproverStatus({
            variables: {
                input: {
                    approverId: approverAri,
                    status: option
                }
            },
            optimisticResponse: {
                jira: {
                    updateJiraVersionApproverStatus: {
                        success: true,
                        errors: null,
                        approver: {
                            id: approverAri,
                            status: option
                        }
                    }
                }
            },
            onCompleted: (data)=>{
                if (data.jira?.updateJiraVersionApproverStatus?.success !== true) {
                    const responseErrors = data?.jira?.updateJiraVersionApproverStatus?.errors;
                    const errorMessage = responseErrors?.[0]?.message ?? 'addVersionApprover graphql mutation failed';
                    onMutationError(new Error(errorMessage));
                    return;
                }
                experienceSuccess();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'versionApproverStatus'
                }), 'versionApproverStatusSelection', {
                    versionApproverOldStatus: approver.status,
                    versionApproverNewStatus: option
                });
            },
            onError: (error)=>{
                onMutationError(error);
            }
        });
        setIsStatusOpen(false);
    };
    const statusOptions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06d70052bb72bd42$var$PopupContainer, null, !isApproved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-ignore-target": (0, $ieQ6k.STATUS_APPROVED_BUTTON_CLICK_IGNORE_TARGET),
        onClick: ()=>{
            experienceStart();
            handleChange('APPROVED');
        }
    }, formatMessage((0, $kTfkq.default).approveOptionLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-ignore-target": (0, $ieQ6k.STATUS_PENDING_BUTTON_CLICK_IGNORE_TARGET),
        onClick: ()=>{
            experienceStart();
            handleChange('PENDING');
        }
    }, formatMessage((0, $kTfkq.default).revokeApprovalOptionLabel)), !isDeclined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-ignore-target": (0, $ieQ6k.STATUS_DECLINED_BUTTON_CLICK_IGNORE_TARGET),
        onClick: ()=>{
            experienceStart();
            handleChange('DECLINED');
        }
    }, formatMessage((0, $kTfkq.default).declineOptionLabel)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        onClose: ()=>setIsStatusOpen(false),
        isOpen: isStatusOpen,
        placement: "bottom-end",
        content: ()=>statusOptions,
        offset: [
            0,
            8
        ],
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06d70052bb72bd42$var$StyledButton, {
                "data-ignore-target": (0, $ieQ6k.STATUS_POPUP_TRIGGER_CLICK_IGNORE_TARGET),
                ...triggerProps,
                onClick: handleClick,
                isDisabled: !canChangeStatus
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: mapApprovalStateToLozengeAppearance(approver.status)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06d70052bb72bd42$var$IconWrapper, null, approver.status, canChangeStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                size: "small",
                label: formatMessage((0, $kTfkq.default).buttonLabel)
            }))))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06d70052bb72bd42$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16hg18uv _rcujidpf _o81cidpf _1l6uidpf _149midpf _w1ap1wug _btpd1wug _1dltidpf _w8sqidpf _fjwridpf _1yxxidpf _1wgm3acm _1tnq14y2 _17bz1r31 _e0gcglyw _1545idpf _1c04idpf _1khaidpf _zqu5idpf _3zhzidpf _davf1vt6 _bqht1vt6",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06d70052bb72bd42$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06d70052bb72bd42$var$PopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb11ux _1yt41bpf _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l34xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fbca942e88d335$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36774dee2ae5df74147e1e12543339e7>>
 * @relayHash fae8e09125eb3d1a476092d10f1ca7df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd41e53ec61eb3d70cb5d16d4e6f89be50283eb1ca953cdce0560bd5f9460de0
const $99fbca942e88d335$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraVersionUpdateApproverStatusPayload",
                    "kind": "LinkedField",
                    "name": "updateJiraVersionApproverStatus",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraVersionApprover",
                            "kind": "LinkedField",
                            "name": "approver",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "approvalStatus_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "approvalStatus_softwareReleasesApproversMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dd41e53ec61eb3d70cb5d16d4e6f89be50283eb1ca953cdce0560bd5f9460de0",
            "metadata": {},
            "name": "approvalStatus_softwareReleasesApproversMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$99fbca942e88d335$var$node.hash = "7843a481920e13d3191728ecd38dfb98";
var $99fbca942e88d335$export$2e2bcd8739ae039 = $99fbca942e88d335$var$node;

});

parcelRegister("3W9pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $842be703397c0265$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee5499c00a861407898b350b94a66324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $842be703397c0265$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "approvalStatus_softwareReleasesApprovers",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        "action": "THROW",
                        "path": "user.accountId"
                    }
                ]
            },
            "action": "THROW",
            "path": "user"
        }
    ],
    "type": "JiraVersionApprover"
};
$842be703397c0265$var$node.hash = "a9facaa120985a7b998fdeec16b9f3e0";
var $842be703397c0265$export$2e2bcd8739ae039 = $842be703397c0265$var$node;

});

parcelRegister("rti3k", function(module, exports) {

$parcel$export(module.exports, "useChangeVersionApproversStatusStart", () => $8892787bc9fc97bb$export$ff2e479c13524c0d);
$parcel$export(module.exports, "useChangeVersionApproversStatusFail", () => $8892787bc9fc97bb$export$e0d622bd76bafc5f);
$parcel$export(module.exports, "useChangeVersionApproversStatusSuccess", () => $8892787bc9fc97bb$export$def59195977f72c6);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $8892787bc9fc97bb$var$EXPERIENCE_NAME = 'updateVersionApproversStatus';
const $8892787bc9fc97bb$var$SOURCE = 'versionDetails';
const $8892787bc9fc97bb$export$ff2e479c13524c0d = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $8892787bc9fc97bb$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $8892787bc9fc97bb$var$SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $8892787bc9fc97bb$export$e0d622bd76bafc5f = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $8892787bc9fc97bb$var$EXPERIENCE_NAME
    });
const $8892787bc9fc97bb$export$def59195977f72c6 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $8892787bc9fc97bb$var$EXPERIENCE_NAME
    });

});

parcelRegister("kTfkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0445019ad9d6504$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e0445019ad9d6504$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "software-releases-approvers.task-approver.approval-status.button-label",
        "defaultMessage": "Approval state dropdown"
    },
    approveOptionLabel: {
        "id": "software-releases-approvers.task-approver.approval-status.approve-option-label",
        "defaultMessage": "Approve"
    },
    revokeApprovalOptionLabel: {
        "id": "software-releases-approvers.task-approver.approval-status.revoke-approval-option-label",
        "defaultMessage": "Revoke approval"
    },
    declineOptionLabel: {
        "id": "software-releases-approvers.task-approver.approval-status.decline-option-label",
        "defaultMessage": "Decline"
    },
    genericUpdateFailedFlagTitle: {
        "id": "software-releases-approvers.task-approver.approval-status.generic-update-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    statusFailedFlagDescription: {
        "id": "software-releases-approvers.task-approver.approval-status.status-failed-flag-description",
        "defaultMessage": "We were not able to update the approval status. Please refresh the page and try again."
    }
});

});


parcelRegister("hGwrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2d0b2afe6903959$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a2d0b2afe6903959$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openApproverIcon: {
        "id": "software-releases-approvers.task-approver.open-approver-icon",
        "defaultMessage": "click to open approver"
    }
});

});




parcelRegister("a5QNi", function(module, exports) {

$parcel$export(module.exports, "useSidebarStore", () => $8a021db81f49c01a$export$118f45a8309a4356);
$parcel$export(module.exports, "useSidebarActions", () => $8a021db81f49c01a$export$685a45ff9d61633f);

var $giI3b = parcelRequire("giI3b");

var $WBLbN = parcelRequire("WBLbN");
const { CLOSED: $8a021db81f49c01a$var$CLOSED, SHOWING_ISSUE: $8a021db81f49c01a$var$SHOWING_ISSUE } = (0, $giI3b.SidebarStatuses);
const $8a021db81f49c01a$var$initialState = {
    state: {
        status: $8a021db81f49c01a$var$CLOSED
    }
};
const $8a021db81f49c01a$export$e324594224ef24da = {
    close: ()=>({ setState: setState })=>setState({
                state: {
                    status: $8a021db81f49c01a$var$CLOSED
                }
            }),
    showIssue: (issueKey)=>({ setState: setState })=>setState({
                state: {
                    status: $8a021db81f49c01a$var$SHOWING_ISSUE,
                    issueKey: issueKey
                }
            })
};
const $8a021db81f49c01a$var$Store = (0, $WBLbN.createStore)({
    name: 'versionDetailsSidebarStore',
    initialState: $8a021db81f49c01a$var$initialState,
    actions: $8a021db81f49c01a$export$e324594224ef24da
});
const $8a021db81f49c01a$var$useStore = (0, $WBLbN.createHook)($8a021db81f49c01a$var$Store);
const $8a021db81f49c01a$export$118f45a8309a4356 = ()=>{
    const [{ state: state }, sidebarActions] = $8a021db81f49c01a$var$useStore();
    return [
        state,
        sidebarActions
    ];
};
const $8a021db81f49c01a$var$useSidebarWithoutState = (0, $WBLbN.createHook)($8a021db81f49c01a$var$Store, {
    selector: null
});
const $8a021db81f49c01a$export$685a45ff9d61633f = ()=>{
    const [, sidebarActions] = $8a021db81f49c01a$var$useSidebarWithoutState();
    return sidebarActions;
};

});
parcelRegister("giI3b", function(module, exports) {

$parcel$export(module.exports, "SidebarStatuses", () => $214555b67485bd9e$export$a4b0bca2b71ad188);
const $214555b67485bd9e$var$CLOSED = 'CLOSED';
const $214555b67485bd9e$var$SHOWING_ISSUE = 'SHOWING_ISSUE';
const $214555b67485bd9e$export$a4b0bca2b71ad188 = {
    CLOSED: $214555b67485bd9e$var$CLOSED,
    SHOWING_ISSUE: $214555b67485bd9e$var$SHOWING_ISSUE
};

});


parcelRegister("75bi0", function(module, exports) {

$parcel$export(module.exports, "IssueSidebar", () => $6537852009b6cdc3$export$cd07ab049c87f027);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giI3b = parcelRequire("giI3b");

var $a5QNi = parcelRequire("a5QNi");

var $1DvSO = parcelRequire("1DvSO");
const $6537852009b6cdc3$export$cd07ab049c87f027 = ()=>{
    const [sidebarState] = (0, $a5QNi.useSidebarStore)();
    const isOpen = sidebarState.status !== (0, $giI3b.SidebarStatuses).CLOSED;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6537852009b6cdc3$var$IssueSidebarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DvSO.SidebarContent), null)) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6537852009b6cdc3$var$IssueSidebarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _kqswh2mm _1yt410cz _vchhusvi _bfhktxrc _1bsblti4 _p12flti4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1DvSO", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $1ab8ca5ef6c91f78$export$49e8f7b58a4df4ea);

var $eUqFw = parcelRequire("eUqFw");

var $giI3b = parcelRequire("giI3b");

var $a5QNi = parcelRequire("a5QNi");

var $amjhp = parcelRequire("amjhp");
const $1ab8ca5ef6c91f78$export$49e8f7b58a4df4ea = ()=>{
    const [sidebarState, sidebarActions] = (0, $a5QNi.useSidebarStore)();
    const onClose = sidebarActions.close;
    switch(sidebarState.status){
        case (0, $giI3b.SidebarStatuses).CLOSED:
            return null;
        case (0, $giI3b.SidebarStatuses).SHOWING_ISSUE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $amjhp.Issue), {
                issueKey: sidebarState.issueKey,
                onClose: onClose
            });
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sidebarState.status;
            throw Error('Unhandled sidebar status');
    }
};

});
parcelRegister("amjhp", function(module, exports) {

$parcel$export(module.exports, "Issue", () => $dbf5aa51e27d0cc6$export$c175600e334513b4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");


var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $lpokX = parcelRequire("lpokX");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dbf5aa51e27d0cc6$var$IssueApp = (0, $7rh0R.lazy)(()=>(parcelRequire("kT5hT")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $dbf5aa51e27d0cc6$export$c175600e334513b4 = ({ issueKey: issueKey, onClose: onClose })=>{
    const { refetch: refetch } = (0, $lpokX.useRefetchContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "versionDetailsIssue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbf5aa51e27d0cc6$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbf5aa51e27d0cc6$var$IssueApp, {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: issueKey,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true // TODO: Once all fields used in the issue link component and the version
        ,
        // details issue list have been migrated to use Relay, we should be able to
        // remove the onChange callback used here, since the data will sync to the
        // Relay store without having to call "refetch" here
        onChange: (event)=>{
            if (event.type === 'FIELD_CHANGED') refetch();
        },
        onIssueDeleteSuccess: refetch,
        onClose: onClose,
        isLoadedWithPage: false,
        isSpaEnabled: false,
        analyticsSource: (0, $0100842672acae20$export$5b73d694a6048002)
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbf5aa51e27d0cc6$var$DetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1reo15vq",
            __cmplp.className
        ])
    });
});

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("lpokX", function(module, exports) {

$parcel$export(module.exports, "RefetchContext", () => $51134705c2bdc22e$export$9943e630ea9ac16a);
$parcel$export(module.exports, "useRefetchContext", () => $51134705c2bdc22e$export$947d5554caab689a);

var $eUqFw = parcelRequire("eUqFw");
const $51134705c2bdc22e$export$9943e630ea9ac16a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $51134705c2bdc22e$export$947d5554caab689a = ()=>{
    const refetchContext = (0, $eUqFw.useContext)($51134705c2bdc22e$export$9943e630ea9ac16a);
    if (refetchContext == null) throw new Error('Version details refetch provider was not found');
    return refetchContext;
};

});

parcelRegister("kT5hT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});




parcelRegister("jPZ7t", function(module, exports) {

$parcel$export(module.exports, "LaunchCardExperienceStart", () => $e27864b3ab36767a$export$5715f82a8f696e44);
$parcel$export(module.exports, "LaunchCardExperienceSuccess", () => $e27864b3ab36767a$export$8e01269c24812c16);
$parcel$export(module.exports, "useLaunchCardExperienceFail", () => $e27864b3ab36767a$export$207918c16c60fcae);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $e27864b3ab36767a$export$52919046b94109dc = 'launchCard';
const $e27864b3ab36767a$var$ANALYTICS_SOURCE = 'versionDetails';
const $e27864b3ab36767a$export$5715f82a8f696e44 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $e27864b3ab36767a$export$52919046b94109dc,
        analyticsSource: $e27864b3ab36767a$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $e27864b3ab36767a$export$8e01269c24812c16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $e27864b3ab36767a$export$52919046b94109dc
    });
const $e27864b3ab36767a$export$207918c16c60fcae = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $e27864b3ab36767a$export$52919046b94109dc
    });

});

parcelRegister("erKV3", function(module, exports) {

$parcel$export(module.exports, "LaunchCard", () => $48421fae95184b1d$export$1c9fa03e23146e86);

var $gL8iV = parcelRequire("gL8iV");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $gGtKh = parcelRequire("gGtKh");

var $15qOJ = parcelRequire("15qOJ");

var $168X7 = parcelRequire("168X7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $48421fae95184b1d$var$LazyLaunchCard = (0, $7rh0R.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("168X7"))).then((module)=>module.LaunchCard), {
    ssr: false,
    moduleId: "./src/packages/releases/launch-card/src/ui/index.tsx"
});
const $48421fae95184b1d$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $168X7.BaseWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $168X7.MainContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.StatusLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.TwoColumnFieldWrapper), {
        height: 63
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldContentLoading), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.TwoColumnFieldWrapper), {
        height: 52
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.FieldContentLoading), null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15qOJ.LatestDeploymentLoading), null));
const $48421fae95184b1d$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const { startNextPhase: startNextPhase } = (0, $7rh0R.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $iWLL0.useFragment)((0, $gL8iV.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-detail-launch-card",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48421fae95184b1d$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48421fae95184b1d$var$LazyLaunchCard, {
        jiraVersion: version
    }));
};

});
parcelRegister("gL8iV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c73ee06bfac606$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0fe1a4283ec3216e0228279fe31b9ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d2c73ee06bfac606$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_LaunchCard",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesLaunchCard_LaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$d2c73ee06bfac606$var$node.hash = "ed744d145282aafc0de30b038a930975";
var $d2c73ee06bfac606$export$2e2bcd8739ae039 = $d2c73ee06bfac606$var$node;

});

parcelRegister("15qOJ", function(module, exports) {

$parcel$export(module.exports, "LoadingWrapper", () => $7e570c46bfad75f3$export$43a792a870d28db2);
$parcel$export(module.exports, "StatusLoading", () => $7e570c46bfad75f3$export$51c5b32c3d6a82a3);
$parcel$export(module.exports, "LatestDeploymentLoading", () => $7e570c46bfad75f3$export$312fd886f74b4447);
$parcel$export(module.exports, "TwoColumnFieldWrapper", () => $7e570c46bfad75f3$export$6dbdef323b681eb1);
$parcel$export(module.exports, "FieldLoadingWrapper", () => $7e570c46bfad75f3$export$6f356a6f7f11d124);
$parcel$export(module.exports, "FieldLabelLoading", () => $7e570c46bfad75f3$export$1411e5aa93aa9d74);
$parcel$export(module.exports, "FieldContentLoading", () => $7e570c46bfad75f3$export$9f4ff45992eb7f88);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
/**
 * Loading component starts
 */ const $7e570c46bfad75f3$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e570c46bfad75f3$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19iti1qc _2rko1l7b",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$51c5b32c3d6a82a3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7e570c46bfad75f3$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$312fd886f74b4447 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7e570c46bfad75f3$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$6dbdef323b681eb1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$6f356a6f7f11d124 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$1411e5aa93aa9d74 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7e570c46bfad75f3$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ssb _4t3i7vkz _19pkftgi _2hwxidpf _otyrftgi _18u0idpf",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$9f4ff45992eb7f88 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7e570c46bfad75f3$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1n8h _4t3i1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf",
            __cmplp.className
        ])
    });
});
const $7e570c46bfad75f3$export$22183793b514d3aa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("168X7", function(module, exports) {

$parcel$export(module.exports, "LaunchCard", () => $c1fdbc05369381b7$export$1c9fa03e23146e86);
$parcel$export(module.exports, "BaseWrapper", () => $c1fdbc05369381b7$export$c07bd9612bb2b971);
$parcel$export(module.exports, "MainContentWrapper", () => $c1fdbc05369381b7$export$7f55214bcae58e5d);

var $axImm = parcelRequire("axImm");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $1dH2n = parcelRequire("1dH2n");

var $yyqSx = parcelRequire("yyqSx");

var $h2x4y = parcelRequire("h2x4y");

var $5ZuHf = parcelRequire("5ZuHf");

var $lR2Nb = parcelRequire("lR2Nb");

var $jC0OR = parcelRequire("jC0OR");

var $jPZ7t = parcelRequire("jPZ7t");

var $fQtxa = parcelRequire("fQtxa");

var $d9lWl = parcelRequire("d9lWl");

var $4L9Jt = parcelRequire("4L9Jt");

var $6cGTB = parcelRequire("6cGTB");
const $c1fdbc05369381b7$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $iWLL0.useFragment)((0, $axImm.default), jiraVersion);
    const [preconditionQueryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $1dH2n.default));
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)()) loadQuery({
            cloudId: version.project.cloudId,
            projectKey: version.project.key
        });
    }, [
        loadQuery,
        version.project.cloudId,
        version.project.key
    ]);
    const hasDriver = version.driverData?.driver?.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "launchCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            hasDriver: Boolean(hasDriver),
            versionAri: version.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1fdbc05369381b7$export$c07bd9612bb2b971, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPZ7t.LaunchCardExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1fdbc05369381b7$export$7f55214bcae58e5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cGTB.AsyncVersionStatus), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4L9Jt.VersionDates), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1fdbc05369381b7$var$UserFieldsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1fdbc05369381b7$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jC0OR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardDriverField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2x4y.DriverField), {
        jiraVersion: version,
        width: (0, $lR2Nb.FIRST_COLUMN_MIN_WIDTH),
        isDisabled: !version.canEdit
    }))), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1fdbc05369381b7$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jC0OR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardContributorsField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9lWl.AsyncVersionContributors), {
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZuHf.VersionSummaryDescription), {
        jiraVersion: version
    })), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && preconditionQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jC0OR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardLatestDeployment",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "latest-deployment",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQtxa.LatestDeployment), {
        jiraVersion: version,
        preconditionQueryRef: preconditionQueryRef
    })))));
};
const $c1fdbc05369381b7$export$c07bd9612bb2b971 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1tke18pt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c1fdbc05369381b7$export$7f55214bcae58e5d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1yt41ejb _zulppxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1fdbc05369381b7$var$UserFieldsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1fdbc05369381b7$var$FieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _prventd2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("axImm", function(module, exports) {

$parcel$export(module.exports, "default", () => $134d53e65590c5a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<386cb530a3758aca88c75b3201779308>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $134d53e65590c5a0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesLaunchCard_LaunchCard",
        "selections": [
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "versionDates_softwareReleasesLaunchCard"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDriverField_DriverField"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                "action": "THROW",
                "path": "canEdit"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "cloudId"
                            },
                            "action": "THROW",
                            "path": "project.cloudId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$134d53e65590c5a0$var$node.hash = "895f1ae46eb71f223dc9353087cec375";
var $134d53e65590c5a0$export$2e2bcd8739ae039 = $134d53e65590c5a0$var$node;

});

parcelRegister("1dH2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f209c3ac6ab66a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<404f0936c589f2bac5fc9b25c6f0c25c>>
 * @relayHash 6139c5ac9eede3cb4cb45119f82b6c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326
const $53f209c3ac6ab66a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    }
                ],
                "kind": "ScalarField",
                "name": "deploymentsFeaturePreconditionByProjectKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326",
            "metadata": {},
            "name": "latestDeploymentForVersionPreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$53f209c3ac6ab66a$var$node.hash = "af15b08c11e01f89f1bd0ec84b873d12";
var $53f209c3ac6ab66a$export$2e2bcd8739ae039 = $53f209c3ac6ab66a$var$node;

});

parcelRegister("h2x4y", function(module, exports) {

$parcel$export(module.exports, "DriverFieldStateless", () => $e6f94a88358bd533$export$9ede53742ae13d69);
$parcel$export(module.exports, "DriverField", () => $e6f94a88358bd533$export$4de1488fc0a2d937);

var $eagsE = parcelRequire("eagsE");

var $2UREL = parcelRequire("2UREL");

var $d2gQg = parcelRequire("d2gQg");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $jYnpi = parcelRequire("jYnpi");

var $c9TLT = parcelRequire("c9TLT");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $7Vqtj = parcelRequire("7Vqtj");

var $8meCs = parcelRequire("8meCs");
const $e6f94a88358bd533$var$isOptionData = (val)=>val != null && typeof val.name === 'string' && typeof val.id === 'string';
const $e6f94a88358bd533$var$createLoadQueryFunc = (environment, cloudId, projectAri)=>(searchText)=>(0, $iWLL0.fetchQuery)(environment, (0, $d2gQg.default), {
            projectAri: projectAri,
            searchText: searchText
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise().then(// @ts-expect-error - TS2345 - Argument of type '(response: Response) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
        (response)=>{
            const edges = response.jira.jiraProject.suggestedDriversForJiraVersion?.edges ?? [];
            return edges.filter(Boolean).map((edge)=>edge?.node).map((user)=>user == null ? null : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    avatarUrl: user.picture,
                    name: user.name,
                    id: user.accountId,
                    byline: user?.extendedProfile?.jobTitle ?? '',
                    type: 'user'
                }).filter($e6f94a88358bd533$var$isOptionData);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'ui_versionDriverFieldQuery',
                    packageName: 'jiraSoftwareReleasesVersionDriverField'
                },
                error: error
            }); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
        });
const $e6f94a88358bd533$export$9ede53742ae13d69 = ({ width: width, projectId: projectId, initialDriverValue: initialDriverValue, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, menuPortalTargetRef: menuPortalTargetRef, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const menuPortalTarget = menuPortalTargetRef && menuPortalTargetRef.current;
    const loadOptions = $e6f94a88358bd533$var$createLoadQueryFunc(environment, cloudId, `ari:cloud:jira:${cloudId}:project/${projectId}`);
    const experienceStart = (0, $7Vqtj.useUpdateDriverExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6f94a88358bd533$var$Wrapper, null, isDisplayLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $8meCs.default).fieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6f94a88358bd533$var$PlacholderStyleOverrider, {
        isDisplayBorder: isDisplayBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        fieldId: "jiraVersionDriver",
        ariaLabelledBy: ariaLabelledBy,
        loadOptions: loadOptions,
        isDisabled: isDisabled,
        width: width,
        menuPortalTarget: isRenderedInModal ? menuPortalTarget || document.body : undefined,
        styles: isRenderedInModal && !menuPortalTarget ? {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        } : undefined,
        menuMinWidth: 33 * (0, $c9TLT.gridSize),
        defaultValue: initialDriverValue,
        placeholder: formatMessage((0, $8meCs.default).unassigned),
        onChange: (value)=>{
            // it is single select, so it should never be an array
            if (Array.isArray(value)) return;
            onChange?.(value == null ? null : value);
        },
        onFocus: ()=>experienceStart(),
        onClear: ()=>experienceStart()
    })));
};
const $e6f94a88358bd533$export$4de1488fc0a2d937 = ({ jiraVersion: jiraVersion, width: width, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const experienceFail = (0, $7Vqtj.useUpdateDriverExperienceFail)();
    const experienceSuccess = (0, $7Vqtj.useUpdateDriverExperienceSuccess)();
    const version = (0, $iWLL0.useFragment)((0, $2UREL.default), jiraVersion);
    const versionAri = version.id;
    const { projectId: projectId } = version.project;
    const onMutationError = (error)=>{
        experienceFail('graphql error', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.release-modals-relay.create-release-modal',
                packageName: 'jiraSoftwareReleasesVersionDriverField',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: formatMessage((0, $8meCs.default).genericErrorFlagTitle),
            description: formatMessage((0, $8meCs.default).genericErrorFlagDescription),
            type: 'error'
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticEvent = createAnalyticsEvent({
        action: 'updated',
        actionSubject: 'versionDriver'
    });
    const [updateDriverOnVersion] = (0, $iWLL0.useMutation)((0, $eagsE.default));
    const driverError = version.driverData?.queryError?.message;
    if (driverError != null) throw new Error('Received QueryError when fetching driver');
    const driver = version?.driverData?.driver; // eslint-disable-next-line no-console
    console.log('driver', driver);
    const currentlySetDriver = driver == null ? undefined : {
        avatarUrl: driver.picture,
        name: driver.name,
        id: driver.accountId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6f94a88358bd533$export$9ede53742ae13d69, {
        width: width,
        ariaLabelledBy: ariaLabelledBy,
        projectId: projectId,
        initialDriverValue: currentlySetDriver,
        isDisplayLabel: isDisplayLabel,
        isRenderedInModal: isRenderedInModal,
        isDisabled: isDisabled,
        isDisplayBorder: isDisplayBorder,
        onChange: (newDriver)=>{
            updateDriverOnVersion({
                variables: {
                    input: {
                        id: versionAri,
                        driver: newDriver?.id
                    }
                },
                onCompleted: (data)=>{
                    if (data.jira?.updateJiraVersionDriver?.success !== true) {
                        const responseErrors = data?.jira?.updateJiraVersionDriver?.errors;
                        const errorMessage = responseErrors?.[0]?.message ?? 'updateJiraVersionDriver graphql mutation failed';
                        onMutationError(new Error(errorMessage));
                        return;
                    }
                    experienceSuccess();
                    (0, $jMP2a.fireTrackAnalytics)(analyticEvent, 'versionDriver updated', {
                        isDriverSet: Boolean(newDriver?.id)
                    });
                },
                onError: (error)=>{
                    onMutationError(error);
                }
            });
            onChange?.(newDriver);
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6f94a88358bd533$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $e6f94a88358bd533$var$PlacholderStyleOverrider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisplayBorder: isDisplayBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1owr16oo _1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw _djrp1mxx",
            !__cmplp.isDisplayBorder && "_18u0196n _hfmuglyw _16daglyw _wadh1otk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eagsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a20f9f04716eb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba9e18fc7e4b7dc6d70a6d3ca1bcf0ee>>
 * @relayHash 1f0e21f625d813fb1281d39baff3148c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855
const $c4a20f9f04716eb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855",
            "metadata": {},
            "name": "ui_updateDriverMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c4a20f9f04716eb3$var$node.hash = "08128527381c648c0856caf35f97d544";
var $c4a20f9f04716eb3$export$2e2bcd8739ae039 = $c4a20f9f04716eb3$var$node;

});

parcelRegister("2UREL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5762fdee3bc3009$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b301f0c56f2e8ec78c0ba5c963f8e2bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c5762fdee3bc3009$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDriverField_DriverField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        "action": "THROW",
                        "path": "project.projectId"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "concreteType": "JiraVersionDriverResult",
            "kind": "LinkedField",
            "name": "driverData",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.accountId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "queryError",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$c5762fdee3bc3009$var$node.hash = "699193bd41c7f6c4d596a3dd505592df";
var $c5762fdee3bc3009$export$2e2bcd8739ae039 = $c5762fdee3bc3009$var$node;

});

parcelRegister("d2gQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $df6d6917998cac56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ce245015522b195c8b0a32bd953b6ff>>
 * @relayHash 1cc363ec0a8878a3883c74210aec4e75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc
const $df6d6917998cac56$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchText"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "searchText",
            "variableName": "searchText"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraVersionDriverConnection",
                                            "kind": "LinkedField",
                                            "name": "suggestedDriversForJiraVersion",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionDriverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.accountId"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.name"
                                                                    },
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraVersionDriverConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedDriversForJiraVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionDriverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc",
            "metadata": {},
            "name": "ui_versionDriverFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$df6d6917998cac56$var$node.hash = "43d45f30b77d193c46e6ddd3e1cb725a";
var $df6d6917998cac56$export$2e2bcd8739ae039 = $df6d6917998cac56$var$node;

});

parcelRegister("jYnpi", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd);

var $2jDha = parcelRequire("2jDha");

var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");

var $uMitL = parcelRequire("uMitL");

var $eUqFw = parcelRequire("eUqFw");

var $3IZWd = parcelRequire("3IZWd");

var $dTS4n = parcelRequire("dTS4n");

var $4dR1n = parcelRequire("4dR1n");

var $fiLGD = parcelRequire("fiLGD");

var $bxvbM = parcelRequire("bxvbM");

var $1mZCo = parcelRequire("1mZCo");

var $ToOs1 = parcelRequire("ToOs1");

var $a1Z9P = parcelRequire("a1Z9P");

var $hompL = parcelRequire("hompL");
class $a9ecfa55df3af3b8$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $hompL.v4)();
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
            (0, $uMitL.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $28t3A.default) : (0, $5wCDk.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bxvbM.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fiLGD.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1Z9P.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mZCo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ToOs1.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3IZWd.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            width: width,
            SelectComponent: SelectComponent,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $dTS4n.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles),
            components: (0, $4dR1n.getComponents)(isMulti, anchor),
            pickerProps: pickerProps
        }))));
    }
}
const $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd = (0, $2jDha.default)()($a9ecfa55df3af3b8$export$164f4d95e5d7e2f5);

});
parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
const $2ab404645f53318b$var$CreatableSelect = (0, $5FjBr.default)((0, $lOwgQ.default));
var $2ab404645f53318b$export$2e2bcd8739ae039 = $2ab404645f53318b$var$CreatableSelect;

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});
parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("fiLGD", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $8c4e3608dc9bf116$export$36f97d8afa97203d);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $8c4e3608dc9bf116$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $8c4e3608dc9bf116$var$isValidNewOption = (isValidEmail = (0, $eL5KE.isValidEmail))=>(inputValue)=>inputValue && $8c4e3608dc9bf116$var$validOption.includes(isValidEmail(inputValue));
const $8c4e3608dc9bf116$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $0b440fae145c26fc$export$6662b3461398ef8c)
        }
    });
const $8c4e3608dc9bf116$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $8c4e3608dc9bf116$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $8c4e3608dc9bf116$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $8c4e3608dc9bf116$var$isValidNewOption(isValidEmail),
        getNewOptionData: $8c4e3608dc9bf116$var$getNewOptionData,
        formatCreateLabel: $8c4e3608dc9bf116$var$formatCreateLabel,
        isOptionDisabled: $8c4e3608dc9bf116$var$isOptionDisabled(isValidEmail)
    };
}
const $8c4e3608dc9bf116$export$36f97d8afa97203d = (0, $5iWql.default)($8c4e3608dc9bf116$var$creatableProps);

});

parcelRegister("bxvbM", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $c7d74c04cc603d9e$export$34b9dd2dd6a225e5);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $c7d74c04cc603d9e$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c7d74c04cc603d9e$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c7d74c04cc603d9e$var$getNewOptionData = (isValidEmail = (0, $eL5KE.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c7d74c04cc603d9e$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $0b440fae145c26fc$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $c7d74c04cc603d9e$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c7d74c04cc603d9e$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c7d74c04cc603d9e$export$34b9dd2dd6a225e5 = (0, $5iWql.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c7d74c04cc603d9e$var$isValidNewOption,
        getNewOptionData: $c7d74c04cc603d9e$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c7d74c04cc603d9e$var$formatCreateLabel,
        isOptionDisabled: $c7d74c04cc603d9e$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("1mZCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bdf5d8ea911c991$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $fgOWi = parcelRequire("fgOWi");
const $5bdf5d8ea911c991$var$EMPTY = {};
const $5bdf5d8ea911c991$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($5bdf5d8ea911c991$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($5bdf5d8ea911c991$var$EMPTY);
        (0, $fgOWi.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5bdf5d8ea911c991$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { children: children } = props;
    const messages = $5bdf5d8ea911c991$var$useI18n(intl.locale);
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $5bdf5d8ea911c991$export$2e2bcd8739ae039 = $5bdf5d8ea911c991$var$MessagesIntlProvider;

});
parcelRegister("fgOWi", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0294972dd0e7529b$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $0294972dd0e7529b$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("baTmd")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("izFzj")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("6SFt8")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("kGmwS")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ilBg0")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("69A6y")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("7PFQm")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("jXj5T")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4KWIq")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("8xtm3")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("l1q1j")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("lFPEu")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("k83ZD")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("84r0w")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5lmmg")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("4TyK7")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("88i5c")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("aMhDi")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7bhXC")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("05cKn")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jRs45")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("gQK5o")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("l0UPQ")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cVaCM")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("f10W2")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("hgyQW")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("eKtFN")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("7v9Lp")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("aQWkV")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0294972dd0e7529b$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("kGmwS")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("baTmd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i0Pe8").then(()=>parcelRequire('or03D'));

});

parcelRegister("izFzj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8BOU0").then(()=>parcelRequire('lNiRt'));

});

parcelRegister("6SFt8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8l0dy").then(()=>parcelRequire('p7JNt'));

});

parcelRegister("kGmwS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bxgOi").then(()=>parcelRequire('eILmt'));

});

parcelRegister("ilBg0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3pgy1").then(()=>parcelRequire('7vzzX'));

});

parcelRegister("69A6y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8W7RH").then(()=>parcelRequire('7Ptvo'));

});

parcelRegister("7PFQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7NgAP").then(()=>parcelRequire('bYcIY'));

});

parcelRegister("jXj5T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ifr0G").then(()=>parcelRequire('2HL4d'));

});

parcelRegister("4KWIq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4TLdl").then(()=>parcelRequire('gBgnK'));

});

parcelRegister("8xtm3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("knvW7").then(()=>parcelRequire('fWgwA'));

});

parcelRegister("l1q1j", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7BTAu").then(()=>parcelRequire('bWAwm'));

});

parcelRegister("lFPEu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kMXHV").then(()=>parcelRequire('bfB2v'));

});

parcelRegister("k83ZD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6szWe").then(()=>parcelRequire('fEK8N'));

});

parcelRegister("84r0w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6nfH5").then(()=>parcelRequire('guy7d'));

});

parcelRegister("5lmmg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hcA4m").then(()=>parcelRequire('8b2sJ'));

});

parcelRegister("4TyK7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dGDd3").then(()=>parcelRequire('3CFXE'));

});

parcelRegister("88i5c", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b1OEX").then(()=>parcelRequire('5OhZL'));

});

parcelRegister("aMhDi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6L31b").then(()=>parcelRequire('2usan'));

});

parcelRegister("7bhXC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aJiHI").then(()=>parcelRequire('fUbQi'));

});

parcelRegister("05cKn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6oIXh").then(()=>parcelRequire('87pIs'));

});

parcelRegister("jRs45", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l6J1G").then(()=>parcelRequire('1Ydae'));

});

parcelRegister("gQK5o", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bYIVb").then(()=>parcelRequire('cNlCa'));

});

parcelRegister("l0UPQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2SONo").then(()=>parcelRequire('24GPb'));

});

parcelRegister("cVaCM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bUOZE").then(()=>parcelRequire('4Zzmi'));

});

parcelRegister("f10W2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b3vK4").then(()=>parcelRequire('cZgsZ'));

});

parcelRegister("hgyQW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("czbsK").then(()=>parcelRequire('eLbuu'));

});

parcelRegister("eKtFN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cdt3f").then(()=>parcelRequire('3UnDQ'));

});

parcelRegister("7v9Lp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jzy6n").then(()=>parcelRequire('7qhnG'));

});

parcelRegister("aQWkV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kukRa").then(()=>parcelRequire('mz9nj'));

});



parcelRegister("ToOs1", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $8f66b178b236b94b$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8f66b178b236b94b$export$c6c0c1a2bac363f);

var $eUqFw = parcelRequire("eUqFw");
const $8f66b178b236b94b$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $8f66b178b236b94b$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f66b178b236b94b$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $8f66b178b236b94b$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eUqFw.useContext)($8f66b178b236b94b$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eUqFw.useState)([]);
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("7Vqtj", function(module, exports) {

$parcel$export(module.exports, "useUpdateDriverExperienceStart", () => $3defb64fd8fe1e21$export$6e6b386771ff8a93);
$parcel$export(module.exports, "useUpdateDriverExperienceFail", () => $3defb64fd8fe1e21$export$a86702725d24ceba);
$parcel$export(module.exports, "useUpdateDriverExperienceSuccess", () => $3defb64fd8fe1e21$export$ce389ea9709547fd);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $3defb64fd8fe1e21$var$EXPERIENCE_NAME = 'updateJiraVersionDriver';
const $3defb64fd8fe1e21$var$SOURCE = 'versionDetails';
const $3defb64fd8fe1e21$export$6e6b386771ff8a93 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $3defb64fd8fe1e21$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $3defb64fd8fe1e21$var$SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $3defb64fd8fe1e21$export$a86702725d24ceba = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $3defb64fd8fe1e21$var$EXPERIENCE_NAME
    });
const $3defb64fd8fe1e21$export$ce389ea9709547fd = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $3defb64fd8fe1e21$var$EXPERIENCE_NAME
    });

});

parcelRegister("8meCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $478a04903161942c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $478a04903161942c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "software-releases-version-driver-field.unassigned",
        "defaultMessage": "Unassigned"
    },
    fieldLabel: {
        "id": "software-releases-version-driver-field.field-label",
        "defaultMessage": "Driver"
    },
    genericErrorFlagTitle: {
        "id": "software-releases-version-driver-field.generic-error-flag-title",
        "defaultMessage": "We couldn't update the version driver."
    },
    genericErrorFlagDescription: {
        "id": "software-releases-version-driver-field.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("5ZuHf", function(module, exports) {

$parcel$export(module.exports, "VersionSummaryDescription", () => $8fbdb7ea41a69a7d$export$e4174f5e9c00a5fc);

var $lyKhY = parcelRequire("lyKhY");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1J9oV = parcelRequire("1J9oV");

var $9cgpw = parcelRequire("9cgpw");
const $8fbdb7ea41a69a7d$export$e4174f5e9c00a5fc = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $lyKhY.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fbdb7ea41a69a7d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200",
        as: "h2"
    }, formatMessage((0, $9cgpw.default).descriptionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fbdb7ea41a69a7d$var$DescriptionContainer, {
        "data-testid": "software-releases-version-summary-description.ui.description-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8fbdb7ea41a69a7d$var$inlinedEditOffsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1J9oV.AsyncEditableVersionSummaryDescription), {
        jiraVersion: version,
        shouldTruncateText: true
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fbdb7ea41a69a7d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $8fbdb7ea41a69a7d$var$DescriptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $8fbdb7ea41a69a7d$var$inlinedEditOffsetStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.negative.100',
    marginLeft: 'space.negative.100'
});

});
parcelRegister("lyKhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79c5c9e745abfd5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<590483254f3e5ae0689c5da4f6f780a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a79c5c9e745abfd5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$a79c5c9e745abfd5$var$node.hash = "ed1e590e92f538e88d28c5f6bba7c77c";
var $a79c5c9e745abfd5$export$2e2bcd8739ae039 = $a79c5c9e745abfd5$var$node;

});

parcelRegister("1J9oV", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableVersionSummaryDescription", () => $3329e54e9e9080e1$export$6da629078e9c0cf3);

var $i6aAj = parcelRequire("i6aAj");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8W7F3 = parcelRequire("8W7F3");

var $8vhIP = parcelRequire("8vhIP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3329e54e9e9080e1$var$LazyEditableSummaryDescription = (0, $7rh0R.lazy)(()=>(parcelRequire("4S9lC")).then((module)=>module.EditableVersionSummaryDescription), {
    moduleId: "./src/packages/releases/version-summary-description/src/ui/editable-version-summary-description/index.tsx"
});
const $3329e54e9e9080e1$export$6da629078e9c0cf3 = ({ jiraVersion: jiraVersion, shouldTruncateText: shouldTruncateText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $i6aAj.default), jiraVersion);
    const descriptionText = version.description !== '' ? version.description : formatMessage((0, $8vhIP.default).descriptionPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "editable-description",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3329e54e9e9080e1$var$InlineEditReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8W7F3.DescriptionContent), {
            descriptionText: descriptionText || '',
            isNonEmpty: !!version.description,
            shouldTruncateText: shouldTruncateText
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3329e54e9e9080e1$var$LazyEditableSummaryDescription, {
        jiraVersion: version,
        shouldTruncateText: shouldTruncateText
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3329e54e9e9080e1$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itj1ic _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i6aAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f796efe5a9741ef5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<61c524636ae7c6db90724329336f57a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f796efe5a9741ef5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$f796efe5a9741ef5$var$node.hash = "2a90bb83f1ef52be3fdf77ad96c33404";
var $f796efe5a9741ef5$export$2e2bcd8739ae039 = $f796efe5a9741ef5$var$node;

});

parcelRegister("8W7F3", function(module, exports) {

$parcel$export(module.exports, "DescriptionContent", () => $334cfce752bcd7b4$export$afe6a96ed909bf0f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ebDNl = parcelRequire("ebDNl");
const $334cfce752bcd7b4$var$TRUNCATE_TEXT_LENGTH = 300;
const $334cfce752bcd7b4$export$afe6a96ed909bf0f = ({ isNonEmpty: isNonEmpty, shouldTruncateText: shouldTruncateText, descriptionText: descriptionText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($334cfce752bcd7b4$var$DescriptionContentContainer, {
        isNonEmpty: isNonEmpty
    }, shouldTruncateText ? (0, (/*@__PURE__*/$parcel$interopDefault($ebDNl)))(descriptionText, {
        length: $334cfce752bcd7b4$var$TRUNCATE_TEXT_LENGTH,
        separator: ' '
    }) : descriptionText);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $334cfce752bcd7b4$var$DescriptionContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNonEmpty: isNonEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt458a2 _slp31hna _o5726vc6 _vwz4cjiy",
            __cmplp.isNonEmpty ? "_syaz1kw7" : "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ebDNl", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $8SGvQ = parcelRequire("8SGvQ");

var $fFFC0 = parcelRequire("fFFC0");

var $feGjZ = parcelRequire("feGjZ");

var $k6zhy = parcelRequire("k6zhy");

var $eQiJU = parcelRequire("eQiJU");

var $aSldm = parcelRequire("aSldm");

var $hNahz = parcelRequire("hNahz");

var $1uqnh = parcelRequire("1uqnh");
/** Used as default options for `_.truncate`. */ var $a540f6345fb61874$var$DEFAULT_TRUNC_LENGTH = 30, $a540f6345fb61874$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $a540f6345fb61874$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $a540f6345fb61874$var$truncate(string, options) {
    var length = $a540f6345fb61874$var$DEFAULT_TRUNC_LENGTH, omission = $a540f6345fb61874$var$DEFAULT_TRUNC_OMISSION;
    if ($feGjZ(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $hNahz(options.length) : length;
        omission = 'omission' in options ? $TLr3n(options.omission) : omission;
    }
    string = $1uqnh(string);
    var strLength = string.length;
    if ($fFFC0(string)) {
        var strSymbols = $aSldm(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $eQiJU(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $8SGvQ(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($k6zhy(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $1uqnh($a540f6345fb61874$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($TLr3n(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $a540f6345fb61874$var$truncate;

});
parcelRegister("k6zhy", function(module, exports) {

var $2b0k8 = parcelRequire("2b0k8");

var $74vSq = parcelRequire("74vSq");

var $2MqHZ = parcelRequire("2MqHZ");
/* Node.js helper references. */ var $ea2fbc79dbd1a9b1$var$nodeIsRegExp = $2MqHZ && $2MqHZ.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $ea2fbc79dbd1a9b1$var$isRegExp = $ea2fbc79dbd1a9b1$var$nodeIsRegExp ? $74vSq($ea2fbc79dbd1a9b1$var$nodeIsRegExp) : $2b0k8;
module.exports = $ea2fbc79dbd1a9b1$var$isRegExp;

});
parcelRegister("2b0k8", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $195cdc22d2f1b49a$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $195cdc22d2f1b49a$var$baseIsRegExp(value) {
    return $hYEMs(value) && $2OY5s(value) == $195cdc22d2f1b49a$var$regexpTag;
}
module.exports = $195cdc22d2f1b49a$var$baseIsRegExp;

});


parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});




parcelRegister("8vhIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4dd3419fb5f1d24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c4dd3419fb5f1d24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionPlaceholder: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.description-placeholder",
        "defaultMessage": "No description added yet."
    },
    errorFlagTitle: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-title",
        "defaultMessage": "We couldn't update the description"
    },
    errorFlagDescription: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    maxDescriptionSizeExceededErrorMessage: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.max-description-size-exceeded-error-message",
        "defaultMessage": "Maximum description size exceeded"
    }
});

});

parcelRegister("4S9lC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2ySv4").then(()=>parcelRequire('ftglY'));

});


parcelRegister("9cgpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ede0a6da8bcc61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $01ede0a6da8bcc61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionHeader: {
        "id": "software-releases-version-summary-description.description-header",
        "defaultMessage": "Description"
    }
});

});


parcelRegister("lR2Nb", function(module, exports) {

$parcel$export(module.exports, "ARCHIVED", () => $a58acf1bca9a6bbd$export$c936349447a77fe0);
$parcel$export(module.exports, "RELEASED", () => $a58acf1bca9a6bbd$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNARCHIVED", () => $a58acf1bca9a6bbd$export$5813036ca984d7f3);
$parcel$export(module.exports, "UNRELEASED", () => $a58acf1bca9a6bbd$export$cb459d726a8530a5);
$parcel$export(module.exports, "FIRST_COLUMN_MIN_WIDTH", () => $a58acf1bca9a6bbd$export$f6fe47beb5520aca);
$parcel$export(module.exports, "SUPPORT_DOCS_LINK_URL", () => $a58acf1bca9a6bbd$export$cfcb17c409b4e552);

var $c9TLT = parcelRequire("c9TLT");
const $a58acf1bca9a6bbd$export$c936349447a77fe0 = 'ARCHIVED';
const $a58acf1bca9a6bbd$export$b983f2cb1f658a55 = 'RELEASED';
const $a58acf1bca9a6bbd$export$5813036ca984d7f3 = 'UNARCHIVED';
const $a58acf1bca9a6bbd$export$cb459d726a8530a5 = 'UNRELEASED';
const $a58acf1bca9a6bbd$export$f6fe47beb5520aca = (0, $c9TLT.gridSize) * 23;
const $a58acf1bca9a6bbd$export$cfcb17c409b4e552 = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a58acf1bca9a6bbd$export$2e2bcd8739ae039 = [
    $a58acf1bca9a6bbd$export$c936349447a77fe0,
    $a58acf1bca9a6bbd$export$b983f2cb1f658a55,
    $a58acf1bca9a6bbd$export$cb459d726a8530a5,
    $a58acf1bca9a6bbd$export$5813036ca984d7f3
];

});

parcelRegister("jC0OR", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $c928dfdafef5ab52$export$1625b7ea4c7a5a23);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $c928dfdafef5ab52$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesLaunchCard",
        teamName: "fusion-solaris",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("fQtxa", function(module, exports) {

$parcel$export(module.exports, "LatestDeployment", () => $9f0b219d7f4e8839$export$4c54e4ee90dcb7e7);

var $1dH2n = parcelRequire("1dH2n");

var $1VsO4 = parcelRequire("1VsO4");

var $jG1YX = parcelRequire("jG1YX");

var $cOePM = parcelRequire("cOePM");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3e6lq = parcelRequire("3e6lq");
var $jtnES = parcelRequire("jtnES");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");
var $4pEpX = parcelRequire("4pEpX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jG1YX = parcelRequire("jG1YX");

var $lB25E = parcelRequire("lB25E");

var $lR2Nb = parcelRequire("lR2Nb");

var $euFtm = parcelRequire("euFtm");

var $jq7vW = parcelRequire("jq7vW");

var $kNBFz = parcelRequire("kNBFz");

var $6f59c = parcelRequire("6f59c");

var $iuua3 = parcelRequire("iuua3");
const $9f0b219d7f4e8839$export$9fbf3675ff70ff0 = ({ jiraVersion: jiraVersion, queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const deploymentsRoute = (0, $euFtm.useDeploymentsRoute)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const version = (0, $iWLL0.useFragment)((0, $cOePM.default), jiraVersion);
    const isMoreThanAWeekApart = (a, b)=>{
        const oneWeekInMilliseconds = 604800000;
        return (0, $3e6lq.default)(a, b) > oneWeekInMilliseconds;
    };
    const data = (0, $iWLL0.usePreloadedQuery)((0, $jG1YX.default), queryReference);
    const deploymentNodes = data.devOps.ariGraph.relationships.edges.filter(Boolean).map((edge)=>edge.node);
    const renderLink = (content, hasNoRecentDeployments)=>hasNoRecentDeployments ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f0b219d7f4e8839$var$StyledLink, {
            href: (0, $lR2Nb.SUPPORT_DOCS_LINK_URL),
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            target: "_blank"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f0b219d7f4e8839$var$StyledLink, {
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            prefetch: "hover",
            params: {
                projectKey: version.project.key
            },
            query: {
                startDate: '-3m',
                endDate: 'now',
                fixVersions: version.name
            },
            to: deploymentsRoute
        }, content);
    const latestDeployment = deploymentNodes[0]?.to.data;
    const hasNoDeploymentInLastWeek = latestDeployment?.lastUpdated ? isMoreThanAWeekApart(new Date(), new Date(latestDeployment.lastUpdated)) : true;
    let linkContent = null;
    if (latestDeployment == null) linkContent = formatMessage((0, $6f59c.default).noDeployments);
    else if (latestDeployment.lastUpdated !== undefined) {
        if (hasNoDeploymentInLastWeek) linkContent = formatMessage((0, $6f59c.default).noDeployments);
        else linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $6f59c.default).lastDeployment), (0, $jtnES.default)(new Date(latestDeployment.lastUpdated), new Date(), {
            addSuffix: true,
            roundingMethod: 'floor'
        }));
    }
    const [providersListQuery, loadProvidersListQuery] = (0, $iuua3.useLoadProvidersListQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default // @ts-expect-error - TS3233 - unsure why it doesn't like my tooltip :|
    ), {
        component: $9f0b219d7f4e8839$var$CustomTooltip,
        content: hasNoDeploymentInLastWeek && providersListQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iuua3.ProvidersList), {
            queryReference: providersListQuery
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jq7vW.DeploymentTooltipContent), {
            jiraVersion: version,
            deployment: latestDeployment
        }),
        onShow: (analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, hasNoDeploymentInLastWeek && providersListQuery ? 'latestDeploymentInVersionProvidersTooltip' : 'latestDeploymentInVersionDetailsTooltip');
        }
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f0b219d7f4e8839$var$Wrapper, {
            ...tooltipProps,
            onMouseOver: (event)=>{
                tooltipProps.onMouseOver(event);
                if (hasNoDeploymentInLastWeek) loadProvidersListQuery();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNBFz.PulseIcon), null), linkContent && renderLink(linkContent, latestDeployment == null || hasNoDeploymentInLastWeek)));
};
const $9f0b219d7f4e8839$export$4c54e4ee90dcb7e7 = ({ jiraVersion: jiraVersion, preconditionQueryRef: preconditionQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $1VsO4.default), jiraVersion);
    const { jira: { deploymentsFeaturePreconditionByProjectKey: deploymentsFeaturePreconditionByProjectKey } } = (0, $iWLL0.usePreloadedQuery)((0, $1dH2n.default), preconditionQueryRef);
    const [queryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $jG1YX.default));
    (0, $eUqFw.useEffect)(()=>{
        if (deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED') loadQuery({
            from: version.id
        });
    }, [
        deploymentsFeaturePreconditionByProjectKey,
        version.id,
        loadQuery
    ]);
    return deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "latest-deployment-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f0b219d7f4e8839$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNBFz.PulseIcon), null), formatMessage((0, $6f59c.default).loading))
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f0b219d7f4e8839$export$9fbf3675ff70ff0, {
        jiraVersion: version,
        queryReference: queryRef
    })) : null;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f0b219d7f4e8839$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f0b219d7f4e8839$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _11q71yrq _1e0c1txw _zulpu2gc _1yt44ar7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f0b219d7f4e8839$var$CustomTooltip = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4pEpX.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _16qsjdvv _vchh18uv _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1VsO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c2de769209e481$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77f1e70ec27936e5cf3f69a6a6c7a721>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12c2de769209e481$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$12c2de769209e481$var$node.hash = "9635192fd480eb66a7ef3d1c281498c0";
var $12c2de769209e481$export$2e2bcd8739ae039 = $12c2de769209e481$var$node;

});

parcelRegister("jG1YX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef39c0182b62ab03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<855bffdf0a0ebd0d581a3f4d15327342>>
 * @relayHash 4c378178746771081cd0d544a68b161d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f22a1f87c0835eeb644c45a7e790c9dcb473ce5783334aed5e082d45ceeac51
const $ef39c0182b62ab03$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "from"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "from",
            "variableName": "from"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastUpdatedSortDirection": "DESC"
            }
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "version-associated-deployment"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "AriGraph",
                                    "kind": "LinkedField",
                                    "name": "ariGraph",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v1 /*: any*/ ,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "relationships",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "AriGraphRelationshipEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "AriGraphRelationship",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v2 /*: any*/ ,
                                                                                                                "action": "THROW",
                                                                                                                "path": "devOps.ariGraph.relationships.edges.node.to.data.lastUpdated"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "FragmentSpread",
                                                                                                                "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "DeploymentSummary"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "THROW",
                                                                                            "path": "devOps.ariGraph.relationships.edges.node.to.data"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "devOps.ariGraph.relationships.edges.node.to"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "devOps.ariGraph.relationships.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.ariGraph.relationships.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.ariGraph.relationships"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.ariGraph"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "environment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "displayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "issueIds"
                                                                                }
                                                                            ],
                                                                            "type": "DeploymentSummary"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "ConfluenceSpace"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1f22a1f87c0835eeb644c45a7e790c9dcb473ce5783334aed5e082d45ceeac51",
            "metadata": {},
            "name": "latestDeploymentForVersionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ef39c0182b62ab03$var$node.hash = "804051e6b542c6dc7bf401419bdfe7f9";
var $ef39c0182b62ab03$export$2e2bcd8739ae039 = $ef39c0182b62ab03$var$node;

});

parcelRegister("cOePM", function(module, exports) {

$parcel$export(module.exports, "default", () => $39da4a1fccfb97b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebfd8958a9f620c0b5965b0317d16e8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $39da4a1fccfb97b4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "FragmentSpread",
            "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$39da4a1fccfb97b4$var$node.hash = "636e16e48d5710e3c9d238bef208f75d";
var $39da4a1fccfb97b4$export$2e2bcd8739ae039 = $39da4a1fccfb97b4$var$node;

});

parcelRegister("euFtm", function(module, exports) {

$parcel$export(module.exports, "useDeploymentsRoute", () => $4ce5bd2e3824d965$export$7a17d870b2f984df);

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");
const $4ce5bd2e3824d965$export$7a17d870b2f984df = ()=>{
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const routeName = project?.simplified ? (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS) : (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC);
    return (0, $10fdS.useRouteByName)(routeName) ?? routeName;
};

});

parcelRegister("jq7vW", function(module, exports) {

$parcel$export(module.exports, "DeploymentTooltipContent", () => $a4bd54f3f609129e$export$c36a118f96728a11);

var $3v4s6 = parcelRequire("3v4s6");

var $cjyRG = parcelRequire("cjyRG");

var $eUqFw = parcelRequire("eUqFw");

var $jtnES = parcelRequire("jtnES");

var $iWLL0 = parcelRequire("iWLL0");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $e9Jo2 = parcelRequire("e9Jo2");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3oKhY = parcelRequire("3oKhY");

var $lB25E = parcelRequire("lB25E");

var $euFtm = parcelRequire("euFtm");

var $fbhRR = parcelRequire("fbhRR");

var $4PD9l = parcelRequire("4PD9l");
const $a4bd54f3f609129e$export$c36a118f96728a11 = ({ deployment: deployment, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $cjyRG.default), jiraVersion);
    const { lastUpdated: lastUpdated, environment: environment, state: state, issueIds: issueIds } = (0, $iWLL0.useFragment)((0, $3v4s6.default), deployment);
    const deploymentsRoute = (0, $euFtm.useDeploymentsRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupTitle), null, formatMessage((0, $fbhRR.default).deploymentPopupTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $a4bd54f3f609129e$var$headerStatusIconAndLozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $a4bd54f3f609129e$var$headerStatusIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
        deploymentState: (0, $4PD9l.mapDeploymentState)(state, environment.category),
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: (0, $4PD9l.mapStateToLozengeProp)(state)
    }, state))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.LinkContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a4bd54f3f609129e$var$environmentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p",
        weight: "bold"
    }, (0, $4PD9l.capitalizeOnlyFirstLetter)(environment.category), environment.displayName ? ` (${environment.displayName})` : ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $a4bd54f3f609129e$var$environmentDetailStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, (0, $jtnES.default)(new Date(lastUpdated), new Date(), {
        addSuffix: true,
        roundingMethod: 'floor'
    })), issueIds == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $a4bd54f3f609129e$var$environmentDetailBetweenMarginStyles
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $a4bd54f3f609129e$var$environmentDetailBetweenMarginStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $fbhRR.default).issuesDeployed, {
        issueCount: issueIds.length
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupOverflowSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupKeyline), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupOverflowButton), {
        component: (0, $lB25E.Link),
        appearance: "link",
        // @ts-expect-error - TS2322 - Problem with `Button` types, in practice this gets forwarded to the `Link`
        prefetch: "hover",
        params: {
            projectKey: version.project.key
        },
        query: {
            startDate: '-3m',
            endDate: 'now',
            fixVersions: version.name
        },
        to: deploymentsRoute,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'latestDeploymentInVersionDetailsTooltipLink');
        }
    }, formatMessage((0, $fbhRR.default).viewAllDeployments))));
};
const $a4bd54f3f609129e$var$headerStatusIconAndLozengeStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    justifyContent: 'end',
    alignItems: 'center'
});
const $a4bd54f3f609129e$var$headerStatusIconStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100',
    justifyContent: 'center',
    alignItems: 'center'
});
const $a4bd54f3f609129e$var$environmentStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $a4bd54f3f609129e$var$environmentDetailStyles = (0, $1ZAYh.xcss)({
    height: '16px',
    lineHeight: '16px',
    marginBottom: 'space.100',
    marginTop: 'space.0'
});
const $a4bd54f3f609129e$var$environmentDetailBetweenMarginStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("3v4s6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c76a79ab39041791$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10c719c98390f5498900124b91a968f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c76a79ab39041791$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "state"
            },
            "action": "THROW",
            "path": "state"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "environment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "THROW",
                        "path": "environment.category"
                    }
                ]
            },
            "action": "THROW",
            "path": "environment"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "lastUpdated"
            },
            "action": "THROW",
            "path": "lastUpdated"
        },
        {
            "kind": "ScalarField",
            "name": "issueIds"
        }
    ],
    "type": "DeploymentSummary"
};
$c76a79ab39041791$var$node.hash = "f474689f31fc91d3dfb760e1b811618d";
var $c76a79ab39041791$export$2e2bcd8739ae039 = $c76a79ab39041791$var$node;

});

parcelRegister("cjyRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $89e4206377696373$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2ef2fde713507dbf018acf99cdd24e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89e4206377696373$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        }
    ],
    "type": "JiraVersion"
};
$89e4206377696373$var$node.hash = "fc05ee90d6c0521ade9b87e6185e0b92";
var $89e4206377696373$export$2e2bcd8739ae039 = $89e4206377696373$var$node;

});

parcelRegister("e9Jo2", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $4d67de45504f6b7f$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $4d67de45504f6b7f$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $4d67de45504f6b7f$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $4d67de45504f6b7f$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $4d67de45504f6b7f$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $4d67de45504f6b7f$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $4d67de45504f6b7f$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $4d67de45504f6b7f$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $4d67de45504f6b7f$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $4d67de45504f6b7f$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $4d67de45504f6b7f$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $dnbhd = parcelRequire("dnbhd");
const $4d67de45504f6b7f$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$30301703d55848e7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$80b51772092eddc0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d67de45504f6b7f$export$80b51772092eddc0, props));
const $4d67de45504f6b7f$export$9048d548939551ee = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $dnbhd.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1igg _syaz1y58 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$a0765d4427758c62 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _bfhk1wws _otyrutpp",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});


parcelRegister("3oKhY", function(module, exports) {

$parcel$export(module.exports, "DeploymentIcons", () => $8bdf916238e64d28$export$5202eabf0ef214b4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $90EwC = parcelRequire("90EwC");

var $5FxEu = parcelRequire("5FxEu");

var $2VvCK = parcelRequire("2VvCK");

var $172mV = parcelRequire("172mV");

var $5xL3w = parcelRequire("5xL3w");

var $4R69K = parcelRequire("4R69K");

var $6DPSE = parcelRequire("6DPSE");

var $jV3Wn = parcelRequire("jV3Wn");

var $3275y = parcelRequire("3275y");
const $8bdf916238e64d28$export$16b26cd5e98d9100 = (state)=>{
    switch(state){
        case (0, $jV3Wn.DeploymentStateOptions).PENDING:
            return 0, $172mV.default;
        case (0, $jV3Wn.DeploymentStateOptions).IN_PROGRESS:
            return 0, $2VvCK.default;
        case (0, $jV3Wn.DeploymentStateOptions).SUCCESSFUL:
            return 0, $6DPSE.default;
        case (0, $jV3Wn.DeploymentStateOptions).SUCCESSFULNONPRODUCTION:
            return 0, $4R69K.default;
        case (0, $jV3Wn.DeploymentStateOptions).CANCELLED:
            return 0, $90EwC.default;
        case (0, $jV3Wn.DeploymentStateOptions).FAILED:
            return 0, $5FxEu.default;
        case (0, $jV3Wn.DeploymentStateOptions).ROLLED_BACK:
            return 0, $5xL3w.default;
        case (0, $jV3Wn.DeploymentStateOptions).UNKNOWN:
            return 0, $3275y.default;
        default:
            throw Error(`Unhandled deployment state - ${state}`);
    }
};
const $8bdf916238e64d28$export$c7835fd8b8ca1d68 = {
    width: '20',
    height: '20',
    padding: '2'
};
const $8bdf916238e64d28$export$148e312beb132853 = {
    width: '16',
    height: '16',
    padding: '0'
};
const $8bdf916238e64d28$export$31b21d0167753bb4 = (state)=>{
    switch(state){
        case 'small':
            return $8bdf916238e64d28$export$148e312beb132853;
        case 'medium':
            return $8bdf916238e64d28$export$c7835fd8b8ca1d68;
        default:
            return $8bdf916238e64d28$export$148e312beb132853;
    }
};
const $8bdf916238e64d28$export$5202eabf0ef214b4 = ({ deploymentState: deploymentState, size: size })=>{
    const Icon = $8bdf916238e64d28$export$16b26cd5e98d9100(deploymentState);
    const iconSize = $8bdf916238e64d28$export$31b21d0167753bb4(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bdf916238e64d28$var$Wrapper, {
        "data-testid": `software-deployments-icons-common.ui.wrapper-${deploymentState}`,
        width: iconSize.width,
        height: iconSize.height,
        padding: iconSize.padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bdf916238e64d28$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { padding: padding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height, "px"),
            "--_fl6vf6": (0, $9t7rW.default)(__cmplp.padding, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1rkg _4t3i1474 _19pk1wug _2hwxidpf _otyr1wug _18u0idpf _1yt4gesh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90EwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede440a3dd103644$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $ede440a3dd103644$var$cancelledIcon = `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`;
const $ede440a3dd103644$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $ede440a3dd103644$var$CancelledIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $ede440a3dd103644$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.184 9h8V7h-8v2zm11.367-4.102a8.039 8.039 0 0 0-1.703-2.546A8.122 8.122 0 0 0 11.293.641 7.769 7.769 0 0 0 8.184 0a7.789 7.789 0 0 0-3.102.633 8.043 8.043 0 0 0-2.547 1.703A8.11 8.11 0 0 0 .824 4.891 7.747 7.747 0 0 0 .184 8c0 1.083.211 2.117.632 3.102.422.984.99 1.833 1.704 2.546a8.084 8.084 0 0 0 2.554 1.711 7.766 7.766 0 0 0 3.11.641 7.788 7.788 0 0 0 3.101-.633 8.043 8.043 0 0 0 2.547-1.703 8.133 8.133 0 0 0 1.711-2.555A7.765 7.765 0 0 0 16.184 8a7.796 7.796 0 0 0-.633-3.102z",
        fill: $ede440a3dd103644$var$cancelledIcon,
        fillRule: "evenodd"
    }));
$ede440a3dd103644$var$CancelledIcon.displayName = 'CancelledIcon';
var $ede440a3dd103644$export$2e2bcd8739ae039 = $ede440a3dd103644$var$CancelledIcon;

});

parcelRegister("5FxEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1f3716fc3673e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $ce1f3716fc3673e9$var$failedColor = `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
const $ce1f3716fc3673e9$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $ce1f3716fc3673e9$var$FailedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "6",
        cx: "8",
        cy: "8",
        fill: $ce1f3716fc3673e9$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $ce1f3716fc3673e9$var$failedColor,
        fillRule: "evenodd",
        d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
$ce1f3716fc3673e9$var$FailedIcon.displayName = 'FailedIcon';
var $ce1f3716fc3673e9$export$2e2bcd8739ae039 = $ce1f3716fc3673e9$var$FailedIcon;

});

parcelRegister("2VvCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e5767ae44dbd10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $c7e5767ae44dbd10$var$inProgressColor = `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
const $c7e5767ae44dbd10$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $c7e5767ae44dbd10$var$InProgressIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7e5767ae44dbd10$var$SpinningSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $c7e5767ae44dbd10$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $c7e5767ae44dbd10$var$inProgressColor,
        d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 12.444A4.445 4.445 0 013.556 8a.889.889 0 111.777 0A2.667 2.667 0 008 10.667a.888.888 0 110 1.777zm3.556-3.555a.889.889 0 01-.89-.889A2.667 2.667 0 008 5.333a.889.889 0 010-1.777A4.445 4.445 0 0112.444 8a.888.888 0 01-.888.889z"
    }));
$c7e5767ae44dbd10$var$InProgressIcon.displayName = 'InProgressIcon';
var $c7e5767ae44dbd10$export$2e2bcd8739ae039 = $c7e5767ae44dbd10$var$InProgressIcon;
const $c7e5767ae44dbd10$var$spin = null;
// 1.5s matches the same animation on bitbucket for builds
const $c7e5767ae44dbd10$var$spinAnimation = `${$c7e5767ae44dbd10$var$spin} 1.5s linear infinite`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e5767ae44dbd10$var$SpinningSvg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1xz6pnn": (0, $9t7rW.default)($c7e5767ae44dbd10$var$spinAnimation)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y44v1wf2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("172mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c798ddbfac1954e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $2c798ddbfac1954e$var$pendingColor = `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
const $2c798ddbfac1954e$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $2c798ddbfac1954e$var$PendingIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $2c798ddbfac1954e$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $2c798ddbfac1954e$var$pendingColor,
        d: "M13.657 2.343A8 8 0 102.343 13.657 8 8 0 0013.657 2.343zm-2.308 9.006a1 1 0 01-1.389.024L7.294 8.707a.988.988 0 01-.217-.325l.002.007-.005-.013.003.006A.993.993 0 017 8V4a1 1 0 012 0v3.587l2.373 2.373a1 1 0 01-.024 1.389z"
    }));
$2c798ddbfac1954e$var$PendingIcon.displayName = 'PendingIcon';
var $2c798ddbfac1954e$export$2e2bcd8739ae039 = $2c798ddbfac1954e$var$PendingIcon;

});

parcelRegister("5xL3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f24f22a5783234$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $49f24f22a5783234$var$rolledBackColor = `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y400})`;
const $49f24f22a5783234$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $49f24f22a5783234$var$RolledBackIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $49f24f22a5783234$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $49f24f22a5783234$var$rolledBackColor,
        fillRule: "evenodd",
        d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7.707 3.293a1 1 0 010 1.414L7.414 5H8.6C10.516 5 12 6.606 12 8.5S10.516 12 8.6 12H7a1 1 0 110-2h1.6c.735 0 1.4-.633 1.4-1.5S9.335 7 8.6 7H7.414l.293.293a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414l2-2a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
$49f24f22a5783234$var$RolledBackIcon.displayName = 'RolledBackIcon';
var $49f24f22a5783234$export$2e2bcd8739ae039 = $49f24f22a5783234$var$RolledBackIcon;

});

parcelRegister("4R69K", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f279b31bea95d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $05f279b31bea95d3$var$successColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $05f279b31bea95d3$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $05f279b31bea95d3$var$SuccessNonProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $05f279b31bea95d3$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $05f279b31bea95d3$var$successColor,
        fillRule: "evenodd",
        d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm2 0A8 8 0 110 8a8 8 0 0116 0zm-4.293-1.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$05f279b31bea95d3$var$SuccessNonProductionIcon.displayName = 'SuccessNonProductionIcon';
var $05f279b31bea95d3$export$2e2bcd8739ae039 = $05f279b31bea95d3$var$SuccessNonProductionIcon;

});

parcelRegister("6DPSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d2b4a7cc011df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $907d2b4a7cc011df$var$successColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $907d2b4a7cc011df$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $907d2b4a7cc011df$var$SuccessProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $907d2b4a7cc011df$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $907d2b4a7cc011df$var$successColor,
        fillRule: "evenodd",
        d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$907d2b4a7cc011df$var$SuccessProductionIcon.displayName = 'SuccessProductionIcon';
var $907d2b4a7cc011df$export$2e2bcd8739ae039 = $907d2b4a7cc011df$var$SuccessProductionIcon;

});

parcelRegister("jV3Wn", function(module, exports) {

$parcel$export(module.exports, "DeploymentStateOptions", () => $a6f4e1105c83e0f3$export$a761da6c19e008f6);
const $a6f4e1105c83e0f3$var$PENDING = 'PENDING';
const $a6f4e1105c83e0f3$var$IN_PROGRESS = 'IN_PROGRESS';
const $a6f4e1105c83e0f3$var$SUCCESSFUL = 'SUCCESSFUL';
const $a6f4e1105c83e0f3$var$SUCCESSFULNONPRODUCTION = 'SUCCESSFULNONPRODUCTION';
const $a6f4e1105c83e0f3$var$CANCELLED = 'CANCELLED';
const $a6f4e1105c83e0f3$var$FAILED = 'FAILED';
const $a6f4e1105c83e0f3$var$ROLLED_BACK = 'ROLLED_BACK';
const $a6f4e1105c83e0f3$var$UNKNOWN = 'UNKNOWN';
const $a6f4e1105c83e0f3$export$a761da6c19e008f6 = {
    PENDING: $a6f4e1105c83e0f3$var$PENDING,
    IN_PROGRESS: $a6f4e1105c83e0f3$var$IN_PROGRESS,
    SUCCESSFUL: $a6f4e1105c83e0f3$var$SUCCESSFUL,
    SUCCESSFULNONPRODUCTION: $a6f4e1105c83e0f3$var$SUCCESSFULNONPRODUCTION,
    CANCELLED: $a6f4e1105c83e0f3$var$CANCELLED,
    FAILED: $a6f4e1105c83e0f3$var$FAILED,
    ROLLED_BACK: $a6f4e1105c83e0f3$var$ROLLED_BACK,
    UNKNOWN: $a6f4e1105c83e0f3$var$UNKNOWN
};

});

parcelRegister("3275y", function(module, exports) {

$parcel$export(module.exports, "default", () => $258a218a3e327f9b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $258a218a3e327f9b$var$unknownColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $258a218a3e327f9b$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $258a218a3e327f9b$var$Unknown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $258a218a3e327f9b$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "path-1-inside-1",
        fill: $258a218a3e327f9b$var$backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        d: "M15.367 4.898a8.039 8.039 0 00-1.703-2.546A8.118 8.118 0 0011.11.641 7.777 7.777 0 008 0a7.784 7.784 0 00-3.101.633 8.032 8.032 0 00-2.547 1.703A8.11 8.11 0 00.641 4.891 7.748 7.748 0 000 8c0 1.083.211 2.117.633 3.102a8.022 8.022 0 001.703 2.546 8.1 8.1 0 002.555 1.711A7.762 7.762 0 008 16a7.796 7.796 0 003.102-.633 8.055 8.055 0 002.547-1.703 8.15 8.15 0 001.711-2.555C15.786 10.12 16 9.083 16 8a7.796 7.796 0 00-.633-3.102z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $258a218a3e327f9b$var$unknownColor,
        d: "M11.11.641l.793-1.836H11.9L11.11.64zM4.899.633l.788 1.838L4.9.633zM.641 4.891l1.836.794v-.002L.641 4.891zm-.008 6.211l-1.838.788 1.838-.788zm1.703 2.546l1.415-1.413-.002-.002-1.413 1.415zm2.555 1.711l.793-1.836-.793 1.836zm6.211.008l.788 1.838-.788-1.838zm2.547-1.703l1.413 1.415.002-.002-1.415-1.413zm1.711-2.555l1.836.794V11.9l-1.836-.791zm1.845-7A10.037 10.037 0 0015.078.939L12.25 3.766a6.041 6.041 0 011.279 1.92l3.676-1.576zM15.078.939a10.116 10.116 0 00-3.175-2.133l-1.586 3.672a6.12 6.12 0 011.933 1.29l2.828-2.83zm-3.177-2.134A9.777 9.777 0 008-2v4c.811 0 1.578.159 2.319.478L11.9-1.196zM8-2a9.784 9.784 0 00-3.89.795L5.688 2.47A5.784 5.784 0 018 2v-4zm-3.889.795A10.031 10.031 0 00.938.922L3.766 3.75a6.034 6.034 0 011.92-1.279L4.112-1.205zM.938.922a10.11 10.11 0 00-2.133 3.177l3.672 1.584a6.113 6.113 0 011.29-1.933L.936.922zm-2.132 3.175A9.748 9.748 0 00-2 8h4c0-.813.158-1.58.476-2.315l-3.67-1.588zM-2 8c0 1.35.265 2.653.795 3.89l3.676-1.576A5.796 5.796 0 012 8h-4zm.795 3.89a10.021 10.021 0 002.128 3.173l2.826-2.83a6.024 6.024 0 01-1.278-1.92l-3.676 1.577zM.92 15.061a10.1 10.1 0 003.178 2.134l1.584-3.672a6.1 6.1 0 01-1.932-1.288L.921 15.06zm3.177 2.134A9.763 9.763 0 008 18v-4a5.76 5.76 0 01-2.316-.477l-1.586 3.672zM8 18c1.35 0 2.653-.265 3.89-.795l-1.576-3.676C9.581 13.843 8.815 14 8 14v4zm3.89-.795a10.054 10.054 0 003.172-2.126l-2.826-2.83a6.056 6.056 0 01-1.922 1.28l1.576 3.676zm3.174-2.128c.902-.903 1.61-1.969 2.132-3.174l-3.672-1.588a6.152 6.152 0 01-1.29 1.936l2.83 2.826zm2.133-3.177A9.78 9.78 0 0018 8h-4c0 .812-.159 1.58-.477 2.318l3.674 1.582zM18 8c0-1.35-.265-2.653-.795-3.89L13.53 5.686C13.843 6.419 14 7.185 14 8h4z",
        mask: "url(#path-1-inside-1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $258a218a3e327f9b$var$unknownColor,
        d: "M5.419 6.425h1.456c.032-.607.44-1 1.058-1 .612 0 1.02.371 1.02.882 0 .51-.21.773-.902 1.187-.741.435-1.037.918-.967 1.761l.01.312h1.424v-.285c0-.526.199-.79.913-1.203.758-.446 1.15-1.01 1.15-1.82 0-1.225-1.016-2.08-2.552-2.08-1.649 0-2.583.924-2.61 2.246zm2.444 5.73c.601 0 .972-.343.972-.896 0-.559-.37-.903-.972-.903s-.978.344-.978.903c0 .553.376.897.978.897z"
    }));
$258a218a3e327f9b$var$Unknown.displayName = 'Unknown';
var $258a218a3e327f9b$export$2e2bcd8739ae039 = $258a218a3e327f9b$var$Unknown;

});


parcelRegister("fbhRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $caea0c250786bcb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $caea0c250786bcb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deploymentPopupTitle: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title",
        "defaultMessage": "Deployment"
    },
    viewAllDeployments: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments",
        "defaultMessage": "View all deployments"
    },
    issuesDeployed: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} deployed"
    }
});

});

parcelRegister("4PD9l", function(module, exports) {

$parcel$export(module.exports, "capitalizeOnlyFirstLetter", () => $5163d2dcd2add7c3$export$1f9f0c721cdd6cac);
$parcel$export(module.exports, "mapDeploymentState", () => $5163d2dcd2add7c3$export$e46eedc73b6bf584);
$parcel$export(module.exports, "mapStateToLozengeProp", () => $5163d2dcd2add7c3$export$bb72fc1de2630393);

var $ltmWH = parcelRequire("ltmWH");

var $kociE = parcelRequire("kociE");

var $jV3Wn = parcelRequire("jV3Wn");
const $5163d2dcd2add7c3$export$1f9f0c721cdd6cac = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($kociE)))((0, (/*@__PURE__*/$parcel$interopDefault($ltmWH)))(str));
const $5163d2dcd2add7c3$export$e46eedc73b6bf584 = (state, environmentCategory)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
        case 'ROLLED_BACK':
        case 'CANCELLED':
        case 'FAILED':
            return state;
        case 'SUCCESSFUL':
            if (environmentCategory !== 'PRODUCTION') return (0, $jV3Wn.DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
            return state;
        default:
            return (0, $jV3Wn.DeploymentStateOptions).UNKNOWN;
    }
};
const $5163d2dcd2add7c3$export$bb72fc1de2630393 = (state)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
            return 'inprogress';
        case 'ROLLED_BACK':
        case 'CANCELLED':
            return 'moved';
        case 'FAILED':
            return 'removed';
        case 'SUCCESSFUL':
        default:
            return 'success';
    }
};

});
parcelRegister("ltmWH", function(module, exports) {

var $lrLC2 = parcelRequire("lrLC2");
/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */ var $fa1e1af516aa88e3$var$lowerCase = $lrLC2(function(result, word, index) {
    return result + (index ? ' ' : '') + word.toLowerCase();
});
module.exports = $fa1e1af516aa88e3$var$lowerCase;

});



parcelRegister("kNBFz", function(module, exports) {

$parcel$export(module.exports, "PulseIcon", () => $bbb0913d4a8c0049$export$821b06bbcfc0bc3c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");


var $c9TLT = parcelRequire("c9TLT");
const $bbb0913d4a8c0049$export$f27fc5fc552d177d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: (0, $c9TLT.gridSize) * 2,
        height: (0, $c9TLT.gridSize) * 2,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M2 8.70457H5.81067L7.7095 4L8.7403 12L10.5306 7.07724H14",
        stroke: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $bbb0913d4a8c0049$export$821b06bbcfc0bc3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bbb0913d4a8c0049$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $bbb0913d4a8c0049$export$f27fc5fc552d177d,
        size: "medium",
        label: ""
    }));
const $bbb0913d4a8c0049$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6f59c", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b96293d189117dc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b96293d189117dc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noDeployments: {
        "id": "software-releases-launch-card.latest-deployment.no-deployments",
        "defaultMessage": "No deployments for the last week"
    },
    lastDeployment: {
        "id": "software-releases-launch-card.latest-deployment.last-deployment",
        "defaultMessage": "Last deployment: "
    },
    loading: {
        "id": "software-releases-launch-card.latest-deployment.loading",
        "defaultMessage": "Loading..."
    }
});

});

parcelRegister("iuua3", function(module, exports) {

$parcel$export(module.exports, "useLoadProvidersListQuery", () => $53a43db090d1bfc0$export$8544c7d4cd7544c3);
$parcel$export(module.exports, "ProvidersList", () => $53a43db090d1bfc0$export$82486456ea9f13cc);

var $jln7Z = parcelRequire("jln7Z");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $aWvIp = parcelRequire("aWvIp");

var $4Bees = parcelRequire("4Bees");


var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $huI7r = parcelRequire("huI7r");

var $jln7Z = parcelRequire("jln7Z");

var $dWLk9 = parcelRequire("dWLk9");

var $lR2Nb = parcelRequire("lR2Nb");

var $5CxBx = parcelRequire("5CxBx");

var $eD3NW = parcelRequire("eD3NW");
const $53a43db090d1bfc0$export$8544c7d4cd7544c3 = ()=>{
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $jln7Z.default));
    const cloudId = (0, $dWLk9.useCloudId)();
    const loadProvidersListQuery = ()=>{
        if (queryReference == null) loadQuery({
            cloudId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: cloudId
            })
        });
    };
    return [
        queryReference,
        loadProvidersListQuery
    ];
};
const $53a43db090d1bfc0$export$6bc5a3de56260df3 = ({ queryReference: queryReference })=>{
    const { devOps: devOps } = (0, $iWLL0.usePreloadedQuery)((0, $jln7Z.default), queryReference);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { deploymentProviders: deploymentProviders } = devOps.providers;
    const renderProvidersConnectedMessage = ()=>{
        switch(deploymentProviders.length){
            case 1:
                return formatMessage((0, $5CxBx.default).oneProviderIsConnected, {
                    providerName: deploymentProviders[0]?.name
                });
            case 2:
                return formatMessage((0, $5CxBx.default).twoProvidersAreConnected);
            default:
                return formatMessage((0, $5CxBx.default).threeOrMoreProvidersAreConnected);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$ProviderList, null, deploymentProviders.filter(Boolean).slice(0, 3).map((provider)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$LogoContainer, {
            key: provider.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eD3NW.ProviderLogo), {
            provider: provider
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$CheckIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, renderProvidersConnectedMessage()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$DetailText, null, formatMessage((0, $5CxBx.default).setUpDeploymentsDetail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$LinkText, {
        href: (0, $lR2Nb.SUPPORT_DOCS_LINK_URL),
        target: "_blank"
    }, formatMessage((0, $5CxBx.default).supportLinkText)));
};
const $53a43db090d1bfc0$export$82486456ea9f13cc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "providers-list-inner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53a43db090d1bfc0$export$6bc5a3de56260df3, {
        queryReference: props.queryReference
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1lze _vchhusvi _1yt4xy5q _y3gn1h6o _syaz1wmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$ProviderList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _otyrutpp _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$LogoContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _79apxmi2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$DetailText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4381o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$CheckIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1bsb1tcg _4t3i1tcg _bfhkvuon _2rko1osq _154ir5cr _1xi2r5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53a43db090d1bfc0$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1y58",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jln7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3ce251ae0f82d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484fd7fef369b6ade30fe6cb89abc829>>
 * @relayHash efe9f1db11e6de328e9f1549d3bf2dda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908
const $ca3ce251ae0f82d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEPLOYMENT"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevOpsDeploymentProvider",
                                                "kind": "LinkedField",
                                                "name": "deploymentProviders",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.name"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "providerLogo_softwareReleasesLaunchCard"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.providers.deploymentProviders"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDeploymentProvider",
                                    "kind": "LinkedField",
                                    "name": "deploymentProviders",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "logoUrl"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908",
            "metadata": {},
            "name": "providersListTooltipContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca3ce251ae0f82d6$var$node.hash = "2fb2dcefa503b43df945cc594382beab";
var $ca3ce251ae0f82d6$export$2e2bcd8739ae039 = $ca3ce251ae0f82d6$var$node;

});

parcelRegister("5CxBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2beb5f5e87b69983$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2beb5f5e87b69983$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    oneProviderIsConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.one-provider-is-connected",
        "defaultMessage": "{providerName} is installed"
    },
    twoProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.two-providers-are-connected",
        "defaultMessage": "2 deployment tools installed"
    },
    threeOrMoreProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.three-or-more-providers-are-connected",
        "defaultMessage": "3+ deployment tools installed"
    },
    setUpDeploymentsDetail: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail",
        "defaultMessage": "To track deployments in Jira, start linking your work to issues in this project."
    },
    supportLinkText: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text",
        "defaultMessage": "Learn how to link development work to issues"
    }
});

});

parcelRegister("eD3NW", function(module, exports) {

$parcel$export(module.exports, "ProviderLogo", () => $2f6d72c08974086d$export$a48c0a0510fd5b7a);

var $bNJcI = parcelRequire("bNJcI");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $dNC7c = parcelRequire("dNC7c");
const $2f6d72c08974086d$export$a48c0a0510fd5b7a = ({ provider: provider })=>{
    const { name: name, logoUrl: logoUrl } = (0, $iWLL0.useFragment)((0, $bNJcI.default), provider);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f6d72c08974086d$export$e464f89b9068f431, {
        src: logoUrl ?? '',
        alt: name ?? '',
        title: name ?? '',
        onError: (e)=>{
            if (e.target instanceof HTMLImageElement) e.target.src = (0, (/*@__PURE__*/$parcel$interopDefault($dNC7c)));
        }
    });
};
const $2f6d72c08974086d$export$e464f89b9068f431 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbzwfg _4t3izwfg _1yt4u2gc _2rko1osq _16qsvjj6 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bNJcI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcfb2d60a4fca7ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7752b05a0a8bdae34a7f01febb9a6714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bcfb2d60a4fca7ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "providerLogo_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "logoUrl"
        }
    ],
    "type": "DevOpsDeploymentProvider"
};
$bcfb2d60a4fca7ae$var$node.hash = "a69ed29281953f2d0dd2061c60855b1f";
var $bcfb2d60a4fca7ae$export$2e2bcd8739ae039 = $bcfb2d60a4fca7ae$var$node;

});

parcelRegister("dNC7c", function(module, exports) {
module.exports = new URL("addon.840ab9ef.svg", import.meta.url).toString();

});




parcelRegister("d9lWl", function(module, exports) {

$parcel$export(module.exports, "AsyncVersionContributors", () => $515422e623106ee1$export$c80cf9cb5de0170f);

var $jzUoJ = parcelRequire("jzUoJ");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $6GbOh = parcelRequire("6GbOh");

var $bNKbJ = parcelRequire("bNKbJ");

var $aTAgc = parcelRequire("aTAgc");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $515422e623106ee1$var$LazyVersionContributors = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("aTAgc"))).then((module)=>module.VersionContributors), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-contributors/index.tsx"
});
const $515422e623106ee1$export$c80cf9cb5de0170f = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $jzUoJ.default), jiraVersion);
    const contributorCount = version.contributors.edges.length;
    const maxContributorCount = contributorCount >= 4 ? 4 : contributorCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-contributors",
        fallback: contributorCount <= 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTAgc.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            level: "h200"
        }, formatMessage((0, $bNKbJ.default).contributorsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GbOh.ContributorsSkeleton), {
            contributorCount: maxContributorCount
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($515422e623106ee1$var$LazyVersionContributors, {
        jiraVersionContributors: version.contributors.edges.filter(Boolean)
    }));
};

});
parcelRegister("jzUoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3d4938d536d6ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df1174cc15a058925e75406b6d0ec4e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e3d4938d536d6ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionContributorConnection",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraVersionContributorEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "versionContributors_softwareReleasesLaunchCard"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "contributors.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "contributors"
        }
    ],
    "type": "JiraVersion"
};
$5e3d4938d536d6ab$var$node.hash = "1c2f7736ef0703bba0e1b3081509e3ee";
var $5e3d4938d536d6ab$export$2e2bcd8739ae039 = $5e3d4938d536d6ab$var$node;

});

parcelRegister("6GbOh", function(module, exports) {

$parcel$export(module.exports, "ContributorsSkeleton", () => $22d148f3e3f6053a$export$bd943a9e5a9521c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $22d148f3e3f6053a$export$bd943a9e5a9521c = ({ contributorCount: contributorCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22d148f3e3f6053a$var$Container, null, [
        ...Array(contributorCount)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22d148f3e3f6053a$var$SkeletonGroup, {
            key: i
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22d148f3e3f6053a$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p5aglyw _kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $22d148f3e3f6053a$var$SkeletonGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _bfhkqrzy _1e0c1o8l _2rko1ssb _19ithba0 _79apxmi2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bNKbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a20755d380d8c8a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a20755d380d8c8a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    contributorsLabel: {
        "id": "software-releases-launch-card.version-contributors.contributors-label",
        "defaultMessage": "Contributors"
    }
});

});

parcelRegister("aTAgc", function(module, exports) {

$parcel$export(module.exports, "VersionContributors", () => $eb8ef6674fa28bf4$export$9b2969e79fd97829);
$parcel$export(module.exports, "Container", () => $eb8ef6674fa28bf4$export$42a852a2b6b56249);

var $ajXPo = parcelRequire("ajXPo");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $6R0C9 = parcelRequire("6R0C9");
var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNKbJ = parcelRequire("bNKbJ");
const $eb8ef6674fa28bf4$export$9b2969e79fd97829 = ({ jiraVersionContributors: jiraVersionContributors })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const contributorsData = (0, $iWLL0.useFragment)((0, $ajXPo.default), jiraVersionContributors);
    const avatarData = contributorsData.map((edge)=>({
            key: edge.node.id,
            name: edge.node.name,
            src: edge.node.picture
        }));
    return avatarData.length <= 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb8ef6674fa28bf4$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $bNKbJ.default).contributorsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: avatarData,
        maxCount: 4,
        size: "small",
        overrides: {
            AvatarGroupItem: {
                render: (_, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6R0C9.default), {
                        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), props.avatar),
                        primaryText: props.avatar.name,
                        secondaryText: contributorsData.find((edge)=>edge.node.id === props.avatar.key)?.node.extendedProfile?.jobTitle ?? ''
                    })
            }
        }
    }));
};
const $eb8ef6674fa28bf4$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ajXPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de497e77e563267$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<438c8ccf5af2466a576ed050d799fe88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7de497e77e563267$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionContributors_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "jobTitle"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraVersionContributorEdge"
};
$7de497e77e563267$var$node.hash = "48615e9b01f03fa862341197581c3df7";
var $7de497e77e563267$export$2e2bcd8739ae039 = $7de497e77e563267$var$node;

});

parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $2eG9N = parcelRequire("2eG9N");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});




parcelRegister("4L9Jt", function(module, exports) {

$parcel$export(module.exports, "VersionDates", () => $b456dfa21371bb9b$export$2f6a5887195e56f4);

var $fdwD8 = parcelRequire("fdwD8");

var $b0enN = parcelRequire("b0enN");

var $fzxE5 = parcelRequire("fzxE5");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2W8po = parcelRequire("2W8po");

var $kbt7X = parcelRequire("kbt7X");

var $6CHy4 = parcelRequire("6CHy4");

var $lGpbd = parcelRequire("lGpbd");

var $1d0Aj = parcelRequire("1d0Aj");
const $b456dfa21371bb9b$var$BAD_START_RELEASE_DATE_ORDER_ERROR = 'BAD_START_RELEASE_DATE_ORDER';
const $b456dfa21371bb9b$var$useFormattedDates = (startDate, releaseDate)=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    return {
        formattedStartDate: startDate === null ? formatMessage((0, $1d0Aj.default).startDateNotSet) : formatDate(new Date(startDate), {
            timeZone: (0, $2W8po.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }),
        formattedReleaseDate: releaseDate === null ? formatMessage((0, $1d0Aj.default).releaseDateNotSet) : formatDate(new Date(releaseDate), {
            timeZone: (0, $2W8po.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        })
    };
};
const $b456dfa21371bb9b$export$2f6a5887195e56f4 = ({ jiraVersion: jiraVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $fzxE5.default), jiraVersion);
    const [updateVersionStartDate] = (0, $iWLL0.useMutation)((0, $b0enN.default));
    const [updateVersionReleaseDate] = (0, $iWLL0.useMutation)((0, $fdwD8.default));
    const handleStartDateMutationError = (data)=>{
        const flagText = {
            title: (0, $1d0Aj.default).startDateGenericErrorFlagTitle,
            description: (0, $1d0Aj.default).genericErrorFlagDescription
        };
        if (data.jira?.updateVersionStartDate?.errors) {
            const { extensions: extensions } = data.jira.updateVersionStartDate.errors[0];
            if (extensions?.errorType === $b456dfa21371bb9b$var$BAD_START_RELEASE_DATE_ORDER_ERROR) {
                flagText.title = (0, $1d0Aj.default).badReleaseStartDateOrderErrorFlagTitle;
                flagText.description = (0, $1d0Aj.default).badReleaseStartDateOrderErrorFlagDescription;
            }
        }
        showFlag({
            type: 'warning',
            ...flagText
        });
    };
    const handleStartDateChange = (startDate)=>{
        updateVersionStartDate({
            variables: {
                input: {
                    id: version.id,
                    startDate: startDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionStartDate?.success) handleStartDateMutationError(data);
                else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionStartDate'
                }), 'versionStartDate updated');
            },
            onError: ()=>{
                (0, $kbt7X.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $1d0Aj.default).startDateGenericErrorFlagTitle,
                    description: (0, $1d0Aj.default).genericErrorFlagDescription
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionStartDate: {
                        success: true,
                        errors: [],
                        version: {
                            id: version.id,
                            startDate: startDate
                        }
                    }
                }
            }
        });
    };
    const handleReleaseDateChange = (releaseDate)=>{
        updateVersionReleaseDate({
            variables: {
                input: {
                    id: version.id,
                    releaseDate: releaseDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionReleaseDate?.success) showFlag({
                    type: 'warning',
                    title: (0, $1d0Aj.default).releaseDateErrorFlagTitle,
                    description: (0, $1d0Aj.default).genericErrorFlagDescription
                });
                else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionReleaseDate'
                }), 'versionReleaseDate updated');
            },
            onError: ()=>{
                (0, $kbt7X.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $1d0Aj.default).releaseDateErrorFlagTitle,
                    description: (0, $1d0Aj.default).genericErrorFlagDescription
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionReleaseDate: {
                        success: true,
                        version: {
                            id: version.id,
                            releaseDate: releaseDate
                        }
                    }
                }
            }
        });
    };
    const { formattedStartDate: formattedStartDate, formattedReleaseDate: formattedReleaseDate } = $b456dfa21371bb9b$var$useFormattedDates(// @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
    version.startDate, version.releaseDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b456dfa21371bb9b$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CHy4.AsyncEditableDatePicker), {
        analyticsEventName: "versionStartDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.startDate,
        displayDate: formattedStartDate,
        label: formatMessage((0, $1d0Aj.default).startDateFieldLabel),
        maxDate: (0, $lGpbd.convertDatetimeToDate)(version.releaseDate),
        onUpdateDate: handleStartDateChange,
        testId: "software-releases-launch-card.ui.version-dates.start-date-editable-date-picker"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CHy4.AsyncEditableDatePicker), {
        analyticsEventName: "versionReleaseDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.releaseDate,
        displayDate: formattedReleaseDate,
        label: formatMessage((0, $1d0Aj.default).releaseDateFieldLabel),
        minDate: (0, $lGpbd.convertDatetimeToDate)(version.startDate),
        onUpdateDate: handleReleaseDateChange,
        testId: "software-releases-launch-card.ui.version-dates.release-date-editable-date-picker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b456dfa21371bb9b$var$DateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fdwD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe0968373750c2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8537225dbdb3f656ce85fc0d4ec98947>>
 * @relayHash 76fcdda26d5cebfbc0bdbfc7500aaba8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5
const $3fe0968373750c2d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "releaseDate"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5",
            "metadata": {},
            "name": "versionDates_updateVersionReleaseDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3fe0968373750c2d$var$node.hash = "0404a02cdc80d06adbaaf61ada39552b";
var $3fe0968373750c2d$export$2e2bcd8739ae039 = $3fe0968373750c2d$var$node;

});

parcelRegister("b0enN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d600abf89c638ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc667416605c45f4e9fb29c8594b350e>>
 * @relayHash 0f9f8a79d54b7bf69bd4ddc3c65a57b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906
const $9d600abf89c638ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906",
            "metadata": {},
            "name": "versionDates_updateVersionStartDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9d600abf89c638ca$var$node.hash = "9222866e01fe4d9b93a39fe2c827a3b0";
var $9d600abf89c638ca$export$2e2bcd8739ae039 = $9d600abf89c638ca$var$node;

});

parcelRegister("fzxE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d21f4674faa119$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7c6c5dbd8eb08f103adecc53342a48c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1d21f4674faa119$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionDates_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "ScalarField",
            "name": "startDate"
        },
        {
            "kind": "ScalarField",
            "name": "releaseDate"
        }
    ],
    "type": "JiraVersion"
};
$e1d21f4674faa119$var$node.hash = "4dcf74d53cdeafe5bdc663fa3f4c36e4";
var $e1d21f4674faa119$export$2e2bcd8739ae039 = $e1d21f4674faa119$var$node;

});

parcelRegister("kbt7X", function(module, exports) {

$parcel$export(module.exports, "fireFieldUpdateErrorAnalytics", () => $2c9457a2f596bacc$export$f84dee30e0e69629);

var $guiFP = parcelRequire("guiFP");
const $2c9457a2f596bacc$export$f84dee30e0e69629 = ()=>{
    (0, $guiFP.default)({
        meta: {
            id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
            packageName: 'jiraSoftwareReleasesLaunchCard',
            teamName: 'fusion-solaris'
        },
        error: Error('Unable to update version'),
        sendToPrivacyUnsafeSplunk: true
    });
};

});

parcelRegister("6CHy4", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableDatePicker", () => $e066c4571f1d9095$export$e5d82c99aef790b1);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $6ROLN = parcelRequire("6ROLN");

var $gGtKh = parcelRequire("gGtKh");

var $8g8tH = parcelRequire("8g8tH");

var $66Wo9 = parcelRequire("66Wo9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e066c4571f1d9095$var$LazyEditableDatePicker = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("66Wo9"))).then((module)=>module.EditableDatePicker), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-dates/editable-date-picker/index.tsx"
});
const $e066c4571f1d9095$export$e5d82c99aef790b1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "editable-date-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e066c4571f1d9095$export$66b8cea0c448285, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
            htmlFor: "version-details-editable-date-picker"
        }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66Wo9.InlineEditReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8g8tH.DatePickerReadView), {
            displayDate: props.displayDate
        })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e066c4571f1d9095$var$LazyEditableDatePicker, props));
const $e066c4571f1d9095$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91lit _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("8g8tH", function(module, exports) {

$parcel$export(module.exports, "DatePickerReadView", () => $6ed1d5f5bece52da$export$e9b589e36300c388);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $6ed1d5f5bece52da$export$e9b589e36300c388 = ({ displayDate: displayDate, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ed1d5f5bece52da$var$ReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ed1d5f5bece52da$var$ReadViewItem, {
        "data-testid": testId
    }, displayDate));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ed1d5f5bece52da$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1ul91qr7 _1yt45fii",
            __cmplp.className
        ])
    });
});
const $6ed1d5f5bece52da$var$ReadViewItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("66Wo9", function(module, exports) {

$parcel$export(module.exports, "EditableDatePicker", () => $782d45c36e7c8b2f$export$9bd88e6f248fc8ea);
$parcel$export(module.exports, "InlineEditReadViewContainer", () => $782d45c36e7c8b2f$export$408cb7913975dc96);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jXg8H = parcelRequire("jXg8H");

var $6ROLN = parcelRequire("6ROLN");

var $2yRWX = parcelRequire("2yRWX");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bZPtv = parcelRequire("bZPtv");

var $4xHig = parcelRequire("4xHig");

var $8g8tH = parcelRequire("8g8tH");

var $5gggr = parcelRequire("5gggr");

var $lGpbd = parcelRequire("lGpbd");
const $782d45c36e7c8b2f$var$INPUT_NAME = 'version-details-editable-date-picker';
const $782d45c36e7c8b2f$export$9bd88e6f248fc8ea = ({ analyticsEventName: analyticsEventName, canEdit: canEdit, currentDate: currentDate, displayDate: displayDate, label: label, maxDate: maxDate, minDate: minDate, onUpdateDate: onUpdateDate, testId: testId })=>{
    const locale = (0, $4xHig.useLocale)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const defaultValue = currentDate != null ? (0, $bZPtv.extractDate)(currentDate) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($782d45c36e7c8b2f$var$Container, {
        "data-testid": testId !== undefined ? `${testId}-container` : undefined
    }, canEdit === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
        defaultValue: defaultValue,
        editView: ({ ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
                autoFocus: true,
                locale: locale,
                defaultValue: defaultValue || undefined,
                maxDate: maxDate,
                minDate: minDate,
                placeholder: formatMessage((0, $5gggr.default).selectDateLabel),
                spacing: "compact",
                testId: testId,
                ...fieldProps
            }),
        label: label,
        onConfirm: (newValue)=>{
            if ((0, $lGpbd.convertDatetimeToDate)(newValue) !== (0, $lGpbd.convertDatetimeToDate)(currentDate)) onUpdateDate(newValue ? new Date(newValue).toISOString() : null);
        },
        onEdit: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'datePicker'
            }), analyticsEventName);
        },
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8g8tH.DatePickerReadView), {
                displayDate: displayDate,
                testId: testId !== undefined ? `${testId}-read-view` : undefined
            }),
        readViewFitContainerWidth: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $782d45c36e7c8b2f$var$noEditContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: $782d45c36e7c8b2f$var$INPUT_NAME
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($782d45c36e7c8b2f$export$408cb7913975dc96, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8g8tH.DatePickerReadView), {
        displayDate: displayDate,
        testId: "software-releases-launch-card.ui.version-dates.editable-date-picker.date-picker-read-view"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $782d45c36e7c8b2f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19pkx0bf _otyru2gc _prventd2",
            __cmplp.className
        ])
    });
});
const $782d45c36e7c8b2f$var$noEditContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $782d45c36e7c8b2f$export$408cb7913975dc96 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itj1ic _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $aYOOX = parcelRequire("aYOOX");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = "platform-pkg";
const $a38f1e4301a686fa$var$packageVersion = "0.0.0-use.local";
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $aYOOX.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $aYOOX.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $aYOOX.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, disabled: disabled, disabledDateFilter: disabledDateFilter, hideIcon: hideIcon = false, icon: // TODO: Resolve this typing to be more intuitive
        icon = (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $aYOOX.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $aYOOX.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        })));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $a38f1e4301a686fa$var$DatePicker = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = $a38f1e4301a686fa$var$DatePicker;

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("aYOOX", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $be48f7c2ad85fcf1$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $be48f7c2ad85fcf1$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $be48f7c2ad85fcf1$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $be48f7c2ad85fcf1$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $EN9B6 = parcelRequire("EN9B6");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $jP55W = parcelRequire("jP55W");

var $7i5dr = parcelRequire("7i5dr");
const $be48f7c2ad85fcf1$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $be48f7c2ad85fcf1$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
    return newIso;
};
const $be48f7c2ad85fcf1$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
    return l10n.parseDate(date);
};
const $be48f7c2ad85fcf1$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
    const date = (0, $3xcI8.default)(value);
    return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $7i5dr.placeholderDatetime));
};

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $knRXm = parcelRequire("knRXm");


var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $c845995965375b9a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $3xcI8.default)(iso);
        return (0, $7ueqz.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $c845995965375b9a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $knRXm.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $ki32l = parcelRequire("ki32l");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $ki32l.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("2yRWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0664d820ae0097f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $XHGTv = parcelRequire("XHGTv");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $5wwB6 = parcelRequire("5wwB6");

var $kNcDT = parcelRequire("kNcDT");

var $8hUcM = parcelRequire("8hUcM");
function $0664d820ae0097f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0664d820ae0097f9$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $0664d820ae0097f9$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $0664d820ae0097f9$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel = (0, $5Q9wj.default), onEdit: providedOnEdit = (0, $5Q9wj.default), testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $kNcDT.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$0664d820ae0097f9$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8hUcM.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $XHGTv.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $0664d820ae0097f9$var$fieldStyles,
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wwB6.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $0664d820ae0097f9$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $byn9U.jsx)($0664d820ae0097f9$var$InnerInlineEdit, props);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0664d820ae0097f9$export$2e2bcd8739ae039 = $0664d820ae0097f9$var$InlineEdit;

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("5wwB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d378d9c54c5a6cc$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
                                                                                                                                      * @jsxRuntime classic
                                                                                                                                      * @jsx jsx
                                                                                                                                      */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");


var $8tdcZ = parcelRequire("8tdcZ");
function $6d378d9c54c5a6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d378d9c54c5a6cc$var$buttonsContainerStyles = {
    name: "ki22df",
    styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
};
const $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    fontSize: (0, $8tdcZ.fontSize),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`
    },
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
    },
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $6d378d9c54c5a6cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $6d378d9c54c5a6cc$export$2e2bcd8739ae039 = $6d378d9c54c5a6cc$var$Buttons;

});
parcelRegister("8tdcZ", function(module, exports) {

$parcel$export(module.exports, "fontSize", () => $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "borderRadius", () => $0b3df1ecc0dc12b2$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93 = 14;
const $0b3df1ecc0dc12b2$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();

});


parcelRegister("kNcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc2637f9691157f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $acc2637f9691157f$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $acc2637f9691157f$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $acc2637f9691157f$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $acc2637f9691157f$export$2e2bcd8739ae039 = $acc2637f9691157f$var$useButtonFocusHook;

});

parcelRegister("8hUcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e4844bc5b892d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");


var $8tdcZ = parcelRequire("8tdcZ");
function $f1e4844bc5b892d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1e4844bc5b892d8$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $f1e4844bc5b892d8$var$editButtonStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $f1e4844bc5b892d8$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $8tdcZ.borderRadius),
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    }
});
const $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $f1e4844bc5b892d8$var$DRAG_THRESHOLD = 5;
const $f1e4844bc5b892d8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f1e4844bc5b892d8$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $f1e4844bc5b892d8$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f1e4844bc5b892d8$var$readViewWrapperStyles,
            readViewFitContainerWidth && $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $f1e4844bc5b892d8$export$2e2bcd8739ae039 = $f1e4844bc5b892d8$var$ReadView;

});


parcelRegister("bZPtv", function(module, exports) {

$parcel$export(module.exports, "extractDate", () => $43b0da3c7dcdf50a$export$22fa983d82ded8f8);
// Use this to extract date only from the date value that comes from GraphQL, such as 2023-05-09T00:00:00Z
// It is also ok to apply this function to the date value that comes from Rest API, because the value is already in the form of YYYY-MM-DD
// The actualy backend only stores YYYY-MM-DD but graphql adds time information to it, therefore it is anyway meaningless.
// Do not use date-fn's format function because it will apply local timezone to the graphql date value that will result wrong date, instead, use this function
// to supply value to DatePicker's defaultValue that accepts YYYY-MM-DD only
const $43b0da3c7dcdf50a$export$22fa983d82ded8f8 = (dateFromGraphQl)=>dateFromGraphQl.slice(0, 10);

});

parcelRegister("5gggr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be7a53e620fa8cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6be7a53e620fa8cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectDateLabel: {
        "id": "software-releases-launch-card.version-dates.editable-date-picker.select-date-label",
        "defaultMessage": "Select date"
    }
});

});

parcelRegister("lGpbd", function(module, exports) {

$parcel$export(module.exports, "convertDatetimeToDate", () => $244df77718f4e4f2$export$f2eb3c0da1d3f89e);

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
const $244df77718f4e4f2$export$f2eb3c0da1d3f89e = (startDate)=>startDate != null && (0, $7ueqz.default)(new Date(startDate)) ? (0, $EN9B6.default)(new Date(startDate), 'yyyy-MM-dd') : '';

});



parcelRegister("1d0Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6420adfb945ad66e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6420adfb945ad66e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateNotSet: {
        "id": "software-releases-launch-card.version-dates.start-date-not-set",
        "defaultMessage": "Start date not set"
    },
    releaseDateNotSet: {
        "id": "software-releases-launch-card.version-dates.release-date-not-set",
        "defaultMessage": "Release date not set"
    },
    startDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.start-date-field-label",
        "defaultMessage": "Start date"
    },
    startDateGenericErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.start-date-generic-error-flag-title",
        "defaultMessage": "We couldn't update the start date"
    },
    badReleaseStartDateOrderErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-title",
        "defaultMessage": "The start date cannot be after the release date"
    },
    badReleaseStartDateOrderErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-description",
        "defaultMessage": "Please select a different start date."
    },
    releaseDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.release-date-field-label",
        "defaultMessage": "Release date"
    },
    releaseDateErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.release-date-error-flag-title",
        "defaultMessage": "We couldn't update the release date"
    },
    genericErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("6cGTB", function(module, exports) {

$parcel$export(module.exports, "AsyncVersionStatus", () => $f1890ba67e937662$export$f6bcf9d2a3221dfb);

var $c1oLC = parcelRequire("c1oLC");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $gGtKh = parcelRequire("gGtKh");

var $4FMAx = parcelRequire("4FMAx");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f1890ba67e937662$var$LazyVersionStatus = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("4FMAx"))).then((module)=>module.VersionStatus), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-status/index.tsx"
});
const $f1890ba67e937662$export$f6bcf9d2a3221dfb = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $iWLL0.useFragment)((0, $c1oLC.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-status",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1890ba67e937662$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), null, (0, $4FMAx.GetCurrentStatusLabel)(version.status)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1890ba67e937662$var$LazyVersionStatus, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1890ba67e937662$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c1oLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8a57bf5d8533c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ef6fed889609df73bcc4587dc5f0110>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba8a57bf5d8533c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionStatus_softwareReleasesLaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$ba8a57bf5d8533c7$var$node.hash = "bbfb4743758d7a0f5d5885118b67b179";
var $ba8a57bf5d8533c7$export$2e2bcd8739ae039 = $ba8a57bf5d8533c7$var$node;

});

parcelRegister("4FMAx", function(module, exports) {

$parcel$export(module.exports, "GetCurrentStatusLabel", () => $1f4dd3d1637e4bb3$export$3e6be0c31593f3c4);
$parcel$export(module.exports, "VersionStatus", () => $1f4dd3d1637e4bb3$export$8c6e0f93bfb5c6a4);

var $kEcgg = parcelRequire("kEcgg");

var $7Pncx = parcelRequire("7Pncx");

var $4cSsR = parcelRequire("4cSsR");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $7opLA = parcelRequire("7opLA");

var $9nt1B = parcelRequire("9nt1B");

var $86Ndv = parcelRequire("86Ndv");

var $dxopF = parcelRequire("dxopF");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");


var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cJzpl = parcelRequire("cJzpl");

var $yyqSx = parcelRequire("yyqSx");

var $dctpP = parcelRequire("dctpP");

var $lpokX = parcelRequire("lpokX");

var $4xHig = parcelRequire("4xHig");

var $3Gr3b = parcelRequire("3Gr3b");

var $lR2Nb = parcelRequire("lR2Nb");

var $jC0OR = parcelRequire("jC0OR");

var $iJ6Ji = parcelRequire("iJ6Ji");
const $1f4dd3d1637e4bb3$var$overrideComponents = {
    Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, {
            ...props,
            className: (0, $7JEyt.default)([
                "_1695idpf _1pnsidpf _vktqidpf _1byqidpf"
            ])
        })
};
const $1f4dd3d1637e4bb3$var$CustomOptionLabel = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f4dd3d1637e4bb3$var$VersionStatusOptionLabel, {
        isArchiveOption: value === (0, $lR2Nb.ARCHIVED)
    }, label);
const $1f4dd3d1637e4bb3$export$3e6be0c31593f3c4 = (currentStatusValue)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    switch(currentStatusValue){
        case 0, $lR2Nb.ARCHIVED:
            return formatMessage((0, $iJ6Ji.default).archivedLabel);
        case 0, $lR2Nb.RELEASED:
            return formatMessage((0, $iJ6Ji.default).releasedLabel);
        case 0, $lR2Nb.UNRELEASED:
            return formatMessage((0, $iJ6Ji.default).unreleasedLabel);
        default:
            return formatMessage((0, $iJ6Ji.default).unreleasedLabel);
    }
};
const $1f4dd3d1637e4bb3$export$8c6e0f93bfb5c6a4 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isReleasedModalOpen, setIsReleaseModalOpen] = (0, $eUqFw.useState)(false);
    const { refetch: refetch, isLoading: isRefetchLoading } = (0, $lpokX.useRefetchContext)();
    const locale = (0, $4xHig.useLocale)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [selectWidth, setSelectWidth] = (0, $eUqFw.useState)(undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const selectRef = (0, $eUqFw.useRef)();
    const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (selectRef.current) setSelectWidth(selectRef.current.offsetWidth);
    }, []);
    const version = (0, $iWLL0.useFragment)((0, $4cSsR.default), jiraVersion);
    const isVersionReleased = version.status === (0, $lR2Nb.RELEASED);
    const [updateVersionReleased] = (0, $iWLL0.useMutation)((0, $7Pncx.default));
    const [updateVersionArchived, isUpdateArchivedLoading] = (0, $iWLL0.useMutation)((0, $kEcgg.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $iWLL0.useQueryLoader)((0, $cJzpl.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
    };
    const isLoading = isUpdateArchivedLoading || isRefetchLoading;
    const releaseOptions = [
        {
            label: formatMessage((0, $iJ6Ji.default).releaseOptionLabel),
            value: (0, $lR2Nb.RELEASED)
        },
        {
            label: formatMessage((0, $iJ6Ji.default).unreleaseOptionLabel),
            value: (0, $lR2Nb.UNRELEASED)
        },
        {
            label: formatMessage((0, $iJ6Ji.default).archiveOptionLabel),
            value: (0, $lR2Nb.ARCHIVED)
        }
    ];
    const archiveOptions = [
        {
            label: formatMessage((0, $iJ6Ji.default).unarchiveOptionLabel),
            value: (0, $lR2Nb.UNARCHIVED)
        }
    ];
    const currentOptions = version.status === (0, $lR2Nb.ARCHIVED) ? archiveOptions : releaseOptions;
    const getCurrentValue = (currentStatusValue)=>[
            ...releaseOptions,
            ...archiveOptions
        ].find((option)=>option.value === currentStatusValue);
    const handleChange = (option)=>{
        if (option === null) return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        }), option.value);
        switch(option.value){
            case 0, $lR2Nb.RELEASED:
                setIsReleaseModalOpen(true);
                if (!(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)()) loadReleaseNoteModalResource();
                break;
            case 0, $lR2Nb.UNRELEASED:
                updateVersionReleased({
                    variables: {
                        input: {
                            id: version.id,
                            isReleased: false
                        }
                    },
                    onError: ()=>{
                        (0, $guiFP.default)({
                            meta: {
                                id: 'jira.releases.launch.card.update.released.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'fusion-solaris'
                            },
                            error: new Error('Unable to update version released status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $iJ6Ji.default).genericUpdateFailedFlagTitle,
                            description: (0, $iJ6Ji.default).releaseFailedFlagDescription
                        });
                    },
                    optimisticResponse: {
                        jira: {
                            updateVersionReleasedStatus: {
                                success: true,
                                version: {
                                    id: version.id,
                                    status: option.value
                                }
                            }
                        }
                    }
                });
                break;
            case 0, $lR2Nb.ARCHIVED:
            case 0, $lR2Nb.UNARCHIVED:
                updateVersionArchived({
                    variables: {
                        input: {
                            id: version.id,
                            isArchived: option.value === (0, $lR2Nb.ARCHIVED)
                        }
                    },
                    onError: ()=>{
                        (0, $guiFP.default)({
                            meta: {
                                id: 'jira.releases.launch.card.update.archived.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'fusion-solaris'
                            },
                            error: new Error('Unable to update version archived status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $iJ6Ji.default).genericUpdateFailedFlagTitle,
                            description: (0, $iJ6Ji.default).archiveFailedFlagDescription
                        });
                    }
                });
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f4dd3d1637e4bb3$var$Container, {
        ref: selectRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        hideSelectedOptions: true,
        components: $1f4dd3d1637e4bb3$var$overrideComponents,
        formatOptionLabel: $1f4dd3d1637e4bb3$var$CustomOptionLabel,
        minMenuWidth: `${selectWidth}px`,
        onChange: handleChange,
        options: currentOptions,
        target: ({ isOpen: isOpen, ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f4dd3d1637e4bb3$var$StyledLoadingButton, {
                ...triggerProps,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: formatMessage((0, $iJ6Ji.default).buttonLabel)
                }),
                isDisabled: !version.canEdit,
                isLoading: isLoading,
                isSelected: isOpen,
                ref: ref,
                released: isVersionReleased && !isOpen ? 1 : 0,
                shouldFitContainer: true,
                onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionStatusDropdown')
            }, isVersionReleased ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f4dd3d1637e4bb3$var$ReleasedContentWrapper, null, $1f4dd3d1637e4bb3$export$3e6be0c31593f3c4(version.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f4dd3d1637e4bb3$var$ReleaseSucceededIcon, null)) : $1f4dd3d1637e4bb3$export$3e6be0c31593f3c4(version.status)),
        value: getCurrentValue(version.status)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jC0OR.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "release-notes-modal",
        fallback: null
    }, isReleaseNotesModalOpen && releaseNotesQueryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dctpP.ReleaseNotesModal), {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsReleaseNotesModalOpen(false)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isReleasedModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Gr3b.default // eslint-disable-next-line jira/deprecations/no-base-url
    ), {
        baseUrl: "" // @ts-expect-error - TS2322 - Type '{ baseUrl: string; locale: Locale; projectKey: string; versionId: string; onOpened: (...args: any[]) => void; onCancel: () => void; onSuccess: () => void; onError: () => void; }' is not assignable to type 'IntrinsicAttributes & StateProps & Handlers & { children?: ReactNode; }'.
        ,
        locale: locale,
        projectKey: version.project.key,
        versionId: version.versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCancel: ()=>{
            setIsReleaseModalOpen(false);
        },
        onSuccess: (_updatedVersion, params)=>{
            refetch();
            setIsReleaseModalOpen(false);
            if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
        },
        onError: ()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, $iJ6Ji.default).genericUpdateFailedFlagTitle),
                description: formatMessage((0, $iJ6Ji.default).releaseFailedFlagDescription)
            });
            (0, $guiFP.default)({
                error: new Error('Failed to release the version'),
                meta: {
                    id: 'versionDetailsLaunchCardReleaseModal',
                    packageName: 'jiraSoftwareReleasesLaunchCard',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldShowCreateReleaseNotesOption: !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
        hasReleaseNote: version.hasReleaseNote ?? false
    })));
};
const $1f4dd3d1637e4bb3$var$ReleaseSucceededIcon = ()=>// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        label: "",
        primaryColor: $1f4dd3d1637e4bb3$export$a7643b841a7da7eb,
        size: "small"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
const $1f4dd3d1637e4bb3$var$styles = null;
const $1f4dd3d1637e4bb3$var$RELEASED_BACKGROUND_COLOR = `var(--ds-background-success, ${(0, $73a5c9d720aa66e1$exports).G50})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f4dd3d1637e4bb3$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f4dd3d1637e4bb3$var$ReleasedContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _zulp1b66 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $1f4dd3d1637e4bb3$export$a7643b841a7da7eb = `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).G500})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f4dd3d1637e4bb3$var$StyledLoadingButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_mc545c": (0, $9t7rW.default)($1f4dd3d1637e4bb3$var$RELEASED_BACKGROUND_COLOR),
            "--_pgbpk1": (0, $9t7rW.default)($1f4dd3d1637e4bb3$export$a7643b841a7da7eb)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_15s31ylp _1ilx1txw _ubnr1h6o",
            __cmplp.released && "_bikluv1w",
            __cmplp.released && "_1gty12xq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f4dd3d1637e4bb3$var$VersionStatusOptionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isArchiveOption: isArchiveOption, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _80omtlke _1e0c1txw _1yt41azu",
            __cmplp.isArchiveOption ? "_x3dope8f" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kEcgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e02d6b5863f6f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f27e7443d050ab4137264e6846e36fe6>>
 * @relayHash 340d4f5f070919a0755dcf2816c6e362
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49
const $97e02d6b5863f6f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49",
            "metadata": {},
            "name": "versionStatus_updateVersionArchivedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$97e02d6b5863f6f5$var$node.hash = "3e4bee8708d54a5a32d8530c63b327c7";
var $97e02d6b5863f6f5$export$2e2bcd8739ae039 = $97e02d6b5863f6f5$var$node;

});

parcelRegister("7Pncx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c836ed6efac06fc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d39098cd4aca8ffd1c5445682305611d>>
 * @relayHash 08bc9d2a69bd2c858ab39655b3facfa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079
const $c836ed6efac06fc3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079",
            "metadata": {},
            "name": "versionStatus_updateVersionReleasedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c836ed6efac06fc3$var$node.hash = "0608e97fa861a9ec4da08bc961c0e4d0";
var $c836ed6efac06fc3$export$2e2bcd8739ae039 = $c836ed6efac06fc3$var$node;

});

parcelRegister("4cSsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef4a891698da4646$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c885b0523b70dc4755d8599deda36b0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ef4a891698da4646$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "versionStatus_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canEdit"
            },
            "action": "THROW",
            "path": "canEdit"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasReleaseNote"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$ef4a891698da4646$var$node.hash = "73ad533d7bc635895bf9a3e3b4a39f81";
var $ef4a891698da4646$export$2e2bcd8739ae039 = $ef4a891698da4646$var$node;

});

parcelRegister("cJzpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $98666f0a1a89d1e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5d23bf1931d8c74129b1c2266fe7573>>
 * @relayHash 77444086c0531826d7b3caa08fb6142c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d6d23b6065cb533e3b4351015a459a3c6213ad2058325a312dcb87b424b774dd
const $98666f0a1a89d1e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "releaseNoteConfiguration"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    }, v6 = {
        "kind": "ScalarField",
        "name": "releasesNotesPreferenceType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueKeyConfig"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueFieldIds"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeIds"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "releaseNoteConfiguration",
            "variableName": "releaseNoteConfiguration"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "isSystem"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v17 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v20 = [
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ], v21 = [
        "searchString"
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.version.id"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraReleaseNotesConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesConfiguration"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v10 /*: any*/ ,
                                                        "concreteType": "JiraIssueTypeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesOptionsIssueTypes",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                            }
                                                        ],
                                                        "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                },
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "versionSelector_softwareReleasesAddReleaseNotesModal"
                                                },
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "availableSites",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v12 /*: any*/ ,
                                                                                    "action": "LOG",
                                                                                    "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "LOG",
                                                                        "path": "jira.version.availableSites.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "LOG",
                                                            "path": "jira.version.availableSites.edges"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleaseNotesConfiguration",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "xsmall"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueTypes"
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "releaseNotes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v20 /*: any*/ ,
                                            "storageKey": "releaseNotesOptionsIssueFields(first:10)"
                                        },
                                        {
                                            "args": v19 /*: any*/ ,
                                            "filters": v21 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "nativeReleaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v20 /*: any*/ ,
                                            "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                        },
                                        {
                                            "args": v19 /*: any*/ ,
                                            "filters": v21 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "nativeReleaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                            "kind": "LinkedField",
                                            "name": "availableSites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "type": "JiraVersion"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d6d23b6065cb533e3b4351015a459a3c6213ad2058325a312dcb87b424b774dd",
            "metadata": {},
            "name": "uiReleaseNotesModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$98666f0a1a89d1e0$var$node.hash = "f68c70e5840c60381e97022c22e35462";
var $98666f0a1a89d1e0$export$2e2bcd8739ae039 = $98666f0a1a89d1e0$var$node;

});

parcelRegister("dctpP", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesModal", () => $b21a58253f2a5e9d$export$d334132901e7fcb2);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");

var $4Bees = parcelRequire("4Bees");

var $kGQen = parcelRequire("kGQen");

var $eI5EY = parcelRequire("eI5EY");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b21a58253f2a5e9d$var$LazyReleaseNotesModalContent = (0, $7rh0R.lazy)(()=>(parcelRequire("7gwVL")).then((module)=>module.ReleaseNotesModalContent), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b21a58253f2a5e9d$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, $7rh0R.lazy)(()=>(parcelRequire("7B5Me")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/index.tsx"
});
const $b21a58253f2a5e9d$var$LoadingModalBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b21a58253f2a5e9d$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    })));
const $b21a58253f2a5e9d$export$d334132901e7fcb2 = (props)=>{
    const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $eUqFw.useState)(null);
    const isAutomatedReleaseNotesEnabled = (0, $eI5EY.fg)('automated-release-notes-v1');
    const { onClose: onClose } = props;
    const onCreateConfluenceReleaseNotes = (0, $eUqFw.useCallback)((draftUrl)=>{
        setConfluenceReleaseNotesDraftUrl(draftUrl);
    }, []);
    const onCloseConfluenceReleaseNotes = (0, $eUqFw.useCallback)(()=>{
        setConfluenceReleaseNotesDraftUrl(null);
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, isAutomatedReleaseNotesEnabled && confluenceReleaseNotesDraftUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b21a58253f2a5e9d$var$LazyEmbeddedPageReleaseNotesEditorModal, {
        draftUrl: confluenceReleaseNotesDraftUrl,
        onClose: onCloseConfluenceReleaseNotes
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "x-large",
        autoFocus: false,
        onClose: props.onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "release-notes-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b21a58253f2a5e9d$var$LoadingModalBody, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b21a58253f2a5e9d$var$LazyReleaseNotesModalContent, {
        ...props,
        onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
    }))));
};
const $b21a58253f2a5e9d$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("7gwVL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8Mx1g")
]).then(()=>parcelRequire('dhZRf'));

});

parcelRegister("7B5Me", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("jeHr8")
]).then(()=>parcelRequire('93eqM'));

});


parcelRegister("3Gr3b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a868c1b46d64e50e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $5BRby = parcelRequire("5BRby");

var $aFvYX = parcelRequire("aFvYX");

var $dBhdL = parcelRequire("dBhdL");

var $ds1bp = parcelRequire("ds1bp");

var $hAL5N = parcelRequire("hAL5N");

var $eDaUO = parcelRequire("eDaUO");
class $a868c1b46d64e50e$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.store = (0, $ds1bp.default)((0, $dBhdL.default));
        this.setAppProps(this.props);
        this.store.dispatch((0, $hAL5N.initialRequest)(this.props.versionId));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((0, $aFvYX.default)(nextProps, this.props)) return;
        this.setAppProps(this.props);
    }
    setAppProps(props) {
        const { baseUrl: baseUrl, projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
        this.store.dispatch((0, $MYW4e.batchActions)([
            (0, $hAL5N.setContext)({
                baseUrl: baseUrl,
                projectKey: projectKey
            }),
            (0, $hAL5N.setHandlers)({
                onOpened: onOpened,
                onError: onError,
                onSuccess: onSuccess,
                onCancel: onCancel
            }),
            (0, $hAL5N.setCreateReleaseNotesOptionConfig)({
                shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                hasReleaseNote: hasReleaseNote
            })
        ]));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store,
            id: "versionReleaseModal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDaUO.default), null));
    }
}

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("dBhdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $611c50cc1f21dc97$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $iiK0E = parcelRequire("iiK0E");

var $4uQ2H = parcelRequire("4uQ2H");
var $611c50cc1f21dc97$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $iiK0E.initialRequestEpic), (0, $iiK0E.fetchUnresolvedIssues), (0, $4uQ2H.initialRequestSuccessEpic), (0, $iiK0E.releaseVersionRequestEpic), (0, $4uQ2H.releaseVersionRequestFailureEpic), (0, $4uQ2H.releaseVersionRequestSuccessEpic));

});
parcelRegister("iiK0E", function(module, exports) {

$parcel$export(module.exports, "initialRequestEpic", () => $83a02c528eb4825e$export$73dafa621a3e5eba);
$parcel$export(module.exports, "fetchUnresolvedIssues", () => $83a02c528eb4825e$export$5f5c175d78772606);
$parcel$export(module.exports, "releaseVersionRequestEpic", () => $83a02c528eb4825e$export$b327638b0f58ac49);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $8blac = parcelRequire("8blac");

var $kFGm5 = parcelRequire("kFGm5");

var $8dloj = parcelRequire("8dloj");

var $3JafE = parcelRequire("3JafE");

var $5ysFK = parcelRequire("5ysFK");


var $1G9Bj = parcelRequire("1G9Bj");

var $hAL5N = parcelRequire("hAL5N");

var $NkJgt = parcelRequire("NkJgt");
const $83a02c528eb4825e$export$73dafa621a3e5eba = (action$, store)=>action$.ofType((0, $hAL5N.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        const state = store.getState();
        const baseUrl = (0, $NkJgt.getBaseUrl)(state);
        return (0, $3JafE.Observable).fromPromise((0, $1G9Bj.getVersion)(baseUrl, versionId)).mergeMap((version)=>(0, $3JafE.Observable).of((0, $hAL5N.initialRequestSuccess)(version))).catch((error)=>{
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.version', (0, $a0d961ebe5e84888$export$6c87c1302bf5163c));
            return (0, $3JafE.Observable).of((0, $hAL5N.releaseVersionFailure)({
                id: versionId
            }));
        });
    });
const $83a02c528eb4825e$export$5f5c175d78772606 = (action$, store)=>action$.ofType((0, $hAL5N.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        const state = store.getState();
        const baseUrl = (0, $NkJgt.getBaseUrl)(state);
        return (0, $3JafE.Observable).fromPromise((0, $1G9Bj.getUnresolvedIssues)(baseUrl, versionId)).mergeMap((unresolvedIssuesCount)=>(0, $3JafE.Observable).of((0, $hAL5N.setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.getUnresolvedIssues', (0, $a0d961ebe5e84888$export$6c87c1302bf5163c));
            return (0, $3JafE.Observable).empty();
        });
    });
const $83a02c528eb4825e$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, $hAL5N.RELEASE_VERSION_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $NkJgt.getBaseUrl)(state);
        const keepIssues = (0, $NkJgt.isKeepingIssues)(state);
        const version = (0, $NkJgt.getVersion)(state);
        const versionToRelease = keepIssues ? (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(version, 'moveUnfixedIssuesTo') : version;
        return (0, $3JafE.Observable).fromPromise((0, $1G9Bj.releaseVersion)(baseUrl, versionToRelease)).mergeMap((releasedVersion)=>(0, $3JafE.Observable).of((0, $hAL5N.releaseVersionSuccess)(releasedVersion)))// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ReleaseVersionFailureAction> | Observable<ReleaseVersionValidationFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<ReleaseVersionSuccessAction>) => ObservableInput<ReleaseVersionFailureAction>'.
        .catch((error)=>{
            try {
                const errors = (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(JSON.parse(error.message).errors, [
                    'releaseDate',
                    'moveUnfixedIssuesTo'
                ]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(errors)) return (0, $3JafE.Observable).of((0, $hAL5N.releaseVersionValidationFailure)(errors));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
            /**/ }
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.release.version', (0, $a0d961ebe5e84888$export$6c87c1302bf5163c));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            return (0, $3JafE.Observable).of((0, $hAL5N.releaseVersionFailure)());
        });
    });

});
parcelRegister("5ysFK", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $4626a7a97ad42c00$export$c77be5886e7f1d9e);

var $gUUjF = parcelRequire("gUUjF");
const $4626a7a97ad42c00$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $4626a7a97ad42c00$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

const $a0d961ebe5e84888$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $a0d961ebe5e84888$export$6c87c1302bf5163c = 'directories.versions.error';

parcelRegister("1G9Bj", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $cf1c06882619c9e1$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssues", () => $cf1c06882619c9e1$export$d98ed0fcfb679bfe);
$parcel$export(module.exports, "releaseVersion", () => $cf1c06882619c9e1$export$b8e3d145af76ef26);
$parcel$export(module.exports, "useReleaseAutomationBanner", () => $cf1c06882619c9e1$export$d9a4a1588da51f7c);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $hhKXI = parcelRequire("hhKXI");

var $1U5Zu = parcelRequire("1U5Zu");

var $bjRvd = parcelRequire("bjRvd");

var $fwoXA = parcelRequire("fwoXA");

var $h2UKv = parcelRequire("h2UKv");
const $cf1c06882619c9e1$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, $hhKXI.getVersion)(baseUrl, versionId).then((0, $1U5Zu.transformVersion)).then((0, $fwoXA.addDefaultReleaseDate));
const $cf1c06882619c9e1$export$d98ed0fcfb679bfe = (baseUrl, versionId)=>(0, $hhKXI.getUnresolvedIssuesCount)(baseUrl, versionId).then((0, $1U5Zu.transformUnresolvedIssuesCount));
const $cf1c06882619c9e1$export$b8e3d145af76ef26 = (baseUrl, version)=>(0, $bjRvd.releaseVersion)(baseUrl, (0, $fwoXA.transformReleasableToRestVersion)(version)).then((0, $1U5Zu.transformVersion));
const $cf1c06882619c9e1$export$d9a4a1588da51f7c = ()=>{
    const [showBanner, setShowBanner] = (0, $eUqFw.useState)(false);
    const accountId = (0, $dxcfv.useAccountId)();
    (0, $eUqFw.useEffect)(()=>{
        if (accountId != null) (0, $h2UKv.getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>setShowBanner(!hasDismissed)).catch((0, $h2UKv.fireReleaseAutomationBannerError));
    }, [
        accountId
    ]);
    const dismissBanner = async ()=>{
        setShowBanner(false);
        if (accountId != null) await (0, $h2UKv.dismissReleaseAutomationBanner)(accountId).catch((0, $h2UKv.fireReleaseAutomationBannerError));
    };
    return {
        showBanner: showBanner,
        dismissBanner: dismissBanner
    };
};

});
parcelRegister("hhKXI", function(module, exports) {

$parcel$export(module.exports, "getVersionEndpointUrl", () => $15beae478b5c5587$export$9513b66f34c81f7d);
$parcel$export(module.exports, "getVersion", () => $15beae478b5c5587$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $15beae478b5c5587$export$b7679bf23524baba);

var $2OdyW = parcelRequire("2OdyW");
const $15beae478b5c5587$export$9513b66f34c81f7d = (baseUrl, versionId)=>`${baseUrl}/rest/api/2/version/${versionId}`;
const $15beae478b5c5587$export$18ba274da71f4912 = (baseUrl, versionId)=>`${$15beae478b5c5587$export$9513b66f34c81f7d(baseUrl, versionId)}?expand=issuesstatus`;
const $15beae478b5c5587$export$fdc7e642e6597237 = (baseUrl, versionId)=>`${$15beae478b5c5587$export$9513b66f34c81f7d(baseUrl, versionId)}/unresolvedIssueCount`;
const $15beae478b5c5587$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, $2OdyW.default)($15beae478b5c5587$export$18ba274da71f4912(baseUrl, versionId));
const $15beae478b5c5587$export$b7679bf23524baba = (baseUrl, versionId)=>(0, $2OdyW.default)($15beae478b5c5587$export$fdc7e642e6597237(baseUrl, versionId));

});

parcelRegister("1U5Zu", function(module, exports) {

$parcel$export(module.exports, "transformVersion", () => $7578f99dff63f3ae$export$390ab7123357e756);
$parcel$export(module.exports, "transformUnresolvedIssuesCount", () => $7578f99dff63f3ae$export$9c917bd1ad6cfd7f);

var $8TSnQ = parcelRequire("8TSnQ");
const $7578f99dff63f3ae$var$transformStatus = (archived, released)=>{
    if (archived) return 0, $8TSnQ.ARCHIVED;
    if (released) return 0, $8TSnQ.RELEASED;
    return 0, $8TSnQ.UNRELEASED;
};
const $7578f99dff63f3ae$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
        toDo: toDo,
        inProgress: inProgress,
        done: done
    });
const $7578f99dff63f3ae$export$390ab7123357e756 = (restVersion)=>{
    const version = {
        id: restVersion.id,
        name: restVersion.name,
        description: restVersion.description ? restVersion.description : '',
        status: $7578f99dff63f3ae$var$transformStatus(restVersion.archived, restVersion.released),
        startDate: restVersion.startDate,
        releaseDate: restVersion.releaseDate,
        overdue: !!restVersion.overdue,
        projectId: restVersion.projectId
    };
    if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $7578f99dff63f3ae$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
    return version;
};
const $7578f99dff63f3ae$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;

});

parcelRegister("bjRvd", function(module, exports) {

$parcel$export(module.exports, "releaseVersion", () => $55484dc23ff7c8e7$export$b8e3d145af76ef26);

var $hhKXI = parcelRequire("hhKXI");

var $0VNDc = parcelRequire("0VNDc");
const $55484dc23ff7c8e7$export$b8e3d145af76ef26 = (baseUrl, version)=>{
    const url = (0, $hhKXI.getVersionEndpointUrl)(baseUrl, version.id);
    return (0, $0VNDc.default)(url, {
        method: 'put',
        body: JSON.stringify({
            ...version
        })
    });
};

});
parcelRegister("0VNDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ed1aa811c57db4$export$2e2bcd8739ae039);

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$63ed1aa811c57db4$export$2e2bcd8739ae039 = (url, options = {})=>{
    const option = {
        ...(0, $fVqUX.default),
        ...options
    };
    return fetch(url, option).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $7byHA.default)(status, str);
            });
        }
        return response.json();
    });
};

});


parcelRegister("fwoXA", function(module, exports) {

$parcel$export(module.exports, "transformReleasableToRestVersion", () => $932d4aea481a529a$export$6c7ef87ae81a803f);
$parcel$export(module.exports, "addDefaultReleaseDate", () => $932d4aea481a529a$export$a3871b8272282d64);

var $kFGm5 = parcelRequire("kFGm5");

var $HQAdK = parcelRequire("HQAdK");
const $932d4aea481a529a$export$6c7ef87ae81a803f = (version)=>{
    const restVersion = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(version, [
        'issuesStatus'
    ]);
    return {
        ...restVersion,
        released: true,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
        releaseDate: (0, $HQAdK.atlasKitToServerDateFormat)(version.releaseDate)
    };
};
const $932d4aea481a529a$export$a3871b8272282d64 = (version)=>{
    const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
    return {
        id: id,
        name: name,
        issuesStatus: issuesStatus,
        moveUnfixedIssuesTo: '',
        releaseDate: releaseDate ? (0, $HQAdK.ISOToAtlasKitDateFormat)(releaseDate) : (0, $HQAdK.todayToAtlasKitDateFormat)()
    };
};

});
parcelRegister("HQAdK", function(module, exports) {

$parcel$export(module.exports, "ISOToAtlasKitDateFormat", () => $629e634a20ef6183$export$4df2a4adbb0e5391);
$parcel$export(module.exports, "todayToAtlasKitDateFormat", () => $629e634a20ef6183$export$d9939b5b983bc908);
$parcel$export(module.exports, "atlasKitToServerDateFormat", () => $629e634a20ef6183$export$bcd9d8ad44970e94);
// GOOD TO KNOW
// ------------
// Atlaskit DatePicker has two date formats:
// 1. YYYY/MM/DD which user sees on the screen
// 2. YYYY-MM-DD which DatePicker passes to the onChange callback (ISO format)
//
// Sometimes Atlaskit doesn't convert user-input date (YYYY/MM/DD) to the ISO format.
// It happens when some action gets dispatched before DatePicker receives blur event.
// So we fix it here by replacing `/` with `-`.

var $EN9B6 = parcelRequire("EN9B6");

var $f9KE2 = parcelRequire("f9KE2");

var $7ueqz = parcelRequire("7ueqz");

var $3xcI8 = parcelRequire("3xcI8");

var $2w5Tn = parcelRequire("2w5Tn");
const $629e634a20ef6183$export$c9b0b9ddba618847 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $3xcI8.default)(dateStr.replace(/\//g, '-'));
        if ((0, $7ueqz.default)(date)) return (0, $EN9B6.default)(new Date(date), 'yyyy-MM-dd');
    }
    return '';
};
const $629e634a20ef6183$export$4df2a4adbb0e5391 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $3xcI8.default)(dateStr);
        if ((0, $7ueqz.default)(date)) return (0, $EN9B6.default)(new Date(date), 'yyyy/MM/dd');
    }
    return '';
};
const $629e634a20ef6183$export$d9939b5b983bc908 = ()=>(0, $EN9B6.default)((0, $2w5Tn.default)(), 'yyyy/MM/dd');
const $629e634a20ef6183$export$6350eb346dee22fe = (dateStr)=>{
    if (dateStr) return (0, $7ueqz.default)((0, $3xcI8.default)(dateStr.replace(/\//g, '-')));
    return false;
};
const $629e634a20ef6183$export$bcd9d8ad44970e94 = (dateStr)=>{
    let dateISO;
    if (dateStr && $629e634a20ef6183$export$6350eb346dee22fe(dateStr)) dateISO = $629e634a20ef6183$export$c9b0b9ddba618847(dateStr);
    return dateISO || null;
};
const $629e634a20ef6183$export$e36c611b04695a2e = (dateStr)=>{
    const date = (0, $3xcI8.default)(dateStr);
    if ((0, $7ueqz.default)(date)) return (0, $f9KE2.default)(date);
    return undefined;
};
const $629e634a20ef6183$export$8d60448f563c47a6 = {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
};

});


parcelRegister("h2UKv", function(module, exports) {

$parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", () => $1f0c288e927ded70$export$b8702a08258e1098);
$parcel$export(module.exports, "dismissReleaseAutomationBanner", () => $1f0c288e927ded70$export$7f678873378110b8);
$parcel$export(module.exports, "fireReleaseAutomationBannerError", () => $1f0c288e927ded70$export$76cf25de6ffb8030);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");
const $1f0c288e927ded70$export$b8702a08258e1098 = async (accountId)=>{
    const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, (0, $fVqUX.default));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 401: If credential is incorrect, the user is not authorised and should not see the banner
    if (status === 401) return true;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
    if (status === 404) return false;
    throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
};
const $1f0c288e927ded70$export$7f678873378110b8 = async (accountId)=>{
    const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, {
        ...(0, $fVqUX.default),
        method: 'PUT',
        body: JSON.stringify(true)
    });
    if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
};
const $1f0c288e927ded70$export$76cf25de6ffb8030 = (error)=>(0, $guiFP.default)({
        meta: {
            id: 'versions.release.version.modal.release.automation.user.property',
            packageName: 'jiraVersionModals',
            teamName: 'fusion-solaris'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });

});


parcelRegister("hAL5N", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $5c5aebc459b9d68d$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $5c5aebc459b9d68d$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_HANDLERS", () => $5c5aebc459b9d68d$export$bc2eae499d5e6cec);
$parcel$export(module.exports, "setHandlers", () => $5c5aebc459b9d68d$export$241365d6eef6c169);
$parcel$export(module.exports, "INITIAL_REQUEST", () => $5c5aebc459b9d68d$export$e1efaa8f406867bb);
$parcel$export(module.exports, "initialRequest", () => $5c5aebc459b9d68d$export$3bccc812fdbc3954);
$parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", () => $5c5aebc459b9d68d$export$37a4e72ae1c0a1b5);
$parcel$export(module.exports, "initialRequestSuccess", () => $5c5aebc459b9d68d$export$fbef4e4c40c06dae);
$parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", () => $5c5aebc459b9d68d$export$a558394b02430fa);
$parcel$export(module.exports, "setUnreleasedIssuesCount", () => $5c5aebc459b9d68d$export$521ad3c091ef9f4b);
$parcel$export(module.exports, "SWAP_ISSUES", () => $5c5aebc459b9d68d$export$1e105c795f4df801);
$parcel$export(module.exports, "swapIssues", () => $5c5aebc459b9d68d$export$f9d0b46042c1093d);
$parcel$export(module.exports, "RELEASE_VERSION_UPDATE", () => $5c5aebc459b9d68d$export$a7943bb075347bd4);
$parcel$export(module.exports, "releaseVersionUpdate", () => $5c5aebc459b9d68d$export$6e5a7b93aba64e1c);
$parcel$export(module.exports, "RELEASE_VERSION_REQUEST", () => $5c5aebc459b9d68d$export$b482a6a2418379a4);
$parcel$export(module.exports, "releaseVersionRequest", () => $5c5aebc459b9d68d$export$f25b64441359ac5d);
$parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", () => $5c5aebc459b9d68d$export$9f45f3d28614fd39);
$parcel$export(module.exports, "releaseVersionSuccess", () => $5c5aebc459b9d68d$export$ef2ca233886223dd);
$parcel$export(module.exports, "RELEASE_VERSION_FAILURE", () => $5c5aebc459b9d68d$export$f79008eab89d4f56);
$parcel$export(module.exports, "releaseVersionFailure", () => $5c5aebc459b9d68d$export$f40837cd887e0e7d);
$parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", () => $5c5aebc459b9d68d$export$15feef518e3a0f72);
$parcel$export(module.exports, "releaseVersionValidationFailure", () => $5c5aebc459b9d68d$export$d206bb816a78117c);
$parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", () => $5c5aebc459b9d68d$export$95df9c1149c6615a);
$parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", () => $5c5aebc459b9d68d$export$778db09b7ef0e606);
$parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", () => $5c5aebc459b9d68d$export$95c8c0da90c589f);
$parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", () => $5c5aebc459b9d68d$export$bec051bc82fda7b3);
const $5c5aebc459b9d68d$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
const $5c5aebc459b9d68d$export$2f04de43fe27971a = (payload)=>({
        type: $5c5aebc459b9d68d$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $5c5aebc459b9d68d$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
const $5c5aebc459b9d68d$export$241365d6eef6c169 = (payload)=>({
        type: $5c5aebc459b9d68d$export$bc2eae499d5e6cec,
        payload: payload
    });
const $5c5aebc459b9d68d$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
const $5c5aebc459b9d68d$export$3bccc812fdbc3954 = (versionId)=>({
        type: $5c5aebc459b9d68d$export$e1efaa8f406867bb,
        payload: versionId
    });
const $5c5aebc459b9d68d$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
const $5c5aebc459b9d68d$export$fbef4e4c40c06dae = (version)=>({
        type: $5c5aebc459b9d68d$export$37a4e72ae1c0a1b5,
        payload: version
    });
const $5c5aebc459b9d68d$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
const $5c5aebc459b9d68d$export$521ad3c091ef9f4b = (payload)=>({
        type: $5c5aebc459b9d68d$export$a558394b02430fa,
        payload: payload
    });
const $5c5aebc459b9d68d$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
const $5c5aebc459b9d68d$export$f99c3c9c04cda7ae = (payload)=>({
        type: $5c5aebc459b9d68d$export$33d1af9ce619539e,
        payload: payload
    });
const $5c5aebc459b9d68d$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
const $5c5aebc459b9d68d$export$f9d0b46042c1093d = (payload)=>({
        type: $5c5aebc459b9d68d$export$1e105c795f4df801,
        payload: payload
    });
const $5c5aebc459b9d68d$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
const $5c5aebc459b9d68d$export$6e5a7b93aba64e1c = (payload)=>({
        type: $5c5aebc459b9d68d$export$a7943bb075347bd4,
        payload: payload
    });
const $5c5aebc459b9d68d$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
const $5c5aebc459b9d68d$export$f25b64441359ac5d = ()=>({
        type: $5c5aebc459b9d68d$export$b482a6a2418379a4
    });
const $5c5aebc459b9d68d$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
const $5c5aebc459b9d68d$export$ef2ca233886223dd = (payload)=>({
        type: $5c5aebc459b9d68d$export$9f45f3d28614fd39,
        payload: payload
    });
const $5c5aebc459b9d68d$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
const $5c5aebc459b9d68d$export$f40837cd887e0e7d = (payload)=>({
        type: $5c5aebc459b9d68d$export$f79008eab89d4f56,
        payload: payload
    });
const $5c5aebc459b9d68d$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
const $5c5aebc459b9d68d$export$d206bb816a78117c = (payload)=>({
        type: $5c5aebc459b9d68d$export$15feef518e3a0f72,
        payload: payload
    });
const $5c5aebc459b9d68d$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
const $5c5aebc459b9d68d$export$778db09b7ef0e606 = (payload)=>({
        type: $5c5aebc459b9d68d$export$95df9c1149c6615a,
        payload: payload
    });
const $5c5aebc459b9d68d$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
const $5c5aebc459b9d68d$export$bec051bc82fda7b3 = (payload)=>({
        type: $5c5aebc459b9d68d$export$95c8c0da90c589f,
        payload: payload
    });

});

parcelRegister("NkJgt", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $e670380806eb8ddc$export$f654b28f82155665);
$parcel$export(module.exports, "getProjectKey", () => $e670380806eb8ddc$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getVersion", () => $e670380806eb8ddc$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getVersionId", () => $e670380806eb8ddc$export$d0a84488c5034e2b);
$parcel$export(module.exports, "getTodoInProgressIssuesCount", () => $e670380806eb8ddc$export$7c32856ef2a2cb6);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $e670380806eb8ddc$export$b7679bf23524baba);
$parcel$export(module.exports, "getResolvedIssuesCount", () => $e670380806eb8ddc$export$96488947387acc21);
$parcel$export(module.exports, "getDoneIssuesCount", () => $e670380806eb8ddc$export$51a75c074eb3f4d4);
$parcel$export(module.exports, "getName", () => $e670380806eb8ddc$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getReleaseDate", () => $e670380806eb8ddc$export$9664966f747b3c18);
$parcel$export(module.exports, "getErrors", () => $e670380806eb8ddc$export$501239432719417d);
$parcel$export(module.exports, "isSwapSelected", () => $e670380806eb8ddc$export$8fff49f07292ff94);
$parcel$export(module.exports, "isSaving", () => $e670380806eb8ddc$export$3b51d1dcee070cea);
$parcel$export(module.exports, "isInitiating", () => $e670380806eb8ddc$export$8b35c3a55e549a0d);
$parcel$export(module.exports, "getOnOpenedHandler", () => $e670380806eb8ddc$export$9cb228195867c4ba);
$parcel$export(module.exports, "getOnErrorHandler", () => $e670380806eb8ddc$export$1a207b7e599ecdc7);
$parcel$export(module.exports, "getOnSuccessHandler", () => $e670380806eb8ddc$export$8fb55c0bc571e8e7);
$parcel$export(module.exports, "getOnCancelHandler", () => $e670380806eb8ddc$export$e776433ed4e15cc4);
$parcel$export(module.exports, "getPropsForVersionPicker", () => $e670380806eb8ddc$export$95a1217518b748b8);
$parcel$export(module.exports, "isReleaseDisabled", () => $e670380806eb8ddc$export$2a2f3b8b22c4af1f);
$parcel$export(module.exports, "isKeepingIssues", () => $e670380806eb8ddc$export$e783a0e680cad4ec);
$parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", () => $e670380806eb8ddc$export$37c3a3cc47342e65);
$parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", () => $e670380806eb8ddc$export$24122e8f86a884b6);

var $df4Sl = parcelRequire("df4Sl");
const $e670380806eb8ddc$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $e670380806eb8ddc$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
const $e670380806eb8ddc$export$c506eb22e615ba4a = (state)=>state.version;
const $e670380806eb8ddc$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
const $e670380806eb8ddc$export$d0a84488c5034e2b = (state)=>state.version.id;
const $e670380806eb8ddc$export$7c32856ef2a2cb6 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $e670380806eb8ddc$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
const $e670380806eb8ddc$export$36e4434605c3220 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $e670380806eb8ddc$export$96488947387acc21 = (state)=>$e670380806eb8ddc$export$36e4434605c3220(state) - $e670380806eb8ddc$export$b7679bf23524baba(state);
const $e670380806eb8ddc$export$51a75c074eb3f4d4 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done;
    return 0;
};
const $e670380806eb8ddc$export$7d9f7e9c1c02b41e = (state)=>$e670380806eb8ddc$export$c506eb22e615ba4a(state).name || '';
const $e670380806eb8ddc$export$9664966f747b3c18 = (state)=>$e670380806eb8ddc$export$c506eb22e615ba4a(state).releaseDate || '';
const $e670380806eb8ddc$export$501239432719417d = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.errors, (errors)=>{
    const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
    return {
        releaseDate: releaseDate,
        moveUnfixedIssuesTo: moveUnfixedIssuesTo
    };
});
const $e670380806eb8ddc$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
const $e670380806eb8ddc$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
const $e670380806eb8ddc$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
const $e670380806eb8ddc$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
const $e670380806eb8ddc$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
const $e670380806eb8ddc$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
const $e670380806eb8ddc$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
const $e670380806eb8ddc$export$95a1217518b748b8 = (state)=>({
        baseUrl: state.context.baseUrl,
        projectKey: state.context.projectKey,
        shouldSwapIssues: state.shouldSwapIssues,
        isSaving: state.isSaving,
        versionId: state.version.id
    });
const $e670380806eb8ddc$var$hasTodoInProgressIssues = (state)=>$e670380806eb8ddc$export$7c32856ef2a2cb6(state) > 0;
const $e670380806eb8ddc$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $e670380806eb8ddc$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$e670380806eb8ddc$export$57294fc3393f82ae(state);
const $e670380806eb8ddc$export$e783a0e680cad4ec = (state)=>{
    if ($e670380806eb8ddc$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$e670380806eb8ddc$export$57294fc3393f82ae(state) : true;
    return true;
};
const $e670380806eb8ddc$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
const $e670380806eb8ddc$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;

});


parcelRegister("4uQ2H", function(module, exports) {

$parcel$export(module.exports, "initialRequestSuccessEpic", () => $e78c6ab587c09fc0$export$9d210f02e9fc914d);
$parcel$export(module.exports, "releaseVersionRequestSuccessEpic", () => $e78c6ab587c09fc0$export$77863bf7469abd8f);
$parcel$export(module.exports, "releaseVersionRequestFailureEpic", () => $e78c6ab587c09fc0$export$79de050f634d0345);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("iects");

var $hAL5N = parcelRequire("hAL5N");

var $NkJgt = parcelRequire("NkJgt");
const $e78c6ab587c09fc0$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, $hAL5N.INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const versionId = (0, $NkJgt.getVersionId)(state);
        (0, $NkJgt.getOnOpenedHandler)(state)({
            id: versionId
        });
        return (0, $3JafE.Observable).empty();
    });
const $e78c6ab587c09fc0$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, $hAL5N.RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
        const state = store.getState();
        (0, $NkJgt.getOnSuccessHandler)(state)(version, {
            shouldRedirectToCreateReleaseNotes: (0, $NkJgt.shouldRedirectToCreateReleaseNotes)(state)
        });
        return (0, $3JafE.Observable).empty();
    });
const $e78c6ab587c09fc0$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, $hAL5N.RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
        const state = store.getState();
        (0, $NkJgt.getOnErrorHandler)(state)(id);
        return (0, $3JafE.Observable).empty();
    });

});


parcelRegister("ds1bp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b97d522dd5713d9$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");

var $2UL4E = parcelRequire("2UL4E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b97d522dd5713d9$export$2e2bcd8739ae039 = (rootEpic)=>(0, $8FRHo.default)({
        appName: 'release-version',
        rootReducer: $2UL4E.default,
        rootEpic: rootEpic
    });

});
parcelRegister("2UL4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0f10f3756fd654$export$2e2bcd8739ae039);

var $aeTOI = parcelRequire("aeTOI");

var $2vzCR = parcelRequire("2vzCR");

var $jG2Eu = parcelRequire("jG2Eu");

var $kFGm5 = parcelRequire("kFGm5");

var $hAL5N = parcelRequire("hAL5N");
const $aa0f10f3756fd654$export$d4c72bab9d6cc13a = {
    context: {
        baseUrl: '',
        projectKey: ''
    },
    handlers: {
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    version: {
        id: '0',
        name: ''
    },
    unresolvedIssuesCount: 0,
    shouldSwapIssues: true,
    isInitiating: true,
    isSaving: false,
    shouldShowCreateReleaseNotesOption: false,
    hasReleaseNote: false,
    shouldRedirectToCreateReleaseNotes: true
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa0f10f3756fd654$export$2e2bcd8739ae039 = (state = $aa0f10f3756fd654$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $hAL5N.SET_CONTEXT:
            {
                const context = action.payload;
                // @ts-expect-error - TS2322 - Type 'SetContextPayload | undefined' is not assignable to type '{ readonly baseUrl: string; readonly projectKey: string; }'.
                return {
                    ...state,
                    context: context
                };
            }
        case 0, $hAL5N.SET_VERSION_UNRESOLVED_ISSUES_COUNT:
            {
                const unresolvedIssuesCount = action.payload;
                return {
                    ...state,
                    unresolvedIssuesCount: unresolvedIssuesCount || 0
                };
            }
        case 0, $hAL5N.SWAP_ISSUES:
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            return {
                ...state,
                shouldSwapIssues: action.payload
            };
        case 0, $hAL5N.SET_HANDLERS:
            {
                const handlers = action.payload;
                return {
                    ...state,
                    handlers: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, state.handlers, handlers)
                };
            }
        case 0, $hAL5N.INITIAL_REQUEST_SUCCESS:
            {
                const version = action.payload;
                // @ts-expect-error - TS2322 - Type 'Pick<{ version: ReleasableVersion | undefined; context: { readonly baseUrl: string; readonly projectKey: string; }; handlers: Handlers; errors?: ReleaseVersionValidationErrors | undefined; isInitiating?: boolean | undefined; isSaving?: boolean | undefined; shouldSwapIssues: boolean; }, "version" | ... 4 more ... | "...' is not assignable to type 'State'.
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))({
                    ...state,
                    version: version
                }, 'isInitiating');
            }
        case 0, $hAL5N.RELEASE_VERSION_UPDATE:
            {
                const prevVersion = state.version;
                const prevErrors = state.errors;
                const nextVersion = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const errors = {};
                if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                return {
                    ...state,
                    errors: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, prevErrors, errors),
                    version: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, prevVersion, nextVersion)
                };
            }
        case 0, $hAL5N.RELEASE_VERSION_VALIDATION_FAILURE:
            {
                const errors = action.payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))({
                    ...state,
                    errors: errors
                }, 'isSaving');
            }
        case 0, $hAL5N.RELEASE_VERSION_REQUEST:
            return {
                ...state,
                isSaving: true
            };
        case 0, $hAL5N.RELEASE_VERSION_SUCCESS:
        case 0, $hAL5N.RELEASE_VERSION_FAILURE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state, 'isSaving');
        case 0, $hAL5N.INITIAL_REQUEST:
            return state;
        case 0, $hAL5N.CREATE_RELEASE_NOTES_OPTIONS:
            return {
                ...state,
                ...action.payload,
                shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
            };
        case 0, $hAL5N.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
            {
                const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                return {
                    ...state,
                    shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("eDaUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d03ef71021402f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hAL5N = parcelRequire("hAL5N");

var $NkJgt = parcelRequire("NkJgt");

var $fovxd = parcelRequire("fovxd");

var $dy4qg = parcelRequire("dy4qg");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62d03ef71021402f$var$mapStateToProps = (state)=>({
        unresolvedIssuesCount: (0, $NkJgt.getUnresolvedIssuesCount)(state),
        isReleaseDisabled: (0, $NkJgt.isReleaseDisabled)(state),
        name: (0, $NkJgt.getName)(state),
        isSaving: (0, $NkJgt.isSaving)(state),
        isInitiating: (0, $NkJgt.isInitiating)(state),
        onCancel: (0, $NkJgt.getOnCancelHandler)(state),
        Content: $fovxd.default,
        shouldRedirectToCreateReleaseNotes: (0, $NkJgt.shouldRedirectToCreateReleaseNotes)(state),
        shouldShowCreateReleaseNotesOption: (0, $NkJgt.shouldShowCreateReleaseNotesOption)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62d03ef71021402f$var$dispatcher = (dispatch)=>({
        onRelease: ()=>dispatch((0, $hAL5N.releaseVersionRequest)()),
        setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, $hAL5N.releaseRedirectToCreateReleaseNotesStatus)(value))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62d03ef71021402f$var$mapDispatchToProps = (dispatch)=>$62d03ef71021402f$var$dispatcher(dispatch);
var $62d03ef71021402f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($62d03ef71021402f$var$mapStateToProps, $62d03ef71021402f$var$mapDispatchToProps)((0, $dy4qg.default));

});
parcelRegister("fovxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce0ecffe99d52e6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bGuoA = parcelRequire("bGuoA");

var $NkJgt = parcelRequire("NkJgt");

var $kHfwo = parcelRequire("kHfwo");

var $dbfjk = parcelRequire("dbfjk");

var $61sUV = parcelRequire("61sUV");

var $guMt8 = parcelRequire("guMt8");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ce0ecffe99d52e6$var$mapStateToProps = (state)=>({
        SwapIssues: $61sUV.default,
        ReleaseDate: $dbfjk.default,
        ReleaseAutomationBanner: $kHfwo.ReleaseAutomationBanner,
        doneIssues: (0, $NkJgt.getDoneIssuesCount)(state),
        unresolvedIssuesCount: (0, $NkJgt.getUnresolvedIssuesCount)(state),
        resolvedIssuesCount: (0, $NkJgt.getResolvedIssuesCount)(state),
        unresolvedIssuesUrl: (0, $bGuoA.getUnresolvedIssuesInVersionJql)((0, $NkJgt.getProjectKey)(state), (0, $NkJgt.getName)(state)),
        resolvedIssueUrl: (0, $bGuoA.getResolvedIssuesInVersionJql)((0, $NkJgt.getProjectKey)(state), (0, $NkJgt.getName)(state))
    });
var $4ce0ecffe99d52e6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($4ce0ecffe99d52e6$var$mapStateToProps, {})((0, $guMt8.default));

});
parcelRegister("bGuoA", function(module, exports) {

$parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", () => $a5d13d11899a4a98$export$6ec377b2fc8168c7);
$parcel$export(module.exports, "getResolvedIssuesInVersionJql", () => $a5d13d11899a4a98$export$c14e075033246e76);

var $8g5hT = parcelRequire("8g5hT");
const $a5d13d11899a4a98$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
    const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND fixVersion = ${(0, $8g5hT.toQuotedString)(versionName)} AND resolution is EMPTY`;
    return (0, $8g5hT.createIssuesUrl)(jql);
};
const $a5d13d11899a4a98$export$c14e075033246e76 = (projectKey, versionName)=>(0, $8g5hT.createIssuesUrl)(`project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND fixVersion = ${(0, $8g5hT.toQuotedString)(versionName)} AND resolution is NOT EMPTY`);

});
parcelRegister("8g5hT", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $101afcc0c6282ae9$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $101afcc0c6282ae9$export$c623a4b2d8c439ab);
const $101afcc0c6282ae9$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $101afcc0c6282ae9$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $101afcc0c6282ae9$var$ENCODE_MAP[character] || character;
};
const $101afcc0c6282ae9$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $101afcc0c6282ae9$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $101afcc0c6282ae9$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("kHfwo", function(module, exports) {

$parcel$export(module.exports, "ReleaseAutomationBanner", () => $34845756c7dd80e7$export$45e1a2bd60e730ec);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $l5PRC = parcelRequire("l5PRC");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $lwZcK = parcelRequire("lwZcK");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $1G9Bj = parcelRequire("1G9Bj");

var $7M4Al = parcelRequire("7M4Al");

var $acHkD = parcelRequire("acHkD");
const $34845756c7dd80e7$export$d6be0a6034032add = (projectProps)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $34845756c7dd80e7$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
    const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, $1G9Bj.useReleaseAutomationBanner)();
    const { data: projectContext, loading: loading, error: error } = (0, $bNe1g.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (loading) return null;
    if (error) throw error;
    if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
    const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
    const renderBannerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34845756c7dd80e7$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34845756c7dd80e7$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        width: 14,
        height: 16,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7M4Al))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34845756c7dd80e7$var$CallToAction, {
        href: $34845756c7dd80e7$export$d6be0a6034032add({
            isSimplified: isSimplified,
            projectKey: projectKey,
            projectType: projectType
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        title: formatMessage((0, $acHkD.default).setupReleaseAutomation),
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'newRuleAutomationLink');
            dismissBanner();
        }
    }, formatMessage((0, $acHkD.default).setupReleaseAutomation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34845756c7dd80e7$var$Dismiss, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        shouldFitContainer: true,
        appearance: "subtle" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dismissButton');
            dismissBanner();
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage((0, $acHkD.default).dismiss),
            size: "small"
        })
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$238d30785c4bca84),
        sourceName: "releaseAutomationCallToAction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), isTransitionEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34845756c7dd80e7$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5PRC.default), {
        in: showBanner,
        timeout: $34845756c7dd80e7$var$TRANSITION_DURATION,
        classNames: "release-automation-banner",
        unmountOnExit: true
    }, renderBannerContent)) : renderBannerContent);
};
const $34845756c7dd80e7$var$BANNER_HEIGHT = 80;
const $34845756c7dd80e7$var$TRANSITION_DURATION = 400; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34845756c7dd80e7$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19it1krb _2rko1y44 _1yt4pxbi _zulppxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34845756c7dd80e7$var$CallToAction = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34845756c7dd80e7$var$Dismiss = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34845756c7dd80e7$var$Spacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34845756c7dd80e7$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1k7uidpf _lnbg15vq _11ok15vq _pmb0idpf _lghnkb7n _1sz115vq _iayz15vq _3g9qys9h _19q1o91y _28jmkb7n _1b0e15vq _19ci15vq _13e1ys9h _zsv0idpf _1g5d15vq _153n15vq _qigkidpf _khvao91y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7M4Al", function(module, exports) {
module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();

});

parcelRegister("acHkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0d9c0e85215ca5d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e0d9c0e85215ca5d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setupReleaseAutomation: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
        "defaultMessage": "Set up release automation"
    },
    dismiss: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("dbfjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $550d00e0029722a1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hAL5N = parcelRequire("hAL5N");

var $NkJgt = parcelRequire("NkJgt");

var $c5s8D = parcelRequire("c5s8D");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $550d00e0029722a1$var$mapStateToProps = (state)=>({
        releaseDate: (0, $NkJgt.getReleaseDate)(state),
        errors: (0, $NkJgt.getErrors)(state),
        isSaving: (0, $NkJgt.isSaving)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $550d00e0029722a1$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $hAL5N.releaseVersionUpdate)(version))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $550d00e0029722a1$var$mapDispatchToProps = (dispatch)=>$550d00e0029722a1$var$dispatcher(dispatch);
var $550d00e0029722a1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($550d00e0029722a1$var$mapStateToProps, $550d00e0029722a1$var$mapDispatchToProps)((0, $c5s8D.default));

});
parcelRegister("c5s8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad339b61e86f0c8f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5Okns = parcelRequire("5Okns");

var $jXg8H = parcelRequire("jXg8H");

var $4LhB6 = parcelRequire("4LhB6");

var $gTWD6 = parcelRequire("gTWD6");

var $giAhk = parcelRequire("giAhk");

var $9QVRQ = parcelRequire("9QVRQ");

var $ePLnG = parcelRequire("ePLnG");
class $ad339b61e86f0c8f$export$55e7fadddcffb796 extends (0, $eUqFw.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            releaseDate: update.releaseDate
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
        const { releaseDate: releaseDateError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "releaseDate",
            label: formatMessage((0, $ePLnG.default).releaseDate)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad339b61e86f0c8f$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QVRQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
                isDisabled: isSaving,
                defaultValue: releaseDate !== '' ? (0, $5Okns.default)(new Date(releaseDate)) : releaseDate,
                onChange: this.onReleaseDateChange,
                placeholder: formatMessage((0, $gTWD6.default).placeholderDate),
                locale: locale
            })))), releaseDateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad339b61e86f0c8f$var$ValidationError, null, releaseDateError));
    }
    constructor(...args){
        super(...args);
        this.onReleaseDateChange = (releaseDate)=>{
            if (releaseDate) this.inputChange({
                releaseDate: releaseDate
            });
            else this.inputChange({
                releaseDate: ''
            });
        };
    }
}
var $ad339b61e86f0c8f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($ad339b61e86f0c8f$export$55e7fadddcffb796);
const $ad339b61e86f0c8f$var$DatePickerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
});
const $ad339b61e86f0c8f$var$ValidationError = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _syaz17af",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gTWD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba19be2166d93a9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bba19be2166d93a9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderDate: {
        "id": "common-date.utils.date-messages.placeholder-date",
        "defaultMessage": "e.g. 2018/12/31"
    }
});

});

parcelRegister("9QVRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5895ff07d400e936$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line jira/react/no-class-components
class $5895ff07d400e936$var$SuppressEscKey extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "presentation",
            onKeyDown: this.onKeyEvent,
            onKeyUp: this.onKeyEvent
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.onKeyEvent = (e)=>{
            const { key: key } = e;
            if (key === 'Escape') {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }
        };
    }
}
var $5895ff07d400e936$export$2e2bcd8739ae039 = $5895ff07d400e936$var$SuppressEscKey;

});

parcelRegister("ePLnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d15cda0be51163$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $29d15cda0be51163$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releaseDate: {
        "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
        "defaultMessage": "Release date"
    }
});

});



parcelRegister("61sUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afae041dcfdc44d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $lNNXV = parcelRequire("lNNXV");

var $2bDKn = parcelRequire("2bDKn");

var $hAL5N = parcelRequire("hAL5N");

var $NkJgt = parcelRequire("NkJgt");

var $fvCKH = parcelRequire("fvCKH");
const $5afae041dcfdc44d$var$mapStateToProps = ()=>{
    const renderVersionPickerFactory = (0, $5iWql.default)((shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bDKn.default), {
                isDisabled: !shouldSwapIssues || isSaving,
                baseUrl: baseUrl,
                projectKey: projectKey,
                ignore: [
                    versionId
                ],
                versionStatuses: [
                    'UNRELEASED'
                ],
                ...props
            }));
    return (state)=>{
        const { baseUrl: baseUrl, projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, $NkJgt.getPropsForVersionPicker)(state);
        return {
            toDoInProgressIssuesCount: (0, $NkJgt.getTodoInProgressIssuesCount)(state),
            isSaving: (0, $NkJgt.isSaving)(state),
            shouldSwapIssues: (0, $NkJgt.isSwapSelected)(state),
            errors: (0, $NkJgt.getErrors)(state),
            renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)
        };
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5afae041dcfdc44d$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $hAL5N.releaseVersionUpdate)(version)),
        // @ts-expect-error - TS7006 - Parameter 'swap' implicitly has an 'any' type.
        onSwapIssuesSelected: (swap)=>dispatch((0, $hAL5N.swapIssues)(swap))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5afae041dcfdc44d$var$mapDispatchToProps = (dispatch)=>$5afae041dcfdc44d$var$dispatcher(dispatch);
var $5afae041dcfdc44d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($5afae041dcfdc44d$var$mapStateToProps, $5afae041dcfdc44d$var$mapDispatchToProps)((0, $fvCKH.default));

});
parcelRegister("2bDKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f552bcc3ac9d1db$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8un0w = parcelRequire("8un0w");

var $lDnwy = parcelRequire("lDnwy");

var $giAhk = parcelRequire("giAhk");

var $6VlKp = parcelRequire("6VlKp");

var $jWQHj = parcelRequire("jWQHj");

var $gX6pV = parcelRequire("gX6pV");
class $3f552bcc3ac9d1db$export$c7c815960e157d78 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            baseUrl: '',
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            value.id,
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $gX6pV.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return (0, $jWQHj.transformVersion)(value);
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lDnwy.Picker), {
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $gX6pV.default).error),
            onSelected: this.onSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args);
        this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                id: selectedOption.value,
                name: selectedOption.label
            }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        this.onFetchOptions = (filter)=>(0, $6VlKp.requestVersions)(this.props.baseUrl, this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
    }
}
var $3f552bcc3ac9d1db$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $8un0w.default)({
    onSelected: 'versionPicker'
})($3f552bcc3ac9d1db$export$c7c815960e157d78));

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("lDnwy", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $2d2d94270c4a127f$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $2d2d94270c4a127f$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $2d2d94270c4a127f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $1ZpeU = parcelRequire("1ZpeU");
var $jvznW = parcelRequire("jvznW");
var $jQxSL = parcelRequire("jQxSL");
var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");


var $2eG9N = parcelRequire("2eG9N");

var $3Hawu = parcelRequire("3Hawu");

var $8BJaJ = parcelRequire("8BJaJ");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $giAhk = parcelRequire("giAhk");

var $9JyRh = parcelRequire("9JyRh");
const $2d2d94270c4a127f$export$3a3072dd741f354b = 500;
const $2d2d94270c4a127f$var$Clear = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                link: {
                    borderRadius: 0,
                    borderBottom: `${(0, $c9TLT.gridSize) * 0.25}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N40})`}`,
                    height: 'auto',
                    /*
       * Button doesn't have any top/bottom padding so moving it up a bit using a negative margin
       * is the most convenient way to fix its appearance inside the dropdown menu which has its own padding.
       */ marginTop: `-${(0, $c9TLT.gridSize) * 0.7}px`,
                    marginBottom: "var(--ds-space-050, 4px)",
                    textAlign: 'left'
                }
            }
        })
    });
const $2d2d94270c4a127f$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N90})`,
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $2d2d94270c4a127f$export$ba25329847403e11 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props); // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        };
        this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        };
        this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        };
        this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        };
        this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        };
        this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        };
        this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        };
        this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            });
        this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        };
        this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        };
        this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$Clear, {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $9JyRh.default).clearSelected)), menuListProps.children));
        };
        this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props));
        };
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $2d2d94270c4a127f$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZpeU.default) : (0, $28t3A.default);
        if (isAsync) return 0, $3Hawu.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $jvznW.default) : (0, $5wCDk.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        };
        const MenuList = {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $9JyRh.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>formatMessage((0, $9JyRh.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $9JyRh.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$2d2d94270c4a127f$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BJaJ.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $2d2d94270c4a127f$var$PickerWithIntl = (0, $giAhk.injectIntlV2)($2d2d94270c4a127f$export$ba25329847403e11);
const $2d2d94270c4a127f$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$PickerWithIntl, props);
};
$2d2d94270c4a127f$var$DefaultPicker.defaultProps = $2d2d94270c4a127f$export$ba25329847403e11.defaultProps;
var $2d2d94270c4a127f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2d2d94270c4a127f$var$DefaultPicker;
const $2d2d94270c4a127f$var$StyledValueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ZpeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $724bfa4358c46735$export$2e2bcd8739ae039);

var $03F4S = parcelRequire("03F4S");

var $5FjBr = parcelRequire("5FjBr");
const $724bfa4358c46735$var$AsyncCreatableSelect = (0, $5FjBr.default)((0, $03F4S.default));
var $724bfa4358c46735$export$2e2bcd8739ae039 = $724bfa4358c46735$var$AsyncCreatableSelect;

});
parcelRegister("03F4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b02518902b6778$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $3IL7Z = parcelRequire("3IL7Z");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $00b02518902b6778$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $3IL7Z.u)(props);
    var creatableProps = (0, $7IqRg.u)(stateManagerProps);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $00b02518902b6778$export$2e2bcd8739ae039 = $00b02518902b6778$var$AsyncCreatableSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});



parcelRegister("jvznW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632e850af918cb2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $bVKeg = parcelRequire("bVKeg");
const $a632e850af918cb2$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $bVKeg.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $a632e850af918cb2$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($a632e850af918cb2$var$CheckboxSelectInternal);
var $a632e850af918cb2$export$2e2bcd8739ae039 = $a632e850af918cb2$var$CheckboxSelect;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02468a1d390d1515$var$_radioChecked = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("a7ob3")));
function $02468a1d390d1515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $02468a1d390d1515$var$_radioChecked.default
    }));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});
parcelRegister("a7ob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd4fef0eed872c$var$_react = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75dd4fef0eed872c$var$_UNSAFE_baseNew = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75dd4fef0eed872c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd4fef0eed872c$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $75dd4fef0eed872c$var$_react.default.createElement($75dd4fef0eed872c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$75dd4fef0eed872c$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $75dd4fef0eed872c$var$_default = module.exports.default = $75dd4fef0eed872c$var$RadioCheckedIcon;

});




parcelRegister("3Hawu", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $7680050c258e1266$export$ee664e5add893f9);

var $fm9CZ = parcelRequire("fm9CZ");

var $eGI9v = parcelRequire("eGI9v");
const $7680050c258e1266$export$ee664e5add893f9 = (0, $eGI9v.default)('select', {
    onChange: 'changed'
})((0, $fm9CZ.default));

});
parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
const $a14ede2f273d8bdb$var$AsyncSelect = (0, $5FjBr.default)((0, $hgTYM.default));
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = $a14ede2f273d8bdb$var$AsyncSelect;

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});



parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});

parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $73a5c9d720aa66e1$exports).P400,
            '> span': {
                color: (0, $73a5c9d720aa66e1$exports).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("9JyRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd98b27101186e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd98b27101186e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("6VlKp", function(module, exports) {

$parcel$export(module.exports, "requestVersions", () => $eab07ac33dd7887e$export$aadfb092a4919504);

var $iMdPn = parcelRequire("iMdPn");

var $jWQHj = parcelRequire("jWQHj");
const $eab07ac33dd7887e$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
    const pageVersions = await (0, $iMdPn.requestVersions)(baseUrl, projectKey, filter, versionStatuses, ignore);
    return (0, $jWQHj.transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
};

});
parcelRegister("iMdPn", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $7bf581aba73f2361$export$f6b2881bc1090cea);
$parcel$export(module.exports, "requestVersions", () => $7bf581aba73f2361$export$aadfb092a4919504);

var $53ciZ = parcelRequire("53ciZ");

var $2OdyW = parcelRequire("2OdyW");
const $7bf581aba73f2361$export$f6b2881bc1090cea = 5;
const $7bf581aba73f2361$export$b702ac644ba114c = (baseUrl, projectKey)=>`${baseUrl}/rest/api/2/project/${projectKey}/version`;
const $7bf581aba73f2361$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $53ciZ.stringify)({
        startAt: 0,
        query: filter,
        maxResults: $7bf581aba73f2361$export$f6b2881bc1090cea + ignore.length,
        orderBy: '+NAME',
        status: versionStatuses.join(',')
    });
const $7bf581aba73f2361$export$8395ad088d65e586 = (baseUrl, projectKey, filter, versionStatuses, ignore)=>`${$7bf581aba73f2361$export$b702ac644ba114c(baseUrl, projectKey)}?${$7bf581aba73f2361$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
const $7bf581aba73f2361$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore)=>(0, $2OdyW.default)($7bf581aba73f2361$export$8395ad088d65e586(baseUrl, projectKey, filter, versionStatuses, ignore));

});

parcelRegister("jWQHj", function(module, exports) {

$parcel$export(module.exports, "transformVersion", () => $ad307bad793a6feb$export$390ab7123357e756);
$parcel$export(module.exports, "transformVersions", () => $ad307bad793a6feb$export$8bc7a3929156b65e);

var $iMdPn = parcelRequire("iMdPn");
const $ad307bad793a6feb$export$390ab7123357e756 = (component)=>({
        value: component.id,
        label: component.name
    });
const $ad307bad793a6feb$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($ad307bad793a6feb$export$390ab7123357e756).slice(0, (0, $iMdPn.MAX_RESULTS));

});


parcelRegister("gX6pV", function(module, exports) {

$parcel$export(module.exports, "default", () => $33227c0e2a4366f1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $33227c0e2a4366f1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    error: {
        "id": "version-picker.error",
        "defaultMessage": "We couldn't retrieve versions"
    },
    placeholder: {
        "id": "version-picker.placeholder",
        "defaultMessage": "Select version"
    }
});

});


parcelRegister("fvCKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ddf867bced4dbf0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $hnuwz = parcelRequire("hnuwz");

var $giAhk = parcelRequire("giAhk");

var $d78C8 = parcelRequire("d78C8");
// eslint-disable-next-line jira/react/no-class-components
class $6ddf867bced4dbf0$var$SwapIssues extends (0, $eUqFw.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
        const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "UnresolvedIssue",
            isRequired: true,
            label: formatMessage((0, $d78C8.default).unresolvedIssuesHeader, {
                issues: toDoInProgressIssuesCount
            })
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
                isDisabled: isSaving,
                isChecked: shouldSwapIssues,
                onChange: this.onMoveIssuesSelected,
                label: formatMessage((0, $d78C8.default).unresolvedIssuesMove, {
                    issues: toDoInProgressIssuesCount
                }),
                testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ddf867bced4dbf0$var$VersionPickerContainer, null, renderVersionPicker({
                onSelected: this.onSwapIssues
            })), moveUnfixedIssuesToError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ddf867bced4dbf0$var$ValidationError, null, formatMessage((0, $d78C8.default).invalidVersionChosen, {
                issues: toDoInProgressIssuesCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
                isDisabled: isSaving,
                isChecked: !shouldSwapIssues,
                onChange: this.onRemoveVersionFromIssuesSelected,
                label: formatMessage((0, $d78C8.default).unresolvedIssuesIgnore),
                testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
            })));
    }
    constructor(...args){
        super(...args);
        this.onSwapIssues = (version)=>{
            if (version) this.inputChange({
                moveUnfixedIssuesTo: version.id
            });
            else this.inputChange({
                moveUnfixedIssuesTo: ''
            });
        };
        this.onMoveIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(true);
        };
        this.onRemoveVersionFromIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(false);
        };
    }
}
var $6ddf867bced4dbf0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($6ddf867bced4dbf0$var$SwapIssues);
const $6ddf867bced4dbf0$var$VersionPickerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s88z4d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ddf867bced4dbf0$var$ValidationError = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _syaz17af",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

const $306a59ce4e6b6146$var$packageName = "platform-pkg";
const $306a59ce4e6b6146$var$packageVersion = "0.0.0-use.local";
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});

parcelRegister("d78C8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e239dc871af167fe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e239dc871af167fe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unresolvedIssuesHeader: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
        "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
    },
    unresolvedIssuesMove: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
        "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
    },
    unresolvedIssuesIgnore: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
        "defaultMessage": "Ignore unresolved issues"
    },
    invalidVersionChosen: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
    }
});

});



parcelRegister("guMt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb17371ed27f8bd7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8uD7Y = parcelRequire("8uD7Y");

var $giAhk = parcelRequire("giAhk");

var $hKfDa = parcelRequire("hKfDa");
class $bb17371ed27f8bd7$export$7c6e2c02157bb7d2 extends (0, $eUqFw.Component) {
    renderDescriptionWithIssues() {
        const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
        const unresolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: unresolvedIssuesUrl
        }, formatMessage((0, $hKfDa.default).descriptionWithIssuesCount, {
            issues: unresolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $hKfDa.default).descriptionWithIssues,
            values: {
                issueCountLink: unresolvedIssueJqlViewLink
            }
        }));
    }
    renderDescriptionWithoutIssues() {
        const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
        const resolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: resolvedIssueUrl
        }, formatMessage((0, $hKfDa.default).descriptionWithoutIssues, {
            doneIssues: resolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $hKfDa.default).descriptionWithoutIssuesRestMessage,
            values: {
                issueCountLink: resolvedIssueJqlViewLink
            }
        }));
    }
    render() {
        const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SwapIssues, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseDate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraSoftwareReleasesVersionDetail",
            teamName: "fusion-solaris",
            id: "releaseAutomationBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseAutomationBanner, null)));
    }
}
var $bb17371ed27f8bd7$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($bb17371ed27f8bd7$export$7c6e2c02157bb7d2);

});
parcelRegister("hKfDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $86af127a4d5c54fb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $86af127a4d5c54fb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionWithIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues",
        "defaultMessage": "This release contains {issueCountLink}."
    },
    descriptionWithIssuesCount: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
        "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
    },
    descriptionWithoutIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
    },
    descriptionWithoutIssuesRestMessage: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
        "defaultMessage": "{issueCountLink} will be released."
    }
});

});



parcelRegister("dy4qg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d78a78c7ff63015c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hFmdR = parcelRequire("hFmdR");

var $8un0w = parcelRequire("8un0w");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");


var $9P2nn = parcelRequire("9P2nn");

var $ayyN0 = parcelRequire("ayyN0");
class $d78a78c7ff63015c$export$b77f092f9cf63f1e extends (0, $eUqFw.Component) {
    render() {
        const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
        if (isInitiating) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            isOpen: true,
            width: "small" // @ts-expect-error - TS2769 - No overload matches this call.
            ,
            onClose: onCancel,
            testId: "version-modals.release-version-modal.release-version-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, unresolvedIssuesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
            appearance: "warning"
        }, formatMessage((0, $ayyN0.default).header, {
            name: name
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $ayyN0.default).header, {
            name: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, null)), this.renderFooter(this.props)));
    }
    constructor(...args){
        super(...args);
        // @ts-expect-error - TS2344 - Type '{ new (): HTMLElement; prototype: HTMLElement; }' does not satisfy the constraint 'keyof IntrinsicElements | ForwardRefExoticComponent<any> | (new (props: any) => Component<any, {}, any>) | ((props: any, context?: any) => ReactElement<...> | null)'.
        this.onButtonMounted = (node)=>{
            this.button = node;
        } // focus needs to be set on button in order to hide date-picker
        ;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onRelease = (...args)=>{
            if (this.button) this.button.focus();
            this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
        };
        this.renderFooter = (props)=>{
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d78a78c7ff63015c$var$FooterContainer, {
                showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
            }, shouldShowCreateReleaseNotesOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9P2nn.CreateReleaseNotesPrompt), {
                onChange: setRedirectToCreateReleaseNotesStatus,
                value: shouldRedirectToCreateReleaseNotes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d78a78c7ff63015c$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $d78a78c7ff63015c$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                onClick: this.onRelease,
                appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                type: "submit",
                isDisabled: isReleaseDisabled,
                ref: this.onButtonMounted
            }, formatMessage((0, $ayyN0.default).release)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "subtle-link",
                isDisabled: false,
                onClick: onCancel
            }, formatMessage((0, $ayyN0.default).cancel)))));
        };
    }
}
var $d78a78c7ff63015c$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('releaseVersions', (0, $41ea3621645e2acc$export$1171103ea9083ffa))((0, $8un0w.default)({
    onRelease: (isCreateReleaseNotesOptedIn)=>({
            name: 'release',
            isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
        }),
    onCancel: 'cancel'
})((0, $giAhk.injectIntlV2)($d78a78c7ff63015c$export$b77f092f9cf63f1e)));
const $d78a78c7ff63015c$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d78a78c7ff63015c$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d78a78c7ff63015c$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9P2nn", function(module, exports) {

$parcel$export(module.exports, "CreateReleaseNotesPrompt", () => $cc1db2e985aa58e9$export$d8a8f048cf64e9ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8K3Vh = parcelRequire("8K3Vh");
const $cc1db2e985aa58e9$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onValueChange = (0, $eUqFw.useCallback)((event)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'checkbox'
        }), 'releaseModalCreateReleaseNotesCheckbox');
        onChange(event.target.checked);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc1db2e985aa58e9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        name: "createReleaseNotes",
        label: formatMessage((0, $8K3Vh.default).createReleaseNotesTitle),
        isChecked: value,
        onChange: onValueChange
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc1db2e985aa58e9$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("8K3Vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $693f755caab0ac6e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $693f755caab0ac6e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createReleaseNotesTitle: {
        "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
        "defaultMessage": "Create release notes"
    }
});

});


parcelRegister("ayyN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a200f0a2103a3fcd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a200f0a2103a3fcd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-directories.versions.release-version-modal.header",
        "defaultMessage": "Release {name}"
    },
    release: {
        "id": "project-directories.versions.release-version-modal.release",
        "defaultMessage": "Release"
    },
    cancel: {
        "id": "project-directories.versions.release-version-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});




parcelRegister("iJ6Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $db939f5c0ee903b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db939f5c0ee903b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "software-releases-launch-card.version-status.button-label",
        "defaultMessage": "Version release state dropdown"
    },
    archiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.archive-option-label",
        "defaultMessage": "Archive"
    },
    archivedLabel: {
        "id": "software-releases-launch-card.version-status.archived-label",
        "defaultMessage": "Archived"
    },
    releasedLabel: {
        "id": "software-releases-launch-card.version-status.released-label",
        "defaultMessage": "Released"
    },
    releaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.release-option-label",
        "defaultMessage": "Release"
    },
    unarchiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.unarchive-option-label",
        "defaultMessage": "Unarchive"
    },
    unreleaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.unrelease-option-label",
        "defaultMessage": "Unrelease"
    },
    unreleasedLabel: {
        "id": "software-releases-launch-card.version-status.unreleased-label",
        "defaultMessage": "Unreleased"
    },
    archiveFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.archive-failed-flag-description",
        "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
    },
    genericUpdateFailedFlagTitle: {
        "id": "software-releases-launch-card.version-status.generic-update-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.release-failed-flag-description",
        "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
    }
});

});





parcelRegister("hUZx2", function(module, exports) {

$parcel$export(module.exports, "IssueListWithHeaderWithErrorBoundary", () => $947aa25bb134e4ca$export$d97e9356033839cd);

var $6jRNu = parcelRequire("6jRNu");

var $2QePb = parcelRequire("2QePb");

var $eMFcA = parcelRequire("eMFcA");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");

var $gVPP8 = parcelRequire("gVPP8");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $2jdHI = parcelRequire("2jdHI");

var $8WuJm = parcelRequire("8WuJm");

var $9t9g0 = parcelRequire("9t9g0");

var $5Knhe = parcelRequire("5Knhe");

var $9TlRa = parcelRequire("9TlRa");

var $ephMr = parcelRequire("ephMr");

var $4mKYT = parcelRequire("4mKYT");

var $53FY6 = parcelRequire("53FY6");

var $7Syii = parcelRequire("7Syii");

var $5AnOG = parcelRequire("5AnOG");

var $ltcBr = parcelRequire("ltcBr");

var $gLyQY = parcelRequire("gLyQY");

var $7RpGT = parcelRequire("7RpGT");

var $21rsX = parcelRequire("21rsX");

var $cFeOt = parcelRequire("cFeOt");

var $9zLeS = parcelRequire("9zLeS");

var $k5eBA = parcelRequire("k5eBA");

var $cEndX = parcelRequire("cEndX");

var $jMfaQ = parcelRequire("jMfaQ");
const $947aa25bb134e4ca$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $947aa25bb134e4ca$var$LOAD_MORE_PAGE_SIZE = 50;
const $947aa25bb134e4ca$var$IssuesRefetchable = ({ jiraVersion: jiraVersion })=>{
    const { isAnyFilterApplied: isAnyFilterApplied } = (0, $9TlRa.useFilterSortingQueryParams)();
    const { filters: filters, sortBy: sortBy } = (0, $ephMr.useVersionIssuesGraphQLVariables)();
    const onExperienceSuccess = (0, $7Syii.useViewVersionDetailsPageExperienceSuccess)(); /* eslint-disable @atlassian/relay/unused-fields */ 
    const versionFragmentRef = (0, $iWLL0.usePaginationFragment)((0, $eMFcA.default), jiraVersion);
    /* eslint-enable @atlassian/relay/unused-fields */ const { data: jiraVersionData, refetch: refetch, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = versionFragmentRef;
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        if (hasNext) loadNext($947aa25bb134e4ca$var$LOAD_MORE_PAGE_SIZE);
    }, [
        loadNext,
        hasNext
    ]);
    const issueEdges = jiraVersionData.issuesForList.edges.filter(Boolean);
    const totalIssuesCount = jiraVersionData.issuesForList.totalCount ?? issueEdges.length;
    const nextPageSize = Math.min(totalIssuesCount - issueEdges.length, $947aa25bb134e4ca$var$LOAD_MORE_PAGE_SIZE);
    const setLoadMoreElement = (0, $jMfaQ.useIntersectionObserver)({
        margin: 40,
        onIntersection: loadNextPage
    });
    const variables = (0, $4mKYT.useDeepMemo)({
        sortBy: sortBy,
        filters: filters
    });
    const [debouncedRefetch] = (0, $2jdHI.default)((refetchVariables)=>{
        refetch({
            id: jiraVersionData.id,
            ...refetchVariables
        });
    }, 500);
    const isFirstRenderRef = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (isFirstRenderRef.current) // Initial rendering is already after the query is executed by react-resource-router, so we don't need to run refetch for initial rendering.
        isFirstRenderRef.current = false;
        else debouncedRefetch(variables);
    }, [
        debouncedRefetch,
        variables
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueEdges.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.empty-view",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "fusion-solaris",
        onError: ()=>{
            // We don't want to fire experience failure even if the table rendering fails when the table is empty. Table’s empty state doesn’t really show useful information anyway.
            onExperienceSuccess();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AnOG.EmptyView), {
        jiraVersion: jiraVersionData,
        isAnyFilterApplied: isAnyFilterApplied,
        textFilter: filters.searchStr ?? null
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7RpGT.Issues), {
        jiraIssueEdgesReference: issueEdges,
        jiraVersion: jiraVersionData,
        jiraVersionRefetch: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$LoadingMoreContainer, {
        ref: setLoadMoreElement
    }, isLoadingNext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $21rsX.IssueListSkeleton), {
        rowCount: nextPageSize
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.screen-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEndX.IssueListScreenAnalytics), {
        jiraVersionReference: jiraVersionData,
        jiraIssueEdgesReference: issueEdges
    })));
};
const $947aa25bb134e4ca$var$IssueListWithHeader = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $2QePb.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionDetailsTable",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
        id: "issuesListDevDetailsDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVPP8.DevDetailsDialogLoaderAsync), {
        scopeId: $947aa25bb134e4ca$var$DEV_DETAILS_DIALOG_SCOPE_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleSection), {
        jiraVersion: data,
        uiType: "ISSUES",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$HeaderCollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $947aa25bb134e4ca$var$sectionTitleStyles
            }, formatMessage((0, $k5eBA.default).issues))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "jira.software.releases.version.detail.issue-total-count",
                packageName: "jira-software-releases-version-detail-issue-list",
                teamName: "fusion-solaris"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLyQY.IssueTotalCount), {
                jiraVersion: data
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$HeaderRightWrapper, null, data.canAddAndRemoveIssues === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$AddIssueWrapper, {
                key: "addIssuesButton"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t9g0.AddIssuesToVersion), {
                appearance: "subtle",
                isIssueListFooterButton: true,
                jiraVersion: data,
                showIcon: true,
                showLabel: false
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFeOt.IssuesMoreButton), {
                key: "issuesMoreButton",
                jiraVersion: data,
                jiraIssueEdges: data.issuesForList.edges.filter(Boolean)
            }))),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zLeS.ListOptions), {
                jiraVersion: data
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "issues-refetchable",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $21rsX.IssueListSkeleton), {
                    rowCount: 10,
                    marginTop: (0, $c9TLT.gridSize) * 2
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$IssuesRefetchable, {
                jiraVersion: data
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Syii.ViewVersionDetailsPageExperienceSuccessTracker), null));
};
const $947aa25bb134e4ca$export$d97e9356033839cd = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $6jRNu.default), jiraVersion);
    const onExperienceFail = (0, $7Syii.useViewVersionDetailsPageExperienceFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltcBr.ErrorView), null),
        id: "jira.software.releases.version.detail.issue.list",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "fusion-solaris",
        onError: (location, error)=>{
            // We consider the experience to have failed if the issues don't render.
            onExperienceFail(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($947aa25bb134e4ca$var$IssueListWithHeader, {
        jiraVersion: jiraVersionData
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $947aa25bb134e4ca$var$LoadingMoreContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1tke7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $947aa25bb134e4ca$var$AddIssueWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $947aa25bb134e4ca$var$HeaderCollapsibleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $947aa25bb134e4ca$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $947aa25bb134e4ca$var$HeaderRightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $947aa25bb134e4ca$var$sectionTitleStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("6jRNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $05598d915740ecf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3899b8733ba6e7fa9ae649f9b64eb5ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $05598d915740ecf2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$05598d915740ecf2$var$node.hash = "dcffc936c288beebfd459b5bcb75d18a";
var $05598d915740ecf2$export$2e2bcd8739ae039 = $05598d915740ecf2$var$node;

});

parcelRegister("2QePb", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d434a2f3a29193$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc8305fdf5209e2adc6247847e2cf39d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96d434a2f3a29193$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": "first",
                "cursor": "after",
                "direction": "forward",
                "path": [
                    "issuesForList"
                ]
            }
        ]
    },
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "listOptions_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "issuesForList",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    },
                    {
                        "kind": "Variable",
                        "name": "filters",
                        "variableName": "filters"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__ListVersion_issuesForList_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "issuesForList.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issuesForList"
        }
    ],
    "type": "JiraVersion"
};
$96d434a2f3a29193$var$node.hash = "1b95186d8ae0c639ac2a3313467b4212";
var $96d434a2f3a29193$export$2e2bcd8739ae039 = $96d434a2f3a29193$var$node;

});

parcelRegister("eMFcA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fac72c00dc85fe1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d98ff3c3657d3c7af19176617bd8b2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $glALz = parcelRequire("glALz");
const $4fac72c00dc85fe1$var$node = function() {
    var v0 = [
        "issuesForList"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "filters"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $glALz.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyView_softwareReleasesVersionDetailIssueList"
            },
            {
                "kind": "FragmentSpread",
                "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issuesForList",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        },
                        {
                            "kind": "Variable",
                            "name": "filters",
                            "variableName": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "sortBy"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "__ListVersion_issuesForList_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "issuesForList.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "issuesForList"
            }
        ],
        "type": "JiraVersion"
    };
}();
$4fac72c00dc85fe1$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $4fac72c00dc85fe1$export$2e2bcd8739ae039 = $4fac72c00dc85fe1$var$node;

});
parcelRegister("glALz", function(module, exports) {

$parcel$export(module.exports, "default", () => $10241fe38bc2bcf6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72ccac9e2fb46b612f9922ec062b2a1b>>
 * @relayHash ecfc2ada532c47e2436d6145a90a9a99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26e25861f3c09cd6ac38042267a2bb3604873c383bc5c314249c167618f0c705
const $10241fe38bc2bcf6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v9 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v10 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = [
        v9 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = {
        "kind": "ScalarField",
        "name": "count"
    }, v18 = {
        "kind": "ScalarField",
        "name": "state"
    }, v19 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v20 = [
        v17 /*: any*/ 
    ], v21 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ]
    }, v22 = [
        v17 /*: any*/ ,
        v12 /*: any*/ 
    ], v23 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v22 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ ,
                                {
                                    "alias": "issuesForList",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v12 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "picture"
                                                                                                },
                                                                                                v14 /*: any*/ ,
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": v20 /*: any*/ 
                                                                                },
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v20 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v14 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v20 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "status"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v22 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v15 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26e25861f3c09cd6ac38042267a2bb3604873c383bc5c314249c167618f0c705",
            "metadata": {},
            "name": "verionDetailsIssueListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$10241fe38bc2bcf6$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $10241fe38bc2bcf6$export$2e2bcd8739ae039 = $10241fe38bc2bcf6$var$node;

});


parcelRegister("gVPP8", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $d943de865dd0122f$export$f5ffc0f323543e16);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d943de865dd0122f$var$DevDetailDialogLoaderWithContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("g6LDU")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index.tsx"
});
const $d943de865dd0122f$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d943de865dd0122f$var$DevDetailDialogLoaderWithContainer, props));
$d943de865dd0122f$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});
parcelRegister("g6LDU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("90cOZ")
]).then(()=>parcelRequire('g5FQE'));

});


parcelRegister("5Knhe", function(module, exports) {

$parcel$export(module.exports, "CollapsibleToggleButton", () => $0cbb50e50163a6b7$export$9438d677ba26a40a);
$parcel$export(module.exports, "CollapsibleSection", () => $0cbb50e50163a6b7$export$55b973e094275b13);

var $9rYWp = parcelRequire("9rYWp");

var $ktICy = parcelRequire("ktICy");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7T5mc = parcelRequire("7T5mc");

var $4Maqr = parcelRequire("4Maqr");
const $0cbb50e50163a6b7$var$getNewCollapsedUis = (currentState, type, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== type) : [
        ...currentState,
        type
    ];
const $0cbb50e50163a6b7$export$9438d677ba26a40a = ({ isCollapsed: isCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const icon = isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: formatMessage((0, $7T5mc.default).collapsedIconLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: formatMessage((0, $7T5mc.default).expandedIconLabel)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: icon,
        onClick: onClick
    });
};
const $0cbb50e50163a6b7$export$55b973e094275b13 = ({ jiraVersion: jiraVersion, uiType: uiType, renderHeader: renderHeader, renderBody: renderBody })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const version = (0, $iWLL0.useFragment)((0, $ktICy.default), jiraVersion);
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const [updateCollapsedUis] = (0, $iWLL0.useMutation)((0, $9rYWp.default));
    const onError = ()=>{
        (0, $guiFP.default)({
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesCollapsibleUiToggle',
                teamName: 'fusion-solaris'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const isCollapsed = collapsedUis.includes(uiType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderHeader(isCollapsed, ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'collapsedUiToggleButon'
        }), 'versionDetailsCollapsedUis', {
            uiType: uiType,
            action: isCollapsed ? 'expand' : 'collapse'
        });
        saveUserPreference($0cbb50e50163a6b7$var$getNewCollapsedUis(collapsedUis, uiType, isCollapsed));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cbb50e50163a6b7$var$CollapsibleContent, {
        isCollapsed: (0, $4Maqr.checkIsCollapsed)(version.collapsedUis, uiType)
    }, renderBody()));
};
const $0cbb50e50163a6b7$var$CollapsibleContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isCollapsed ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.isCollapsed ? "_otyr1jfw" : "_otyrze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9rYWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $002cb93e8a2c858f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91eb2a3d04e52917a45ca405de73e8cd>>
 * @relayHash 0d7cc146aa12b13eaa5a11bd667fa49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9
const $002cb93e8a2c858f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9",
            "metadata": {},
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$002cb93e8a2c858f$var$node.hash = "784b6375f621589ebabb1f85323c82aa";
var $002cb93e8a2c858f$export$2e2bcd8739ae039 = $002cb93e8a2c858f$var$node;

});

parcelRegister("ktICy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1669a8dd1d10902$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c85bb8d4319589d7107ce65db6b00c60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1669a8dd1d10902$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$c1669a8dd1d10902$var$node.hash = "4c7960151ff25f69412e79192a278d0e";
var $c1669a8dd1d10902$export$2e2bcd8739ae039 = $c1669a8dd1d10902$var$node;

});

parcelRegister("7T5mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $615b87ebaecf32ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $615b87ebaecf32ac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    collapsedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.collapsed-icon-label",
        "defaultMessage": "Click/enter to expand the section"
    },
    expandedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.expanded-icon-label",
        "defaultMessage": "Click/enter to collapse the section"
    }
});

});

parcelRegister("4Maqr", function(module, exports) {

$parcel$export(module.exports, "checkIsCollapsed", () => $c6817a0bbeb69efe$export$b5bb70308851c0e1);
const $c6817a0bbeb69efe$export$b5bb70308851c0e1 = (collapsedUis, type)=>(collapsedUis ?? []).includes(type);

});


parcelRegister("9TlRa", function(module, exports) {

$parcel$export(module.exports, "useFilterSortingQueryParams", () => $c2f93d551364b375$export$c59d013998b3679d);

var $8Qd0L = parcelRequire("8Qd0L");

var $iclz4 = parcelRequire("iclz4");


var $hTGN1 = parcelRequire("hTGN1");
const $c2f93d551364b375$var$joinValuesIfNotEmpty = (values)=>values.length ? values.join(',') : undefined;
const $c2f93d551364b375$export$c59d013998b3679d = ()=>{
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)((0, $d7c1ea1e2a683c50$export$e39925d10cebc0b), (0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac), (0, $d7c1ea1e2a683c50$export$c307007520232013), (0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd), (0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2), (0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6), (0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb));
    const parsedQueryParams = (0, $hTGN1.parseQueryParams)(queryParams);
    return {
        parsedQueryParams: parsedQueryParams,
        isAnyFilterApplied: (0, $hTGN1.isAnyFilterApplied)(parsedQueryParams),
        setTextFilterParam: (searchStr)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$e39925d10cebc0b)]: searchStr === '' || searchStr == null ? undefined : searchStr
            }),
        setEpicFilterParam: (issueIds)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(issueIds)
            }),
        setStatusCategoryFilterParam: (statusCategories)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$c307007520232013)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(statusCategories.map((0, $8Qd0L.statusCategoryForId)))
            }),
        setWarningsFilterParam: (warnings)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(warnings)
            }),
        setAssigneeFilterParam: (assignees)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(assignees)
            }),
        setSortByParam: (sortBy)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6)]: sortBy
            }),
        setSortOrderParam: (sortOrder)=>setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb)]: sortOrder
            }),
        clearAll: ()=>{
            setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$e39925d10cebc0b)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$c307007520232013)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showIssuesWithWarnings: (warnings)=>{
            setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$e39925d10cebc0b)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$c307007520232013)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(warnings),
                [(0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showStatusCategoryIssues: (statusCategories)=>{
            setQueryParams({
                [(0, $d7c1ea1e2a683c50$export$e39925d10cebc0b)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$c307007520232013)]: $c2f93d551364b375$var$joinValuesIfNotEmpty(statusCategories.map((0, $8Qd0L.statusCategoryForId))),
                [(0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6)]: undefined,
                [(0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb)]: undefined
            });
        }
    };
};
const $c2f93d551364b375$export$22b92ff6db8f144a = ()=>{
    const { parsedQueryParams: parsedQueryParams } = $c2f93d551364b375$export$c59d013998b3679d();
    return {
        sortByField: parsedQueryParams[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] ?? 'CREATED',
        sortOrder: parsedQueryParams[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] ?? 'ASC'
    };
};

});
const $d7c1ea1e2a683c50$export$e39925d10cebc0b = 'text';
const $d7c1ea1e2a683c50$export$b98a7875ddbefaac = 'epics';
const $d7c1ea1e2a683c50$export$c307007520232013 = 'statusCategory';
const $d7c1ea1e2a683c50$export$2552faed9df6a2cd = 'warnings';
const $d7c1ea1e2a683c50$export$f78d8c81fcad32a2 = 'assignee';
const $d7c1ea1e2a683c50$export$13d5b2891ca65cd6 = 'sortBy';
const $d7c1ea1e2a683c50$export$810a1f7ed2facfcb = 'sortOrder';


parcelRegister("4mKYT", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $fd3489af3dc28a6f$export$722debc0e56fea39);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $fd3489af3dc28a6f$export$722debc0e56fea39 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(value, ref.current)) ref.current = value;
    return ref.current;
};

});

parcelRegister("53FY6", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $4b3e3d817d9b52b1$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $4b3e3d817d9b52b1$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionDetailIssueList",
        teamName: "fusion-solaris"
    });

});

parcelRegister("7Syii", function(module, exports) {

$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $0690df084c6c4f27$export$f9fb921f60393679);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceSuccess", () => $0690df084c6c4f27$export$1a84e8ad118354e4);
$parcel$export(module.exports, "ViewVersionDetailsPageExperienceSuccessTracker", () => $0690df084c6c4f27$export$ab0e4c71ad46eacd);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $fDZ6r = parcelRequire("fDZ6r");

var $jrtsz = parcelRequire("jrtsz");
const $0690df084c6c4f27$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $0690df084c6c4f27$export$f9fb921f60393679 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $0690df084c6c4f27$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $0690df084c6c4f27$export$1a84e8ad118354e4 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $0690df084c6c4f27$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $0690df084c6c4f27$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $jrtsz.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $0690df084c6c4f27$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("jrtsz", function(module, exports) {

$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $eea2db460dabb114$export$b6a91b2d78273787);

var $ciulY = parcelRequire("ciulY");

var $ixwgj = parcelRequire("ixwgj");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $eea2db460dabb114$export$a3138047c831fa4e = (0, $ciulY.withSuspense)(()=>(0, $lB25E.useResource)((0, $ixwgj.projectContextResource)));
const $eea2db460dabb114$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $eea2db460dabb114$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $6vrw7.toProjectKey)(data.projectKey),
        projectId: (0, $6vrw7.toProjectId)(data.projectId.toString())
    };
};
const $eea2db460dabb114$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $eea2db460dabb114$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});


parcelRegister("5AnOG", function(module, exports) {

$parcel$export(module.exports, "EmptyView", () => $bd230d8fc1b5e3af$export$f716ac8971c5316e);

var $bpebS = parcelRequire("bpebS");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $9t9g0 = parcelRequire("9t9g0");

var $9TlRa = parcelRequire("9TlRa");

var $7J2l4 = parcelRequire("7J2l4");

var $2u4dg = parcelRequire("2u4dg");

var $bmhsf = parcelRequire("bmhsf");
const $bd230d8fc1b5e3af$export$f716ac8971c5316e = ({ jiraVersion: jiraVersion, isAnyFilterApplied: isAnyFilterApplied, textFilter: textFilter })=>{
    const { clearAll: clearAll } = (0, $9TlRa.useFilterSortingQueryParams)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $bpebS.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd230d8fc1b5e3af$var$Container, {
        "data-testid": "software-releases-version-detail-issue-list.ui.empty-view"
    }, isAnyFilterApplied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: textFilter !== null ? formatMessage((0, $bmhsf.default).noIssuesMatchTextFilterHeader, {
            textFilter: textFilter
        }) : formatMessage((0, $bmhsf.default).noIssuesMatchFilterHeader),
        description: textFilter !== null ? formatMessage((0, $bmhsf.default).noIssuesMatchTextFilterDescription) : formatMessage((0, $bmhsf.default).noIssuesMatchFilterDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2u4dg))),
        imageWidth: (0, $c9TLT.gridSize) * 8,
        imageHeight: (0, $c9TLT.gridSize) * 11.5,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                clearAll();
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clearFilter');
            }
        }, formatMessage((0, $bmhsf.default).clearFilters))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $bmhsf.default).noIssuesInVersionHeader),
        description: formatMessage((0, $bmhsf.default).noIssuesInVersionDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7J2l4))),
        imageWidth: (0, $c9TLT.gridSize) * 16,
        imageHeight: (0, $c9TLT.gridSize) * 13,
        primaryAction: version?.canAddAndRemoveIssues === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t9g0.AddIssuesToVersion), {
            appearance: "primary",
            jiraVersion: version
        }) : undefined
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd230d8fc1b5e3af$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bpebS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c02c5ef24972c560$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69fe4b1ae49101ed737d416416098410>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c02c5ef24972c560$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyView_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            "action": "LOG",
            "path": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        }
    ],
    "type": "JiraVersion"
};
$c02c5ef24972c560$var$node.hash = "e747dc1997c64c6a07fe54d01ff7878c";
var $c02c5ef24972c560$export$2e2bcd8739ae039 = $c02c5ef24972c560$var$node;

});

parcelRegister("7J2l4", function(module, exports) {
module.exports = new URL("noIssuesInVersion.348ccc3b.svg", import.meta.url).toString();

});

parcelRegister("2u4dg", function(module, exports) {
module.exports = new URL("noSearchResults.d74f9061.svg", import.meta.url).toString();

});

parcelRegister("bmhsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $908abd380d518e49$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $908abd380d518e49$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // No issues in version case.
    noIssuesInVersionHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-header",
        "defaultMessage": "Nothing to see here"
    },
    noIssuesInVersionDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description",
        "defaultMessage": "No issues have been added yet."
    },
    // Non-text filter applied, no matching issues.
    noIssuesMatchFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header",
        "defaultMessage": "No issues here"
    },
    noIssuesMatchFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description",
        "defaultMessage": "We didn't find any issues that match the filters you've chosen"
    },
    // Text filter applied, no matching issues.
    // Note that non-text filters may *also* be applied. These messages cover both cases.
    noIssuesMatchTextFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-header",
        "defaultMessage": "We didn't find any results for \"{textFilter}\""
    },
    noIssuesMatchTextFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-description",
        "defaultMessage": "Try changing your search or check any filters."
    },
    clearFilters: {
        "id": "software-releases-version-detail-issue-list.empty-view.clear-filters",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("ltcBr", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $c149fa6def4f57f8$export$8c68b6013ae44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kqLQW = parcelRequire("kqLQW");

var $ivzof = parcelRequire("ivzof");
const $c149fa6def4f57f8$export$8c68b6013ae44ca6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c149fa6def4f57f8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c149fa6def4f57f8$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kqLQW))),
        alt: formatMessage((0, $ivzof.default).errorImageAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, formatMessage((0, $ivzof.default).failToLoadTitleNonFianl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c149fa6def4f57f8$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: ()=>{
            window.location.reload();
        }
    }, formatMessage((0, $ivzof.default).refreshButtonLabel))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c149fa6def4f57f8$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1epz _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c149fa6def4f57f8$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $c149fa6def4f57f8$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqLQW", function(module, exports) {
module.exports = new URL("error.e4b20277.svg", import.meta.url).toString();

});

parcelRegister("ivzof", function(module, exports) {

$parcel$export(module.exports, "default", () => $936557d80a4acb69$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $936557d80a4acb69$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failToLoadTitleNonFianl: {
        "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl",
        "defaultMessage": "Can't load issues"
    },
    refreshButtonLabel: {
        "id": "software-releases-version-detail-issue-list.error-view.refresh-button-label",
        "defaultMessage": "Refresh page"
    },
    errorImageAlt: {
        "id": "software-releases-version-detail-issue-list.error-view.error-image-alt",
        "defaultMessage": "Image that shows loading issues failed."
    }
});

});


parcelRegister("gLyQY", function(module, exports) {

$parcel$export(module.exports, "IssueTotalCount", () => $6108fc60bde3cab1$export$7866c3f349a6505);

var $cuySF = parcelRequire("cuySF");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");
const $6108fc60bde3cab1$export$7866c3f349a6505 = ({ jiraVersion: jiraVersion })=>{
    const data = (0, $iWLL0.useFragment)((0, $cuySF.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6108fc60bde3cab1$var$TotalCountLozenge, null, data.allIssuesRedesignTemp.totalCount);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6108fc60bde3cab1$var$TotalCountLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk4zhb _1wyb1skh _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i7vkz _2rkoftgi _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cuySF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a049094b0fc5c6ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f5e9e98ceace44d2a9daca4b2abd30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a049094b0fc5c6ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTotalCount_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssuesRedesignTemp",
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssuesRedesignTemp.totalCount"
                    }
                ]
            },
            "action": "THROW",
            "path": "allIssuesRedesignTemp"
        }
    ],
    "type": "JiraVersion"
};
$a049094b0fc5c6ae$var$node.hash = "aaf1e03a6deba9e0e365569571ef5db3";
var $a049094b0fc5c6ae$export$2e2bcd8739ae039 = $a049094b0fc5c6ae$var$node;

});


parcelRegister("7RpGT", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $ba5d892e84b1cb17$export$1cb51167b20548a0);

var $8ECvf = parcelRequire("8ECvf");

var $kKlXs = parcelRequire("kKlXs");

var $61GVo = parcelRequire("61GVo");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $4bMJ9 = parcelRequire("4bMJ9");

var $lFZVp = parcelRequire("lFZVp");

var $yyqSx = parcelRequire("yyqSx");

var $lmjwy = parcelRequire("lmjwy");

var $64DwS = parcelRequire("64DwS");
const $ba5d892e84b1cb17$export$1cb51167b20548a0 = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersion: jiraVersion, jiraVersionRefetch: jiraVersionRefetch })=>{
    const [isFeatureFlagEmptyStateModalOpen, setIsFeatureFlagEmptyStateModalOpen] = (0, $eUqFw.useState)(false);
    const jiraIssueEdgeReferenceData = (0, $iWLL0.useFragment)((0, $61GVo.default), jiraIssueEdgesReference);
    const version = (0, $iWLL0.useFragment)((0, $kKlXs.default), jiraVersion);
    const [versionRefetch, refetch] = (0, $iWLL0.useRefetchableFragment)((0, $8ECvf.default), jiraVersionRefetch);
    const [refetchDevOpsProviders] = (0, $4bMJ9.useSuspenselessRefetch)((0, $lFZVp.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const featureFlagProviders = (versionRefetch.devOpsSummarisedEntities?.providers.featureFlagProviders ?? []).filter(Boolean);
    const nodes = jiraIssueEdgeReferenceData?.map((edge)=>edge.node).filter(Boolean); // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>(0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0 : node.devOpsSummarisedEntities?.summarisedDeployments?.count != null && node.devOpsSummarisedEntities?.summarisedDeployments?.count > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>(0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(node.summarisedBuilds?.count) > 0 : Number(node.devOpsSummarisedEntities?.summarisedBuilds?.count) > 0) || nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    const hasDevelopments = hasCommits || hasPullRequests || hasBranches || hasReviews;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5d892e84b1cb17$var$IssuesContainer, null, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64DwS.IssueCard), {
            rowNum: i + 1,
            key: node.key,
            jiraIssue: node,
            jiraVersion: version,
            onFeatureFlagEmptyStateModalOpen: setIsFeatureFlagEmptyStateModalOpen,
            hasBambooDeployment: hasBambooDeployment,
            hasDeployments: hasDeployments,
            hasDevelopments: hasDevelopments,
            hasBuilds: hasBuilds
        })), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmjwy.FeatureFlagEmptyStateExperienceModal), {
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isFeatureFlagEmptyStateModalOpen,
        onClose: ()=>setIsFeatureFlagEmptyStateModalOpen(false),
        onInstallSuccess: ()=>refetchDevOpsProviders({
                id: versionRefetch.id,
                isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)()
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5d892e84b1cb17$var$IssuesContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbykb7n _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ECvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f0d336f24eabd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c3b088ebe7d201a81358ecbe804e714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $lFZVp = parcelRequire("lFZVp");
const $67f0d336f24eabd9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $lFZVp.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "DevOpsFeatureFlagProvider",
                                            "kind": "LinkedField",
                                            "name": "featureFlagProviders",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal"
                                                }
                                            ]
                                        },
                                        "action": "NONE",
                                        "path": "devOpsSummarisedEntities.providers.featureFlagProviders"
                                    }
                                ]
                            },
                            "action": "NONE",
                            "path": "devOpsSummarisedEntities.providers"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$67f0d336f24eabd9$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $67f0d336f24eabd9$export$2e2bcd8739ae039 = $67f0d336f24eabd9$var$node;

});
parcelRegister("lFZVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e05905655e3159a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b14598e6e29ba4e7759c67bfb497ffd8>>
 * @relayHash e4db664c14f25d2cbd5656b656921164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc
const $3e05905655e3159a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc",
            "metadata": {},
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3e05905655e3159a$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $3e05905655e3159a$export$2e2bcd8739ae039 = $3e05905655e3159a$var$node;

});


parcelRegister("kKlXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b990691679e513$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94a622415ac6299a5332ad1cea1e5c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31b990691679e513$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$31b990691679e513$var$node.hash = "224ec701c99ed1fc3c24b3cb47926906";
var $31b990691679e513$export$2e2bcd8739ae039 = $31b990691679e513$var$node;

});

parcelRegister("61GVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adab2752aeb0fb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ad0a579d777c01dd2ce7de72d5cc3c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4adab2752aeb0fb0$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ], v1 = [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v0 /*: any*/ 
        },
        {
            "concreteType": "DevOpsSummarisedBuilds",
            "kind": "LinkedField",
            "name": "summarisedBuilds",
            "plural": false,
            "selections": v0 /*: any*/ 
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "node.key"
                        },
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "pullrequest",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "branch",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "review",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "commit",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "build",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "deploymentEnvironments",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                    "kind": "LinkedField",
                                                                    "name": "topEnvironments",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue"
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$4adab2752aeb0fb0$var$node.hash = "7e745b10637620df992daefcbbc74bdc";
var $4adab2752aeb0fb0$export$2e2bcd8739ae039 = $4adab2752aeb0fb0$var$node;

});

parcelRegister("lmjwy", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceModal", () => $4086cec5e8e1568e$export$4e1e35d50ebac320);

var $i3tT1 = parcelRequire("i3tT1");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $9iKbD = parcelRequire("9iKbD");
const $4086cec5e8e1568e$export$4e1e35d50ebac320 = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
    const featureFlagProviders = (0, $iWLL0.useFragment)((0, $i3tT1.default), devOpsFeatureFlagProviders);
    const entryPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iKbD.FeatureFlagEmptyStateExperienceEntryPoint), {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isOpen,
        onClose: onClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: 592,
        autoFocus: false
    }, entryPoint)) : null);
};

});
parcelRegister("i3tT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d1f801524694ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5ece995d5336893a3d038e4fba6e8d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $70d1f801524694ad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$70d1f801524694ad$var$node.hash = "0fbad5b696ab8a25991a0d1c79838173";
var $70d1f801524694ad$export$2e2bcd8739ae039 = $70d1f801524694ad$var$node;

});

parcelRegister("9iKbD", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceEntryPoint", () => $d34f2dafd3b8e230$export$d0d10a136f7d769f);

var $bnTlY = parcelRequire("bnTlY");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $huI7r = parcelRequire("huI7r");

var $bNe1g = parcelRequire("bNe1g");

var $3bVT2 = parcelRequire("3bVT2");

var $dWLk9 = parcelRequire("dWLk9");

var $6Ye5d = parcelRequire("6Ye5d");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d34f2dafd3b8e230$var$FeatureFlagEmptyStateExperienceQueryLoader = (0, $7rh0R.lazy)(()=>(parcelRequire("flvpY")).then((mod)=>mod.FeatureFlagsEmptyStateExperienceQueryLoader), {
    moduleId: "./src/packages/software/empty-state-experience/feature-flags/src/ui/index.tsx"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d34f2dafd3b8e230$var$Loading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1yt4koci",
            __cmplp.className
        ])
    });
});
const $d34f2dafd3b8e230$export$d0d10a136f7d769f = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $3bVT2.default));
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const onExperienceFail = (0, $6Ye5d.useViewFeatureFlagsEmptyStateExperienceExperienceFail)();
    const featureFlagProviders = (0, $iWLL0.useFragment)((0, $bnTlY.default), devOpsFeatureFlagProviders);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (projectContext?.projectId != null && isOpen) loadQuery({
            projectAri: (0, $huI7r.createAri)({
                resourceId: projectContext.projectId.toString(),
                resourceOwner: 'jira',
                resourceType: 'project',
                cloudId: cloudId
            })
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        isOpen,
        loadQuery,
        cloudId,
        projectContext
    ]);
    return projectContext != null && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "featureFlagEmptyStateExperienceEntryPoint",
        packageName: "jiraSoftwareEmptyStateExperienceFeatureFlags",
        teamName: "fusion-solaris",
        onError: (location, error)=>{
            onExperienceFail(location, error);
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-empty-state-experience-feature-flags",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d34f2dafd3b8e230$var$Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d34f2dafd3b8e230$var$FeatureFlagEmptyStateExperienceQueryLoader, {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        queryReference: queryReference
    }) : null))) : null;
};

});
parcelRegister("bnTlY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6487d25ef3d4cb3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<938070df7d9719f61ec9a07cd353d6c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6487d25ef3d4cb3a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$6487d25ef3d4cb3a$var$node.hash = "17afe0c67200280c81407f20b1ac9cf2";
var $6487d25ef3d4cb3a$export$2e2bcd8739ae039 = $6487d25ef3d4cb3a$var$node;

});

parcelRegister("3bVT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $109dbd292babcd6e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70c3440a202cfdad1b4e531c7435152b>>
 * @relayHash ebd0cfdc3b09a8f2dd0b3e7d12e0b64d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99
const $109dbd292babcd6e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "from",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "project-associated-feature-flag"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99",
            "metadata": {},
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$109dbd292babcd6e$var$node.hash = "c8856730dcfda88439b157a25ff3f97f";
var $109dbd292babcd6e$export$2e2bcd8739ae039 = $109dbd292babcd6e$var$node;

});

parcelRegister("flvpY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9UBjF")
]).then(()=>parcelRequire('kKKLu'));

});



parcelRegister("64DwS", function(module, exports) {

$parcel$export(module.exports, "IssueCard", () => $f008cc5bd6494a51$export$11b5a73dc1ef6ab9);

var $eLXgA = parcelRequire("eLXgA");

var $1TRvH = parcelRequire("1TRvH");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iWLL0 = parcelRequire("iWLL0");


var $2WYJT = parcelRequire("2WYJT");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $yyqSx = parcelRequire("yyqSx");

var $a5QNi = parcelRequire("a5QNi");

var $hN9v7 = parcelRequire("hN9v7");

var $dSx2v = parcelRequire("dSx2v");


var $53FY6 = parcelRequire("53FY6");

var $lVsd0 = parcelRequire("lVsd0");

var $hyWJ1 = parcelRequire("hyWJ1");

var $dYjI0 = parcelRequire("dYjI0");

var $4ri9i = parcelRequire("4ri9i");

var $gGTDa = parcelRequire("gGTDa");

var $lt7ZU = parcelRequire("lt7ZU");

var $2RNeg = parcelRequire("2RNeg");

var $a87ww = parcelRequire("a87ww");
const $f008cc5bd6494a51$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $f008cc5bd6494a51$export$11b5a73dc1ef6ab9 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasBambooDeployment: hasBambooDeployment, hasDeployments: hasDeployments, hasDevelopments: hasDevelopments, hasBuilds: hasBuilds, onFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen, rowNum: rowNum })=>{
    const issue = (0, $iWLL0.useFragment)((0, $1TRvH.default), jiraIssue);
    const { showDevDetailDialog: showDevDetailDialog } = (0, $2WYJT.useDevOpsDetailsDialogLoaderActions)($f008cc5bd6494a51$var$DEV_DETAILS_DIALOG_SCOPE_ID);
    const [, sidebarActions] = (0, $a5QNi.useSidebarStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (dataType, reviewData)=>{
        showDevDetailDialog(dataType, dataType === (0, $14a090e212ebf7a4$export$3f1e2b276d607490) ? reviewData : undefined, (0, $6vrw7.toIssueKey)(issue.key), (0, $6vrw7.toIssueId)(issue.issueId));
    };
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $eLXgA.default), jiraVersion);
    const { canViewDevTools: canViewDevTools, devOpsSummarisedEntities: devOpsSummarisedEntities, versionIssueTableHiddenColumns: versionIssueTableHiddenColumns } = jiraVersionData;
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraIssueSummaryField = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary');
    const jiraIssueTypeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'issuetype');
    const jiraPriorityField = fields.find((fieldNode)=>fieldNode?.fieldId === 'priority');
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const jiraAssigneeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'assignee');
    const issueUrl = `/browse/${issue.key}`;
    const onIssueClick = (e)=>{
        if (e.target instanceof Element && e.target.closest((0, $hN9v7.getIssueCardClickIgnorePreventDefaultTargetSelector)()) != null) {
            // These are a tags with href to create a feature flag that shouldn't prevent default
            if (e.target.closest((0, $hN9v7.getIssueCardClickIgnoreTargetNoPreventDefaultSelector)())) return;
            e.preventDefault();
            return;
        }
        const modifiersPressed = Boolean(e.shiftKey || e.metaKey || e.ctrlKey);
        const shouldOpenIssueSidebar = // on primary button click
        e.button === 0 && // no modifier buttons have been pressed
        !modifiersPressed;
        if (shouldOpenIssueSidebar) {
            // stops the default behaviour of opening the issue in a new link
            e.preventDefault();
            sidebarActions.showIssue(issue.key);
        }
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'versionDetailsIssue', {
            clickType: e.button,
            modifiersPressed: modifiersPressed
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSx2v.IssueWarningProvider), {
        jiraVersion: jiraVersionData,
        jiraIssue: issue
    }, ({ hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f008cc5bd6494a51$var$IssueCardContainer, {
            href: issueUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onIssueClick,
            "data-component-selector": (0, $97888f678fdffcbb$export$b343d4705e10ba61),
            "data-testid": "software-releases-version-detail-issue-list.ui.issues.issue-card",
            hasWarnings: hasWarnings
        }, jiraIssueSummaryField && jiraIssueTypeField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a87ww.Summary), {
            jiraIssue: issue,
            jiraIssueSummaryField: jiraIssueSummaryField,
            jiraIssueTypeField: jiraIssueTypeField
        }), jiraPriorityField && !versionIssueTableHiddenColumns.includes('ISSUE_PRIORITY') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt7ZU.Priority), {
            jiraPriorityField: jiraPriorityField
        }), jiraStatusField && !versionIssueTableHiddenColumns.includes('ISSUE_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RNeg.Status), {
            jiraStatusField: jiraStatusField
        }), jiraAssigneeField && !versionIssueTableHiddenColumns.includes('ISSUE_ASSIGNEE') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lVsd0.Assignee), {
            jiraAssigneeField: jiraAssigneeField
        }), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && hasDevelopments && !versionIssueTableHiddenColumns.includes('DEVELOPMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
            id: "issueListIssueCardDevelopment",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dYjI0.DevelopmentContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dYjI0.Development), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (hasBambooDeployment || hasDeployments || hasBuilds) && canViewDevTools && !versionIssueTableHiddenColumns.includes('DEPLOYMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
            id: "issueListIssueCardDelivery",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hyWJ1.DeliveryContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hyWJ1.Delivery), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && devOpsSummarisedEntities && !versionIssueTableHiddenColumns.includes('FEATURE_FLAG_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
            id: "issueListIssueCardFeatureFlags",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ri9i.FeatureFlagsContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ri9i.FeatureFlags), {
            devOpsSummarisedEntities: devOpsSummarisedEntities,
            jiraIssue: issue,
            onClick: handleClick,
            setFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen,
            rowNum: rowNum
        }))), !versionIssueTableHiddenColumns.includes('MORE_ACTION') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
            id: "issueListIssueCardMoreButton",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGTDa.OnHoverVisibility), null, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGTDa.MoreButton), {
            jiraVersion: jiraVersionData,
            jiraIssue: issue,
            hasWarnings: hasWarnings,
            hasOpenPullRequestWarning: hasOpenPullRequestWarning,
            hasFailingBuildsWarning: hasFailingBuildsWarning,
            hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
            hasOpenReviewWarning: hasOpenReviewWarning
        })))));
};
const $f008cc5bd6494a51$var$WARNING_COLOR = `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$exports).Y50})`;
const $f008cc5bd6494a51$var$WARNING_HOVER_COLOR = `var(--ds-background-warning-hovered, ${(0, $73a5c9d720aa66e1$exports).Y75})`;
const $f008cc5bd6494a51$var$HOVER_COLOR = `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$exports).N20})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f008cc5bd6494a51$var$IssueCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasWarnings: hasWarnings, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d5pv2t": (0, $9t7rW.default)(__cmplp.hasWarnings && $f008cc5bd6494a51$var$WARNING_COLOR),
            "--_dxlr0u": (0, $9t7rW.default)($f008cc5bd6494a51$var$WARNING_HOVER_COLOR),
            "--_158qcri": (0, $9t7rW.default)($f008cc5bd6494a51$var$HOVER_COLOR)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _bfhk62r0 _4t3izwfg _189exib9 _1dqonqa1 _1h6db5v6 _1yt4plml _gy1pu2gc _7cca15wb _64ezt94y _1ov81l7b _k8kw1l7b _1rcd1l7b _1wp91l7b _7ehiglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.hasWarnings ? "_10j71vyq _irr31vyq" : "_10j71h9u _irr31h9u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eLXgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $93afacad69e5ccfa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f23412886a917642ce5f650f64f940>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $93afacad69e5ccfa$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "canViewDevTools"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
            },
            "action": "THROW",
            "path": "versionIssueTableHiddenColumns"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$93afacad69e5ccfa$var$node.hash = "522ae3c2b555fac40be79e26c643efd9";
var $93afacad69e5ccfa$export$2e2bcd8739ae039 = $93afacad69e5ccfa$var$node;

});

parcelRegister("1TRvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08e046e2230959a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53501a3cdefe37344eda446c082034d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d08e046e2230959a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "issueId"
            },
            "action": "THROW",
            "path": "issueId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "priority",
                            "summary",
                            "assignee",
                            "status",
                            "issuetype"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsById.edges.node.fieldId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "status_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraStatusField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "assignee_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField"
                                                }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField"
                                                }
                                            ],
                                            "type": "JiraIssueTypeField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "priority_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraPriorityField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldsById.edges"
                    }
                ],
                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
            },
            "action": "THROW",
            "path": "fieldsById"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "delivery_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "development_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$d08e046e2230959a$var$node.hash = "81587616f95bbce4695593a62ffa6d45";
var $d08e046e2230959a$export$2e2bcd8739ae039 = $d08e046e2230959a$var$node;

});

parcelRegister("2WYJT", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $87c35b59655e803f$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $87c35b59655e803f$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $87c35b59655e803f$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $87c35b59655e803f$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");


var $WBLbN = parcelRequire("WBLbN");

var $fduvM = parcelRequire("fduvM");
const $87c35b59655e803f$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: (0, $fduvM.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $87c35b59655e803f$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $fduvM.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $14a090e212ebf7a4$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $87c35b59655e803f$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $fduvM.INITIAL_STATE),
    actions: $87c35b59655e803f$export$e324594224ef24da
});
const $87c35b59655e803f$export$5e6e4cfb89bdcb55 = (0, $WBLbN.createContainer)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$693f51ab225dff94 = (0, $WBLbN.createSubscriber)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$550d4b3c29100112 = (0, $WBLbN.createHook)($87c35b59655e803f$export$390f32400eaf98c9);
function $87c35b59655e803f$export$506ad06ecf691cd3(scopeId) {
    return (0, $WBLbN.defaultRegistry).getStore($87c35b59655e803f$export$390f32400eaf98c9, scopeId)?.actions;
}

});
const $14a090e212ebf7a4$export$e18d81f044132a0e = 'branch';
const $14a090e212ebf7a4$export$74a388a09f2a004e = 'build';
const $14a090e212ebf7a4$export$2e42513c7764d5f3 = 'repository';
const $14a090e212ebf7a4$export$3f1e2b276d607490 = 'review';
const $14a090e212ebf7a4$export$90cac6260ae9ced5 = 'deployment-environment';
const $14a090e212ebf7a4$export$6f74b53d652f13f3 = 'pullrequest';
const $14a090e212ebf7a4$export$c69477f358d30f7e = 'feature-flags';
const $14a090e212ebf7a4$export$56470bdd9cd798d0 = 'remote-links';
const $14a090e212ebf7a4$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $14a090e212ebf7a4$export$b4bb784d069c9ab = 'development.details.details-header';
const $14a090e212ebf7a4$export$74189cec821240a6 = 'development.details.remote-links';

parcelRegister("fduvM", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $b00e5ffa4dd6d204$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee);
const $b00e5ffa4dd6d204$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $b00e5ffa4dd6d204$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $b00e5ffa4dd6d204$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});


parcelRegister("hN9v7", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CARD_CLICK_IGNORE_TARGET", () => $4981ebc36006a7fb$export$4fbe2e62d82203a7);
$parcel$export(module.exports, "VERSION_SELECT_MENU_PORTAL_CLASS_PREFIX", () => $4981ebc36006a7fb$export$57f23f1fe030a106);
$parcel$export(module.exports, "FEATURE_FLAG_ACTION_DROPDOWN_ANCHORS", () => $4981ebc36006a7fb$export$36d427b8bcbcfc80);
$parcel$export(module.exports, "getIssueCardClickIgnorePreventDefaultTargetSelector", () => $4981ebc36006a7fb$export$31dcba8332a40055);
$parcel$export(module.exports, "getIssueCardClickIgnoreTargetNoPreventDefaultSelector", () => $4981ebc36006a7fb$export$6c4862367e99e37a);
// These are utility data-version-details-issue-click-ignore-target attributes to prevent issue side bar to open when actionable items are clicked in an issue card
// Should prevent default to prevent the whole issue card (a tag) not to be clicked
const $4981ebc36006a7fb$export$4fbe2e62d82203a7 = 'issueClickOpenIssueIgnoreTarget';
const $4981ebc36006a7fb$export$57f23f1fe030a106 = 'move-issue-modal-select-dropdown';
const $4981ebc36006a7fb$export$36d427b8bcbcfc80 = 'featureFlagAnchorActionDropdown';
const $4981ebc36006a7fb$export$31dcba8332a40055 = ()=>`[data-version-details-issue-click-ignore-target="${$4981ebc36006a7fb$export$4fbe2e62d82203a7}"],
    [data-version-details-issue-click-ignore-target="${$4981ebc36006a7fb$export$36d427b8bcbcfc80}"],
    [data-testid="software-releases-move-issues-between-versions.ui.move-issue-version-select-modal--blanket"],
    [class^='${$4981ebc36006a7fb$export$57f23f1fe030a106}'], [class*=' ${$4981ebc36006a7fb$export$57f23f1fe030a106}']`;
const $4981ebc36006a7fb$export$6c4862367e99e37a = ()=>`[data-version-details-issue-click-ignore-target="${$4981ebc36006a7fb$export$36d427b8bcbcfc80}"]`;

});

parcelRegister("dSx2v", function(module, exports) {

$parcel$export(module.exports, "IssueWarningProvider", () => $7cfd075730584eaf$export$3786225113492c89);
$parcel$export(module.exports, "IssuesWarningCountProvider", () => $7cfd075730584eaf$export$d7ec5473e7d825ae);

var $cwdyr = parcelRequire("cwdyr");

var $2Stpo = parcelRequire("2Stpo");

var $gRBev = parcelRequire("gRBev");

var $ipK8V = parcelRequire("ipK8V");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $8Qd0L = parcelRequire("8Qd0L");
const $7cfd075730584eaf$var$getDevSummaryDataWarnings = (issue, jiraVersionData)=>{
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const issueStatus = (0, $8Qd0L.statusCategoryForId)(jiraStatusField?.status?.statusCategory?.statusCategoryId);
    const build = issue.devSummaryCache?.devSummary.build;
    const commit = issue.devSummaryCache?.devSummary.commit;
    const pullrequest = issue.devSummaryCache?.devSummary.pullrequest;
    const pullrequestCount = issue.devSummaryCache?.devSummary.pullrequest?.overall.count ?? 0;
    const reviewState = issue.devSummaryCache?.devSummary?.review?.overall?.state;
    const reviewCount = issue.devSummaryCache?.devSummary?.review?.overall?.count ?? 0;
    const openPullRequest = jiraVersionData.warningConfig?.openPullRequest;
    const failingBuild = jiraVersionData.warningConfig?.failingBuild;
    const unreviewedCode = jiraVersionData.warningConfig?.unreviewedCode;
    const openReview = jiraVersionData.warningConfig?.openReview;
    const failingBuildCount = (build?.overall.failedBuildCount ?? 0) + ((issue.devOpsSummarisedEntities?.summarisedBuilds?.buildStates ?? []).find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0);
    const hasOpenPullRequestWarning = issueStatus === 'DONE' && openPullRequest === 'ENABLED' && pullrequest?.overall?.state === 'OPEN' && pullrequest.overall.count > 0;
    const hasFailingBuildsWarning = issueStatus === 'DONE' && failingBuild === 'ENABLED' && build != null && failingBuildCount > 0;
    const hasUnreviewedCodeWarning = issueStatus === 'DONE' && unreviewedCode === 'ENABLED' && pullrequestCount === 0 && reviewCount === 0 && commit != null && commit.overall.count > 0;
    const hasOpenReviewWarning = issueStatus === 'DONE' && openReview === 'ENABLED' && reviewState != null && ![
        'CLOSED',
        'REJECTED'
    ].includes(reviewState);
    const hasWarnings = issueStatus === 'DONE' && (hasOpenPullRequestWarning || hasFailingBuildsWarning || hasUnreviewedCodeWarning || hasOpenReviewWarning);
    return {
        hasWarnings: hasWarnings,
        hasOpenPullRequestWarning: hasOpenPullRequestWarning,
        hasFailingBuildsWarning: hasFailingBuildsWarning,
        hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
        hasOpenReviewWarning: hasOpenReviewWarning
    };
};
const $7cfd075730584eaf$var$getIssueNodeWarningsCount = (edges, jiraVersionData)=>edges.map((edge)=>edge.node).filter(Boolean).reduce((acc, issue)=>{
        const warningResult = $7cfd075730584eaf$var$getDevSummaryDataWarnings(issue, jiraVersionData);
        if (warningResult.hasWarnings) return acc + 1;
        return acc;
    }, 0);
const $7cfd075730584eaf$var$getIssueWarnings = (issue, jiraVersionData)=>$7cfd075730584eaf$var$getDevSummaryDataWarnings(issue, jiraVersionData);
const $7cfd075730584eaf$export$3786225113492c89 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, children: children })=>{
    const issue = (0, $iWLL0.useFragment)((0, $ipK8V.default), jiraIssue);
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $gRBev.default), jiraVersion);
    const warningFlags = $7cfd075730584eaf$var$getIssueWarnings(issue, jiraVersionData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(warningFlags));
};
const $7cfd075730584eaf$export$d7ec5473e7d825ae = ({ jiraVersion: jiraVersion, issueEdges: issueEdges, children: children })=>{
    const jiraIssueEdgeReferenceData = (0, $iWLL0.useFragment)((0, $2Stpo.default), issueEdges);
    const warningConfig = (0, $iWLL0.useFragment)((0, $cwdyr.default), jiraVersion);
    const warningCount = $7cfd075730584eaf$var$getIssueNodeWarningsCount(jiraIssueEdgeReferenceData, warningConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(warningCount));
};

});
parcelRegister("cwdyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be32095c6dae12a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<181a2844f19811967a175c2a899887e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0be32095c6dae12a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$0be32095c6dae12a$var$node.hash = "a12dea52160bb6c6b5d0ff127f4a7b36";
var $0be32095c6dae12a$export$2e2bcd8739ae039 = $0be32095c6dae12a$var$node;

});

parcelRegister("2Stpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1ba3f92e8e34f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70475c9d29d1800f98ebde7d315b6dbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d1ba3f92e8e34f9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                        "priority",
                                        "summary",
                                        "assignee",
                                        "status",
                                        "issuetype"
                                    ]
                                }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.fieldsById.edges.node.fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "statusCategoryId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.fieldsById.edges"
                                }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                        },
                        "action": "THROW",
                        "path": "node.fieldsById"
                    },
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "concreteType": "DevOpsSummarisedBuildState",
                                                "kind": "LinkedField",
                                                "name": "buildStates",
                                                "plural": true,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    v0 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueDevSummary",
                                                "kind": "LinkedField",
                                                "name": "devSummary",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v1 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.state"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.pullrequest.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.pullrequest"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.review.overall.count"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.review.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.review"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.commit.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.commit.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.commit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.count"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "failedBuildCount"
                                                                                },
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.build.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.build"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "node.devSummaryCache.devSummary"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$4d1ba3f92e8e34f9$var$node.hash = "2af391280f3df5e713e3630effb3b264";
var $4d1ba3f92e8e34f9$export$2e2bcd8739ae039 = $4d1ba3f92e8e34f9$var$node;

});

parcelRegister("gRBev", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c28985a61d1b3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07ab4de75721935837d0b41078aab8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4c28985a61d1b3f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$f4c28985a61d1b3f$var$node.hash = "e4b994880d16817a096017c816579b1b";
var $f4c28985a61d1b3f$export$2e2bcd8739ae039 = $f4c28985a61d1b3f$var$node;

});

parcelRegister("ipK8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $99e72532fc61b69b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d623581b7a92661251cd4486c951a21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $99e72532fc61b69b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    }, v2 = [
        v1 /*: any*/ ,
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "priority",
                                "summary",
                                "assignee",
                                "status",
                                "issuetype"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsById.edges.node.fieldId"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "fieldsById.edges"
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                },
                "action": "THROW",
                "path": "fieldsById"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "concreteType": "DevOpsSummarisedBuildState",
                                        "kind": "LinkedField",
                                        "name": "buildStates",
                                        "plural": true,
                                        "selections": v2 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueDevSummaryResult",
                        "kind": "LinkedField",
                        "name": "devSummaryCache",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.state"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.pullrequest"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.commit.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.commit.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.commit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "failedBuildCount"
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.build.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.build"
                                        },
                                        {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": v2 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "devSummaryCache.devSummary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$99e72532fc61b69b$var$node.hash = "ffa772f7a474b433d08a55e95366246c";
var $99e72532fc61b69b$export$2e2bcd8739ae039 = $99e72532fc61b69b$var$node;

});


const $97888f678fdffcbb$export$b343d4705e10ba61 = 'VersionDetailIssueListIssueCardContainer';
const $97888f678fdffcbb$export$6bc465585d114926 = 'VersionDetailsIssueList';
const $97888f678fdffcbb$export$eb4c541f23d39ba2 = 1740;
const $97888f678fdffcbb$export$ac70ca19af3aa92c = 1380;

parcelRegister("lVsd0", function(module, exports) {

$parcel$export(module.exports, "Assignee", () => $60e437970107aa9b$export$361f73eba39649ac);

var $4Nlsl = parcelRequire("4Nlsl");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hjZv3 = parcelRequire("hjZv3");
const $60e437970107aa9b$export$361f73eba39649ac = ({ jiraAssigneeField: jiraAssigneeField })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $4Nlsl.default), jiraAssigneeField);
    const avatarUrl = data?.user == null ? '' : data.user.picture;
    const displayName = data?.user == null ? formatMessage((0, $hjZv3.default).unassigned) : data.user.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($60e437970107aa9b$var$AssigneeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: displayName,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($60e437970107aa9b$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        src: avatarUrl,
        size: "small"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60e437970107aa9b$var$AssigneeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg _1bsbzwfg _1ul9zwfg _8mocu2gc",
            __cmplp.className
        ])
    });
});
const $60e437970107aa9b$var$VerticalCenter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Nlsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0969ad2e09ef639d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f9ca0ad69f75332a07996cc07876757>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0969ad2e09ef639d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$0969ad2e09ef639d$var$node.hash = "a79331910374d5f581f31a15777ff330";
var $0969ad2e09ef639d$export$2e2bcd8739ae039 = $0969ad2e09ef639d$var$node;

});

parcelRegister("hjZv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b08193b25e475b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b08193b25e475b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.assignee.unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("hyWJ1", function(module, exports) {

$parcel$export(module.exports, "DeliveryInfo", () => $a3e1c0a867fc5a80$export$61f40ad692662ca7);
$parcel$export(module.exports, "Delivery", () => $a3e1c0a867fc5a80$export$12cbedef95fe0035);
$parcel$export(module.exports, "DeliveryContainer", () => $a3e1c0a867fc5a80$export$8901d2e97ed55253);

var $fZ7zu = parcelRequire("fZ7zu");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");


var $8gviD = parcelRequire("8gviD");

var $1187v = parcelRequire("1187v");


var $eI5EY = parcelRequire("eI5EY");

var $hN9v7 = parcelRequire("hN9v7");


var $53FY6 = parcelRequire("53FY6");

var $kbzTL = parcelRequire("kbzTL");

var $4u1G9 = parcelRequire("4u1G9");

var $15UWM = parcelRequire("15UWM");
const $a3e1c0a867fc5a80$var$getDeploymentDetails = (devOpsSummarisedEntities)=>{
    const summaries = devOpsSummarisedEntities?.summarisedDeployments;
    if (!summaries) return undefined;
    const { deploymentState: deploymentState, deploymentEnvironment: deploymentEnvironment } = summaries;
    return {
        deploymentState: deploymentState ?? undefined,
        deploymentEnvironment: deploymentEnvironment?.category ?? undefined
    };
};
const $a3e1c0a867fc5a80$export$61f40ad692662ca7 = ({ issueId: issueId, scopeId: scopeId, customTrigger: customTrigger, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, zIndexForPopup: zIndexForPopup, location: location, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0;
    const deploymentCount = devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) {
        const deploymentDetails = $a3e1c0a867fc5a80$var$getDeploymentDetails(devOpsSummarisedEntities);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1187v.default), {
            devInfoType: (0, $8gviD.DevInfoTypes).DEPLOYMENT,
            issueId: Number(issueId),
            customTrigger: customTrigger,
            scopeId: scopeId,
            deploymentDetails: deploymentDetails,
            zIndex: zIndexForPopup,
            location: location
        });
    }
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbzTL.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $14a090e212ebf7a4$export$90cac6260ae9ced5))
    });
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4u1G9.BuildData), {
        devOpsSummarisedBuilds: devOpsSummarisedEntities?.summarisedBuilds ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $14a090e212ebf7a4$export$74a388a09f2a004e))
    });
    return null;
};
const $a3e1c0a867fc5a80$export$12cbedef95fe0035 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { issueId: issueId, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, summarisedDeployments: summarisedDeployments, summarisedBuilds: summarisedBuilds } = (0, $iWLL0.useFragment)((0, $fZ7zu.default), jiraIssue);
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || ((0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(summarisedBuilds?.count) > 0 : Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0);
    const deploymentCount = (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? summarisedDeployments?.count ?? 0 : devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3e1c0a867fc5a80$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
        id: "issuesListDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1187v.default), {
        devInfoType: (0, $8gviD.DevInfoTypes).DEPLOYMENT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15UWM.DeploymentData), {
            jiraIssueDevOpsSummarisedEntities: devOpsSummarisedEntities,
            onDeploymentClicked: ()=>onClick((0, $14a090e212ebf7a4$export$90cac6260ae9ced5))
        }),
        scopeId: (0, $97888f678fdffcbb$export$6bc465585d114926),
        isStopPropagationOnClick: false,
        location: (0, $673f6d2b4a68f5cb$export$ede40e627a0cbf14)
    })));
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3e1c0a867fc5a80$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
        id: "issuesListBambooDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbzTL.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $14a090e212ebf7a4$export$90cac6260ae9ced5))
    })));
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3e1c0a867fc5a80$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53FY6.ErrorBoundary), {
        fallback: "flag",
        id: "issuesListBuildData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4u1G9.BuildData), {
        devOpsSummarisedBuilds: ((0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? summarisedBuilds : devOpsSummarisedEntities?.summarisedBuilds) ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $14a090e212ebf7a4$export$74a388a09f2a004e))
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3e1c0a867fc5a80$export$8901d2e97ed55253, null);
};
const $a3e1c0a867fc5a80$export$8901d2e97ed55253 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_17av1lit _fmdx1lit _jyrf1tcg _3ufp1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fZ7zu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff8b5149a56a085$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dd609576641dc2c5fc660f8071188fa0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ff8b5149a56a085$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = [
        v0 /*: any*/ 
    ], v2 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v1 /*: any*/ 
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "name": "delivery_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedEntities",
                "kind": "LinkedField",
                "name": "devOpsSummarisedEntities",
                "plural": false,
                "selections": [
                    {
                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "deploymentData_softwareReleasesVersionDetailIssueList"
                    }
                ]
            },
            {
                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "concreteType": "DevOpsSummarisedBuilds",
                        "kind": "LinkedField",
                        "name": "summarisedBuilds",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraIssueDevSummaryResult",
                "kind": "LinkedField",
                "name": "devSummaryCache",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueDevSummary",
                        "kind": "LinkedField",
                        "name": "devSummary",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "build",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueBuildDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": v1 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "deploymentEnvironments",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "issueId"
            }
        ],
        "type": "JiraIssue"
    };
}();
$5ff8b5149a56a085$var$node.hash = "4ee91cee5bc4c8f8709d2bffdcc6225b";
var $5ff8b5149a56a085$export$2e2bcd8739ae039 = $5ff8b5149a56a085$var$node;

});

const $673f6d2b4a68f5cb$export$9b8283d5878d2491 = 'board';
const $673f6d2b4a68f5cb$export$76a449e52fa0e1e8 = 'issue';
const $673f6d2b4a68f5cb$export$ede40e627a0cbf14 = 'version_details';
const $673f6d2b4a68f5cb$export$464c50016d069471 = 'issue_view_child_issues_list';
const $673f6d2b4a68f5cb$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("8gviD", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $37282c0a5dd8d9ce$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $37282c0a5dd8d9ce$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $37282c0a5dd8d9ce$export$477d4d2d93581a40);
const $37282c0a5dd8d9ce$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $37282c0a5dd8d9ce$export$39c00ace65e13f2d = {
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.BRANCH]: 'branch',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.COMMIT]: 'commit',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.MERGED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DESIGN]: 'design'
};
const $37282c0a5dd8d9ce$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("1187v", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb51a92139e5486$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $bbaTG = parcelRequire("bbaTG");

var $1210e = parcelRequire("1210e");

var $5Z1ia = parcelRequire("5Z1ia");

var $987vE = parcelRequire("987vE");

var $1C67U = parcelRequire("1C67U");

var $gAvfi = parcelRequire("gAvfi");

var $4x7h0 = parcelRequire("4x7h0");

var $gojax = parcelRequire("gojax");

var $jXNxi = parcelRequire("jXNxi");

var $5L5WH = parcelRequire("5L5WH");

var $cH5Ip = parcelRequire("cH5Ip");

var $iHib2 = parcelRequire("iHib2");

var $3MV1G = parcelRequire("3MV1G");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $gUUjF = parcelRequire("gUUjF");


var $8gviD = parcelRequire("8gviD");

var $lKCKu = parcelRequire("lKCKu");

var $2ld4O = parcelRequire("2ld4O");

var $1MsyR = parcelRequire("1MsyR");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $0cdA8 = parcelRequire("0cdA8");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iSZ3f = parcelRequire("iSZ3f");

var $huI7r = parcelRequire("huI7r");

var $8WuJm = parcelRequire("8WuJm");

var $ln3W8 = parcelRequire("ln3W8");

var $c5Qiw = parcelRequire("c5Qiw");

var $yyqSx = parcelRequire("yyqSx");

var $gd0Sp = parcelRequire("gd0Sp");

var $8JSt9 = parcelRequire("8JSt9");

var $iFqtN = parcelRequire("iFqtN");
const $6cb51a92139e5486$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
const $6cb51a92139e5486$var$DevInfoIconsMapping = (0, $5iWql.default)((formatMessage)=>({
        [(0, $8gviD.DevInfoTypes).BRANCH]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1210e))), {
            label: formatMessage((0, $iFqtN.default).branchIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).BRANCH]),
        [(0, $8gviD.DevInfoTypes).COMMIT]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($987vE))), {
            label: formatMessage((0, $iFqtN.default).commitIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXNxi))), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).COMMIT]),
        [(0, $8gviD.DevInfoTypes).PULLREQUEST]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4x7h0))), {
            label: formatMessage((0, $iFqtN.default).openPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5L5WH))), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).PULLREQUEST]),
        [(0, $8gviD.DevInfoTypes).DECLINED]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1C67U))), {
            label: formatMessage((0, $iFqtN.default).declinedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.BitbucketPullrequestDeclined), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).DECLINED]),
        [(0, $8gviD.DevInfoTypes).MERGED]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gAvfi))), {
            label: formatMessage((0, $iFqtN.default).mergedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.BitbucketPullrequestMerged), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).MERGED]),
        [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: (0, $eI5EY.fg)('devinfoicon_iconography_update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Z1ia))), {
            label: formatMessage((0, $iFqtN.default).deploymentIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHib2))), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).DEPLOYMENT]),
        [(0, $8gviD.DevInfoTypes).DESIGN]: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cH5Ip))), (0, $8JSt9.DevInfoIconPropsMapping)(formatMessage)[(0, $8gviD.DevInfoTypes).DESIGN])
    }));
const $6cb51a92139e5486$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
    if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
        if (deploymentDetails.deploymentEnvironment === (0, $8JSt9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $8JSt9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.DeploymentProdSuccess), {
            size: "small",
            label: formatMessage((0, $iFqtN.default).deploymentProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment === (0, $8JSt9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $8JSt9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.DeploymentProdFailed), {
            size: "small",
            label: formatMessage((0, $iFqtN.default).deploymentProductionFailedIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $8JSt9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $8JSt9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.DeploymentNonProdSuccess), {
            size: "small",
            label: formatMessage((0, $iFqtN.default).deploymentNonProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $8JSt9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $8JSt9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MsyR.DeploymentNonProdFailed), {
            size: "small",
            label: formatMessage((0, $iFqtN.default).deploymentNonProductionFailedIconLabel)
        });
    }
    return $6cb51a92139e5486$var$DevInfoIconsMapping(formatMessage)[devInfoType];
};
const $6cb51a92139e5486$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: /* Setting zIndex slighlty lower than the default so that other popups (like the right-click context menu) appear on top of this */ zIndex = (0, $c9TLT.layers).layer - 1 })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isHoverMode, setIsHoverMode] = (0, $eUqFw.useState)(true);
    const [shouldAutoFocus, setShouldAutoFocus] = (0, $eUqFw.useState)(true);
    const timeoutRef = (0, $eUqFw.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const issueAri = (0, $eUqFw.useMemo)(()=>(0, $2ld4O.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const siteAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const initialTrigger = (0, $eUqFw.useRef)(null);
    const devInfoIcon = $6cb51a92139e5486$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
    const popupType = devInfoType === (0, $8gviD.DevInfoTypes).MERGED || devInfoType === (0, $8gviD.DevInfoTypes).DECLINED ? (0, $8gviD.DevInfoTypes).PULLREQUEST : devInfoType;
    const { id: experienceId, name: experienceName } = (0, $8JSt9.experienceDetails)[popupType];
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]); // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $8JSt9.popupEntryPoints)[popupType], entryPointParams, (0, $8JSt9.metrics)[popupType]); // Entry point for the design modal that is used in the design details popup
    const designEntrypoint = (0, $6j4bv.useEntryPoint)((0, $iSZ3f.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: issueAri,
        cloudId: cloudId
    });
    const designModalTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
    const entryPointErrorBoundaryProps = (0, $eUqFw.useMemo)(()=>({
            ...(0, $8JSt9.packageDetails)[popupType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lKCKu.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: scopeId
                })
        }), [
        devInfoType,
        issueAri,
        popupType,
        scopeId
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            issueAri: issueAri,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            devInfoType: devInfoType,
            trigger: initialTrigger.current ?? undefined,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: scopeId,
            modalTriggerRef: devInfoType === (0, $8gviD.DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
        }), [
        issueAri,
        devInfoType,
        scopeId,
        designModalTriggerRef,
        stopMetric,
        onExperienceSuccess
    ]);
    const handleDevIconClick = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        if (initialTrigger.current === null) initialTrigger.current = 'click';
        if (isOpen && isHoverMode) setIsHoverMode(false);
        else if (isOpen && !isHoverMode) {
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        } else {
            entryPointActions.load();
            setShouldAutoFocus(true);
            setIsOpen(true);
            setIsHoverMode(false);
        }
    }, [
        entryPointActions,
        isHoverMode,
        isOpen
    ]);
    const handleMouseEnter = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        setShouldAutoFocus(false);
        if (!isOpen) {
            entryPointActions.preload();
            timeoutRef.current = undefined;
            timeoutRef.current = setTimeout(()=>{
                if (initialTrigger.current === null) initialTrigger.current = 'hover';
                entryPointActions.load();
                setIsOpen(true);
            }, (0, $8JSt9.HOVER_TIMEOUT_MS));
        }
    };
    const handleMouseLeave = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        entryPointActions.cancelPreload();
        timeoutRef.current = undefined;
        if (isOpen) timeoutRef.current = setTimeout(()=>{
            initialTrigger.current = null;
            setShouldAutoFocus(true);
            setIsHoverMode(true);
            setIsOpen(false);
        }, (0, $8JSt9.HOVER_TIMEOUT_MS));
    };
    if ((0, $8JSt9.iconColor)[devInfoType] === undefined) (0, $gUUjF.default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
        devInfoType: devInfoType
    });
    const customTheme = (0, $dzpl6.getTheme)({
        buttonStyles: {
            subtle: {
                color: {
                    // @ts-expect-error - TS2322 - Type '{ color: { default: string | undefined; hover: string | undefined; active: string | undefined; }; }' is not assignable to type 'CSSInterpolation'. | TS2532 - Object is possibly 'undefined'.
                    default: (0, $8JSt9.iconColor)[devInfoType][(0, $8gviD.ButtonStatus).DEFAULT],
                    hover: (0, $8JSt9.iconColor)[devInfoType][(0, $8gviD.ButtonStatus).HOVER],
                    active: (0, $8JSt9.iconColor)[devInfoType][(0, $8gviD.ButtonStatus).ACTIVE]
                }
            }
        }
    });
    const devInfoTextId = `${$6cb51a92139e5486$var$DEV_INFO_BUTTON_ID}-${issueId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        role: "presentation",
        "data-testid": "development-board-dev-info-icon.container",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: (e)=>{
            // Prevents clicks on the icon from opening the Issue view
            if (isStopPropagationOnClick) e.stopPropagation();
        },
        onKeyDown: (e)=>{
            // Prevents using keyboard to open the Issue view
            e.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: placement,
        shouldFlip: true,
        autoFocus: shouldAutoFocus,
        shouldUseCaptureOnOutsideClick: true,
        testId: "development-board-dev-info-icon.popup",
        trigger: (triggerProps)=>customTrigger != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, customTrigger) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                ...triggerProps,
                onClick: handleDevIconClick,
                isSelected: isOpen && !isHoverMode,
                theme: customTheme,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: devInfoIcon,
                "aria-describedby": devInfoTextId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cb51a92139e5486$var$DevInfoButtonText, {
                id: devInfoTextId
            }, (0, $8JSt9.DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
        isOpen: isOpen,
        onClose: ()=>{
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        },
        offset: offset,
        zIndex: zIndex,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // We are stopping right-click event propagation to not show the custom context menu from the Jira Issue Card
            , {
                // and instead use the event default
                onContextMenu: (event)=>{
                    if (!allowNativeContextMenu) event.preventDefault();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5Qiw.DevInfoDetailsPopupSkeleton), {
                    devinfoType: popupType
                }),
                runtimeProps: runtimeProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
        id: "jiraDesignModal",
        packageName: "design-modal",
        entryPointActions: designEntrypoint.entryPointActions,
        runtimeProps: {
            initialSelectedDesign: 0
        }
    }));
};
const $6cb51a92139e5486$var$ERROR_ID = 'renderDevInfoIcon';
const $6cb51a92139e5486$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
const $6cb51a92139e5486$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $673f6d2b4a68f5cb$export$9b8283d5878d2491) })=>{
    const attributes = {
        devInfoType: devInfoType ?? 'unexpected',
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $6cb51a92139e5486$var$ERROR_ID,
        packageName: $6cb51a92139e5486$var$PACKAGE_NAME,
        teamName: "fusion-isotopes",
        fallback: "unmount",
        attributes: attributes,
        extraEventData: attributes,
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
        sourceName: "DevInfoIcon",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cb51a92139e5486$export$b98af1fb6b8b345e, {
        issueId: issueId,
        devInfoType: devInfoType,
        allowNativeContextMenu: allowNativeContextMenu,
        customTrigger: customTrigger,
        scopeId: scopeId,
        deploymentDetails: deploymentDetails,
        isStopPropagationOnClick: isStopPropagationOnClick,
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }))));
};
var $6cb51a92139e5486$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6cb51a92139e5486$var$DevInfoIcon;
const $6cb51a92139e5486$var$DevInfoButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1210e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::819aaba4ce720b386ac455b06c3dfba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c06c178a8a70140$var$_react = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0c06c178a8a70140$var$_UNSAFE_baseNew = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0c06c178a8a70140$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c06c178a8a70140$var$BranchIcon = (props)=>/*#__PURE__*/ $0c06c178a8a70140$var$_react.default.createElement($0c06c178a8a70140$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$0c06c178a8a70140$var$BranchIcon.displayName = 'BranchIcon';
var $0c06c178a8a70140$var$_default = module.exports.default = $0c06c178a8a70140$var$BranchIcon;

});

parcelRegister("5Z1ia", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6538c11424fcd7a335bc8ee8ba51483f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45b3a6cc7855c144$var$_react = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $45b3a6cc7855c144$var$_UNSAFE_baseNew = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $45b3a6cc7855c144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45b3a6cc7855c144$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $45b3a6cc7855c144$var$_react.default.createElement($45b3a6cc7855c144$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
    }, props));
$45b3a6cc7855c144$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $45b3a6cc7855c144$var$_default = module.exports.default = $45b3a6cc7855c144$var$CloudArrowUpIcon;

});

parcelRegister("987vE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf6838b72780d519bb539edbde68438>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a5aafa47f388eac$var$_react = $6a5aafa47f388eac$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6a5aafa47f388eac$var$_UNSAFE_baseNew = $6a5aafa47f388eac$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6a5aafa47f388eac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a5aafa47f388eac$var$CommitIcon = (props)=>/*#__PURE__*/ $6a5aafa47f388eac$var$_react.default.createElement($6a5aafa47f388eac$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 10a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v6M8 6V0"/>`
    }, props));
$6a5aafa47f388eac$var$CommitIcon.displayName = 'CommitIcon';
var $6a5aafa47f388eac$var$_default = module.exports.default = $6a5aafa47f388eac$var$CommitIcon;

});

parcelRegister("1C67U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad48e901fe03e9767fb442db98217bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12ce17a51f2e137f$var$_react = $12ce17a51f2e137f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $12ce17a51f2e137f$var$_UNSAFE_baseNew = $12ce17a51f2e137f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $12ce17a51f2e137f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12ce17a51f2e137f$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $12ce17a51f2e137f$var$_react.default.createElement($12ce17a51f2e137f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM2 1l2.25 2.25m0 0L6.5 5.5M4.25 3.25 6.5 1M4.25 3.25 2 5.5"/>`
    }, props));
$12ce17a51f2e137f$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $12ce17a51f2e137f$var$_default = module.exports.default = $12ce17a51f2e137f$var$MergeFailureIcon;

});

parcelRegister("gAvfi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4206b68c67f6c54a25165d427522e58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1383ee815fbfb8f$var$_react = $c1383ee815fbfb8f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c1383ee815fbfb8f$var$_UNSAFE_baseNew = $c1383ee815fbfb8f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c1383ee815fbfb8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1383ee815fbfb8f$var$MergeSuccessIcon = (props)=>/*#__PURE__*/ $c1383ee815fbfb8f$var$_react.default.createElement($c1383ee815fbfb8f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10-8 1.667 2 3.333-4"/>`
    }, props));
$c1383ee815fbfb8f$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var $c1383ee815fbfb8f$var$_default = module.exports.default = $c1383ee815fbfb8f$var$MergeSuccessIcon;

});

parcelRegister("4x7h0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40fc287887fb7d6bfe3f12ef5c4816a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34cfe2d5e3847031$var$_react = $34cfe2d5e3847031$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $34cfe2d5e3847031$var$_UNSAFE_baseNew = $34cfe2d5e3847031$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $34cfe2d5e3847031$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34cfe2d5e3847031$var$PullRequestIcon = (props)=>/*#__PURE__*/ $34cfe2d5e3847031$var$_react.default.createElement($34cfe2d5e3847031$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.25h1.75a2 2 0 0 1 2 2v6m-7.5-6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0v6.5m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>`
    }, props));
$34cfe2d5e3847031$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $34cfe2d5e3847031$var$_default = module.exports.default = $34cfe2d5e3847031$var$PullRequestIcon;

});

parcelRegister("gojax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beedc1cceb482b08$var$_react = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $beedc1cceb482b08$var$_branch = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("1210e")));
function $beedc1cceb482b08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $beedc1cceb482b08$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $beedc1cceb482b08$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $beedc1cceb482b08$var$_branch.default
    }));
$beedc1cceb482b08$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $beedc1cceb482b08$var$_default = module.exports.default = $beedc1cceb482b08$var$BitbucketBranchesIcon;

});

parcelRegister("jXNxi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e889f3d2c83721f9$var$_react = $e889f3d2c83721f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e889f3d2c83721f9$var$_commit = $e889f3d2c83721f9$var$_interopRequireDefault((parcelRequire("987vE")));
function $e889f3d2c83721f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e889f3d2c83721f9$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $e889f3d2c83721f9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $e889f3d2c83721f9$var$_commit.default
    }));
$e889f3d2c83721f9$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $e889f3d2c83721f9$var$_default = module.exports.default = $e889f3d2c83721f9$var$BitbucketCommitsIcon;

});

parcelRegister("5L5WH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4315f43fbe294787$var$_react = $4315f43fbe294787$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4315f43fbe294787$var$_pullRequest = $4315f43fbe294787$var$_interopRequireDefault((parcelRequire("4x7h0")));
function $4315f43fbe294787$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4315f43fbe294787$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $4315f43fbe294787$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $4315f43fbe294787$var$_pullRequest.default
    }));
$4315f43fbe294787$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $4315f43fbe294787$var$_default = module.exports.default = $4315f43fbe294787$var$BitbucketPullrequestsIcon;

});

parcelRegister("cH5Ip", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93ddef200174846f$var$_react = $93ddef200174846f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $93ddef200174846f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93ddef200174846f$var$MediaServicesAnnotateIcon = (props)=>/*#__PURE__*/ $93ddef200174846f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"/></svg>`
    }, props));
$93ddef200174846f$var$MediaServicesAnnotateIcon.displayName = 'MediaServicesAnnotateIcon';
var $93ddef200174846f$var$_default = module.exports.default = $93ddef200174846f$var$MediaServicesAnnotateIcon;

});

parcelRegister("iHib2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ca57b7a20a40df$var$_react = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d9ca57b7a20a40df$var$_cloudArrowUp = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("5Z1ia")));
function $d9ca57b7a20a40df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9ca57b7a20a40df$var$UploadIcon = (props)=>/*#__PURE__*/ $d9ca57b7a20a40df$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $d9ca57b7a20a40df$var$_cloudArrowUp.default
    }));
$d9ca57b7a20a40df$var$UploadIcon.displayName = 'UploadIcon';
var $d9ca57b7a20a40df$var$_default = module.exports.default = $d9ca57b7a20a40df$var$UploadIcon;

});

parcelRegister("lKCKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49a01e4d7de0f03$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $96IgR = parcelRequire("96IgR");


var $5JgJ2 = parcelRequire("5JgJ2");

var $e9Jo2 = parcelRequire("e9Jo2");

var $8gviD = parcelRequire("8gviD");

var $eQ4bB = parcelRequire("eQ4bB");

var $cpgno = parcelRequire("cpgno");
const $b49a01e4d7de0f03$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $eQ4bB.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8gviD.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8gviD.DevInfoTypes).DESIGN ? formatMessage((0, $cpgno.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $cpgno.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupTitle), null, formatMessage((0, $cpgno.default).errorPopupTitle, {
        devInfoType: (0, $8gviD.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Title, null, formatMessage((0, $cpgno.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Description, null, errorMessage, devInfoType !== (0, $8gviD.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $cpgno.default).developmentErrorDescriptionCta))));
};
var $b49a01e4d7de0f03$export$2e2bcd8739ae039 = $b49a01e4d7de0f03$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b49a01e4d7de0f03$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eQ4bB", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $0f663eb0f0e5c7d1$export$cdc75a6c65207319);

var $2WYJT = parcelRequire("2WYJT");


var $huI7r = parcelRequire("huI7r");

var $8gviD = parcelRequire("8gviD");
const $0f663eb0f0e5c7d1$export$166d6c8e7de25541 = (issueAri)=>(0, $huI7r.parseAri)(issueAri)?.resourceId;
const $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8gviD.DevInfoTypes).COMMIT) return 0, $14a090e212ebf7a4$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8gviD.DevInfoTypes).DEPLOYMENT) return 0, $14a090e212ebf7a4$export$90cac6260ae9ced5;
    return devInfoType;
};
function $0f663eb0f0e5c7d1$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $2WYJT.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $0f663eb0f0e5c7d1$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});

parcelRegister("cpgno", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bd4bef6d1b1266$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $44bd4bef6d1b1266$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("2ld4O", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $b5e04eaf4130b68e$export$6b0ec881a3540845);

var $huI7r = parcelRequire("huI7r");
const $b5e04eaf4130b68e$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("1MsyR", function(module, exports) {

$parcel$export(module.exports, "BitbucketPullrequestMerged", () => $c507832651728137$export$3800ce670a7fa29b);
$parcel$export(module.exports, "BitbucketPullrequestDeclined", () => $c507832651728137$export$9a767285e35d722a);
$parcel$export(module.exports, "DeploymentProdSuccess", () => $c507832651728137$export$8409a6d16fd5ac8e);
$parcel$export(module.exports, "DeploymentNonProdSuccess", () => $c507832651728137$export$814ebe75b826c47b);
$parcel$export(module.exports, "DeploymentProdFailed", () => $c507832651728137$export$22f2b1620b38359);
$parcel$export(module.exports, "DeploymentNonProdFailed", () => $c507832651728137$export$5b461fe0712c5c45);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

const $c507832651728137$export$3800ce670a7fa29b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m0 0h24v24h-24z",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
                clipRule: "evenodd",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m7 7c.55228 0 1 .44772 1 1v2c0 3.5912 2.7043 6.5508 6.1876 6.9534.4247-1.1408 1.5237-1.9534 2.8124-1.9534 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3c-1.3207 0-2.4421-.8534-2.8428-2.0389-4.57535-.4249-8.1572-4.2747-8.1572-8.9611v-2c0-.55228.44772-1 1-1zm10 10c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m20.7071 4.29289c.3905.39053.3905 1.02369 0 1.41422l-4 4c-.3905.39049-1.0237.39049-1.4142 0l-2-2c-.3905-.39053-.3905-1.02369 0-1.41422.3905-.39052 1.0237-.39052 1.4142 0l1.2929 1.2929 3.2929-3.2929c.3905-.39052 1.0237-.39052 1.4142 0z"
            })))
    });
const $c507832651728137$export$9a767285e35d722a = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m0 0h24v24h-24z",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
                clipRule: "evenodd",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`,
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m17 11c.5523 0 1 .4477 1 1v3.1707c1.1652.4118 2 1.5231 2 2.8293 0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.3062.8348-2.4175 2-2.8293v-3.1707c0-.5523.4477-1 1-1zm0 6c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "m13.7929 2.79289c.3905-.39052 1.0237-.39052 1.4142 0l1.7929 1.7929 1.7929-1.7929c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-1.7929 1.79289 1.7929 1.79289c.3905.39053.3905 1.02369 0 1.41422-.3905.39052-1.0237.39052-1.4142 0l-1.7929-1.7929-1.7929 1.7929c-.3905.39052-1.0237.39052-1.4142 0-.3905-.39053-.3905-1.02369 0-1.41422l1.7929-1.79289-1.7929-1.79289c-.3905-.39053-.3905-1.02369 0-1.41422z"
            })))
    });
const $c507832651728137$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 9.74998C1 11.3714 2.22503 12.7067 3.80003 12.8808V12.9H12.2V12.8807C13.775 12.7066 15 11.3713 15 9.74998C15 8.31668 14.0427 7.10697 12.7326 6.72531C12.1716 4.63715 10.2653 3.09998 8.00006 3.09998C5.73479 3.09998 3.82855 4.63713 3.2675 6.72527C1.95735 7.10688 1 8.31663 1 9.74998ZM6.84995 7.94994C6.78825 7.88606 6.71445 7.83511 6.63285 7.80005C6.55124 7.765 6.46348 7.74655 6.37467 7.74578C6.28586 7.745 6.19778 7.76193 6.11558 7.79556C6.03338 7.82919 5.9587 7.87885 5.8959 7.94165C5.8331 8.00445 5.78344 8.07913 5.74981 8.16133C5.71618 8.24353 5.69925 8.33161 5.70003 8.42042C5.7008 8.50923 5.71925 8.59699 5.7543 8.6786C5.78936 8.7602 5.84031 8.834 5.90419 8.8957L7.0542 10.0457C7.17963 10.171 7.34973 10.2415 7.52708 10.2415C7.70444 10.2415 7.87453 10.171 7.99996 10.0457L10.0958 7.94996C10.1597 7.88826 10.2106 7.81446 10.2457 7.73286C10.2808 7.65125 10.2992 7.56349 10.3 7.47467C10.3007 7.38586 10.2838 7.29779 10.2502 7.21559C10.2166 7.13339 10.1669 7.05871 10.1041 6.99591C10.0413 6.93311 9.96662 6.88345 9.88442 6.84982C9.80222 6.81619 9.71414 6.79926 9.62533 6.80003C9.53652 6.80081 9.44876 6.81926 9.36715 6.85431C9.28555 6.88936 9.21175 6.94032 9.15005 7.0042L7.52708 8.62702L6.84995 7.94994Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }))
    });
const $c507832651728137$export$814ebe75b826c47b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-1-inside-1_81_24007",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
                mask: "url(#path-1-inside-1_81_24007)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M6.81117 7.86961C6.88213 7.90009 6.94631 7.9444 6.99996 7.99995L7.58877 8.58871L9.00004 7.17757C9.05369 7.12202 9.11787 7.07771 9.18883 7.04723C9.25979 7.01674 9.33611 7.0007 9.41333 7.00003C9.49056 6.99936 9.56715 7.01407 9.63862 7.04332C9.7101 7.07256 9.77504 7.11575 9.82965 7.17036C9.88426 7.22497 9.92745 7.28991 9.95669 7.36138C9.98593 7.43286 10.0006 7.50945 9.99998 7.58667C9.99931 7.6639 9.98326 7.74022 9.95278 7.81118C9.9223 7.88214 9.87799 7.94632 9.82244 7.99997L7.99997 9.82231C7.8909 9.93135 7.74299 9.9926 7.58877 9.9926C7.43454 9.9926 7.28663 9.93135 7.17757 9.82231L6.17756 8.82235C6.12201 8.7687 6.0777 8.70452 6.04722 8.63356C6.01674 8.5626 6.00069 8.48628 6.00002 8.40906C5.99935 8.33183 6.01407 8.25525 6.04331 8.18377C6.07255 8.11229 6.11574 8.04735 6.17035 7.99274C6.22496 7.93813 6.2899 7.89495 6.36138 7.8657C6.43285 7.83646 6.50944 7.82174 6.58667 7.82241C6.66389 7.82308 6.74021 7.83913 6.81117 7.86961Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }))
    });
const $c507832651728137$export$22f2b1620b38359 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808ZM7.35 6.25C7.35 5.83579 7.68579 5.5 8.1 5.5C8.51421 5.5 8.85 5.83579 8.85 6.25V8.25C8.85 8.66421 8.51421 9 8.1 9C7.68579 9 7.35 8.66421 7.35 8.25V6.25ZM8.1 9.5C7.68579 9.5 7.35 9.83579 7.35 10.25C7.35 10.6642 7.68579 11 8.1 11C8.51421 11 8.85 10.6642 8.85 10.25C8.85 9.83579 8.51421 9.5 8.1 9.5Z",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }))
    });
const $c507832651728137$export$5b461fe0712c5c45 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-1-inside-1_91_14760",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`,
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`,
                mask: "url(#path-1-inside-1_91_14760)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "7.3501",
                y: "5.5",
                width: "1.5",
                height: "3.5",
                rx: "0.75",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "7.3501",
                y: "9.5",
                width: "1.5",
                height: "1.5",
                rx: "0.75",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }))
    });

});

parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("3q7Yq", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $79aee538140aeba6$export$4d67c6ee49f3d14d);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("iSZ3f", function(module, exports) {

$parcel$export(module.exports, "designModalEntryPoint", () => $a48199c11e08862a$export$b98395a806b85a49);

var $2m7gt = parcelRequire("2m7gt");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a48199c11e08862a$export$b98395a806b85a49 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("86PXi")), {
        moduleId: "576d28f0"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
            queries: {
                designModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $2m7gt.default),
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId,
                        designAri: designAri
                    }
                }
            }
        })
});

});
parcelRegister("2m7gt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a299af72b997b8d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1775dc6f451f5aa08f2de993d8e993cc>>
 * @relayHash f75963656ac83b6e4f5b855b41942d4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b
const $3a299af72b997b8d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
        "metadata": {},
        "name": "ui_DesignModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3a299af72b997b8d$export$2e2bcd8739ae039 = $3a299af72b997b8d$var$node;

});

parcelRegister("86PXi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hEBcp")
]).then(()=>parcelRequire('aJOG8'));

});


parcelRegister("c5Qiw", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $6593062fea30be6d$export$9044eba4855892a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $jwCRu = parcelRequire("jwCRu");

var $lRZkV = parcelRequire("lRZkV");

var $5v1Iy = parcelRequire("5v1Iy");

var $dexFQ = parcelRequire("dexFQ");

var $dmHv3 = parcelRequire("dmHv3");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $6593062fea30be6d$var$customCssStyles = null;
const $6593062fea30be6d$var$skeletonStyles = null;
const $6593062fea30be6d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $6593062fea30be6d$var$skeletonAsset = {
    [$6593062fea30be6d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($jwCRu))),
    [$6593062fea30be6d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($lRZkV))),
    [$6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($dmHv3))),
    [$6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($5v1Iy))),
    [$6593062fea30be6d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($dexFQ)))
};
const $6593062fea30be6d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: $6593062fea30be6d$var$skeletonAsset[devinfoType],
        className: (0, $7JEyt.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("jwCRu", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("lRZkV", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("5v1Iy", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("dexFQ", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("dmHv3", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("8JSt9", function(module, exports) {

$parcel$export(module.exports, "HOVER_TIMEOUT_MS", () => $6f46d7bbe4fc8faf$export$bbec45119b804b4d);
$parcel$export(module.exports, "DevInfoIconPropsMapping", () => $6f46d7bbe4fc8faf$export$cd5138f3581ca0d5);
$parcel$export(module.exports, "DevInfoButtonLabelMapping", () => $6f46d7bbe4fc8faf$export$41f3316f17440396);
$parcel$export(module.exports, "iconColor", () => $6f46d7bbe4fc8faf$export$3797a580396e3639);
$parcel$export(module.exports, "experienceDetails", () => $6f46d7bbe4fc8faf$export$ba2604b0fdde2542);
$parcel$export(module.exports, "metrics", () => $6f46d7bbe4fc8faf$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "packageDetails", () => $6f46d7bbe4fc8faf$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $6f46d7bbe4fc8faf$export$1452632269dce6);
$parcel$export(module.exports, "DeploymentState", () => $6f46d7bbe4fc8faf$export$a12a01ce2571070a);
$parcel$export(module.exports, "DeploymentEnvironment", () => $6f46d7bbe4fc8faf$export$618f130aff825d2b);

var $5iWql = parcelRequire("5iWql");


var $04BUu = parcelRequire("04BUu");

var $9Lh4U = parcelRequire("9Lh4U");

var $8gviD = parcelRequire("8gviD");

var $9Rqul = parcelRequire("9Rqul");

var $5jQ11 = parcelRequire("5jQ11");

var $8qFOR = parcelRequire("8qFOR");

var $iFqtN = parcelRequire("iFqtN");

var $3OxBp = parcelRequire("3OxBp");
const $6f46d7bbe4fc8faf$export$bbec45119b804b4d = 300;
const $6f46d7bbe4fc8faf$export$cd5138f3581ca0d5 = (0, $5iWql.default)((formatMessage)=>({
        [(0, $8gviD.DevInfoTypes).BRANCH]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).branchIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).COMMIT]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).commitIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).openPullRequestIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).DECLINED]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).declinedPullRequestIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).MERGED]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).mergedPullRequestIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).deploymentIconLabel)
        },
        [(0, $8gviD.DevInfoTypes).DESIGN]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $iFqtN.default).designIconLabel)
        }
    }));
const $6f46d7bbe4fc8faf$export$41f3316f17440396 = (0, $5iWql.default)((formatMessage)=>({
        [(0, $8gviD.DevInfoTypes).BRANCH]: formatMessage((0, $iFqtN.default).branchIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).COMMIT]: formatMessage((0, $iFqtN.default).commitIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).PULLREQUEST]: formatMessage((0, $iFqtN.default).pullRequestIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).MERGED]: formatMessage((0, $iFqtN.default).pullRequestIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).DECLINED]: formatMessage((0, $iFqtN.default).pullRequestIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: formatMessage((0, $iFqtN.default).deploymentIconButtonLabel),
        [(0, $8gviD.DevInfoTypes).DESIGN]: formatMessage((0, $iFqtN.default).designIconButtonLabel)
    }));
const $6f46d7bbe4fc8faf$export$3797a580396e3639 = {
    [(0, $8gviD.DevInfoTypes).BRANCH]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`
    },
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`
    },
    [(0, $8gviD.DevInfoTypes).MERGED]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
    },
    [(0, $8gviD.DevInfoTypes).DECLINED]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
    },
    [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`
    },
    [(0, $8gviD.DevInfoTypes).DESIGN]: {
        [(0, $8gviD.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        [(0, $8gviD.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        [(0, $8gviD.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`
    }
};
const $6f46d7bbe4fc8faf$export$ba2604b0fdde2542 = {
    [(0, $8gviD.DevInfoTypes).BRANCH]: {
        id: 'branchDetailsPopup',
        name: 'jiraSoftwareBoardBranchDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareBoardCommitDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: {
        id: 'deploymentDetailsPopup',
        name: 'jiraSoftwareBoardDeploymentDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareBoardPrDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).DESIGN]: {
        id: 'designDetailsPopup',
        name: 'jiraSoftwareBoardDesignDetailsPopup'
    }
};
const $6f46d7bbe4fc8faf$export$b0c5c2fac8144e54 = {
    [(0, $8gviD.DevInfoTypes).BRANCH]: (0, $3OxBp.branchDetailsPopupLoad),
    [(0, $8gviD.DevInfoTypes).COMMIT]: (0, $3OxBp.commitDetailsPopupLoad),
    [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: (0, $3OxBp.deploymentDetailsPopupLoad),
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: (0, $3OxBp.prDetailsPopupLoad),
    [(0, $8gviD.DevInfoTypes).DESIGN]: (0, $3OxBp.designDetailsPopupLoad)
};
const $6f46d7bbe4fc8faf$export$48b44d9f3c6e15de = {
    [(0, $8gviD.DevInfoTypes).BRANCH]: {
        id: 'renderBranchDetailsPopup',
        packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: {
        id: 'renderDeploymentDetailsPopup',
        packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
        teamName: 'fusion-solaris'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentBoardPrDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8gviD.DevInfoTypes).DESIGN]: {
        id: 'renderDesignDetailsPopup',
        packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
        teamName: 'helios-headcoach'
    }
};
const $6f46d7bbe4fc8faf$export$1452632269dce6 = {
    [(0, $8gviD.DevInfoTypes).BRANCH]: (0, $04BUu.branchDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).COMMIT]: (0, $9Lh4U.commitDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).DEPLOYMENT]: (0, $9Rqul.deploymentDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: (0, $8qFOR.pullRequestDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).DESIGN]: (0, $5jQ11.designDetailsEntryPoint)
};
const $6f46d7bbe4fc8faf$export$a12a01ce2571070a = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED'
});
const $6f46d7bbe4fc8faf$export$618f130aff825d2b = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING'
});

});
parcelRegister("04BUu", function(module, exports) {

$parcel$export(module.exports, "branchDetailsEntryPoint", () => $bb194bce83cb1346$export$4e1fb223e6b994ad);

var $cD2IS = parcelRequire("cD2IS");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $bb194bce83cb1346$export$4e1fb223e6b994ad = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("j7aRm")), {
        moduleId: "283a656c"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cD2IS.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cD2IS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a20cc58cf50c485$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53221fefa0f4443cf65a4215c479359b>>
 * @relayHash 369bf10bb8009c658a35cf0bdf685efa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6
const $6a20cc58cf50c485$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6",
        "metadata": {},
        "name": "mainJiraBoardFetchBranchDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a20cc58cf50c485$export$2e2bcd8739ae039 = $6a20cc58cf50c485$var$node;

});

parcelRegister("j7aRm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aYSEN").then(()=>parcelRequire('3MOwM'));

});


parcelRegister("9Lh4U", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $3c86546e63859b12$export$543707906869c79b);

var $cRNlw = parcelRequire("cRNlw");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $3c86546e63859b12$export$543707906869c79b = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("as4bY")), {
        moduleId: "0f8578e0"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cRNlw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cRNlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec06dfcbd43e202$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $eec06dfcbd43e202$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eec06dfcbd43e202$export$2e2bcd8739ae039 = $eec06dfcbd43e202$var$node;

});

parcelRegister("as4bY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Ydge").then(()=>parcelRequire('8jOtz'));

});


parcelRegister("9Rqul", function(module, exports) {

$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $26bee2b6e021d854$export$bb44df517ead129f);

var $eI5EY = parcelRequire("eI5EY");

var $eZr9E = parcelRequire("eZr9E");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $26bee2b6e021d854$export$bb44df517ead129f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("jt7hq")), {
        moduleId: "12f43749"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eZr9E.default,
                    variables: {
                        issueAris: [
                            issueId
                        ],
                        isDevOpsDataAgsMigrationOn: (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re')
                    }
                }
            }
        })
});

});
parcelRegister("eZr9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9942b21dbfa302c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af679ec527d1981dcdaff0e5cc594ad9>>
 * @relayHash 0014097d1ce5fa1efc5b91a05152d101
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45a6c6bb5a98d9a9c3dbcd9f289262fb7d192b97d36ffaa9a2819f875e9e95f4
const $9942b21dbfa302c2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "45a6c6bb5a98d9a9c3dbcd9f289262fb7d192b97d36ffaa9a2819f875e9e95f4",
        "metadata": {},
        "name": "uiDevOpsBoardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9942b21dbfa302c2$export$2e2bcd8739ae039 = $9942b21dbfa302c2$var$node;

});

parcelRegister("jt7hq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("alF7y").then(()=>parcelRequire('1fiCv'));

});


parcelRegister("5jQ11", function(module, exports) {

$parcel$export(module.exports, "designDetailsEntryPoint", () => $edd5a7fd1f1b3fbe$export$9b838851ea165d28);

var $7WraE = parcelRequire("7WraE");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $edd5a7fd1f1b3fbe$export$9b838851ea165d28 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hvMBJ")), {
        moduleId: "b9d22806"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                designDetailsPopup: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7WraE.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("7WraE", function(module, exports) {

$parcel$export(module.exports, "default", () => $584fa89739a0dff7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b69286dc3d574c4254b644a20345969>>
 * @relayHash 19dd9f9578703995725a17532527b663
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db
const $584fa89739a0dff7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db",
        "metadata": {},
        "name": "uiDesignDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $584fa89739a0dff7$export$2e2bcd8739ae039 = $584fa89739a0dff7$var$node;

});

parcelRegister("hvMBJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fMVEj").then(()=>parcelRequire('9ORH1'));

});


parcelRegister("8qFOR", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $00e71a60969c485e$export$37ab544e7066c095);

var $jLRNB = parcelRequire("jLRNB");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $00e71a60969c485e$export$37ab544e7066c095 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("1Az09")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jLRNB.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("jLRNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c2342641857612$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $99c2342641857612$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $99c2342641857612$export$2e2bcd8739ae039 = $99c2342641857612$var$node;

});

parcelRegister("1Az09", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("03Ibg")
]).then(()=>parcelRequire('8IcTB'));

});


parcelRegister("iFqtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a69d44abfd9ec8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d1a69d44abfd9ec8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    branchIconLabel: {
        "id": "development-board-dev-info-icon.branch-icon-label",
        "defaultMessage": "branch"
    },
    commitIconLabel: {
        "id": "development-board-dev-info-icon.commit-icon-label",
        "defaultMessage": "commit"
    },
    designIconLabel: {
        "id": "development-board-dev-info-icon.design-icon-label",
        "defaultMessage": "Linked design data"
    },
    deploymentIconLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-label",
        "defaultMessage": "Linked deployment data."
    },
    deploymentProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
        "defaultMessage": "Successful deployment to production."
    },
    deploymentProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
        "defaultMessage": "Failed deployment to production."
    },
    deploymentNonProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
        "defaultMessage": "Successful deployment to non-production environment."
    },
    deploymentNonProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
        "defaultMessage": "Failed deployment to non-production environment."
    },
    openPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.open-pull-request-icon-label",
        "defaultMessage": "pull request"
    },
    mergedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
        "defaultMessage": "merged pull request"
    },
    declinedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
        "defaultMessage": "declined pull request"
    },
    branchIconButtonLabel: {
        "id": "development-board-dev-info-icon.branch-icon-button-label",
        "defaultMessage": "Select to open branch details."
    },
    commitIconButtonLabel: {
        "id": "development-board-dev-info-icon.commit-icon-button-label",
        "defaultMessage": "Select to open commit details."
    },
    pullRequestIconButtonLabel: {
        "id": "development-board-dev-info-icon.pull-request-icon-button-label",
        "defaultMessage": "Select to open pull request details."
    },
    deploymentIconButtonLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-button-label",
        "defaultMessage": "Select to open deployment details."
    },
    designIconButtonLabel: {
        "id": "development-board-dev-info-icon.design-icon-button-label",
        "defaultMessage": "Select to open design details."
    }
});

});

parcelRegister("3OxBp", function(module, exports) {

$parcel$export(module.exports, "branchDetailsPopupLoad", () => $ef17eca950f00a5f$export$1e45f095e94fd8a);
$parcel$export(module.exports, "commitDetailsPopupLoad", () => $ef17eca950f00a5f$export$e3af05dcf8f03d06);
$parcel$export(module.exports, "deploymentDetailsPopupLoad", () => $ef17eca950f00a5f$export$205c7cad3de97a2);
$parcel$export(module.exports, "prDetailsPopupLoad", () => $ef17eca950f00a5f$export$3ca761127f6f2822);
$parcel$export(module.exports, "designDetailsPopupLoad", () => $ef17eca950f00a5f$export$935f70f8029ab734);

var $lNfG4 = parcelRequire("lNfG4");
const $ef17eca950f00a5f$export$1e45f095e94fd8a = (0, $lNfG4.metrics).interaction({
    key: 'board.branch-details-popup-load'
});
const $ef17eca950f00a5f$export$e3af05dcf8f03d06 = (0, $lNfG4.metrics).interaction({
    key: 'board.commit-details-popup-load'
});
const $ef17eca950f00a5f$export$205c7cad3de97a2 = (0, $lNfG4.metrics).interaction({
    key: 'board.deployment-details-popup-load'
});
const $ef17eca950f00a5f$export$3ca761127f6f2822 = (0, $lNfG4.metrics).interaction({
    key: 'board.pr-details-popup-load'
});
const $ef17eca950f00a5f$export$935f70f8029ab734 = (0, $lNfG4.metrics).interaction({
    key: 'board.design-details-popup-load'
});

});



parcelRegister("kbzTL", function(module, exports) {

$parcel$export(module.exports, "BambooDeploymentData", () => $4ce17db515bc30f3$export$d73f8a5da425a8c5);

var $ahe5E = parcelRequire("ahe5E");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $aWvIp = parcelRequire("aWvIp");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $4Gqcv = parcelRequire("4Gqcv");
const $4ce17db515bc30f3$var$MAX_DISPLAYED_ENVIRONMENTS = 3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ce17db515bc30f3$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4ce17db515bc30f3$export$d73f8a5da425a8c5 = ({ jiraIssueDevSummary: jiraIssueDevSummary, onDeploymentClicked: onDeploymentClicked })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $ahe5E.default), jiraIssueDevSummary);
    const deployedBuilds = (data.deploymentEnvironments.overall.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED');
    const environments = deployedBuilds.filter((environment)=>environment).map((environment)=>environment.title);
    const displayedEnvironments = environments.slice(0, $4ce17db515bc30f3$var$MAX_DISPLAYED_ENVIRONMENTS).join(', ');
    const remainingEnvironments = environments.length > $4ce17db515bc30f3$var$MAX_DISPLAYED_ENVIRONMENTS ? deployedBuilds.length - $4ce17db515bc30f3$var$MAX_DISPLAYED_ENVIRONMENTS : null;
    return deployedBuilds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ce17db515bc30f3$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "compact",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bambooSummaryCell');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $4Gqcv.default).deployedEnvironments, {
            hasHiddenEnvironments: !!remainingEnvironments,
            displayedEnvironments: displayedEnvironments,
            othersCount: remainingEnvironments ?? 0
        }),
        onShow: (analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bambooSummaryTooltip');
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        size: "medium",
        label: formatMessage((0, $4Gqcv.default).bambooDeploymentIcon),
        primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
    })))) : null;
};

});
parcelRegister("ahe5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a24bd7215c6659b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0b19c688784554a1b0ae24dca989610>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a24bd7215c6659b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                "kind": "LinkedField",
                "name": "deploymentEnvironments",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                        "kind": "LinkedField",
                                        "name": "topEnvironments",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                "action": "THROW",
                                                "path": "deploymentEnvironments.overall.topEnvironments.status"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "title"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "deploymentEnvironments.overall.topEnvironments"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "deploymentEnvironments.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "deploymentEnvironments"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$7a24bd7215c6659b$var$node.hash = "f1dd87aba73205d2eb34f56156e152c9";
var $7a24bd7215c6659b$export$2e2bcd8739ae039 = $7a24bd7215c6659b$var$node;

});

parcelRegister("4Gqcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf20a9d16dc8c92$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdf20a9d16dc8c92$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    bambooDeploymentIcon: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.bamboo-deployment-icon",
        "defaultMessage": "Bamboo deployment icon"
    },
    deployedEnvironments: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.deployed-environments",
        "defaultMessage": "{hasHiddenEnvironments, select, false {Deployed to {displayedEnvironments}} other {Deployed to {displayedEnvironments} and {othersCount, number} {othersCount, plural, one {other} other {others}}}}"
    }
});

});


parcelRegister("4u1G9", function(module, exports) {

$parcel$export(module.exports, "BuildData", () => $6187d63750d26b9d$export$c35480212824a8c6);

var $5xavm = parcelRequire("5xavm");

var $7Zjxk = parcelRequire("7Zjxk");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $aWvIp = parcelRequire("aWvIp");

var $5k4ch = parcelRequire("5k4ch");

var $ioiQ7 = parcelRequire("ioiQ7");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $91iOF = parcelRequire("91iOF");
const $6187d63750d26b9d$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6187d63750d26b9d$export$c35480212824a8c6 = ({ jiraIssueDevSummary: jiraIssueDevSummary, devOpsSummarisedBuilds: devOpsSummarisedBuilds, onBuildClicked: onBuildClicked })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const appLinkBuildData = (0, $iWLL0.useFragment)((0, $7Zjxk.default), jiraIssueDevSummary);
    const nonAppLinkBuildData = (0, $iWLL0.useFragment)((0, $5xavm.default), devOpsSummarisedBuilds ?? null);
    const { failedBuildCount: failedBuildCountAppLink, successfulBuildCount: successfulBuildCountAppLink, unknownBuildCount: unknownBuildCountAppLink } = appLinkBuildData.build.overall;
    const buildStates = nonAppLinkBuildData?.buildStates ?? [];
    const failedBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0;
    const successfulBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'SUCCESSFUL')?.count ?? 0;
    const unknownBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'UNKNOWN')?.count ?? 0;
    const failedBuildCount = failedBuildCountAppLink + failedBuildCountNonAppLink;
    const successfulBuildCount = successfulBuildCountAppLink + successfulBuildCountNonAppLink;
    const unknownBuildCount = unknownBuildCountAppLink + unknownBuildCountNonAppLink;
    const hasBuilds = failedBuildCount + successfulBuildCount + unknownBuildCount > 0;
    const renderIcon = ()=>{
        if (failedBuildCount > 0) {
            const failedBuildMessage = formatMessage((0, $91iOF.default).failedBuild, {
                buildCount: failedBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: failedBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
                size: "medium",
                label: failedBuildMessage,
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }));
        }
        if (successfulBuildCount > 0) {
            const successfulBuildMessage = formatMessage((0, $91iOF.default).successfulBuild, {
                buildCount: successfulBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: successfulBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
                size: "medium",
                label: successfulBuildMessage,
                primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }));
        }
        if (unknownBuildCount > 0) {
            const unknownBuildMessage = formatMessage((0, $91iOF.default).unknownBuild, {
                buildCount: unknownBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: unknownBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
                size: "medium",
                label: unknownBuildMessage,
                primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`
            }));
        }
        return null;
    };
    return hasBuilds ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6187d63750d26b9d$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onBuildClicked();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionsBuildsLozenge');
        }
    }, renderIcon())) : null;
};

});
parcelRegister("5xavm", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa806cad64ee0823$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c29b101cc868f9fea8432c1a43a162ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa806cad64ee0823$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedBuilds"
};
$aa806cad64ee0823$var$node.hash = "dd56ce5fd7d57ba00bf945a310710b23";
var $aa806cad64ee0823$export$2e2bcd8739ae039 = $aa806cad64ee0823$var$node;

});

parcelRegister("7Zjxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3deabb111c9bfba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02f164da7183161ef2a4218fc267af7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3deabb111c9bfba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueBuildDevSummaryContainer",
                "kind": "LinkedField",
                "name": "build",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueBuildDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.failedBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "successfulBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.successfulBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "unknownBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.unknownBuildCount"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "build.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "build"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$b3deabb111c9bfba$var$node.hash = "51c2585ef90bb27a6d71bf4d7670a32b";
var $b3deabb111c9bfba$export$2e2bcd8739ae039 = $b3deabb111c9bfba$var$node;

});

parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});

parcelRegister("91iOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11f80717e7c4da5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d11f80717e7c4da5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successfulBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.successful-build",
        "defaultMessage": "{buildCount} successful {buildCount, plural, one {build} other {builds}}"
    },
    failedBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.failed-build",
        "defaultMessage": "{buildCount} failed {buildCount, plural, one {build} other {builds}}"
    },
    unknownBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.unknown-build",
        "defaultMessage": "{buildCount} unknown state {buildCount, plural, one {build} other {builds}}"
    }
});

});


parcelRegister("15UWM", function(module, exports) {

$parcel$export(module.exports, "DeploymentData", () => $98dbbecd9b75f840$export$b2b8032dce325acb);

var $87Tt2 = parcelRequire("87Tt2");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $9R6Dh = parcelRequire("9R6Dh");

var $1zxA5 = parcelRequire("1zxA5");
const $98dbbecd9b75f840$var$mapEnvironmentCategory = (category, formatMessage)=>{
    switch(category){
        case 'PRODUCTION':
            return formatMessage((0, $9R6Dh.default).production);
        case 'STAGING':
            return formatMessage((0, $9R6Dh.default).staging);
        case 'TESTING':
            return formatMessage((0, $9R6Dh.default).testing);
        case 'DEVELOPMENT':
            return formatMessage((0, $9R6Dh.default).development);
        case 'UNMAPPED':
            return formatMessage((0, $9R6Dh.default).unmapped);
        default:
            return formatMessage((0, $9R6Dh.default).unmapped);
    }
};
const $98dbbecd9b75f840$export$b2b8032dce325acb = ({ onDeploymentClicked: onDeploymentClicked, jiraIssueDevOpsSummarisedEntities: jiraIssueSummarisedEntities })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { summarisedDeployments: summarisedDeployments } = (0, $iWLL0.useFragment)((0, $87Tt2.default), jiraIssueSummarisedEntities);
    // If null, there is nothing to display
    if (summarisedDeployments == null) return null; // Same logic as <StatusIcon/> component that falls back to Unknown if null
    const category = summarisedDeployments.deploymentEnvironment?.category ? summarisedDeployments.deploymentEnvironment.category : 'UNMAPPED';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98dbbecd9b75f840$var$BaseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deploymentSummaryCell');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98dbbecd9b75f840$var$ContentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98dbbecd9b75f840$var$StatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zxA5.StatusIcon), {
        jiraSummarisedDeployments: summarisedDeployments
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98dbbecd9b75f840$var$DescriptionInternalContainer, null, $98dbbecd9b75f840$var$mapEnvironmentCategory(category, formatMessage)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98dbbecd9b75f840$var$BaseContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98dbbecd9b75f840$var$ContentsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98dbbecd9b75f840$var$DescriptionInternalContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1bto1l2s _1reo15vq _18m915vq _1vhi1ule _ifb4glyw",
            __cmplp.className
        ])
    });
});
const $98dbbecd9b75f840$var$StatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _syaz15i6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("87Tt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8b0c9c16c264a4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<901a84048d79c1879372de976d6c09d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f8b0c9c16c264a4a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "DevOpsEnvironment",
                    "kind": "LinkedField",
                    "name": "deploymentEnvironment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusIcon_softwareReleasesVersionDetailIssueList"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$f8b0c9c16c264a4a$var$node.hash = "0a7623df234c698148c854c1e3a6ce8d";
var $f8b0c9c16c264a4a$export$2e2bcd8739ae039 = $f8b0c9c16c264a4a$var$node;

});

parcelRegister("9R6Dh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0212ecb38159bbbe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0212ecb38159bbbe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deploymentsTooltip: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployments-tooltip",
        "defaultMessage": "{deploymentCount} {deploymentCount, plural, one {deployment} other {deployments}}"
    },
    production: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.unmapped",
        "defaultMessage": "Undefined environment"
    }
});

});

parcelRegister("1zxA5", function(module, exports) {

$parcel$export(module.exports, "StatusIcon", () => $4f0c3175ba98757c$export$b131c49b26d3f427);

var $ca5ft = parcelRequire("ca5ft");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3oKhY = parcelRequire("3oKhY");

var $jV3Wn = parcelRequire("jV3Wn");

var $elCKr = parcelRequire("elCKr");
const $4f0c3175ba98757c$var$mapState = (state, environmentType, formatMessage)=>{
    switch(state){
        case (0, $jV3Wn.DeploymentStateOptions).PENDING:
            return {
                message: formatMessage((0, $elCKr.default).pending),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).PENDING,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).IN_PROGRESS:
            return {
                message: formatMessage((0, $elCKr.default).inProgress),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).IN_PROGRESS,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).SUCCESSFUL:
            if (environmentType === 'PRODUCTION') return {
                message: formatMessage((0, $elCKr.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).SUCCESSFUL,
                    size: "medium"
                })
            };
            return {
                message: formatMessage((0, $elCKr.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).SUCCESSFULNONPRODUCTION,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).FAILED:
            return {
                message: formatMessage((0, $elCKr.default).failed),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).FAILED,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).ROLLED_BACK:
            return {
                message: formatMessage((0, $elCKr.default).rolledBack),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).ROLLED_BACK,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).CANCELLED:
            return {
                message: formatMessage((0, $elCKr.default).cancelled),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).CANCELLED,
                    size: "medium"
                })
            };
        case (0, $jV3Wn.DeploymentStateOptions).UNKNOWN:
            return {
                message: formatMessage((0, $elCKr.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
        default:
            return {
                message: formatMessage((0, $elCKr.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
                    deploymentState: (0, $jV3Wn.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
    }
};
const $4f0c3175ba98757c$export$b131c49b26d3f427 = ({ jiraSummarisedDeployments: jiraSummarisedDeployments })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const deploymentSummary = (0, $iWLL0.useFragment)((0, $ca5ft.default), jiraSummarisedDeployments);
    const state = deploymentSummary.deploymentState ? deploymentSummary.deploymentState : 'UNKNOWN';
    const environment = deploymentSummary.deploymentEnvironment?.category ? deploymentSummary.deploymentEnvironment.category : 'UNMAPPED';
    const { icon: icon, message: message } = $4f0c3175ba98757c$var$mapState(state, environment, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: message
    }, icon);
};

});
parcelRegister("ca5ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a46323e04581abf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<975170e91daa818ce2bf2ced6fa58557>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a46323e04581abf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "statusIcon_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "deploymentState"
        },
        {
            "concreteType": "DevOpsEnvironment",
            "kind": "LinkedField",
            "name": "deploymentEnvironment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "category"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedDeployments"
};
$5a46323e04581abf$var$node.hash = "f151e3f42403e9b74c8517a51ce0be46";
var $5a46323e04581abf$export$2e2bcd8739ae039 = $5a46323e04581abf$var$node;

});

parcelRegister("elCKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79eaf63cbf16b26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79eaf63cbf16b26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pending: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.in-progress",
        "defaultMessage": "In-progress"
    },
    successful: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.unknown",
        "defaultMessage": "Unknown"
    }
});

});




parcelRegister("dYjI0", function(module, exports) {

$parcel$export(module.exports, "Development", () => $b2f492ef0482c88a$export$fb8a2d432bc2d196);
$parcel$export(module.exports, "DevelopmentContainer", () => $b2f492ef0482c88a$export$3c8f918e865f8ead);

var $5N5hi = parcelRequire("5N5hi");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $gojax = parcelRequire("gojax");

var $jXNxi = parcelRequire("jXNxi");

var $5L5WH = parcelRequire("5L5WH");


var $2eG9N = parcelRequire("2eG9N");


var $8gviD = parcelRequire("8gviD");

var $1187v = parcelRequire("1187v");


var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hN9v7 = parcelRequire("hN9v7");


var $bQFnb = parcelRequire("bQFnb");

var $3Lvvt = parcelRequire("3Lvvt");

var $gYjCL = parcelRequire("gYjCL");
const $b2f492ef0482c88a$export$fb8a2d432bc2d196 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { issueId: issueId, devSummaryCache: devSummaryCache } = (0, $iWLL0.useFragment)((0, $5N5hi.default), jiraIssue);
    const { branch: branch, commit: commit, pullrequest: pullrequest, review: review } = devSummaryCache.devSummary;
    const pullRequestCount = pullrequest.overall.count;
    const pullRequestState = pullrequest.overall.state;
    if (pullRequestCount > 0 && pullRequestState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $14a090e212ebf7a4$export$6f74b53d652f13f3));
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionsPullRequestLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1187v.default), {
        devInfoType: (0, $8gviD.DevInfoTypes).PULLREQUEST,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Lvvt.CustomPullRequestIcon), {
            pullRequestState: (0, $gYjCL.toDevInfoType)(pullrequest.overall.state),
            label: formatMessage((0, $bQFnb.default).pullRequestIconLabel),
            primaryColor: (0, $gYjCL.mapPullRequestStateToIconColour)(pullrequest.overall.state)
        }),
        isStopPropagationOnClick: false,
        scopeId: (0, $97888f678fdffcbb$export$6bc465585d114926),
        location: (0, $673f6d2b4a68f5cb$export$ede40e627a0cbf14)
    }))));
    const reviewCount = review.overall.count;
    const reviewState = review.overall.state;
    if (reviewCount > 0 && reviewState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $bQFnb.default).reviewCount, {
            reviewCount: reviewCount
        }),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const reviewDataByProvider = {};
            review.summaryByProvider.forEach(({ providerId: providerId, name: name, count: count })=>{
                if (providerId != null) reviewDataByProvider[providerId] = {
                    name: name,
                    count: count
                };
            });
            onClick((0, $14a090e212ebf7a4$export$3f1e2b276d607490), {
                overall: {
                    count: review.overall.count,
                    lastUpdated: review.overall.lastUpdated ?? '',
                    state: (0, $gYjCL.toReviewState)(reviewState),
                    stateCount: review.overall.stateCount
                },
                byInstanceType: reviewDataByProvider
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionsReviewLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5L5WH))), {
        label: formatMessage((0, $bQFnb.default).reviewIconLabel),
        primaryColor: (0, $gYjCL.mapReviewStateToIconColour)(reviewState)
    })))));
    const branchCount = branch.overall.count;
    if (branchCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $14a090e212ebf7a4$export$e18d81f044132a0e));
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionsBranchLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1187v.default), {
        devInfoType: (0, $8gviD.DevInfoTypes).BRANCH,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
            label: formatMessage((0, $bQFnb.default).branchIconLabel),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`
        }),
        scopeId: (0, $97888f678fdffcbb$export$6bc465585d114926),
        location: (0, $673f6d2b4a68f5cb$export$ede40e627a0cbf14)
    }))));
    const commitCount = commit.overall.count;
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1187v.default), {
        devInfoType: (0, $8gviD.DevInfoTypes).COMMIT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $14a090e212ebf7a4$export$2e42513c7764d5f3));
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionsCommitLozenge');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXNxi))), {
            label: formatMessage((0, $bQFnb.default).commitIconLabel),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`
        })),
        scopeId: (0, $97888f678fdffcbb$export$6bc465585d114926),
        location: (0, $673f6d2b4a68f5cb$export$ede40e627a0cbf14)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2f492ef0482c88a$export$3c8f918e865f8ead, null);
};
const $b2f492ef0482c88a$export$3c8f918e865f8ead = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbckbl _1ul9ckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b2f492ef0482c88a$var$VerticalCenter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5N5hi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5542dc8309094907$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59d3ab5850892cb433979868803b1f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5542dc8309094907$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "development_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueDevSummaryResult",
                    "kind": "LinkedField",
                    "name": "devSummaryCache",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueDevSummary",
                                "kind": "LinkedField",
                                "name": "devSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "branch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.branch.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.branch.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.branch"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "commit",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.commit.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.commit.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.commit"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "pullrequest",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                            },
                                                            v1 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.pullrequest"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.count"
                                                            },
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdated"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "ScalarField",
                                                                    "name": "stateCount"
                                                                },
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.stateCount"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.overall"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueDevSummaryByProvider",
                                                        "kind": "LinkedField",
                                                        "name": "summaryByProvider",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "providerId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            v0 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.summaryByProvider"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.review"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "devSummaryCache.devSummary"
                        }
                    ]
                },
                "action": "THROW",
                "path": "devSummaryCache"
            }
        ],
        "type": "JiraIssue"
    };
}();
$5542dc8309094907$var$node.hash = "a6fa00d421e78b1cfca02a289c940e70";
var $5542dc8309094907$export$2e2bcd8739ae039 = $5542dc8309094907$var$node;

});

parcelRegister("bQFnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8df4b55f284fb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2e8df4b55f284fb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    commitIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.commit-icon-label",
        "defaultMessage": "Commits"
    },
    branchIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.branch-icon-label",
        "defaultMessage": "Branches"
    },
    pullRequestIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.pull-request-icon-label",
        "defaultMessage": "Pull requests"
    },
    reviewCount: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-count",
        "defaultMessage": "{reviewCount} {reviewCount, plural, one {review} other {reviews}}"
    },
    reviewIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-icon-label",
        "defaultMessage": "Reviews"
    }
});

});

parcelRegister("3Lvvt", function(module, exports) {

$parcel$export(module.exports, "CustomPullRequestIcon", () => $a6bc1fd99bb8f12e$export$59a5de4025575d75);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $5L5WH = parcelRequire("5L5WH");


var $8gviD = parcelRequire("8gviD");
const $a6bc1fd99bb8f12e$var$PullrequestDeclinedIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "24",
                height: "24",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.75 5.25C6.19772 5.25 5.75 5.69772 5.75 6.25C5.75 6.80228 6.19772 7.25 6.75 7.25C7.30228 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 7.30228 5.25 6.75 5.25ZM3.75 6.25C3.75 4.59315 5.09315 3.25 6.75 3.25C8.40685 3.25 9.75 4.59315 9.75 6.25C9.75 7.55622 8.91519 8.66746 7.75 9.07929V20.25C7.75 20.8023 7.30228 21.25 6.75 21.25C6.19772 21.25 5.75 20.8023 5.75 20.25V9.07929C4.58481 8.66746 3.75 7.55622 3.75 6.25Z",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25V15.4207C18.9152 15.8325 19.75 16.9438 19.75 18.25C19.75 19.9069 18.4069 21.25 16.75 21.25C15.0931 21.25 13.75 19.9069 13.75 18.25C13.75 16.9438 14.5848 15.8325 15.75 15.4207V12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM16.75 17.25C16.1977 17.25 15.75 17.6977 15.75 18.25C15.75 18.8023 16.1977 19.25 16.75 19.25C17.3023 19.25 17.75 18.8023 17.75 18.25C17.75 17.6977 17.3023 17.25 16.75 17.25Z",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5429 3.04289C13.9334 2.65237 14.5666 2.65237 14.9571 3.04289L16.75 4.83579L18.5429 3.04289C18.9334 2.65237 19.5666 2.65237 19.9571 3.04289C20.3476 3.43342 20.3476 4.06658 19.9571 4.45711L18.1642 6.25L19.9571 8.04289C20.3476 8.43342 20.3476 9.06658 19.9571 9.45711C19.5666 9.84763 18.9334 9.84763 18.5429 9.45711L16.75 7.66421L14.9571 9.45711C14.5666 9.84763 13.9334 9.84763 13.5429 9.45711C13.1524 9.06658 13.1524 8.43342 13.5429 8.04289L15.3358 6.25L13.5429 4.45711C13.1524 4.06658 13.1524 3.43342 13.5429 3.04289Z",
                fill: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
            }))
    });
const $a6bc1fd99bb8f12e$var$PullrequestMergedIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "24",
                height: "24",
                fill: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5ZM3.5 6C3.5 4.34315 4.84315 3 6.5 3C8.15685 3 9.5 4.34315 9.5 6C9.5 7.30622 8.66519 8.41746 7.5 8.82929V20C7.5 20.5523 7.05228 21 6.5 21C5.94772 21 5.5 20.5523 5.5 20V8.82929C4.33481 8.41746 3.5 7.30622 3.5 6Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 7C7.05228 7 7.5 7.44772 7.5 8V10C7.5 13.5912 10.2043 16.5508 13.6876 16.9534C14.1123 15.8126 15.2113 15 16.5 15C18.1569 15 19.5 16.3431 19.5 18C19.5 19.6569 18.1569 21 16.5 21C15.1793 21 14.0579 20.1466 13.6572 18.9611C9.08185 18.5362 5.5 14.6864 5.5 10V8C5.5 7.44772 5.94772 7 6.5 7ZM16.5 17C15.9477 17 15.5 17.4477 15.5 18C15.5 18.5523 15.9477 19 16.5 19C17.0523 19 17.5 18.5523 17.5 18C17.5 17.4477 17.0523 17 16.5 17Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2071 4.29289C20.5976 4.68342 20.5976 5.31658 20.2071 5.70711L16.2071 9.70711C15.8166 10.0976 15.1834 10.0976 14.7929 9.70711L12.7929 7.70711C12.4024 7.31658 12.4024 6.68342 12.7929 6.29289C13.1834 5.90237 13.8166 5.90237 14.2071 6.29289L15.5 7.58579L18.7929 4.29289C19.1834 3.90237 19.8166 3.90237 20.2071 4.29289Z",
                fill: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
            }))
    });
const $a6bc1fd99bb8f12e$export$59a5de4025575d75 = ({ pullRequestState: pullRequestState, label: label, primaryColor: primaryColor })=>{
    if (pullRequestState === (0, $8gviD.DevInfoTypes).DECLINED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6bc1fd99bb8f12e$var$PullrequestDeclinedIcon, {
        label: label
    });
    if (pullRequestState === (0, $8gviD.DevInfoTypes).MERGED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6bc1fd99bb8f12e$var$PullrequestMergedIcon, {
        label: label
    });
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5L5WH))), {
        label: label,
        primaryColor: primaryColor
    });
};

});

parcelRegister("gYjCL", function(module, exports) {

$parcel$export(module.exports, "mapPullRequestStateToIconColour", () => $b807388e28feeaf5$export$b659f6ad1597c81c);
$parcel$export(module.exports, "mapReviewStateToIconColour", () => $b807388e28feeaf5$export$3503f5c2d5e8553a);
$parcel$export(module.exports, "toReviewState", () => $b807388e28feeaf5$export$e4227c1382daeae5);
$parcel$export(module.exports, "toDevInfoType", () => $b807388e28feeaf5$export$f3b34c5748a7d335);


var $8gviD = parcelRequire("8gviD");
const $b807388e28feeaf5$export$b659f6ad1597c81c = (state)=>{
    switch(state){
        case 'MERGED':
            return `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
        case 'DECLINED':
            return `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        default:
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
    }
};
const $b807388e28feeaf5$export$3503f5c2d5e8553a = (state)=>{
    switch(state){
        case 'REVIEW':
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
        case 'APPROVAL':
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
        case 'SUMMARIZE':
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
        case 'REJECTED':
            return `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        case 'CLOSED':
            return `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
        case 'DRAFT':
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
        case 'DEAD':
            return `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        case 'UNKNOWN':
            return `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        default:
            return `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
    }
};
const $b807388e28feeaf5$export$e4227c1382daeae5 = (state)=>{
    switch(state){
        case 'REVIEW':
        case 'APPROVAL':
        case 'SUMMARIZE':
        case 'REJECTED':
        case 'CLOSED':
        case 'DRAFT':
        case 'DEAD':
            return state;
        default:
            return 'UNKNOWN';
    }
};
const $b807388e28feeaf5$export$f3b34c5748a7d335 = (state)=>{
    switch(state){
        case 'DECLINED':
            return (0, $8gviD.DevInfoTypes).DECLINED;
        case 'MERGED':
            return (0, $8gviD.DevInfoTypes).MERGED;
        default:
            return (0, $8gviD.DevInfoTypes).PULLREQUEST;
    }
};

});


parcelRegister("4ri9i", function(module, exports) {

$parcel$export(module.exports, "FeatureFlags", () => $65ba5372674ff577$export$ab28ab2e245553c7);
$parcel$export(module.exports, "FeatureFlagsContainer", () => $65ba5372674ff577$export$c518a6c3736e9db7);

var $fbgO9 = parcelRequire("fbgO9");

var $doVI0 = parcelRequire("doVI0");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");


var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $bgFfx = parcelRequire("bgFfx");

var $kEyKV = parcelRequire("kEyKV");

var $aMVSc = parcelRequire("aMVSc");
const $65ba5372674ff577$export$ab28ab2e245553c7 = ({ devOpsSummarisedEntities: devOpsSummarisedEntities, jiraIssue: jiraIssue, onClick: onClick, setFeatureFlagEmptyStateModalOpen: setFeatureFlagEmptyStateModalOpen, rowNum: rowNum })=>{
    const issue = (0, $iWLL0.useFragment)((0, $doVI0.default), jiraIssue);
    const { providers: providers } = (0, $iWLL0.useFragment)((0, $fbgO9.default), devOpsSummarisedEntities);
    const summarisedFlags = (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? issue.summarisedFeatureFlags : issue.devOpsSummarisedEntities?.summarisedFeatureFlags;
    const featureFlagCount = summarisedFlags?.totalCount ?? 0;
    const hasFeatureFlags = summarisedFlags != null && featureFlagCount != null && featureFlagCount > 0;
    const featureFlagProviders = (providers.featureFlagProviders ?? []).filter(Boolean);
    const hasFeatureFlagProviders = featureFlagProviders.length > 0;
    const renderContent = ()=>{
        const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
        const jiraIssueSummary = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary'); // Render the single or multiple flags component if the issue has at least one linked
        // feature flag
        if (hasFeatureFlags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $14a090e212ebf7a4$export$c69477f358d30f7e));
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryCell');
            }
        }, featureFlagCount === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aMVSc.SingleFlag), {
            summarisedFlags: summarisedFlags
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kEyKV.MultipleFlags), {
            jiraIssue: issue,
            summarisedFlags: summarisedFlags
        }));
         // Render the "add flag" dropdown if there's at least one feature flag provider and the
        // issue has no linked feature flags
        if (hasFeatureFlagProviders) return jiraIssueSummary != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65ba5372674ff577$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bgFfx.AddFeatureFlagDropdown), {
            devOpsFeatureFlagProviders: featureFlagProviders,
            jiraIssue: issue,
            jiraIssueSummary: jiraIssueSummary,
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true)
        })) : null;
         // If the issue has no linked feature flags and there are no linked providers, return the
        // "add feature flag provider" button
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65ba5372674ff577$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bgFfx.AddFeatureFlagButton), {
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true),
            rowNum: rowNum
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65ba5372674ff577$export$c518a6c3736e9db7, null, renderContent(), " ");
};
const $65ba5372674ff577$export$e7937791cac9c51b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1wtl15vq _j9irewfl"
        ])
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $65ba5372674ff577$export$c518a6c3736e9db7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
            __cmplp.className
        ])
    });
});
const $65ba5372674ff577$var$styles = null;

});
parcelRegister("fbgO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $98bfbcec7b9cbdf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce2c34f4872428c634fc08b19e03484c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98bfbcec7b9cbdf5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "providers.featureFlagProviders"
                    }
                ]
            },
            "action": "THROW",
            "path": "providers"
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$98bfbcec7b9cbdf5$var$node.hash = "6396e923543528812899038e05950d31";
var $98bfbcec7b9cbdf5$export$2e2bcd8739ae039 = $98bfbcec7b9cbdf5$var$node;

});

parcelRegister("doVI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fd6bb00d4b8f65f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4c3b543e6411758fca73d81fc4164dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fd6bb00d4b8f65f$var$node = function() {
    var v0 = [
        {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleFlag_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            }
        ],
        "kind": "Fragment",
        "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedEntities",
                "kind": "LinkedField",
                "name": "devOpsSummarisedEntities",
                "plural": false,
                "selections": [
                    {
                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                "kind": "Condition",
                "passingValue": true,
                "selections": v0 /*: any*/ 
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "priority",
                                "summary",
                                "assignee",
                                "status",
                                "issuetype"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsById.edges.node.fieldId"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary"
                                                    }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "fieldsById.edges"
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                },
                "action": "THROW",
                "path": "fieldsById"
            },
            {
                "kind": "FragmentSpread",
                "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue"
            },
            {
                "kind": "FragmentSpread",
                "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
}();
$3fd6bb00d4b8f65f$var$node.hash = "e07d07935307d3c1473575baacb25327";
var $3fd6bb00d4b8f65f$export$2e2bcd8739ae039 = $3fd6bb00d4b8f65f$var$node;

});

parcelRegister("bgFfx", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagDropdown", () => $ebadbd7681432c73$export$e0238a9f85d3899d);
$parcel$export(module.exports, "AddFeatureFlagButton", () => $ebadbd7681432c73$export$18659c2363dd7739);

var $4BgZ3 = parcelRequire("4BgZ3");

var $ig96q = parcelRequire("ig96q");

var $ldeOC = parcelRequire("ldeOC");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $d6f6c = parcelRequire("d6f6c");

var $7ZIvG = parcelRequire("7ZIvG");

var $lg9DG = parcelRequire("lg9DG");

var $29kgh = parcelRequire("29kgh");

const $ebadbd7681432c73$var$ActionMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("1athe")).then((module)=>module.ActionMenu), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-menu/index.tsx"
}); // Extract just the content excluding button so we don't need to worry about passing props and
// forwardRef
const $ebadbd7681432c73$var$TriggerContent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lg9DG.AddFeatureFlagIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$ButtonText, null, children));
const $ebadbd7681432c73$export$e0238a9f85d3899d = ({ jiraIssue: jiraIssue, jiraIssueSummary: jiraIssueSummary, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eUqFw.useState)(false);
    const issue = (0, $iWLL0.useFragment)((0, $ldeOC.default), jiraIssue);
    const issueSummary = (0, $iWLL0.useFragment)((0, $ig96q.default), jiraIssueSummary);
    const featureFlagProviders = (0, $iWLL0.useFragment)((0, $4BgZ3.default), devOpsFeatureFlagProviders);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$OnHoverContainer, {
        isVisible: isDropdownOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "action-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$TriggerContent, null, formatMessage((0, $29kgh.default).addFeatureFlag)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$ActionMenu, {
        jiraIssue: issue,
        jiraIssueSummary: issueSummary,
        onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
        devOpsFeatureFlagProviders: featureFlagProviders,
        onOpenFeatureFlagEmptyStateExperience: onOpenFeatureFlagEmptyStateModal,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "subtle-link",
                spacing: "none",
                ref: triggerRef,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$TriggerContent, null, formatMessage((0, $29kgh.default).addFeatureFlag)))
    })));
};
const $ebadbd7681432c73$export$18659c2363dd7739 = ({ onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal, rowNum: rowNum })=>{
    const spotlightButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "action-button-no-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lg9DG.AddFeatureFlagIcon), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZIvG.ActionButtonNoProviderAsync), {
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lg9DG.AddFeatureFlagIcon), null)));
    const regularButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lg9DG.AddFeatureFlagIcon), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebadbd7681432c73$var$AddFeatureFlagButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionDetailsTableAddFeatureFlagActionButton",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, rowNum === 1 ? spotlightButton : regularButton, rowNum === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null) : null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebadbd7681432c73$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebadbd7681432c73$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebadbd7681432c73$var$AddFeatureFlagButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ebadbd7681432c73$var$OnHoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isVisible ? "_3um015ya" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4BgZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7669021fb443b1b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5e7746a103df83550bdda76eb8415f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7669021fb443b1b5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$7669021fb443b1b5$var$node.hash = "9b78d95e09cfbfd2c5af5b680d6fc543";
var $7669021fb443b1b5$export$2e2bcd8739ae039 = $7669021fb443b1b5$var$node;

});

parcelRegister("ig96q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa6444ea56e29fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c9a416112e3bed4c41b26a4d887a703>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2aa6444ea56e29fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$2aa6444ea56e29fb$var$node.hash = "f26b20a2f8e5f0c916921d8c8691c202";
var $2aa6444ea56e29fb$export$2e2bcd8739ae039 = $2aa6444ea56e29fb$var$node;

});

parcelRegister("ldeOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $140419e42950aee3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5c21fffefe38a3c828a06aaddbce9c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $140419e42950aee3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$140419e42950aee3$var$node.hash = "3ccc732c38654f19cf9d23f0c776cb28";
var $140419e42950aee3$export$2e2bcd8739ae039 = $140419e42950aee3$var$node;

});

parcelRegister("7ZIvG", function(module, exports) {

$parcel$export(module.exports, "ActionButtonNoProviderAsync", () => $d372b1f8a8f9a3a8$export$86b05afa2718604);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d372b1f8a8f9a3a8$var$ActionButtonNoProviderLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("mpv3k")).then((module)=>module.ActionButtonNoProvider), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-button-no-provider/index.tsx"
});
const $d372b1f8a8f9a3a8$export$86b05afa2718604 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d372b1f8a8f9a3a8$var$ActionButtonNoProviderLazy, props);

});
parcelRegister("mpv3k", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("j1MDe").then(()=>parcelRequire('1c0za'));

});


parcelRegister("lg9DG", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagIcon", () => $367f9688e2324109$export$c3b91b420ace5d12);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $25riK = parcelRequire("25riK");
const $367f9688e2324109$var$AddFeatureFlagGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: (0, $c9TLT.gridSize) * 3,
        height: (0, $c9TLT.gridSize) * 3,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 2C17.5523 2 18 2.44772 18 3V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H18V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H16V3C16 2.44772 16.4477 2 17 2ZM12.2444 4.49608C12.3613 4.52442 12.477 4.55249 12.5917 4.57991C12.2263 4.9423 12 5.44472 12 6C12 6.17625 12.0228 6.34718 12.0656 6.50999C11.966 6.48607 11.867 6.46205 11.7688 6.43821L11.768 6.43801L11.7623 6.43662L11.7623 6.43662C10.3856 6.10219 9.16838 5.80649 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V10.737C16.3004 10.9044 16.639 11 17 11C17.3676 11 17.712 10.9008 18.008 10.7278V12.221C18.0081 12.4088 17.9554 12.5927 17.8558 12.7519C17.7562 12.9111 17.6139 13.039 17.445 13.121C16.6509 13.5034 15.7793 13.6974 14.898 13.688C13.8103 13.688 12.7622 13.434 11.785 13.1971L11.785 13.1971L11.768 13.193C10.389 12.858 9.17 12.562 8 12.903V18.681C8 19.218 7.55 19.658 7 19.658C6.45 19.658 6 19.218 6 18.681V12.235V5.46601C6 5.27855 6.05268 5.09486 6.15205 4.93591C6.25143 4.77695 6.39348 4.64912 6.562 4.56701C8.553 3.60001 10.511 4.07501 12.24 4.49501L12.2444 4.49608Z",
        fill: "currentcolor"
    }));
const $367f9688e2324109$export$c3b91b420ace5d12 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($367f9688e2324109$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.add-feature-flag.icon.icon",
        glyph: $367f9688e2324109$var$AddFeatureFlagGlyph,
        size: "medium",
        label: formatMessage((0, $25riK.default).addFeatureFlagIconLabel)
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $367f9688e2324109$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("25riK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0abd681f79b5e926$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0abd681f79b5e926$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addFeatureFlagIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.icon.add-feature-flag-icon-label",
        "defaultMessage": "Add feature flag icon"
    }
});

});


parcelRegister("29kgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c1a5e954e470185$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2c1a5e954e470185$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addFeatureFlag: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.add-feature-flag",
        "defaultMessage": "Add flag"
    },
    createFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.create-feature-flag-menu-item",
        "defaultMessage": "Create feature flag"
    },
    connectFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.connect-feature-flag-menu-item",
        "defaultMessage": "Connect feature flag"
    },
    installAnotherToolMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.install-another-tool-menu-item",
        "defaultMessage": "Install another tool"
    }
});

});

parcelRegister("1athe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1hrAf").then(()=>parcelRequire('lMa5K'));

});


parcelRegister("kEyKV", function(module, exports) {

$parcel$export(module.exports, "MultipleFlags", () => $20e84b57281e6764$export$6d8ca791f6cb1232);

var $50LkO = parcelRequire("50LkO");

var $acOrT = parcelRequire("acOrT");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");

var $9H4av = parcelRequire("9H4av");

var $iylwL = parcelRequire("iylwL");

var $jTEwB = parcelRequire("jTEwB");
const $20e84b57281e6764$export$6d8ca791f6cb1232 = ({ jiraIssue: jiraIssue, summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const issue = (0, $iWLL0.useFragment)((0, $acOrT.default), jiraIssue);
    const { totalCount: totalCount } = (0, $iWLL0.useFragment)((0, $50LkO.default), summarisedFlags);
    const [tooltipQueryReference, loadTooltipQuery] = (0, $jTEwB.useTooltipContentQuery)(issue.id);
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "tooltip-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $iylwL.default).tooltipLoading))
    }, tooltipQueryReference == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTEwB.TooltipContent), {
        queryReference: tooltipQueryReference
    }));
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20e84b57281e6764$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9H4av.MultipleFlagsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20e84b57281e6764$var$TextContainer, null, formatMessage((0, $iylwL.default).flags, {
        count: formatNumber(totalCount)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onFocus: loadTooltipQuery,
        onMouseOver: loadTooltipQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.tooltip",
        content: tooltipContent,
        onShow: (analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, cellContent));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20e84b57281e6764$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20e84b57281e6764$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("50LkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2ef261e6610f64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a012cadd441203c8d2c31f966162e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cc2ef261e6610f64$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$cc2ef261e6610f64$var$node.hash = "f8750caf47e7cdb0f524b2138f711e5d";
var $cc2ef261e6610f64$export$2e2bcd8739ae039 = $cc2ef261e6610f64$var$node;

});

parcelRegister("acOrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $717149641fd896cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e76ab10079ddc5bd9646614f150b688>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $717149641fd896cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraIssue"
};
$717149641fd896cf$var$node.hash = "895bdec15c863c74e317666c4dea1c42";
var $717149641fd896cf$export$2e2bcd8739ae039 = $717149641fd896cf$var$node;

});

parcelRegister("9H4av", function(module, exports) {

$parcel$export(module.exports, "MultipleFlagsIcon", () => $e80b7ee2572a454c$export$b02a1ce334df672e);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8j7ps = parcelRequire("8j7ps");

var $eWo9k = parcelRequire("eWo9k");
const $e80b7ee2572a454c$var$MultipleFlagsGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8j7ps))),
        alt: ""
    });
const $e80b7ee2572a454c$export$b02a1ce334df672e = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple",
        size: "medium",
        glyph: $e80b7ee2572a454c$var$MultipleFlagsGlyph,
        label: formatMessage((0, $eWo9k.default).multipleFlagsIconLabel)
    });
};

});
parcelRegister("8j7ps", function(module, exports) {
module.exports = new URL("multiple-flags.fdb5d926.svg", import.meta.url).toString();

});

parcelRegister("eWo9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $822d6891aa6c1125$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $822d6891aa6c1125$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    multipleFlagsIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.icon.multiple-flags-icon-label",
        "defaultMessage": "Multiple feature flags"
    }
});

});


parcelRegister("iylwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac00ac65488cfeff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ac00ac65488cfeff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flags: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.flags",
        "defaultMessage": "{count} {count, plural, one {flag} other {flags}}"
    },
    tooltipLoading: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-loading",
        "defaultMessage": "Loading..."
    }
});

});

parcelRegister("jTEwB", function(module, exports) {

$parcel$export(module.exports, "useTooltipContentQuery", () => $98823b6a3189bdaa$export$8f5a61dd01353b26);
$parcel$export(module.exports, "TooltipContent", () => $98823b6a3189bdaa$export$e9003e2be37ec060);

var $l9L69 = parcelRequire("l9L69");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ebDNl = parcelRequire("ebDNl");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $l9L69 = parcelRequire("l9L69");

var $9ru5N = parcelRequire("9ru5N");
const $98823b6a3189bdaa$var$MAX_DISPLAY_NAME_LENGTH = 32;
const $98823b6a3189bdaa$var$MAX_FLAGS_TO_SHOW = 3;
const $98823b6a3189bdaa$export$8f5a61dd01353b26 = (issueId)=>{
    const [queryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $l9L69.default));
    return [
        queryRef,
        ()=>loadQuery({
                issueId: issueId
            })
    ];
};
const $98823b6a3189bdaa$export$e9003e2be37ec060 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const result = (0, $iWLL0.usePreloadedQuery)((0, $l9L69.default), queryReference);
    const { totalCount: totalCount, edges: edges } = result.devOps.entitiesByAssociations.featureFlagEntities;
    const featureFlags = edges?.flatMap((edge)=>edge?.node == null ? [] : [
            edge.node
        ]).map((node)=>({
            id: node.id,
            displayName: node.displayName.length > $98823b6a3189bdaa$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($ebDNl)))(node.displayName, {
                length: $98823b6a3189bdaa$var$MAX_DISPLAY_NAME_LENGTH,
                separator: ' '
            }) : node.displayName,
            enabled: node.summary.enabled
        }));
    const hiddenFlagsCount = Math.max(0, totalCount - $98823b6a3189bdaa$var$MAX_FLAGS_TO_SHOW);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $98823b6a3189bdaa$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98823b6a3189bdaa$var$FeatureFlagList, null, featureFlags.map(({ id: id, displayName: displayName, enabled: enabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: id
        }, enabled ? formatMessage((0, $9ru5N.default).flagEnabled, {
            displayName: displayName
        }) : formatMessage((0, $9ru5N.default).flagDisabled, {
            displayName: displayName
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98823b6a3189bdaa$var$MoreFlagsText, null, hiddenFlagsCount > 0 ? formatMessage((0, $9ru5N.default).flagsHidden, {
        hiddenFlagsCount: hiddenFlagsCount
    }) : null));
};
const $98823b6a3189bdaa$var$containerStyles = (0, $1ZAYh.xcss)({
    margin: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98823b6a3189bdaa$var$FeatureFlagList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});
const $98823b6a3189bdaa$var$MoreFlagsText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l9L69", function(module, exports) {

$parcel$export(module.exports, "default", () => $7479708c709cdaba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fbd43c099929d1939c8e2128492206d3>>
 * @relayHash 41cd8d72cd786835b67fae78de599312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc
const $7479708c709cdaba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "issueId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "enabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsEntities",
                                    "kind": "LinkedField",
                                    "name": "entitiesByAssociations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v2 /*: any*/ ,
                                                "concreteType": "DevOpsFeatureFlagConnection",
                                                "kind": "LinkedField",
                                                "name": "featureFlagEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.totalCount"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "DevOpsFeatureFlagEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.displayName"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "DevOpsFeatureFlagSummary",
                                                                                "kind": "LinkedField",
                                                                                "name": "summary",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v6 /*: any*/ ,
                                                                                        "action": "NONE",
                                                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary.enabled"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges"
                                                    }
                                                ],
                                                "storageKey": "featureFlagEntities(first:3)"
                                            },
                                            "action": "THROW",
                                            "path": "devOps.entitiesByAssociations.featureFlagEntities"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.entitiesByAssociations"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsEntities",
                            "kind": "LinkedField",
                            "name": "entitiesByAssociations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "DevOpsFeatureFlagConnection",
                                    "kind": "LinkedField",
                                    "name": "featureFlagEntities",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "DevOpsFeatureFlagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsFeatureFlag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "featureFlagEntities(first:3)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc",
            "metadata": {},
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7479708c709cdaba$var$node.hash = "c17feb1731a74b476c57976ce322ce68";
var $7479708c709cdaba$export$2e2bcd8739ae039 = $7479708c709cdaba$var$node;

});

parcelRegister("9ru5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb70ab0b460bba0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $adb70ab0b460bba0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagEnabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-enabled",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagsHidden: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flags-hidden",
        "defaultMessage": "+ {hiddenFlagsCount} more"
    }
});

});



parcelRegister("aMVSc", function(module, exports) {

$parcel$export(module.exports, "SingleFlag", () => $90b849baba0f9106$export$c039c42a03fd637);

var $cywFl = parcelRequire("cywFl");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ebDNl = parcelRequire("ebDNl");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $8AUe2 = parcelRequire("8AUe2");

var $lBfe9 = parcelRequire("lBfe9");
const $90b849baba0f9106$var$MAX_DISPLAY_NAME_LENGTH = 255;
const $90b849baba0f9106$export$c039c42a03fd637 = ({ summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { mostRelevantDisplayName: mostRelevantDisplayName, mostRelevantEnabled: mostRelevantEnabled, mostRelevantRolloutPercentage: mostRelevantRolloutPercentage } = (0, $iWLL0.useFragment)((0, $cywFl.default), summarisedFlags);
    const truncatedDisplayName = mostRelevantDisplayName.length > $90b849baba0f9106$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($ebDNl)))(mostRelevantDisplayName, {
        length: $90b849baba0f9106$var$MAX_DISPLAY_NAME_LENGTH,
        separator: ' '
    }) : mostRelevantDisplayName;
    const renderTooltip = ()=>{
        if (!mostRelevantEnabled) return formatMessage((0, $lBfe9.default).flagDisabled, {
            displayName: truncatedDisplayName
        });
        if (mostRelevantRolloutPercentage == null) return formatMessage((0, $lBfe9.default).flagWithoutPercentage, {
            displayName: truncatedDisplayName
        });
        return formatMessage((0, $lBfe9.default).flagWithPercentage, {
            displayName: truncatedDisplayName,
            percentage: mostRelevantRolloutPercentage / 100
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.tooltip",
        content: renderTooltip(),
        onShow: (analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($90b849baba0f9106$var$Container, null, mostRelevantEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AUe2.FlagEnabledIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AUe2.FlagDisabledIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($90b849baba0f9106$var$TextContainer, null, mostRelevantRolloutPercentage != null ? `${formatMessage((0, $lBfe9.default).flagPercentageRollout, {
        featureFlagPercentageRollout: mostRelevantRolloutPercentage / 100
    })}` : null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90b849baba0f9106$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90b849baba0f9106$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cywFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a340d15df3f1133$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aad7f5364f82e7ffbeae52ea8540080>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a340d15df3f1133$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleFlag_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            "action": "THROW",
            "path": "mostRelevantDisplayName"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            "action": "THROW",
            "path": "mostRelevantEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "mostRelevantRolloutPercentage"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$4a340d15df3f1133$var$node.hash = "5843724954a8e05bf3074b304ff85341";
var $4a340d15df3f1133$export$2e2bcd8739ae039 = $4a340d15df3f1133$var$node;

});

parcelRegister("8AUe2", function(module, exports) {

$parcel$export(module.exports, "FlagDisabledIcon", () => $20e36fc63aada727$export$a94a5376ccc0e3fb);
$parcel$export(module.exports, "FlagEnabledIcon", () => $20e36fc63aada727$export$b99b90244f32ccbf);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bdibq = parcelRequire("bdibq");

var $jRBCO = parcelRequire("jRBCO");

var $klebs = parcelRequire("klebs");
const $20e36fc63aada727$var$size = 'medium';
const $20e36fc63aada727$var$FlagDisabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bdibq))),
        alt: ""
    });
const $20e36fc63aada727$export$a94a5376ccc0e3fb = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled",
        size: $20e36fc63aada727$var$size,
        glyph: $20e36fc63aada727$var$FlagDisabledGlyph,
        label: formatMessage((0, $klebs.default).flagDisabledIconLabel)
    });
};
const $20e36fc63aada727$var$FlagEnabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jRBCO))),
        alt: ""
    });
const $20e36fc63aada727$export$b99b90244f32ccbf = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled",
        size: $20e36fc63aada727$var$size,
        glyph: $20e36fc63aada727$var$FlagEnabledGlyph,
        label: formatMessage((0, $klebs.default).flagEnabledIconLabel)
    });
};

});
parcelRegister("bdibq", function(module, exports) {
module.exports = new URL("flag-disabled.813c2320.svg", import.meta.url).toString();

});

parcelRegister("jRBCO", function(module, exports) {
module.exports = new URL("flag-enabled.1378f3de.svg", import.meta.url).toString();

});

parcelRegister("klebs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6cf9036a7954c63$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d6cf9036a7954c63$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagEnabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-enabled-icon-label",
        "defaultMessage": "Feature flag enabled"
    },
    flagDisabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-disabled-icon-label",
        "defaultMessage": "Feature flag disabled"
    }
});

});


parcelRegister("lBfe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc1950288a748b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7fc1950288a748b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagWithoutPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-without-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagWithPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-with-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on at {percentage, number, percent}"
    },
    flagPercentageRollout: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-percentage-rollout",
        "defaultMessage": "{featureFlagPercentageRollout, number, percent}"
    }
});

});



parcelRegister("gGTDa", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $ef64edc6e0c4a3f2$export$7f94856880993f27);
$parcel$export(module.exports, "OnHoverVisibility", () => $ef64edc6e0c4a3f2$export$e7937791cac9c51b);

var $iU0FX = parcelRequire("iU0FX");

var $kGSjl = parcelRequire("kGSjl");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $5YsMl = parcelRequire("5YsMl");


var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h8feS = parcelRequire("h8feS");

var $1Iaxm = parcelRequire("1Iaxm");

var $4vHNG = parcelRequire("4vHNG");
const $ef64edc6e0c4a3f2$export$7f94856880993f27 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
    const issue = (0, $iWLL0.useFragment)((0, $kGSjl.default), jiraIssue);
    const version = (0, $iWLL0.useFragment)((0, $iU0FX.default), jiraVersion);
    const [isPopupOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [moveIssuesBetweenVersionsQueryReference, loadMoveIssuesBetweenVersionsQuery] = (0, $1Iaxm.useMoveIssuesBetweenVersionsQuery)(version.project.id, 4, version.id);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const togglePopup = ()=>{
        if (hasWarnings) {
            const warnings = [];
            if (hasOpenPullRequestWarning) warnings.push('OPEN_PULL_REQUEST');
            if (hasFailingBuildsWarning) warnings.push('FAILING_BUILD');
            if (hasUnreviewedCodeWarning) warnings.push('UNREVIEWED_CODE');
            if (hasOpenReviewWarning) warnings.push('OPEN_REVIEW');
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'IssueWarningMoreButton'
            }), {
                warnings: warnings.toString()
            });
        }
        if (moveIssuesBetweenVersionsQueryReference == null) loadMoveIssuesBetweenVersionsQuery();
        setIsOpen(!isPopupOpen);
    };
    const handlePopupClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef64edc6e0c4a3f2$export$e7937791cac9c51b, null, (!!version.canAddAndRemoveIssues || hasWarnings) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h8feS.default), {
        renderTrigger: ({ triggerProps: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                iconBefore: hasWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                    testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.more-button.issue-card-warning-more-button",
                    primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
                    label: formatMessage((0, $4vHNG.default).moreVersions),
                    size: "medium"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $4vHNG.default).moreVersions)
                }),
                onClick: togglePopup,
                onMouseOver: loadMoveIssuesBetweenVersionsQuery,
                appearance: "subtle",
                isSelected: isPopupOpen
            }),
        queryReference: moveIssuesBetweenVersionsQueryReference,
        jiraIssue: issue,
        onClose: handlePopupClose,
        isOpen: isPopupOpen
    }));
};
const $ef64edc6e0c4a3f2$export$e7937791cac9c51b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1ylp _1wtl15vq _j9irewfl"
        ])
    }, children);
const $ef64edc6e0c4a3f2$var$styles = null;

});
parcelRegister("iU0FX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae9576e45c42c08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7122e0be96e2941d3d8936d1014528e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dae9576e45c42c08$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$dae9576e45c42c08$var$node.hash = "e838cd21a0e90d2500f678bc796ae098";
var $dae9576e45c42c08$export$2e2bcd8739ae039 = $dae9576e45c42c08$var$node;

});

parcelRegister("kGSjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e2700d6b4d98c8c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<823740b837a29b2cef6134c1e8a3199b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9e2700d6b4d98c8c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$9e2700d6b4d98c8c$var$node.hash = "fae4c5ea4895f8ef68f1e0800962eb5d";
var $9e2700d6b4d98c8c$export$2e2bcd8739ae039 = $9e2700d6b4d98c8c$var$node;

});

parcelRegister("h8feS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0502d53282b18a6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0502d53282b18a6b$var$MoveVersions = (0, $7rh0R.lazy)(()=>(parcelRequire("aOajQ")).then((mod)=>mod.default), {
    moduleId: "./src/packages/releases/move-issues-between-versions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0502d53282b18a6b$export$2e2bcd8739ae039 = ({ renderTrigger: renderTrigger, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async.jira.move.issues.between.versions",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "fusion-solaris"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "move-issues-between-versions",
        fallback: renderTrigger({
            triggerProps: {},
            isLoading: true,
            isSelected: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0502d53282b18a6b$var$MoveVersions, {
        renderTrigger: renderTrigger,
        ...props
    })));

});
parcelRegister("aOajQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l8HMD").then(()=>parcelRequire('kgtiP'));

});


parcelRegister("1Iaxm", function(module, exports) {

$parcel$export(module.exports, "useMoveIssuesBetweenVersionsQuery", () => $248bf02c5cd84752$export$4d5ca68749a2d51a);
$parcel$export(module.exports, "MoveIssuesBetweenVersions", () => $248bf02c5cd84752$export$1113ac51f1804da9);

var $jH88T = parcelRequire("jH88T");

var $ikq5Q = parcelRequire("ikq5Q");

var $d4TGd = parcelRequire("d4TGd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $3MV1G = parcelRequire("3MV1G");

var $kGQen = parcelRequire("kGQen");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $d4TGd = parcelRequire("d4TGd");

var $hN9v7 = parcelRequire("hN9v7");

var $7XSrK = parcelRequire("7XSrK");

var $aLYIY = parcelRequire("aLYIY");

var $7sRqD = parcelRequire("7sRqD");
const $248bf02c5cd84752$export$4d5ca68749a2d51a = (projectAri, first, versionAri)=>{
    const [queryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $d4TGd.default));
    return [
        queryRef,
        ()=>loadQuery({
                projectAri: projectAri,
                first: first,
                versionAri: versionAri
            }, {
                fetchPolicy: 'store-or-network'
            })
    ];
};
const $248bf02c5cd84752$export$56eba4b61234c117 = ({ queryReference: queryReference, jiraIssue: jiraIssue, onClose: onClose, isVersionPickerModalOpen: isVersionPickerModalOpen, setIsVersionPickerModalOpen: setIsVersionPickerModalOpen })=>{
    const { jira: jira } = (0, $iWLL0.usePreloadedQuery)((0, $d4TGd.default), queryReference);
    const issue = (0, $iWLL0.useFragment)((0, $ikq5Q.default), jiraIssue);
    const { version: version, versionsForProject: versionsForProject } = jira;
    const handleClose = ()=>{
        setIsVersionPickerModalOpen(false);
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7sRqD.VersionList), {
        jiraVersionEdges: versionsForProject.edges.filter(Boolean),
        jiraIssue: issue,
        jiraVersion: version,
        onVersionPickerModalOpen: ()=>{
            setIsVersionPickerModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isVersionPickerModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jira.move.issues.between.versions.version.picker",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "fusion-solaris",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        // This is used to ignore issue click when move issue modal is opened and anywhere is clicked in/outside of the modal
        testId: "software-releases-move-issues-between-versions.ui.move-issue-version-select-modal",
        autoFocus: false,
        width: "small",
        onClose: handleClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XSrK.VersionPicker), {
        jiraVersion: version,
        jiraIssue: issue,
        onClose: handleClose
    }))))));
};
const $248bf02c5cd84752$export$1113ac51f1804da9 = ({ renderTrigger: renderTrigger, jiraIssue: jiraIssue, queryReference: queryReference, isOpen: isOpen, onClose: onClose })=>{
    const [isVersionPickerModalOpen, setIsVersionPickerModalOpen] = (0, $eUqFw.useState)(false);
    const handleClose = ()=>{
        if (!isVersionPickerModalOpen) onClose();
    };
    const issue = (0, $iWLL0.useFragment)((0, $jH88T.default), jiraIssue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLYIY.HoverVisibilityControlWrapper), {
        isVisible: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        autoFocus: false,
        onClose: handleClose,
        placement: "left-start",
        fallbackPlacements: [
            'left-end'
        ],
        content: ()=>queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "move-issues-between-versions-popup-content",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-version-details-issue-click-ignore-target": (0, $hN9v7.ISSUE_CARD_CLICK_IGNORE_TARGET)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($248bf02c5cd84752$export$56eba4b61234c117, {
                isVersionPickerModalOpen: isVersionPickerModalOpen,
                jiraIssue: issue,
                onClose: onClose,
                queryReference: queryReference,
                setIsVersionPickerModalOpen: setIsVersionPickerModalOpen
            }))) : null,
        trigger: (triggerProps)=>renderTrigger({
                triggerProps: triggerProps,
                isSelected: isOpen,
                isLoading: false
            })
    }));
};

});
parcelRegister("jH88T", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e9529f2e1d6877d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7333e707d2161a8b1aa1f22f627e1650>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8e9529f2e1d6877d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$8e9529f2e1d6877d$var$node.hash = "a82d3697e92fea96f21c1bc4281c03e5";
var $8e9529f2e1d6877d$export$2e2bcd8739ae039 = $8e9529f2e1d6877d$var$node;

});

parcelRegister("ikq5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d5ab954a401aaa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb939ed30ff6ba50b14702d8011d102a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a9d5ab954a401aaa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$a9d5ab954a401aaa$var$node.hash = "a7d48e98e04811f2286b41cb01a9419a";
var $a9d5ab954a401aaa$export$2e2bcd8739ae039 = $a9d5ab954a401aaa$var$node;

});

parcelRegister("d4TGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a2859a263a9ccc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0a8342d9fdd521c7874e63ec6e8e6c4>>
 * @relayHash fffb275f3c1642370db8ca26640d4d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f
const $c1a2859a263a9ccc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v4 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "jiraProjectId",
        "variableName": "projectAri"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v11 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProject",
                                    "args": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__moveIssuesBetweenVersions_versionsForProject_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges"
                                                    },
                                                    v6 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v7 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProject.edges"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "jiraProjectId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "moveIssuesBetweenVersions_versionsForProject",
                            "kind": "LinkedHandle",
                            "name": "versionsForProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProject"
                        ]
                    }
                ]
            },
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c1a2859a263a9ccc$var$node.hash = "58c061e61158c45d3f183de8ea9ac7ab";
var $c1a2859a263a9ccc$export$2e2bcd8739ae039 = $c1a2859a263a9ccc$var$node;

});

parcelRegister("7XSrK", function(module, exports) {

$parcel$export(module.exports, "VersionPicker", () => $1304edc5ba920999$export$c7c815960e157d78);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $lfiOu = parcelRequire("lfiOu");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1304edc5ba920999$var$LazyVersionsPicker = (0, $7rh0R.lazy)(()=>(parcelRequire("h5xrh")).then((module)=>module.VersionPicker), {
    moduleId: "./src/packages/releases/version-picker/src/ui/index.tsx"
});
const $1304edc5ba920999$var$LoadingModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1304edc5ba920999$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    })));
const $1304edc5ba920999$export$c7c815960e157d78 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1304edc5ba920999$var$LoadingModal, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1304edc5ba920999$var$LazyVersionsPicker, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1304edc5ba920999$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1lit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h5xrh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aTtOQ").then(()=>parcelRequire('bA5Gf'));

});


parcelRegister("aLYIY", function(module, exports) {

$parcel$export(module.exports, "HoverVisibilityControlWrapper", () => $22c66d2e8de01ba8$export$4d9184008a77c664);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $22c66d2e8de01ba8$export$4d9184008a77c664 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7sRqD", function(module, exports) {

$parcel$export(module.exports, "VersionList", () => $bf4facc8dbba2de9$export$e1d14e02661b0653);

var $iCCdP = parcelRequire("iCCdP");

var $jcu4W = parcelRequire("jcu4W");

var $bAOoi = parcelRequire("bAOoi");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bULPy = parcelRequire("bULPy");
var $5wpwq = parcelRequire("5wpwq");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lg4HD = parcelRequire("lg4HD");

var $2vLQQ = parcelRequire("2vLQQ");

var $cd7EH = parcelRequire("cd7EH");

var $iebBX = parcelRequire("iebBX");
const $bf4facc8dbba2de9$export$e1d14e02661b0653 = ({ jiraVersionEdges: jiraVersionEdges, jiraIssue: jiraIssue, jiraVersion: jiraVersion, onVersionPickerModalOpen: onVersionPickerModalOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const versions = (0, $iWLL0.useFragment)((0, $bAOoi.default), jiraVersionEdges);
    const issue = (0, $iWLL0.useFragment)((0, $jcu4W.default), jiraIssue);
    const version = (0, $iWLL0.useFragment)((0, $iCCdP.default), jiraVersion);
    const originalJiraVersion = version.id;
    const allVersions = versions.filter(Boolean).filter((object)=>object.node.versionId !== version.versionId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
        maxWidth: 221
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lg4HD.IssueWarning), {
        jiraIssue: issue,
        jiraVersion: version
    }), !!version.canAddAndRemoveIssues && allVersions.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, formatMessage((0, $2vLQQ.default).versionsListHeader)), allVersions.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cd7EH.MoveIssueToOtherVersion), {
            originalJiraVersion: originalJiraVersion,
            jiraVersion: edge.node,
            key: edge.node.versionId,
            jiraIssue: issue
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: onVersionPickerModalOpen
    }, formatMessage((0, $2vLQQ.default).otherVersionsButton))) : null, !!version.canAddAndRemoveIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iebBX.RemoveIssueFromVersion), {
        originalJiraVersion: originalJiraVersion,
        jiraIssue: issue
    }));
};

});
parcelRegister("iCCdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2aba522db5aa90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d95a12b061ade2e68cb3366d9b4aafc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db2aba522db5aa90$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$db2aba522db5aa90$var$node.hash = "3401c25196bed99e751ba57506a3021b";
var $db2aba522db5aa90$export$2e2bcd8739ae039 = $db2aba522db5aa90$var$node;

});

parcelRegister("jcu4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2c93c384c8be5b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ad8ccebd103a9c9dc8732c3a9fcce65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c2c93c384c8be5b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$1c2c93c384c8be5b$var$node.hash = "9dbec216043d11ab3ebbdd111e565798";
var $1c2c93c384c8be5b$export$2e2bcd8739ae039 = $1c2c93c384c8be5b$var$node;

});

parcelRegister("bAOoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a0c5148cb99398$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed5cd1b7e4a57c0234a7709c1d5948>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1a0c5148cb99398$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "NONE",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$d1a0c5148cb99398$var$node.hash = "62c56f9fefcd51f7cc6feffc9b24ce64";
var $d1a0c5148cb99398$export$2e2bcd8739ae039 = $d1a0c5148cb99398$var$node;

});

parcelRegister("lg4HD", function(module, exports) {

$parcel$export(module.exports, "IssueWarning", () => $12fdbfa229775659$export$40ff2db377648cee);

var $kw52o = parcelRequire("kw52o");

var $bRljz = parcelRequire("bRljz");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5wpwq = parcelRequire("5wpwq");
var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dSx2v = parcelRequire("dSx2v");

var $7LNP0 = parcelRequire("7LNP0");

var $1LhEZ = parcelRequire("1LhEZ");
const $12fdbfa229775659$export$40ff2db377648cee = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issue = (0, $iWLL0.useFragment)((0, $bRljz.default), jiraIssue);
    const version = (0, $iWLL0.useFragment)((0, $kw52o.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSx2v.IssueWarningProvider), {
        jiraVersion: version,
        jiraIssue: issue
    }, ({ hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
        const warningsMessages = [];
        if (hasOpenPullRequestWarning) warningsMessages.push((0, $7LNP0.default).openPullRequest);
        if (hasFailingBuildsWarning) warningsMessages.push((0, $7LNP0.default).failingBuilds);
        if (hasUnreviewedCodeWarning) warningsMessages.push((0, $7LNP0.default).unreviewedCode);
        if (hasOpenReviewWarning) warningsMessages.push((0, $7LNP0.default).openReviews);
        if (warningsMessages.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, formatMessage((0, $7LNP0.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1LhEZ.WarningDescription), null, formatMessage((0, $7LNP0.default).issueWarning, {
            warning: formatMessage(warningsMessages[0])
        })));
        if (warningsMessages.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, formatMessage((0, $7LNP0.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1LhEZ.WarningDescription), null, formatMessage((0, $7LNP0.default).issueMultipleWarnings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1LhEZ.List), null, warningsMessages.map((warning)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1LhEZ.ListItem), {
                key: warning.id
            }, formatMessage(warning)))));
        return null;
    });
};

});
parcelRegister("kw52o", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb0272ae76455b7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc806f27375ba559d72104dd3b1e5529>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $acb0272ae76455b7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$acb0272ae76455b7$var$node.hash = "4337c06001af5c62a61021cb3fd03fad";
var $acb0272ae76455b7$export$2e2bcd8739ae039 = $acb0272ae76455b7$var$node;

});

parcelRegister("bRljz", function(module, exports) {

$parcel$export(module.exports, "default", () => $82363afbe2686479$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c8e2786f37ec89f823a315d3db55e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82363afbe2686479$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$82363afbe2686479$var$node.hash = "c07bf95905363410cf22a75dbe9a1754";
var $82363afbe2686479$export$2e2bcd8739ae039 = $82363afbe2686479$var$node;

});

parcelRegister("7LNP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7253467af440bc2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d7253467af440bc2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueWarningHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-header",
        "defaultMessage": "Warning"
    },
    issueWarning: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning",
        "defaultMessage": "This issue has {warning}"
    },
    issueMultipleWarnings: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings",
        "defaultMessage": "This issue is done but has:"
    },
    openPullRequest: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-pull-request",
        "defaultMessage": "open pull requests"
    },
    failingBuilds: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.failing-builds",
        "defaultMessage": "failing builds"
    },
    unreviewedCode: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.unreviewed-code",
        "defaultMessage": "unreviewed code"
    },
    openReviews: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-reviews",
        "defaultMessage": "open reviews"
    }
});

});

parcelRegister("1LhEZ", function(module, exports) {

$parcel$export(module.exports, "WarningDescription", () => $ce2f385538072a2a$export$cd80c42dadb896ae);
$parcel$export(module.exports, "List", () => $ce2f385538072a2a$export$54c2e3dc7acea9f5);
$parcel$export(module.exports, "ListItem", () => $ce2f385538072a2a$export$a7b06bfba60a8a78);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ce2f385538072a2a$export$cd80c42dadb896ae = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt494j5 _syazhoca",
            __cmplp.className
        ])
    });
});
const $ce2f385538072a2a$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyrgktf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $ce2f385538072a2a$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazhoca",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2vLQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $284cf4fd0827264d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $284cf4fd0827264d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    versionsListHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.versions-list-header",
        "defaultMessage": "Move to"
    },
    otherVersionsButton: {
        "id": "software-releases-move-issues-between-versions.version-list.other-versions-button",
        "defaultMessage": "View all versions"
    }
});

});

parcelRegister("cd7EH", function(module, exports) {

$parcel$export(module.exports, "MoveIssueToOtherVersion", () => $7aae78258a98d87c$export$7bc266f2ce749644);

var $4Xd2l = parcelRequire("4Xd2l");

var $j3tk1 = parcelRequire("j3tk1");

var $fnTlZ = parcelRequire("fnTlZ");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bULPy = parcelRequire("bULPy");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $yyqSx = parcelRequire("yyqSx");

var $ephMr = parcelRequire("ephMr");

var $gprss = parcelRequire("gprss");

var $eNUFl = parcelRequire("eNUFl");

var $eFBE1 = parcelRequire("eFBE1");
const $7aae78258a98d87c$export$7bc266f2ce749644 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issue = (0, $iWLL0.useFragment)((0, $fnTlZ.default), jiraIssue);
    const version = (0, $iWLL0.useFragment)((0, $j3tk1.default), jiraVersion);
    const [moveIssuesToFixVersion] = (0, $iWLL0.useMutation)((0, $4Xd2l.default));
    const { filters: filters, sortBy: sortBy } = (0, $ephMr.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $gprss.useMoveIssuesBetweenVersionsExperienceStart)();
    const experienceFail = (0, $gprss.useMoveIssuesBetweenVersionsExperienceFail)();
    const experienceSuccess = (0, $gprss.useMoveIssuesBetweenVersionsExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $eNUFl.default).errorFlagDescription, {
                issueKey: issue.key,
                versionName: version.name
            })
        });
        experienceFail('graphql error', err);
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'fusion-solaris'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $eFBE1.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $eNUFl.default).errorFlagTitle),
            description: error
        });
        experienceFail('graphql error', new Error(error));
        (0, $guiFP.default)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'fusion-solaris'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        moveIssuesToFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    originalVersionId: originalJiraVersion,
                    targetVersionId: version.id
                },
                isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.moveIssuesToFixVersion?.success !== true) onErrorWithPermissionValidationEnabled(issue.key, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingResolvePermission, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingEditPermission);
                else {
                    const flagText = formatMessage((0, $eNUFl.default).successFlagDescription, {
                        issueKey: issue.key,
                        versionName: version.name
                    });
                    showFlag({
                        type: 'success',
                        title: flagText
                    });
                    experienceSuccess();
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moveIssueToVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, version.name);
};

});
parcelRegister("4Xd2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $5432ebed597ffe73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d49a047320475040ddcd95c0825a442>>
 * @relayHash 0588bcb7e98e2dfaa1fc6898a137fb8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1308b713ba85518b29c08c67aeca171f721c48a58cfef76b361daf002e182c81
const $5432ebed597ffe73$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "success"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v9 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v8 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v14 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v19 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "description"
    }, v25 = [
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "count"
    }, v27 = {
        "kind": "ScalarField",
        "name": "state"
    }, v28 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v27 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v29 = [
        v26 /*: any*/ 
    ], v30 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "title"
    }, v32 = [
        v26 /*: any*/ ,
        v12 /*: any*/ 
    ], v33 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v34 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v35 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v38 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v39 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v13 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "doneIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "DONE"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                        },
                                        {
                                            "alias": "inProgressIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "IN_PROGRESS"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                        },
                                        {
                                            "alias": "todoIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "TODO"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningsCount"
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v25 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v24 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": v29 /*: any*/ 
                                                                                        },
                                                                                        v30 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v29 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v29 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                v31 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v33 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": v15 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v25 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        {
                                            "args": v36 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v24 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v36 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v38 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasReleaseNote"
                                                },
                                                {
                                                    "concreteType": "JiraVersionContributorConnection",
                                                    "kind": "LinkedField",
                                                    "name": "contributors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionContributorEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": v36 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v39 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v39 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        }
                                                                    ]
                                                                },
                                                                v34 /*: any*/ 
                                                            ]
                                                        },
                                                        v35 /*: any*/ 
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v36 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                },
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1308b713ba85518b29c08c67aeca171f721c48a58cfef76b361daf002e182c81",
            "metadata": {},
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5432ebed597ffe73$var$node.hash = "678bdd4ff02d7ba9790ffbbad0483994";
var $5432ebed597ffe73$export$2e2bcd8739ae039 = $5432ebed597ffe73$var$node;

});

parcelRegister("j3tk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef9a6e210f98c13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fca745311578f3101b6fa0e65717a6fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ef9a6e210f98c13$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        }
    ],
    "type": "JiraVersion"
};
$8ef9a6e210f98c13$var$node.hash = "84a88afd5bdd1daa65b86ea3c2e3ac4e";
var $8ef9a6e210f98c13$export$2e2bcd8739ae039 = $8ef9a6e210f98c13$var$node;

});

parcelRegister("fnTlZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b4f026b5ea92d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0944c4d992234c1aa8d6cf7cf7334012>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f29b4f026b5ea92d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$f29b4f026b5ea92d$var$node.hash = "970de75536631065f879841e95abf41b";
var $f29b4f026b5ea92d$export$2e2bcd8739ae039 = $f29b4f026b5ea92d$var$node;

});

parcelRegister("gprss", function(module, exports) {

$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceStart", () => $4df4f30f70610dd0$export$b93744d3b3f8b975);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceFail", () => $4df4f30f70610dd0$export$476b47bb3c16d45a);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceSuccess", () => $4df4f30f70610dd0$export$a7bd95f0cc752718);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $4df4f30f70610dd0$export$52919046b94109dc = 'moveIssueBetweenVersions';
const $4df4f30f70610dd0$var$ANALYTICS_SOURCE = 'versionDetails';
const $4df4f30f70610dd0$export$b93744d3b3f8b975 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $4df4f30f70610dd0$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $4df4f30f70610dd0$var$ANALYTICS_SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $4df4f30f70610dd0$export$476b47bb3c16d45a = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $4df4f30f70610dd0$export$52919046b94109dc
    });
const $4df4f30f70610dd0$export$a7bd95f0cc752718 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $4df4f30f70610dd0$export$52919046b94109dc
    });

});

parcelRegister("eNUFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f31591cafce7adb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f31591cafce7adb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title",
        "defaultMessage": "Can't move this issue to another version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-description",
        "defaultMessage": "We couldn't move {issueKey} to {versionName}. Please try again."
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.success-flag-description",
        "defaultMessage": "{issueKey} has been moved to {versionName}."
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't move it to another version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't move it to another version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't move it to another version."
    }
});

});

parcelRegister("eFBE1", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $9b674df5cbaef3d2$export$82f46aa4e6535a45);

var $eNUFl = parcelRequire("eNUFl");
const $9b674df5cbaef3d2$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $eNUFl.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $eNUFl.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $eNUFl.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $eNUFl.default).errorFlagDescription);
};

});


parcelRegister("iebBX", function(module, exports) {

$parcel$export(module.exports, "RemoveIssueFromVersion", () => $3cd73875afa80c98$export$d34fb821a58a3d5c);

var $1Ef5y = parcelRequire("1Ef5y");

var $7nIce = parcelRequire("7nIce");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bULPy = parcelRequire("bULPy");
var $8BKky = parcelRequire("8BKky");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $yyqSx = parcelRequire("yyqSx");

var $ephMr = parcelRequire("ephMr");

var $1p3Ma = parcelRequire("1p3Ma");

var $3gRyB = parcelRequire("3gRyB");

var $ifRls = parcelRequire("ifRls");
const $3cd73875afa80c98$export$d34fb821a58a3d5c = ({ jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issue = (0, $iWLL0.useFragment)((0, $7nIce.default), jiraIssue);
    const [removeIssuesFromFixVersion] = (0, $iWLL0.useMutation)((0, $1Ef5y.default));
    const { filters: filters, sortBy: sortBy } = (0, $ephMr.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $1p3Ma.useRemoveIssueFromVersionExperienceStart)();
    const experienceFail = (0, $1p3Ma.useRemoveIssueFromVersionExperienceFail)();
    const experienceSuccess = (0, $1p3Ma.useRemoveIssueFromVersionExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $3gRyB.default).errorFlagDescription, {
                issueKey: issue.key
            })
        });
        experienceFail('graphql error', err);
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'fusion-solaris'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $ifRls.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $3gRyB.default).errorFlagTitle),
            description: error
        });
        experienceFail('graphql error', new Error(error));
        (0, $guiFP.default)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'fusion-solaris'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        removeIssuesFromFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    versionId: originalJiraVersion
                },
                isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.removeIssuesFromFixVersion?.success !== true) {
                    const issuesWithMissingResolvePermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingResolvePermission || [];
                    const issuesWithMissingEditPermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingEditPermission || [];
                    onErrorWithPermissionValidationEnabled(issue.key, issuesWithMissingResolvePermission, issuesWithMissingEditPermission);
                } else {
                    const flagText = formatMessage((0, $3gRyB.default).successFlagDescription, {
                        issueKey: issue.key
                    });
                    experienceSuccess();
                    showFlag({
                        type: 'success',
                        title: flagText
                    });
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'removeIssueFromVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, formatMessage((0, $3gRyB.default).removeButtonTitle)));
};

});
parcelRegister("1Ef5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb5b24244040984$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7255bb8321cad0997d42cf92152561c>>
 * @relayHash 84d235ee614dd35e15ad693adb59d3e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7435366e6ee246909ca7eddf24269b2ee6121f646fa75653b9529b8f55f22b71
const $deb5b24244040984$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "success"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v9 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v8 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v14 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v19 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "description"
    }, v25 = [
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "count"
    }, v27 = {
        "kind": "ScalarField",
        "name": "state"
    }, v28 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v27 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v29 = [
        v26 /*: any*/ 
    ], v30 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "title"
    }, v32 = [
        v26 /*: any*/ ,
        v12 /*: any*/ 
    ], v33 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v34 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v35 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v38 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v39 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v13 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "doneIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "DONE"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                        },
                                        {
                                            "alias": "inProgressIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "IN_PROGRESS"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                        },
                                        {
                                            "alias": "todoIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "TODO"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v15 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningsCount"
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v25 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v24 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": v29 /*: any*/ 
                                                                                        },
                                                                                        v30 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v29 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v29 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                v31 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v33 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": v15 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v25 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        {
                                            "args": v36 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v24 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v36 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v38 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasReleaseNote"
                                                },
                                                {
                                                    "concreteType": "JiraVersionContributorConnection",
                                                    "kind": "LinkedField",
                                                    "name": "contributors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionContributorEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": v36 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v39 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v39 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        }
                                                                    ]
                                                                },
                                                                v34 /*: any*/ 
                                                            ]
                                                        },
                                                        v35 /*: any*/ 
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v36 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                },
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7435366e6ee246909ca7eddf24269b2ee6121f646fa75653b9529b8f55f22b71",
            "metadata": {},
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$deb5b24244040984$var$node.hash = "7a6b944f00d21566398340aaa81314c4";
var $deb5b24244040984$export$2e2bcd8739ae039 = $deb5b24244040984$var$node;

});

parcelRegister("7nIce", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae634be1f0d1e76$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30ef410b078961ea01bc83dfef2d6e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ae634be1f0d1e76$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$8ae634be1f0d1e76$var$node.hash = "bf7da4aac2b6cd1fbe625288d4086691";
var $8ae634be1f0d1e76$export$2e2bcd8739ae039 = $8ae634be1f0d1e76$var$node;

});

parcelRegister("1p3Ma", function(module, exports) {

$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceStart", () => $8577236e69d16a13$export$7d327eeb0dc00eee);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceFail", () => $8577236e69d16a13$export$5da0a49410009ec1);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceSuccess", () => $8577236e69d16a13$export$234c5c3c1b869f23);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $8577236e69d16a13$export$52919046b94109dc = 'removeIssueFromVersion';
const $8577236e69d16a13$var$ANALYTICS_SOURCE = 'versionDetails';
const $8577236e69d16a13$export$7d327eeb0dc00eee = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $8577236e69d16a13$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $8577236e69d16a13$var$ANALYTICS_SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $8577236e69d16a13$export$5da0a49410009ec1 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $8577236e69d16a13$export$52919046b94109dc
    });
const $8577236e69d16a13$export$234c5c3c1b869f23 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $8577236e69d16a13$export$52919046b94109dc
    });

});

parcelRegister("3gRyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a6425a27913a227$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a6425a27913a227$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title",
        "defaultMessage": "Can't remove this issue from version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-description",
        "defaultMessage": "We couldn't remove {issueKey} from this version. Please try again"
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.success-flag-description",
        "defaultMessage": "{issueKey} has been removed from this version."
    },
    removeButtonTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.remove-button-title",
        "defaultMessage": "Remove from version"
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't remove it from the version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't remove it from the version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't remove it from the version."
    }
});

});

parcelRegister("ifRls", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $5c55d33df428fd65$export$82f46aa4e6535a45);

var $3gRyB = parcelRequire("3gRyB");
const $5c55d33df428fd65$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $3gRyB.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $3gRyB.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $3gRyB.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $3gRyB.default).errorFlagDescription);
};

});




parcelRegister("4vHNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb98a16e54a02f9e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb98a16e54a02f9e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreVersions: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions",
        "defaultMessage": "More"
    }
});

});


parcelRegister("lt7ZU", function(module, exports) {

$parcel$export(module.exports, "Priority", () => $a5b9ef0b5a1c64dd$export$300334f671c43555);

var $cPRqd = parcelRequire("cPRqd");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $bEi3B = parcelRequire("bEi3B");
const $a5b9ef0b5a1c64dd$export$300334f671c43555 = ({ jiraPriorityField: jiraPriorityField })=>{
    const [isPriorityIconBroken, setIsPriorityIconBroken] = (0, $eUqFw.useState)(false);
    const { priority: priority } = (0, $iWLL0.useFragment)((0, $cPRqd.default), jiraPriorityField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5b9ef0b5a1c64dd$var$PriorityContainer, null, priority && (isPriorityIconBroken ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEi3B))), {
        size: "small",
        label: priority.name || ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5b9ef0b5a1c64dd$var$Icon, {
        src: priority.iconUrl,
        alt: priority.name ?? undefined,
        title: priority.name ?? undefined,
        onError: ()=>{
            setIsPriorityIconBroken(true);
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5b9ef0b5a1c64dd$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _18s8m31d _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5b9ef0b5a1c64dd$var$PriorityContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _1ul97vkz _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cPRqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e8ac49e476580b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e91e20f3fb1d0c82c7279249a4ac22bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e8ac49e476580b8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    "action": "NONE",
                    "path": "priority.iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$6e8ac49e476580b8$var$node.hash = "ab255857fbd72fa53e70fe6a619699a6";
var $6e8ac49e476580b8$export$2e2bcd8739ae039 = $6e8ac49e476580b8$var$node;

});

parcelRegister("bEi3B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b16fe626dca7d3$var$_react = $87b16fe626dca7d3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $87b16fe626dca7d3$var$_questionCircle = $87b16fe626dca7d3$var$_interopRequireDefault((parcelRequire("8MkOl")));
function $87b16fe626dca7d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $87b16fe626dca7d3$var$EditorHelpIcon = (props)=>/*#__PURE__*/ $87b16fe626dca7d3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10h2.5c0-2 1.5-2 1.5-2 1.5 0 2.5 1.5.5 3-1.5 1-1.5 1.5-1.5 3 0 .144-.016.824 0 1h2c0-1.568 0-2 1.5-3 1.446-.964 1.5-1.896 1.5-3 0-2-1.5-3-4-3-2 0-4 1-4 4m5 8v-2h-2v2z"/></svg>`
    }, props, {
        newIcon: $87b16fe626dca7d3$var$_questionCircle.default
    }));
$87b16fe626dca7d3$var$EditorHelpIcon.displayName = 'EditorHelpIcon';
var $87b16fe626dca7d3$var$_default = module.exports.default = $87b16fe626dca7d3$var$EditorHelpIcon;

});


parcelRegister("2RNeg", function(module, exports) {

$parcel$export(module.exports, "Status", () => $d78571207eec895a$export$96e9906d6d93a972);

var $gnUBt = parcelRequire("gnUBt");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");
const $d78571207eec895a$export$96e9906d6d93a972 = ({ jiraStatusField: jiraStatusField })=>{
    const { status: status } = (0, $iWLL0.useFragment)((0, $gnUBt.default), jiraStatusField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d78571207eec895a$var$StatusName, null, status.name), status.description != null && status.description.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d78571207eec895a$var$StatusDescription, null, status.description))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        name: status.name,
        category: (0, $8Qd0L.statusCategoryForId)(status.statusCategory.statusCategoryId)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d78571207eec895a$var$StatusName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p8n31",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d78571207eec895a$var$StatusDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gnUBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $684cc6a5c499d4c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95f1026434793df353f849ec59749a29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $684cc6a5c499d4c9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "status_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "status.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                    },
                                    "action": "THROW",
                                    "path": "status.statusCategory.statusCategoryId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "status.statusCategory"
                    }
                ]
            },
            "action": "THROW",
            "path": "status"
        }
    ],
    "type": "JiraStatusField"
};
$684cc6a5c499d4c9$var$node.hash = "5e65ebd3a202999e9094506fd6a31982";
var $684cc6a5c499d4c9$export$2e2bcd8739ae039 = $684cc6a5c499d4c9$var$node;

});

parcelRegister("3ySoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ca0a8de67cc8ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
class $84ca0a8de67cc8ac$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});


parcelRegister("a87ww", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $c18135b68d73091d$export$46453a0401d6cd1a);

var $caixt = parcelRequire("caixt");

var $7HuQu = parcelRequire("7HuQu");

var $i2QYp = parcelRequire("i2QYp");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $fUXJc = parcelRequire("fUXJc");
const $c18135b68d73091d$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c18135b68d73091d$var$IssueSummary, {
        ...props,
        ref: ref
    }));
const $c18135b68d73091d$export$46453a0401d6cd1a = ({ jiraIssue: jiraIssue, jiraIssueSummaryField: jiraIssueSummaryField, jiraIssueTypeField: jiraIssueTypeField })=>{
    const { key: key } = (0, $iWLL0.useFragment)((0, $i2QYp.default), jiraIssue);
    const { text: summary } = (0, $iWLL0.useFragment)((0, $7HuQu.default), jiraIssueSummaryField);
    const { issueType: issueType } = (0, $iWLL0.useFragment)((0, $caixt.default), jiraIssueTypeField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c18135b68d73091d$var$SummaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c18135b68d73091d$var$Icon, {
        src: issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($fUXJc))),
        alt: issueType.name,
        title: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c18135b68d73091d$var$IssueKey, null, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: summary,
        tag: $c18135b68d73091d$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c18135b68d73091d$var$IssueSummary, null, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c18135b68d73091d$var$SummaryContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1ul9uuw1 _4cvr1h6o _8mocu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c18135b68d73091d$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _18s8m31d _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c18135b68d73091d$var$IssueSummary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c18135b68d73091d$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _syaz1wmz _u5f3pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("caixt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6046dd862bfc4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<269b69055861a60c9b538a02f44d6bfb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f6046dd862bfc4a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "issueType.name"
                    },
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                },
                                "action": "LOG",
                                "path": "issueType.avatar.xsmall"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issueType"
        }
    ],
    "type": "JiraIssueTypeField"
};
$6f6046dd862bfc4a$var$node.hash = "9c2af22d7b07779fb498e0197b0b8a31";
var $6f6046dd862bfc4a$export$2e2bcd8739ae039 = $6f6046dd862bfc4a$var$node;

});

parcelRegister("7HuQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b595735ca5b7b98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9997bef9f319cb4f9014d445188f50b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b595735ca5b7b98$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "text"
            },
            "action": "THROW",
            "path": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$8b595735ca5b7b98$var$node.hash = "ecdba23eb4bd24552ee157f9d7e6c2dc";
var $8b595735ca5b7b98$export$2e2bcd8739ae039 = $8b595735ca5b7b98$var$node;

});

parcelRegister("i2QYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae3617710d8f1de7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f3bafcb10f68f21b62cadc5fae27824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae3617710d8f1de7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$ae3617710d8f1de7$var$node.hash = "be0a5b93419942c75fd2d852a9d5c8fc";
var $ae3617710d8f1de7$export$2e2bcd8739ae039 = $ae3617710d8f1de7$var$node;

});

parcelRegister("fUXJc", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});




parcelRegister("21rsX", function(module, exports) {

$parcel$export(module.exports, "IssueListSkeleton", () => $876450cf3ab6599c$export$ebd1a9517b9c28aa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $876450cf3ab6599c$var$IssueRowSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueRowSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueTypeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueSummarySkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueAssigneeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueDevDataSkeleton, null));
const $876450cf3ab6599c$export$ebd1a9517b9c28aa = ({ rowCount: rowCount, marginTop: marginTop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$Wrapper, {
        marginTop: marginTop
    }, [
        ...Array(rowCount < 0 ? 10 : rowCount).keys()
    ].map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($876450cf3ab6599c$var$IssueRowSkeleton, {
            key: index
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $876450cf3ab6599c$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fj4wta": (0, $9t7rW.default)(__cmplp.marginTop, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.marginTop ? "_19pkmye1" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $876450cf3ab6599c$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueRowSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _19bvpxbi _u5f3oahv _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueTypeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $876450cf3ab6599c$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _4t3i7vkz _1bsb7vkz _2hwxftgi",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueFieldSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $876450cf3ab6599c$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwx7vkz",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueDevDataSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $876450cf3ab6599c$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwxzwfg",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueSummarySkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $876450cf3ab6599c$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _4t3i7vkz _2hwx16xz _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $876450cf3ab6599c$var$IssueAssigneeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $876450cf3ab6599c$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1tcg _4t3i1tcg _1bsb1tcg _2hwxvbgk",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cFeOt", function(module, exports) {

$parcel$export(module.exports, "IssuesMoreButton", () => $987488427a56b345$export$ef8795476184c09b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $dA2HD = parcelRequire("dA2HD");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $987488427a56b345$var$MoreButtonLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("1jnZg")).then((mod)=>mod.IssuesMoreButton), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues-more-button/index.tsx"
});
const $987488427a56b345$export$ef8795476184c09b = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.more.button",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "fusion-solaris"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-releases-version-detail-issue-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: formatMessage((0, $dA2HD.default).moreButtonLabel)
            })
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($987488427a56b345$var$MoreButtonLazy, props)));
};

});
parcelRegister("dA2HD", function(module, exports) {

$parcel$export(module.exports, "default", () => $383a1198b3bab406$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $383a1198b3bab406$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueNavigatorLink: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link",
        "defaultMessage": "View in Issue Navigator"
    },
    moreButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-button-label",
        "defaultMessage": "More"
    },
    displayInformation: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.display-information",
        "defaultMessage": "Display information"
    },
    assigneeColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.assignee-column-label",
        "defaultMessage": "Assignee"
    },
    priorityColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.priority-column-label",
        "defaultMessage": "Priority"
    },
    issueStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label",
        "defaultMessage": "Issue status"
    },
    developmentStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.development-status-column-label",
        "defaultMessage": "Development status"
    },
    buildStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.build-status-column-label",
        "defaultMessage": "Build status"
    },
    deliveryStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.delivery-status-column-label",
        "defaultMessage": "Delivery status"
    },
    featureFlagStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.feature-flag-status-column-label",
        "defaultMessage": "Feature flag status"
    },
    errorFlagDescription: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.error-flag-description",
        "defaultMessage": "We couldn't save your preference. Please try again."
    },
    moreActionColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-action-column-label",
        "defaultMessage": "More actions"
    },
    manageWarningsButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.manage-warnings-button-label",
        "defaultMessage": "Manage warnings"
    }
});

});

parcelRegister("1jnZg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2wLt9").then(()=>parcelRequire('eApMy'));

});


parcelRegister("9zLeS", function(module, exports) {

$parcel$export(module.exports, "ListOptions", () => $bd7bc32eaec44371$export$c50fde0141a9ce82);

var $2l2hG = parcelRequire("2l2hG");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $ifZZG = parcelRequire("ifZZG");

var $bvoF2 = parcelRequire("bvoF2");
const $bd7bc32eaec44371$export$c50fde0141a9ce82 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $2l2hG.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd7bc32eaec44371$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifZZG.FiltersAsync), {
        jiraVersion: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd7bc32eaec44371$var$SortingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvoF2.AsyncSortIssues), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd7bc32eaec44371$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1ylp _1ul9idpf _kqsw1if8 _154iidpf _1pbycs5v _11q7vuon _ca0qv47k _n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $bd7bc32eaec44371$var$SortingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2l2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6019fb0bdca3de34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ad9d1719b1000d014e3db5d4e26f842>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6019fb0bdca3de34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "listOptions_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync"
        }
    ],
    "type": "JiraVersion"
};
$6019fb0bdca3de34$var$node.hash = "72816e24a790f41b4c2b45bd06ad26f9";
var $6019fb0bdca3de34$export$2e2bcd8739ae039 = $6019fb0bdca3de34$var$node;

});

parcelRegister("ifZZG", function(module, exports) {

$parcel$export(module.exports, "FiltersAsync", () => $3ffa479f2f690d88$export$c2ea1db993d10580);

var $9slqP = parcelRequire("9slqP");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $3ffa479f2f690d88$var$FiltersLazy = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gRqW2")).then((mod)=>mod.Filters), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/filters/index.tsx"
});
const $3ffa479f2f690d88$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$FilterBarLoadingWraper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$TextFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$AssigneeFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$DropdownFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$DropdownFilterSkeleton, null));
const $3ffa479f2f690d88$export$c2ea1db993d10580 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $iWLL0.useFragment)((0, $9slqP.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.filters",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "fusion-solaris"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-releases-version-detail-issue-list-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ffa479f2f690d88$var$FiltersLazy, {
        jiraVersion: jiraVersionData
    })));
};
const $3ffa479f2f690d88$var$skeletonKeyFrames = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ffa479f2f690d88$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ffa479f2f690d88$var$FilterBarLoadingWraper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _1bsb1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ffa479f2f690d88$var$TextFilterSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3ffa479f2f690d88$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1y44 _1bsb68cl _4t3i1ylp _2hwx7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ffa479f2f690d88$var$AssigneeFilterSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3ffa479f2f690d88$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko7vkz _4t3izwfg _1bsbzwfg _2hwx7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ffa479f2f690d88$var$DropdownFilterSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3ffa479f2f690d88$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko7vkz _4t3igktf _1bsbvbgk _2hwx7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9slqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8969c5cf6d6d68c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42b58b01a1994dfcf0a3ac5a5b822aa3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f8969c5cf6d6d68c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "filters_softwareReleasesVersionDetailIssueList"
        }
    ],
    "type": "JiraVersion"
};
$f8969c5cf6d6d68c$var$node.hash = "80684c6429225cfc5da72844f8d61f76";
var $f8969c5cf6d6d68c$export$2e2bcd8739ae039 = $f8969c5cf6d6d68c$var$node;

});

parcelRegister("gRqW2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("4NtHW")
]).then(()=>parcelRequire('hdiMy'));

});


parcelRegister("bvoF2", function(module, exports) {

$parcel$export(module.exports, "AsyncSortIssues", () => $8813be10ce29dbd1$export$e985a1e694548d49);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $43ZCh = parcelRequire("43ZCh");

var $7Maix = parcelRequire("7Maix");

var $6rOg7 = parcelRequire("6rOg7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8813be10ce29dbd1$var$LazySortIssues = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("43ZCh"))).then((module)=>module.SortIssuesDropdown), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/sorting/sorting-dropdown/index.tsx"
});
const $8813be10ce29dbd1$export$e985a1e694548d49 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $6rOg7.useCurrentSortOptions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-detail-sort-issues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43ZCh.StyledButton), {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43ZCh.SortOrderIcon), {
                order: currentSortOrderOption.id
            })
        }, `${formatMessage((0, $7Maix.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8813be10ce29dbd1$var$LazySortIssues, null));
};

});
parcelRegister("43ZCh", function(module, exports) {

$parcel$export(module.exports, "SortIssuesDropdown", () => $99f06dd8929c5738$export$2c14c390745c589);
$parcel$export(module.exports, "StyledButton", () => $99f06dd8929c5738$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "SortOrderIcon", () => $99f06dd8929c5738$export$80ba57d0e34e16ec);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7opLA = parcelRequire("7opLA");

var $6OfWd = parcelRequire("6OfWd");
var $lmeyI = parcelRequire("lmeyI");
var $hIuJI = parcelRequire("hIuJI");

var $9SdpV = parcelRequire("9SdpV");

var $hL0Qd = parcelRequire("hL0Qd");

var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9TlRa = parcelRequire("9TlRa");

var $7Maix = parcelRequire("7Maix");

var $6rOg7 = parcelRequire("6rOg7");
const $99f06dd8929c5738$export$2c14c390745c589 = ({ defaultOpen: defaultOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $6rOg7.useCurrentSortOptions)();
    const { setSortByParam: setSortByParam, setSortOrderParam: setSortOrderParam } = (0, $9TlRa.useFilterSortingQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: defaultOpen,
        spacing: "compact",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99f06dd8929c5738$export$2d5d2ba3c7c8c40b, {
                ...providedProps,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99f06dd8929c5738$export$80ba57d0e34e16ec, {
                    order: currentSortOrderOption.id
                }),
                appearance: "subtle"
            }, `${formatMessage((0, $7Maix.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIuJI.default), {
        id: "sortByFields"
    }, (0, $6rOg7.sortByFieldOptions).map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99f06dd8929c5738$export$29d4895f75c15b40, {
            isSelected: field.id === currentSortByOption.id,
            id: field.id,
            key: field.id,
            onClick: ()=>{
                setSortByParam(field.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: field.id,
                    sortOrder: currentSortOrderOption.id
                });
            }
        }, formatMessage(field.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIuJI.default), {
        id: "sortOrderOptions"
    }, (0, $6rOg7.sortOrderOptions).map((order)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99f06dd8929c5738$export$29d4895f75c15b40, {
            isSelected: order.id === currentSortOrderOption.id,
            id: order.id,
            key: order.id,
            onClick: ()=>{
                setSortOrderParam(order.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: currentSortByOption.id,
                    sortOrder: order.id
                });
            }
        }, formatMessage(order.label))))));
};
const $99f06dd8929c5738$export$80ba57d0e34e16ec = ({ order: order })=>{
    switch(order){
        case 'ASC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.ascending",
                size: "small"
            });
        case 'DESC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                size: "small"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                size: "small"
            });
    }
}; // This component is defined here deliberately to avoid DropdownItemRadio to be included in the Version details bundle.
const $99f06dd8929c5738$export$29d4895f75c15b40 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lmeyI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _1kha1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $99f06dd8929c5738$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_if291txw _1kba1h6o _1i92dlk8 _12r2bfng",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("lmeyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed394ec493e143b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $iP9LU = parcelRequire("iP9LU");

var $brxwV = parcelRequire("brxwV");

var $h1Q9j = parcelRequire("h1Q9j");

var $efWFe = parcelRequire("efWFe");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $ed394ec493e143b5$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $brxwV.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iP9LU.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $efWFe.default)() ? 'radio' : 'menuitemradio',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, this attribute are passed to ButtonItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        title: title,
        ...rest
    }, children));
};
var $ed394ec493e143b5$export$2e2bcd8739ae039 = $ed394ec493e143b5$var$DropdownItemRadio;

});
parcelRegister("iP9LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d086ff5ea2ed155$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $5d086ff5ea2ed155$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    })));
};
var $5d086ff5ea2ed155$export$2e2bcd8739ae039 = $5d086ff5ea2ed155$var$RadioIcon;

});

parcelRegister("brxwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac57de6175be933$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hIuJI = parcelRequire("hIuJI");

var $7mYCs = parcelRequire("7mYCs");

var $89aMM = parcelRequire("89aMM");
function $8ac57de6175be933$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $eUqFw.useContext)((0, $hIuJI.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $eUqFw.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        setGroupState(group, {
            ...(0, $89aMM.default)(existing || {}),
            [id]: defaultSelected || false
        });
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $8ac57de6175be933$export$2e2bcd8739ae039 = $8ac57de6175be933$var$useRadioState;

});
parcelRegister("hIuJI", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $4bf10c112f2f0cf0$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $4bf10c112f2f0cf0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");

var $7mYCs = parcelRequire("7mYCs");

var $89aMM = parcelRequire("89aMM");
const $4bf10c112f2f0cf0$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $5Q9wj.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $4bf10c112f2f0cf0$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $eUqFw.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $89aMM.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4bf10c112f2f0cf0$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children));
};
var $4bf10c112f2f0cf0$export$2e2bcd8739ae039 = $4bf10c112f2f0cf0$var$DropdownItemRadioGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});

parcelRegister("89aMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $669f816b2109040a$export$2e2bcd8739ae039);
const $669f816b2109040a$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $669f816b2109040a$export$2e2bcd8739ae039 = $669f816b2109040a$var$resetOptionsInGroup;

});



parcelRegister("efWFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $040ecfdbbd3bc304$export$2e2bcd8739ae039);
const $040ecfdbbd3bc304$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $040ecfdbbd3bc304$var$isVoiceOverSupported = ()=>/Mac OS X/.test($040ecfdbbd3bc304$var$canUseDOM() ? navigator.userAgent : '');
var $040ecfdbbd3bc304$export$2e2bcd8739ae039 = $040ecfdbbd3bc304$var$isVoiceOverSupported;

});


parcelRegister("9SdpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $730390946cb60768$var$_react = $730390946cb60768$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $730390946cb60768$var$_arrowDown = $730390946cb60768$var$_interopRequireDefault((parcelRequire("l53D0")));
function $730390946cb60768$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $730390946cb60768$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $730390946cb60768$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $730390946cb60768$var$_arrowDown.default
    }));
$730390946cb60768$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $730390946cb60768$var$_default = module.exports.default = $730390946cb60768$var$ArrowDownIcon;

});
parcelRegister("l53D0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf1bf814ca1500813733301d71932a50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f58ce116508c34ca$var$_react = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f58ce116508c34ca$var$_UNSAFE_baseNew = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f58ce116508c34ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f58ce116508c34ca$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f58ce116508c34ca$var$_react.default.createElement($f58ce116508c34ca$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$f58ce116508c34ca$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f58ce116508c34ca$var$_default = module.exports.default = $f58ce116508c34ca$var$ArrowDownIcon;

});


parcelRegister("hL0Qd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ced77a83dab807a4$var$_react = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ced77a83dab807a4$var$_arrowUp = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("8Kx08")));
function $ced77a83dab807a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ced77a83dab807a4$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $ced77a83dab807a4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $ced77a83dab807a4$var$_arrowUp.default
    }));
$ced77a83dab807a4$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $ced77a83dab807a4$var$_default = module.exports.default = $ced77a83dab807a4$var$ArrowUpIcon;

});
parcelRegister("8Kx08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65ec37f1dfc82391$var$_react = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $65ec37f1dfc82391$var$_UNSAFE_baseNew = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $65ec37f1dfc82391$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65ec37f1dfc82391$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $65ec37f1dfc82391$var$_react.default.createElement($65ec37f1dfc82391$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$65ec37f1dfc82391$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $65ec37f1dfc82391$var$_default = module.exports.default = $65ec37f1dfc82391$var$ArrowUpIcon;

});


parcelRegister("7Maix", function(module, exports) {

$parcel$export(module.exports, "default", () => $05575321d3f821ff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $05575321d3f821ff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortByAssignee: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-assignee",
        "defaultMessage": "Assignee"
    },
    sortByDateCreated: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-date-created",
        "defaultMessage": "Date created"
    },
    sortByIssueKey: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key",
        "defaultMessage": "Issue key"
    },
    sortByPriority: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-priority",
        "defaultMessage": "Priority"
    },
    sortByIssueStatusCategory: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-status-category",
        "defaultMessage": "Status category"
    },
    sortByIssueType: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-type",
        "defaultMessage": "Type"
    },
    ascending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.ascending",
        "defaultMessage": "Ascending"
    },
    descending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.descending",
        "defaultMessage": "Descending"
    },
    sortBy: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by",
        "defaultMessage": "Sort by"
    }
});

});

parcelRegister("6rOg7", function(module, exports) {

$parcel$export(module.exports, "sortOrderOptions", () => $7672a950a8bda63c$export$2969b4c3e7255782);
$parcel$export(module.exports, "sortByFieldOptions", () => $7672a950a8bda63c$export$bdbfa34747bc5af);
$parcel$export(module.exports, "useCurrentSortOptions", () => $7672a950a8bda63c$export$43a8856ed2deb26e);


var $9TlRa = parcelRequire("9TlRa");

var $7Maix = parcelRequire("7Maix");
const $7672a950a8bda63c$export$2969b4c3e7255782 = [
    {
        id: 'ASC',
        label: (0, $7Maix.default).ascending
    },
    {
        id: 'DESC',
        label: (0, $7Maix.default).descending
    }
];
const $7672a950a8bda63c$export$bdbfa34747bc5af = [
    {
        id: 'CREATED',
        label: (0, $7Maix.default).sortByDateCreated
    },
    {
        id: 'ASSIGNEE',
        label: (0, $7Maix.default).sortByAssignee
    },
    {
        id: 'KEY',
        label: (0, $7Maix.default).sortByIssueKey
    },
    {
        id: 'PRIORITY',
        label: (0, $7Maix.default).sortByPriority
    },
    {
        id: 'STATUS',
        label: (0, $7Maix.default).sortByIssueStatusCategory
    },
    {
        id: 'TYPE',
        label: (0, $7Maix.default).sortByIssueType
    }
];
const $7672a950a8bda63c$export$43a8856ed2deb26e = ()=>{
    const { parsedQueryParams: parsedQueryParams } = (0, $9TlRa.useFilterSortingQueryParams)();
    const currentSortByOption = $7672a950a8bda63c$export$bdbfa34747bc5af.find((option)=>option.id === parsedQueryParams[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6]) ?? $7672a950a8bda63c$export$bdbfa34747bc5af[0];
    const currentSortOrderOption = $7672a950a8bda63c$export$2969b4c3e7255782.find((option)=>option.id === parsedQueryParams[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb]) ?? $7672a950a8bda63c$export$2969b4c3e7255782[0];
    return {
        currentSortByOption: currentSortByOption,
        currentSortOrderOption: currentSortOrderOption
    };
};

});




parcelRegister("k5eBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $080b3ca1af398cb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $080b3ca1af398cb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "software-releases-version-detail-issue-list.issues",
        "defaultMessage": "Issues"
    },
    addIssueIconLabel: {
        "id": "software-releases-version-detail-issue-list.add-issue-icon-label",
        "defaultMessage": "Add issues"
    }
});

});

parcelRegister("cEndX", function(module, exports) {

$parcel$export(module.exports, "IssueListScreenAnalytics", () => $cf71097fa6e6f20a$export$44cca2bcabf50abc);

var $Mtiqq = parcelRequire("Mtiqq");

var $7c8nD = parcelRequire("7c8nD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $d6f6c = parcelRequire("d6f6c");

var $dSx2v = parcelRequire("dSx2v");
const $cf71097fa6e6f20a$export$44cca2bcabf50abc = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersionReference: jiraVersionReference })=>{
    const jiraIssueEdgeReferenceData = (0, $iWLL0.useFragment)((0, $7c8nD.default), jiraIssueEdgesReference);
    const warningConfigFragment = (0, $iWLL0.useFragment)((0, $Mtiqq.default), jiraVersionReference);
    const nodes = jiraIssueEdgeReferenceData.map((edge)=>edge.node).filter(Boolean);
    // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>(0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0 : node.devOpsSummarisedEntities?.summarisedDeployments?.count != null && node.devOpsSummarisedEntities?.summarisedDeployments?.count > 0);
    const hasFeatureFlags = nodes.some((node)=>(0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? (node.summarisedFeatureFlags?.totalCount ?? 0) > 0 : (node.devOpsSummarisedEntities?.summarisedFeatureFlags?.totalCount ?? 0) > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>(0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.summarisedBuilds?.count) > 0 : Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.devOpsSummarisedEntities?.summarisedBuilds?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSx2v.IssuesWarningCountProvider), {
        jiraVersion: warningConfigFragment,
        issueEdges: jiraIssueEdgeReferenceData
    }, (warningCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                hasBamboo: hasBambooDeployment,
                hasBranches: hasBranches,
                hasBuilds: hasBuilds,
                hasCommits: hasCommits,
                hasDeployments: hasDeployments,
                hasFeatureFlags: hasFeatureFlags,
                hasPullRequests: hasPullRequests,
                hasReviews: hasReviews,
                warningCount: warningCount
            }
        }));
};

});
parcelRegister("Mtiqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91cd04aa5b250e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e7b3053e164d5901e6af58b7a501d5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f91cd04aa5b250e6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$f91cd04aa5b250e6$var$node.hash = "2dad59bd036f7e19ca923546c2912289";
var $f91cd04aa5b250e6$export$2e2bcd8739ae039 = $f91cd04aa5b250e6$var$node;

});

parcelRegister("7c8nD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc41cddd144647a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e9ae36f2c1ce1fca92e6e24bfbb87eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc41cddd144647a2$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ], v1 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v0 /*: any*/ 
    }, v2 = {
        "concreteType": "DevOpsSummarisedFeatureFlags",
        "kind": "LinkedField",
        "name": "summarisedFeatureFlags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ]
    }, v3 = {
        "concreteType": "DevOpsSummarisedBuilds",
        "kind": "LinkedField",
        "name": "summarisedBuilds",
        "plural": false,
        "selections": v0 /*: any*/ 
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDevSummary",
                                        "kind": "LinkedField",
                                        "name": "devSummary",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironments",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                                "kind": "LinkedField",
                                                                "name": "topEnvironments",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v2 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$bc41cddd144647a2$var$node.hash = "ea60645c920c025333573ec5ba26fd4d";
var $bc41cddd144647a2$export$2e2bcd8739ae039 = $bc41cddd144647a2$var$node;

});


parcelRegister("jMfaQ", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $4edf34eb51dd027a$export$a7395f9832c00176);

var $eUqFw = parcelRequire("eUqFw");
const $4edf34eb51dd027a$export$a7395f9832c00176 = ({ margin: margin, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting })=>{
                if (isIntersecting) onIntersection();
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: 0
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin
    ]);
    return setObservedElement;
};

});


parcelRegister("hG7ij", function(module, exports) {

$parcel$export(module.exports, "VersionRelatedWorkExperienceStart", () => $6b2d3411c5e4d7d5$export$e99e651b72ab598a);
$parcel$export(module.exports, "useViewVersionRelatedWorkExperienceFail", () => $6b2d3411c5e4d7d5$export$ffb9ab4bec7b2f3c);
$parcel$export(module.exports, "VersionRelatedWorkExperienceSuccessTracker", () => $6b2d3411c5e4d7d5$export$4e4779a3c4cff596);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $6b2d3411c5e4d7d5$var$VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';
const $6b2d3411c5e4d7d5$export$e99e651b72ab598a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $6b2d3411c5e4d7d5$var$VERSION_RELATED_WORK_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $6b2d3411c5e4d7d5$export$ffb9ab4bec7b2f3c = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $6b2d3411c5e4d7d5$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });
const $6b2d3411c5e4d7d5$export$4e4779a3c4cff596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $6b2d3411c5e4d7d5$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });

});

parcelRegister("9hVW3", function(module, exports) {

$parcel$export(module.exports, "RelatedWork", () => $394208c2994d6f25$export$3200bfb79e9adbfb);

var $fNwed = parcelRequire("fNwed");

var $dIEey = parcelRequire("dIEey");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $gO9Xw = parcelRequire("gO9Xw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $4M8lK = parcelRequire("4M8lK");

var $8bNZT = parcelRequire("8bNZT");

var $5Knhe = parcelRequire("5Knhe");

var $lB25E = parcelRequire("lB25E");

var $jfao4 = parcelRequire("jfao4");

var $8QywJ = parcelRequire("8QywJ");

var $g9Uvo = parcelRequire("g9Uvo");

var $dC8VL = parcelRequire("dC8VL");

var $fpIhA = parcelRequire("fpIhA");

var $dzVsj = parcelRequire("dzVsj");
const $394208c2994d6f25$export$8beb67dd759bbe2 = 5;
const $394208c2994d6f25$export$3200bfb79e9adbfb = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { jira: jira } = (0, $iWLL0.usePreloadedQuery)((0, $dIEey.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $iWLL0.useFragment)((0, $fNwed.default), versionFrag);
    const [selectedCategory, setSelectedCategory] = (0, $lB25E.useQueryParam)('relatedWorkCategory');
    const addRelatedWorkExpFailed = (0, $4M8lK.useAddRelatedWorkExperienceFail)();
    const allRelatedWork = version.relatedWorkV2.edges.filter(Boolean);
    const relatedWorkInCategory = selectedCategory === undefined ? allRelatedWork : allRelatedWork.filter(({ node: node })=>node?.category === selectedCategory);
    const body = allRelatedWork.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC8VL.RelatedWorkEmptyState), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfao4.ErrorBoundary), {
        id: "relatedWorkCategoryFilter",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Uvo.CategoryFilter), {
        relatedWorkEdges: allRelatedWork,
        selectedCategory: selectedCategory,
        onCategorySelected: (category)=>setSelectedCategory(category, 'replace')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dzVsj.RelatedWorkList), {
        jiraVersion: version,
        relatedWorkEdges: relatedWorkInCategory
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$ActionsContainer, null, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfao4.ErrorBoundary), {
        id: "addRelatedPopup",
        fallback: "flag",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bNZT.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork,
        renderTrigger: ({ triggerProps: triggerProps, isLoading: isLoading, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$AddButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$AddButton, {
                ...triggerProps,
                appearance: "subtle-link",
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.add-button',
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$ActionIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                    size: "small",
                    label: ""
                })),
                onClick: onClick,
                onMouseOver: onMouseOver,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$ShowMoreTextContainer, null, formatMessage((0, $fpIhA.default).addRelatedWork))))
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QywJ.default), {
        relatedWorkEdges: allRelatedWork
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleSection), {
        jiraVersion: version,
        uiType: "RELATED_WORK",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $394208c2994d6f25$var$sectionTitleStyles
            }, formatMessage((0, $fpIhA.default).relatedWorkHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$TotalCountLozenge, null, allRelatedWork.length), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$HeaderRightWrapper, null, version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfao4.ErrorBoundary), {
                key: "addRelatedWorkButton",
                id: "addRelatedPopupHeaderPlusButton",
                fallback: "flag",
                onError: (location, error)=>{
                    addRelatedWorkExpFailed(location, error);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bNZT.AddRelatedWorkPopup), {
                jiraVersion: version,
                relatedWorkEdges: allRelatedWork,
                renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($394208c2994d6f25$var$AddIconButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        ...triggerProps,
                        appearance: "subtle",
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                            label: "",
                            size: "small"
                        }),
                        onClick: onClick,
                        onMouseOver: onMouseOver,
                        shouldFitContainer: true,
                        "aria-label": formatMessage((0, $fpIhA.default).addRelatedWork)
                    }))
            })))),
        renderBody: ()=>body
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulppxbi _ca0qu2gc _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$ActionIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$ShowMoreTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1",
            __cmplp.className
        ])
    });
}); // RLSS-2812 color.background.accent.gray.subtlest might be better than color.background.neutral
const $394208c2994d6f25$var$AddButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _2rko14y2 _80omtlke _1yt4wo40 _10j7iw92 _irr3iw92",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$AddButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14741e5h",
            __cmplp.className
        ])
    });
});
const $394208c2994d6f25$var$sectionTitleStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300',
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$AddIconButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbxy5q _4t3ixy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$HeaderRightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $394208c2994d6f25$var$TotalCountLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk4zhb _1wyb1skh _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ipxbi _2rkoftgi _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fNwed", function(module, exports) {

$parcel$export(module.exports, "default", () => $55fad24075682041$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9594b0e9cfedaf2fac09cafe5fbee81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55fad24075682041$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "relatedWorkV2"
                    ]
                }
            ]
        },
        "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "relatedWorkV2",
                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                    "kind": "LinkedField",
                    "name": "__version_relatedWorkV2_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraVersionRelatedWorkV2Edge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "categoryFilter_softwareReleasesVersionRelatedWork"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "category"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "relatedWorkV2.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "relatedWorkV2"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
            }
        ],
        "type": "JiraVersion"
    };
}();
$55fad24075682041$var$node.hash = "ee870a351f61b9ac907790203ed00950";
var $55fad24075682041$export$2e2bcd8739ae039 = $55fad24075682041$var$node;

});

parcelRegister("4M8lK", function(module, exports) {

$parcel$export(module.exports, "useAddRelatedWorkExperienceStart", () => $57835c3125239a9c$export$2a84c09279dbc41e);
$parcel$export(module.exports, "useAddRelatedWorkExperienceFail", () => $57835c3125239a9c$export$b2970d2d64ed7236);
$parcel$export(module.exports, "useAddRelatedWorkExperienceSuccess", () => $57835c3125239a9c$export$f01728e86602e7e0);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $57835c3125239a9c$var$EXPERIENCE_NAME = 'addRelatedWork';
const $57835c3125239a9c$var$ANALYTICS_SOURCE = 'versionDetails';
const $57835c3125239a9c$export$2a84c09279dbc41e = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $57835c3125239a9c$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $57835c3125239a9c$var$ANALYTICS_SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $57835c3125239a9c$export$b2970d2d64ed7236 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $57835c3125239a9c$var$EXPERIENCE_NAME
    });
const $57835c3125239a9c$export$f01728e86602e7e0 = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $57835c3125239a9c$var$EXPERIENCE_NAME
    });

});

parcelRegister("8bNZT", function(module, exports) {

$parcel$export(module.exports, "AddRelatedWorkPopup", () => $bb81b0ae8dc36015$export$7c8948b134dbfa2e);

var $5o9d0 = parcelRequire("5o9d0");

var $3gwa4 = parcelRequire("3gwa4");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bb81b0ae8dc36015$var$LazyAddRelatedWorkPopup = (0, $7rh0R.lazy)(()=>(parcelRequire("54ypw")).then((module)=>module.AddRelatedWorkPopup), {
    moduleId: "./src/packages/releases/add-related-work-to-version/src/ui/add-related-work-popup/index.tsx"
});
const $bb81b0ae8dc36015$export$7c8948b134dbfa2e = ({ jiraVersion: jiraVersion, renderTrigger: renderTrigger, relatedWorkEdges: relatedWorkEdges })=>{
    const version = (0, $iWLL0.useFragment)((0, $3gwa4.default), jiraVersion);
    const edges = (0, $iWLL0.useFragment)((0, $5o9d0.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-related-work-popup",
        fallback: renderTrigger({
            triggerProps: {},
            onClick: ()=>undefined,
            onMouseOver: ()=>undefined,
            isLoading: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb81b0ae8dc36015$var$LazyAddRelatedWorkPopup, {
        jiraVersion: version,
        renderTrigger: renderTrigger,
        relatedWorkEdges: edges
    }));
};

});
parcelRegister("5o9d0", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d9a88461abcdba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1093bcdbe8a0213bfff539dbd23c487>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06d9a88461abcdba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$06d9a88461abcdba$var$node.hash = "a1ee6f3b568b757ef42ae7c9484cb878";
var $06d9a88461abcdba$export$2e2bcd8739ae039 = $06d9a88461abcdba$var$node;

});

parcelRegister("3gwa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c62786b5ab7f69a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ae5b22d33923ae62c0eb9c486b2bf3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c62786b5ab7f69a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$c62786b5ab7f69a9$var$node.hash = "61023dc51339302e0390200141db5335";
var $c62786b5ab7f69a9$export$2e2bcd8739ae039 = $c62786b5ab7f69a9$var$node;

});

parcelRegister("54ypw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8u1SP").then(()=>parcelRequire('cC8eZ'));

});


parcelRegister("jfao4", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $847533cd3a6843c1$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $847533cd3a6843c1$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionRelatedWork",
        teamName: "fusion-solaris"
    });

});

parcelRegister("8QywJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e25fb8a4c75c0930$export$2e2bcd8739ae039);

var $k3UPJ = parcelRequire("k3UPJ");

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $iWLL0 = parcelRequire("iWLL0");

var $8WuJm = parcelRequire("8WuJm");

var $iG5Z7 = parcelRequire("iG5Z7");
const $e25fb8a4c75c0930$var$isFirstPartyLink = (url)=>new URL(url).hostname === window.location.hostname;
const $e25fb8a4c75c0930$var$useAnalyticsAttributes = (relatedWorkItems)=>{
    const numberOfRelatedWorkItems = relatedWorkItems.length;
    const relatedWorkTypes = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(relatedWorkItems, (item)=>item.node?.__typename);
    const hasNativeReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkNativeReleaseNotes?.length > 0;
    const numConfluenceReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkConfluenceReleaseNotes?.length ?? 0;
    const getIssueLinkingAttributes = ()=>{
        const numOfLinkedIssues = relatedWorkItems.filter((item)=>item.node?.issue !== null).length;
        return {
            numOfLinkedIssues: numOfLinkedIssues
        };
    };
    const formatCategoryName = (0, $iG5Z7.useFormatCategoryName)();
    const getPlaceholderStateAttributes = ()=>{
        const genericLinks = relatedWorkTypes.JiraVersionRelatedWorkGenericLink ?? [];
        const numPlaceholderItems = genericLinks.filter((item)=>item.node?.url === null).length;
        const numNonPlaceholderItems = genericLinks.length - numPlaceholderItems;
        const numFirstPartyLinks = genericLinks.filter((item)=>item.node?.url != null && $e25fb8a4c75c0930$var$isFirstPartyLink(item.node.url)).length;
        const numThirdPartyLinks = numNonPlaceholderItems - numFirstPartyLinks;
        const itemsByCategories = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(relatedWorkItems, (item)=>item.node?.category);
        // This is a temporary approach that won't properly recognise categories if the item was created in a different
        // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work
        // items are migrated out of Data Depot and into ERS.
        const countItemsInCategory = (category)=>itemsByCategories[formatCategoryName(category)]?.length ?? 0;
        const defaultCategoryUsageCounts = (0, $iG5Z7.DEFAULT_CATEGORIES).map((category)=>[
                category.analyticsAttributeName,
                countItemsInCategory(category)
            ]);
        const numItemsInDefaultCategories = defaultCategoryUsageCounts.reduce((runningTotal, [, itemsInCategory])=>runningTotal + itemsInCategory, 0);
        const numItemsInOtherCategories = numberOfRelatedWorkItems - numItemsInDefaultCategories;
        const numCategories = Object.keys(itemsByCategories).length;
        return {
            numPlaceholderItems: numPlaceholderItems,
            numNonPlaceholderItems: numNonPlaceholderItems,
            numFirstPartyLinks: numFirstPartyLinks,
            numThirdPartyLinks: numThirdPartyLinks,
            numItemsInOtherCategories: numItemsInOtherCategories,
            numCategories: numCategories,
            ...Object.fromEntries(defaultCategoryUsageCounts)
        };
    };
    return {
        // The `numLinks` name is slightly misleading, but we're keeping it for historical reasons
        numLinks: numberOfRelatedWorkItems,
        hasNativeReleaseNotes: hasNativeReleaseNotes,
        numConfluenceReleaseNotes: numConfluenceReleaseNotes,
        // Note: when you clean up these flags, make the relevant fields in `AnalyticsAttributes`
        // required rather than optional.
        ...getPlaceholderStateAttributes(),
        ...getIssueLinkingAttributes()
    };
};
const $e25fb8a4c75c0930$export$e6de70608562a971 = ({ relatedWorkEdges: relatedWorkEdges, children: children })=>{
    const data = (0, $iWLL0.useFragment)((0, $k3UPJ.default), relatedWorkEdges);
    const attributes = $e25fb8a4c75c0930$var$useAnalyticsAttributes(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionRelatedWork",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
var $e25fb8a4c75c0930$export$2e2bcd8739ae039 = $e25fb8a4c75c0930$export$e6de70608562a971;

});
parcelRegister("k3UPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80b9c884903e334$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b00338198aa2a5443fe90e410f9e4c7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f80b9c884903e334$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ],
                        "type": "JiraVersionRelatedWorkGenericLink"
                    }
                ]
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$f80b9c884903e334$var$node.hash = "aa20d10ea14c3261013e36223676a0c8";
var $f80b9c884903e334$export$2e2bcd8739ae039 = $f80b9c884903e334$var$node;

});

parcelRegister("iG5Z7", function(module, exports) {

$parcel$export(module.exports, "CommunicationCategory", () => $2c8cbe3d23057cf3$export$4c00bbfcc0ecf975);
$parcel$export(module.exports, "RolloutCategory", () => $2c8cbe3d23057cf3$export$f4e280770913e10f);
$parcel$export(module.exports, "TestingCategory", () => $2c8cbe3d23057cf3$export$a6d4661a542d168f);
$parcel$export(module.exports, "AnalyticsCategory", () => $2c8cbe3d23057cf3$export$257af46c9923adf8);
$parcel$export(module.exports, "DevelopmentCategory", () => $2c8cbe3d23057cf3$export$d3d779bdc5757c39);
$parcel$export(module.exports, "SupportCategory", () => $2c8cbe3d23057cf3$export$1909a2cc48b27b53);
$parcel$export(module.exports, "DEFAULT_CATEGORIES", () => $2c8cbe3d23057cf3$export$b101d8f25cc16679);
$parcel$export(module.exports, "useFormatCategoryName", () => $2c8cbe3d23057cf3$export$890bc5a26a499c1d);
$parcel$export(module.exports, "usePlaceholderIcon", () => $2c8cbe3d23057cf3$export$ec6234b435e23f80);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iJ9G3 = parcelRequire("iJ9G3");

var $86NfB = parcelRequire("86NfB");

var $hu996 = parcelRequire("hu996");

var $am56B = parcelRequire("am56B");
const $2c8cbe3d23057cf3$export$4c00bbfcc0ecf975 = {
    i18nMessage: (0, $am56B.default).communicationCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ9G3.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInCommunicationCategory'
};
const $2c8cbe3d23057cf3$export$f4e280770913e10f = {
    i18nMessage: (0, $am56B.default).rolloutCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86NfB.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInRolloutCategory'
};
const $2c8cbe3d23057cf3$export$a6d4661a542d168f = {
    i18nMessage: (0, $am56B.default).testingCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ9G3.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInTestingCategory'
};
const $2c8cbe3d23057cf3$export$257af46c9923adf8 = {
    i18nMessage: (0, $am56B.default).analyticsCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hu996.PresentationPlusGlyph), null),
    analyticsAttributeName: 'numLinksInAnalyticsCategory'
};
const $2c8cbe3d23057cf3$export$d3d779bdc5757c39 = {
    i18nMessage: (0, $am56B.default).developmentCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86NfB.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInDevelopmentCategory'
};
const $2c8cbe3d23057cf3$export$1909a2cc48b27b53 = {
    i18nMessage: (0, $am56B.default).supportCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86NfB.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInSupportCategory'
};
const $2c8cbe3d23057cf3$export$b101d8f25cc16679 = [
    $2c8cbe3d23057cf3$export$4c00bbfcc0ecf975,
    $2c8cbe3d23057cf3$export$f4e280770913e10f,
    $2c8cbe3d23057cf3$export$a6d4661a542d168f,
    $2c8cbe3d23057cf3$export$257af46c9923adf8,
    $2c8cbe3d23057cf3$export$d3d779bdc5757c39,
    $2c8cbe3d23057cf3$export$1909a2cc48b27b53
];
const $2c8cbe3d23057cf3$export$890bc5a26a499c1d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (defaultCategoryInfo)=>formatMessage(defaultCategoryInfo.i18nMessage);
};
const $2c8cbe3d23057cf3$export$ec6234b435e23f80 = (categoryName)=>{
    const formatCategoryName = $2c8cbe3d23057cf3$export$890bc5a26a499c1d();
    // This is a temporary approach that will fall back to a generic icon if the placeholder was created in a different
    // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work items
    // are migrated out of Data Depot and into ERS.
    const defaultCategory = $2c8cbe3d23057cf3$export$b101d8f25cc16679.find((category)=>formatCategoryName(category) === categoryName);
    return defaultCategory?.placeholderIcon ? defaultCategory.placeholderIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86NfB.GenericPlusGlyph), null);
};

});
parcelRegister("iJ9G3", function(module, exports) {

$parcel$export(module.exports, "DocumentPlusGlyph", () => $853cf605ffa63691$export$95d5a31c5e54a0d2);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $853cf605ffa63691$export$95d5a31c5e54a0d2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_10645_15672)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.365 14.7342 20.8832 14.037 19.7084 13H12C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11H18.0703C17.5478 10.0968 17.1968 9.08194 17.0619 8ZM11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H20C20.2652 15 20.5196 15.1054 20.7071 15.2929C20.8946 15.4804 21 15.7348 21 16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929ZM11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19H16C16.2652 19 16.5196 19.1054 16.7071 19.2929C16.8946 19.4804 17 19.7348 17 20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_10645_15672"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("86NfB", function(module, exports) {

$parcel$export(module.exports, "GenericPlusGlyph", () => $7baba43c539ad8bf$export$e68c0551132b814f);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $7baba43c539ad8bf$export$e68c0551132b814f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_10645_15679)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H9.994C8.895 8 8 8.893 8 9.994V22.006C8.00026 22.5348 8.21043 23.0418 8.58432 23.4157C8.95821 23.7896 9.46524 23.9997 9.994 24H22.006C22.5348 23.9997 23.0418 23.7896 23.4157 23.4157C23.7896 23.0418 23.9997 22.5348 24 22.006V14.9381C20.3813 14.4869 17.5131 11.6187 17.0619 8ZM13.333 11H16H16.782C16.9614 10.9998 17.139 11.0359 17.3041 11.106C17.4692 11.1761 17.6185 11.2788 17.743 11.408L19.907 13.658C19.9667 13.7201 20 13.8029 20 13.889V14.792C20 14.975 19.851 15.125 19.667 15.125H17.333C16.597 15.125 16 14.528 16 13.792V12.378H13.333V19.622H18.667V16H20V19.622C20 20.383 19.403 21 18.667 21H13.333C12.597 21 12 20.382 12 19.622V12.378C12 11.617 12.597 11 13.333 11Z",
        fill: "#5E6C84"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_10645_15679"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("hu996", function(module, exports) {

$parcel$export(module.exports, "PresentationPlusGlyph", () => $21b188370ad1db6f$export$4026a3889e667c70);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $21b188370ad1db6f$export$4026a3889e667c70 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_10645_15686)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.9181 14.8032 21.9032 14.4522 21 13.9297V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C19.7348 21 19.4804 20.8946 19.2929 20.7071C19.1054 20.5196 19 20.2652 19 20V12.2916C17.963 11.1168 17.2658 9.635 17.0619 8ZM15.2929 14.2929C15.4804 14.1054 15.7348 14 16 14C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21C15.7348 21 15.4804 20.8946 15.2929 20.7071C15.1054 20.5196 15 20.2652 15 20V15C15 14.7348 15.1054 14.4804 15.2929 14.2929ZM11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V18C11 17.7348 11.1054 17.4804 11.2929 17.2929Z",
        fill: "#8270DB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_10645_15686"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("am56B", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcee8fb7c903a836$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bcee8fb7c903a836$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    testingCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.testing-category",
        "defaultMessage": "Testing"
    },
    rolloutCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.rollout-category",
        "defaultMessage": "Rollout"
    },
    analyticsCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.analytics-category",
        "defaultMessage": "Analytics"
    },
    communicationCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.communication-category",
        "defaultMessage": "Communication"
    },
    developmentCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.development-category",
        "defaultMessage": "Development"
    },
    supportCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.support-category",
        "defaultMessage": "Support"
    }
});

});



parcelRegister("g9Uvo", function(module, exports) {

$parcel$export(module.exports, "CategoryFilter", () => $72c49138f4424a63$export$cb2cc3e02411c0f4);

var $lMKLN = parcelRequire("lMKLN");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fcWBJ = parcelRequire("fcWBJ");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f3MXv = parcelRequire("f3MXv");

var $bNskL = parcelRequire("bNskL");

var $4xo8T = parcelRequire("4xo8T");
const $72c49138f4424a63$export$c50c7c4a5ff445b1 = 5;
const $72c49138f4424a63$export$cb2cc3e02411c0f4 = ({ relatedWorkEdges: relatedWorkEdges, selectedCategory: selectedCategory, onCategorySelected: onCategorySelected })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const edges = (0, $iWLL0.useFragment)((0, $lMKLN.default), relatedWorkEdges);
    const edgesByCategory = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(edges, (edge)=>edge?.node.category);
    const sortedCategoriesWithCounts = Object.keys(edgesByCategory).map((category)=>[
            category,
            edgesByCategory[category].length
        ]).sort(([categoryA], [categoryB])=>categoryA.localeCompare(categoryB));
    const isknownCategory = selectedCategory === undefined || sortedCategoriesWithCounts.some(([category])=>category === selectedCategory); // If the selected category is unknown, un-select it (the selected category comes from
    // a query param, so we can't trust it will always be valid).
    (0, $eUqFw.useEffect)(()=>{
        if (!isknownCategory) onCategorySelected(undefined);
    }, [
        isknownCategory,
        onCategorySelected
    ]);
    const categoriesWithCountWithinThreshold = sortedCategoriesWithCounts.slice(0, $72c49138f4424a63$export$c50c7c4a5ff445b1);
    const categoriesWithCountAfterThreshold = sortedCategoriesWithCounts.slice($72c49138f4424a63$export$c50c7c4a5ff445b1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72c49138f4424a63$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f3MXv.Lozenge), {
        label: formatMessage((0, $bNskL.default).all),
        count: edges.length ?? 0,
        isSelected: selectedCategory === undefined,
        onClick: ()=>onCategorySelected(undefined)
    }), categoriesWithCountWithinThreshold.map(([category, count])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f3MXv.Lozenge), {
            key: category,
            label: category,
            count: count,
            isSelected: category === selectedCategory,
            onClick: ()=>onCategorySelected(category)
        })), categoriesWithCountAfterThreshold.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xo8T.MoreLozengeAsync), {
        categories: categoriesWithCountAfterThreshold.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([category, count])=>({
                label: category,
                count: count,
                isSelected: category === selectedCategory,
                onClick: ()=>onCategorySelected(category)
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72c49138f4424a63$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lMKLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d09c7a7bd70aa2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37fd70250cf323faed8eaab1c7b77e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d09c7a7bd70aa2d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "categoryFilter_softwareReleasesVersionRelatedWork",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "NONE",
                        "path": "node.category"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$0d09c7a7bd70aa2d$var$node.hash = "26b1d568eba141b6bfe3000d32fec7e5";
var $0d09c7a7bd70aa2d$export$2e2bcd8739ae039 = $0d09c7a7bd70aa2d$var$node;

});

parcelRegister("f3MXv", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $5fd773e47314412f$export$a31cbe1bf5463979);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
const $5fd773e47314412f$export$a31cbe1bf5463979 = ({ label: label, count: count, isSelected: isSelected, onClick: onClick })=>{
    const { formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd773e47314412f$var$Button, {
        title: label,
        isSelected: isSelected,
        onClick: ()=>{
            onClick();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'lozenge'
            }), 'relatedWorkCategory');
        },
        "data-testid": "software-releases-version-related-work.ui.category-filter.lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd773e47314412f$var$Label, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd773e47314412f$var$Count, null, formatNumber(count)));
};
// RLSS-2812 Replace color.background.neutral to color.background.accent.gray.subtlest
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd773e47314412f$var$Button = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2rkodlk8 _1dqoglyw _1yt418iy _80omtlke _k48p1nn1 _1wybw1gv _vwz4f6fq",
            __cmplp.isSelected ? "_bfhk29zg" : "_bfhk1s4m",
            __cmplp.isSelected ? "_syaz1fp7" : "_syaz1rr7",
            __cmplp.className
        ])
    });
});
const $5fd773e47314412f$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _p12f1kdj _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd773e47314412f$var$Count = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1fw0 _19bv12x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bNskL", function(module, exports) {

$parcel$export(module.exports, "default", () => $972fca88f67177b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $972fca88f67177b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    all: {
        "id": "software-releases-version-related-work.category-filter.all",
        "defaultMessage": "All"
    }
});

});

parcelRegister("4xo8T", function(module, exports) {

$parcel$export(module.exports, "MoreLozengeAsync", () => $296321f0d777b13f$export$1e468fbbda90a7b4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $6pFOU = parcelRequire("6pFOU");

var $d4Frt = parcelRequire("d4Frt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $296321f0d777b13f$var$LazyMoreLozenge = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("d4Frt"))).then((mod)=>mod.MoreLozenge), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/category-filter/more-lozenge/index.tsx"
});
const $296321f0d777b13f$export$1e468fbbda90a7b4 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { categories: categories } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-releases-version-detail-related-work-more-lozenge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d4Frt.LozengeButton), {
            isSelected: categories.some((category)=>category.isSelected)
        }, formatMessage((0, $6pFOU.default).moreButtonLabel, {
            count: categories.length
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($296321f0d777b13f$var$LazyMoreLozenge, props));
};

});
parcelRegister("6pFOU", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f832f91da44681$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28f832f91da44681$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButtonLabel: {
        "id": "software-releases-version-related-work.category-filter.more-lozenge.more-button-label",
        "defaultMessage": "+{count} more"
    }
});

});

parcelRegister("d4Frt", function(module, exports) {

$parcel$export(module.exports, "MoreLozenge", () => $e64328e03ef4d8a9$export$394f480a87f8efa7);
$parcel$export(module.exports, "LozengeButton", () => $e64328e03ef4d8a9$export$2c8fc3c10740b2a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $6OfWd = parcelRequire("6OfWd");
var $lmeyI = parcelRequire("lmeyI");
var $hIuJI = parcelRequire("hIuJI");


var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $6pFOU = parcelRequire("6pFOU");
const $e64328e03ef4d8a9$export$394f480a87f8efa7 = ({ categories: categories, defaultOpen: defaultOpen = false })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: defaultOpen,
        trigger: ({ triggerRef: triggerRef, ...otherProps })=>{
            const { isSelected: isDropdownOpen } = otherProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e64328e03ef4d8a9$export$2c8fc3c10740b2a5, {
                ...otherProps,
                isDropdownOpen: isDropdownOpen ?? false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: categories.some((category)=>category.isSelected),
                "data-testid": "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-trigger"
            }, formatMessage((0, $6pFOU.default).moreButtonLabel, {
                count: categories.length
            }));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIuJI.default), {
        id: "categories"
    }, categories.map(({ label: label, count: count, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmeyI.default), {
            isSelected: isSelected,
            onClick: ()=>{
                onClick();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'lozenge'
                }), 'relatedWorkCategory');
            },
            id: label,
            key: label,
            testId: "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-item-button"
        }, label, " (", formatNumber(count), ")"))));
};
const $e64328e03ef4d8a9$export$2c8fc3c10740b2a5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDropdownOpen: isDropdownOpen, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_24nxvd": (0, $9t7rW.default)((()=>{
                if (__cmplp.isDropdownOpen) // RLSS-2812 color.background.accent.gray.bolder should be better fit
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$exports).N700})`;
                return __cmplp.isSelected ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B50})` : // RLSS-2812 Replace color.background.neutral to color.background.accent.gray.subtlest
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20})`;
            })()),
            "--_1by0n80": (0, $9t7rW.default)((()=>{
                if (__cmplp.isDropdownOpen) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
                return __cmplp.isSelected ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `var(--ds-text-information, ${(0, $73a5c9d720aa66e1$exports).B500})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N500})`;
            })())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2rkodlk8 _1dqoglyw _1yt418iy _80omtlke _bfhk3hhc _syazvaks _k48p1nn1 _1wybw1gv _vwz4f6fq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dC8VL", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkEmptyState", () => $8304020b6e8ababf$export$eeabb037f6ceac15);

var $43FwZ = parcelRequire("43FwZ");

var $gSxbD = parcelRequire("gSxbD");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4M8lK = parcelRequire("4M8lK");

var $8bNZT = parcelRequire("8bNZT");

var $jfao4 = parcelRequire("jfao4");

var $hG7ij = parcelRequire("hG7ij");

var $iJ5fN = parcelRequire("iJ5fN");

var $6qNlv = parcelRequire("6qNlv");
const $8304020b6e8ababf$export$eeabb037f6ceac15 = ({ jiraVersion: jiraVersion, relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const addRelatedWorkExpFailed = (0, $4M8lK.useAddRelatedWorkExperienceFail)();
    const version = (0, $iWLL0.useFragment)((0, $gSxbD.default), jiraVersion);
    const edges = (0, $iWLL0.useFragment)((0, $43FwZ.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8304020b6e8ababf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hG7ij.VersionRelatedWorkExperienceSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iJ5fN))),
        width: 80,
        height: 71.45,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $6qNlv.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8304020b6e8ababf$var$Description, null, formatMessage((0, $6qNlv.default).emptyStateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfao4.ErrorBoundary), {
        id: "addRelatedPopupInEmptyState",
        fallback: "unmount",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bNZT.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: edges,
        renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, isLoading: isLoading, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                onClick: onClick,
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.empty-state.button',
                onMouseOver: onMouseOver
            }, formatMessage((0, $6qNlv.default).add))
    })));
};
// RLSS-2812 color.border.bold might look better than color.border. Personally I feel that color.border is too subtle in Dark mode
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8304020b6e8ababf$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _1yt41ejb _2rkoftgi _19itzqnv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8304020b6e8ababf$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _p12f1ffr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("43FwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeeccd62bd8aa83c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3933bc99277dd3082f972f5de4a18d40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aeeccd62bd8aa83c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$aeeccd62bd8aa83c$var$node.hash = "93018a8cf1d1d8516c9bb5d6c022ae78";
var $aeeccd62bd8aa83c$export$2e2bcd8739ae039 = $aeeccd62bd8aa83c$var$node;

});

parcelRegister("gSxbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c96a764c3a6cf0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2798bc7e1de0fb498b8952176e0d5284>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58c96a764c3a6cf0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "JiraVersion"
};
$58c96a764c3a6cf0$var$node.hash = "8330954195b2fe0fa1d89b6b61b53975";
var $58c96a764c3a6cf0$export$2e2bcd8739ae039 = $58c96a764c3a6cf0$var$node;

});

parcelRegister("iJ5fN", function(module, exports) {
module.exports = new URL("documents-illustration.37d481a2.svg", import.meta.url).toString();

});

parcelRegister("6qNlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a63d0f7d89e712c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0a63d0f7d89e712c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "software-releases-version-related-work.empty-state.empty-state-heading",
        "defaultMessage": "Start adding some related work"
    },
    emptyStateDescription: {
        "id": "software-releases-version-related-work.empty-state.empty-state-description",
        "defaultMessage": "Add the work that's needed to get ready for your release like designs, release notes, analytics dashboards, and more!"
    },
    add: {
        "id": "software-releases-version-related-work.empty-state.add",
        "defaultMessage": "Add related work"
    }
});

});


parcelRegister("fpIhA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f4fecad9cc1b4b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0f4fecad9cc1b4b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    relatedWorkHeading: {
        "id": "software-releases-version-related-work.related-work-heading",
        "defaultMessage": "Related work"
    },
    addRelatedWork: {
        "id": "software-releases-version-related-work.add-related-work",
        "defaultMessage": "Add links, release notes, and more\u2026"
    },
    showMore: {
        "id": "software-releases-version-related-work.show-more",
        "defaultMessage": "Show {moreItemsCount} more"
    },
    showLess: {
        "id": "software-releases-version-related-work.show-less",
        "defaultMessage": "Show {moreItemsCount} less"
    }
});

});

parcelRegister("dzVsj", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkList", () => $e71f893f53737eae$export$25137fc5a267c4a9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $kyhbK = parcelRequire("kyhbK");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e71f893f53737eae$var$LazyRelatedWorkList = (0, $7rh0R.lazy)(()=>(parcelRequire("gxSCB")).then((module)=>module.RelatedWorkList), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/related-work-list/index.tsx"
});
const $e71f893f53737eae$export$25137fc5a267c4a9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "related-work-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyhbK.SkeletonRelatedWorkList), {
            numLinks: props.relatedWorkEdges.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e71f893f53737eae$var$LazyRelatedWorkList, props));

});
parcelRegister("kyhbK", function(module, exports) {

$parcel$export(module.exports, "SkeletonRelatedWorkList", () => $61defe534fb1a944$export$98236437a8dbfc1c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $61defe534fb1a944$export$98236437a8dbfc1c = ({ numLinks: numLinks })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$RelatedWorkItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$RelatedWorkItemWrapper, {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$SkeletonRelatedWorkIcon, {
            opacity: 1 - i * 0.2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$SkeletonRelatedWorkItemLarge, {
            opacity: 1 - i * 0.2
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61defe534fb1a944$var$SkeletonRelatedWorkItemSmall, {
            key: i,
            opacity: 1 - i * 0.2
        })))));
const $61defe534fb1a944$var$shimmer = null;
const $61defe534fb1a944$var$SkeletonRelatedWorkItemStyles = null;
const $61defe534fb1a944$var$verticalMargin = 15;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61defe534fb1a944$var$SkeletonRelatedWorkIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $9t7rW.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsbqslr _18s81vn1",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $61defe534fb1a944$var$SkeletonRelatedWorkItemLarge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $9t7rW.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsbpo3b _19pko7ao _2hwxidpf _otyro7ao _18u0idpf",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $61defe534fb1a944$var$SkeletonRelatedWorkItemSmall = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $9t7rW.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsb1ex1 _18s81w5s",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $61defe534fb1a944$var$TableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm _2lx21bp4 _ca0qutpp",
            __cmplp.className
        ])
    });
});
const $61defe534fb1a944$var$SkeletonRelatedWorkRowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _19bv1b66 _1p571b66",
            __cmplp.className
        ])
    });
});
const $61defe534fb1a944$var$RelatedWorkItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gxSCB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("k9Udi")
]).then(()=>parcelRequire('i1dfw'));

});



parcelRegister("3AmM5", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkLoadingSkeleton", () => $3e67dbda27fc0d19$export$d1ea41fcd84767c8);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $hFxJG = parcelRequire("hFxJG");
const $3e67dbda27fc0d19$var$RelatedWorkItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $3e67dbda27fc0d19$var$relatedWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $3e67dbda27fc0d19$var$relatedWorkLeftWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        width: "24px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $3e67dbda27fc0d19$var$relatedWorkRightWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        width: "350px",
        height: "24px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        width: "220px",
        height: "18px",
        isShimmering: true
    })));
const $3e67dbda27fc0d19$export$d1ea41fcd84767c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $3e67dbda27fc0d19$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        width: "220px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $3e67dbda27fc0d19$var$categoryFilterRowStlyes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "52px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "85px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "125px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "70px",
        height: "26px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e67dbda27fc0d19$var$RelatedWorkItemSkeleton, null)));
const $3e67dbda27fc0d19$var$headerSkeletonStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.500',
    marginBottom: 'space.250'
});
const $3e67dbda27fc0d19$var$categoryFilterRowStlyes = (0, $1ZAYh.xcss)({
    gap: 'space.100',
    marginBottom: 'space.150'
});
const $3e67dbda27fc0d19$var$relatedWorkWrapperStyles = (0, $1ZAYh.xcss)({
    height: 'space.800'
});
const $3e67dbda27fc0d19$var$relatedWorkRightWrapperStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.150'
});
const $3e67dbda27fc0d19$var$relatedWorkLeftWrapperStyles = (0, $1ZAYh.xcss)({
    width: '64px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("hFxJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6854df9b98f4b182$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $6854df9b98f4b182$var$shimmer = (0, $lcnyw.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6854df9b98f4b182$var$shimmerKeyframes = (0, $byn9U.keyframes)($6854df9b98f4b182$var$shimmer.keyframes);
const $6854df9b98f4b182$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$6854df9b98f4b182$var$shimmer.css
});
const $6854df9b98f4b182$var$activeShimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationName: `${$6854df9b98f4b182$var$shimmerKeyframes}`
});
const $6854df9b98f4b182$var$getKeyframes = (fromColor, toColor)=>(0, $byn9U.keyframes)({
        from: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            backgroundColor: fromColor
        },
        to: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            backgroundColor: toColor
        }
    });
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $6854df9b98f4b182$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6854df9b98f4b182$var$skeletonStyles,
            isShimmering && $6854df9b98f4b182$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                animationName: color && ShimmeringEndColor ? $6854df9b98f4b182$var$getKeyframes(color, ShimmeringEndColor) : undefined
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $6854df9b98f4b182$export$2e2bcd8739ae039 = $6854df9b98f4b182$var$Skeleton;

});


parcelRegister("4mRwo", function(module, exports) {

$parcel$export(module.exports, "AsyncVersionRichTextSection", () => $3ff7857f1ea929db$export$6803497461260cfa);

var $7OuCV = parcelRequire("7OuCV");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $gGtKh = parcelRequire("gGtKh");

var $iMbGs = parcelRequire("iMbGs");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ff7857f1ea929db$var$LazyVersionRichTextSection = (0, $7rh0R.lazy)(()=>(parcelRequire("dKpKb")).then((module)=>module.VersionRichTextSection), {
    moduleId: "./src/packages/releases/version-rich-text-section/src/ui/index.tsx"
});
const $3ff7857f1ea929db$export$6803497461260cfa = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $iWLL0.useFragment)((0, $7OuCV.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "rich-text-section",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMbGs.SkeletonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMbGs.SkeletonItem), {
            width: "15%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMbGs.SkeletonItem), {
            width: "45%"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ff7857f1ea929db$var$LazyVersionRichTextSection, {
        jiraVersion: version
    }));
};

});
parcelRegister("7OuCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74605a8be4bf04ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6be8816f0e078a42b8f843748f38b46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74605a8be4bf04ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionRichTextSection_VersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$74605a8be4bf04ea$var$node.hash = "d5a19fe58067365a8d3ea1743ac2c96d";
var $74605a8be4bf04ea$export$2e2bcd8739ae039 = $74605a8be4bf04ea$var$node;

});

parcelRegister("iMbGs", function(module, exports) {

$parcel$export(module.exports, "SkeletonWrapper", () => $d9b779aed20f790c$export$6069cbe61f690103);
$parcel$export(module.exports, "SkeletonItem", () => $d9b779aed20f790c$export$fbc0ea7debdb77e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $d9b779aed20f790c$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bah1y6m _19pk1ejb",
            __cmplp.className
        ])
    });
});
const $d9b779aed20f790c$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1aqf _4t3idlk8 _1bsb1rkg _2rko1l7b _19pkutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dKpKb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5ymRu")
]).then(()=>parcelRequire('4BIOM'));

});


parcelRegister("1byaX", function(module, exports) {

$parcel$export(module.exports, "IssueAssociatedDesignsExperienceStart", () => $8648ba69513fb430$export$81d77c7d61cbddef);
$parcel$export(module.exports, "IssueAssociatedDesignsExperienceSuccess", () => $8648ba69513fb430$export$709f489a7a70c461);
$parcel$export(module.exports, "useIssueAssociatedDesignsExperienceFail", () => $8648ba69513fb430$export$715c37bd4d0b2cba);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $8648ba69513fb430$var$EXPERIENCE_NAME = 'issueAssociatedDesigns';
const $8648ba69513fb430$var$ANALYTICS_SOURCE = 'versionDetails';
const $8648ba69513fb430$export$81d77c7d61cbddef = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: "jiraVersionDetailsIssueAssociatedDesigns",
        experience: $8648ba69513fb430$var$EXPERIENCE_NAME,
        analyticsSource: $8648ba69513fb430$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $8648ba69513fb430$export$709f489a7a70c461 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $8648ba69513fb430$var$EXPERIENCE_NAME
    });
const $8648ba69513fb430$export$715c37bd4d0b2cba = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $8648ba69513fb430$var$EXPERIENCE_NAME
    });

});

parcelRegister("j1rVF", function(module, exports) {

$parcel$export(module.exports, "IssueAssociatedDesigns", () => $d4b03267399060f5$export$891b244b5d2793aa);
$parcel$export(module.exports, "DesignSectionSkeleton", () => $d4b03267399060f5$export$b6a2d0e3927c95cf);

var $3GsbF = parcelRequire("3GsbF");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iWLL0 = parcelRequire("iWLL0");

var $9nkwJ = parcelRequire("9nkwJ");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $5Knhe = parcelRequire("5Knhe");

var $eeUc9 = parcelRequire("eeUc9");

var $1byaX = parcelRequire("1byaX");

var $ikX47 = parcelRequire("ikX47");

var $5T027 = parcelRequire("5T027");

var $7iK5y = parcelRequire("7iK5y");
const $d4b03267399060f5$export$891b244b5d2793aa = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { jira: { version: version } } = (0, $iWLL0.usePreloadedQuery)((0, $3GsbF.default), queryRef);
    // In real world this shouldn't happen, since this query won't be even executed when this happen by version detail's page main query
    if (version.__typename !== 'JiraVersion') throw new Error('Version query result is not VersionResult');
    const { totalCount: totalCount } = version.issueAssociatedDesigns;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionIssueAssociatedDesigns",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            designsCount: totalCount
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleSection), {
        jiraVersion: version,
        renderBody: ()=>{
            if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5T027.EmptyState), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ikX47.DesignCarousel), {
                jiraVersion: version
            });
        },
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4b03267399060f5$var$HeaderWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                size: "small",
                as: "h2"
            }, formatMessage((0, $7iK5y.default).designSectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, totalCount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleToggleButton), {
                isCollapsed: isCollapsed,
                onClick: onToggleClicked
            })),
        uiType: "ISSUE_ASSOCIATED_DESIGNS"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1byaX.IssueAssociatedDesignsExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $d4b03267399060f5$export$b6a2d0e3927c95cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4b03267399060f5$var$SkeletonItem, {
        width: "220px",
        height: "24px",
        margin: "44px 0 20px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $d4b03267399060f5$var$designCardsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $d4b03267399060f5$var$crouselCounterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4b03267399060f5$var$SkeletonItem, {
        width: "100px",
        height: "20px",
        margin: "20px 0 0 0"
    })));
const $d4b03267399060f5$var$designCardsSkeletonWrapperStyles = (0, $1ZAYh.xcss)({
    gap: 'space.200',
    width: '100%',
    overflow: 'hidden',
    padding: 'space.050',
    marginTop: 'space.100'
});
const $d4b03267399060f5$var$crouselCounterStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px'
});
const $d4b03267399060f5$var$animationOptionStyles = null;
const $d4b03267399060f5$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d4b03267399060f5$var$SkeletonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_146ducd": (0, $9t7rW.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _j7hqw3o4 _bfhkqrzy _2rko1y44 _4t3i1474 _1bsb1rkg _18s8j3fp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4b03267399060f5$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1y6m _zulpu2gc _80omtlke _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("eeUc9", function(module, exports) {

$parcel$export(module.exports, "DesignCardSkeleton", () => $ec14ddcc702ee331$export$1743685a5725b0ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $6TTwz = parcelRequire("6TTwz");
const $ec14ddcc702ee331$export$1743685a5725b0ae = ({ onVisible: onVisible })=>{
    const onSetElementRef = (0, $6TTwz.useIntersectionObserver)({
        margin: 0,
        onIntersection: ()=>onVisible?.()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ec14ddcc702ee331$var$cardContainerStyles,
        ref: onSetElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "24px",
        height: "24px",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $ec14ddcc702ee331$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "220px",
        height: "16px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "80px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "120px",
        height: "24px",
        margin: "12px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "50px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec14ddcc702ee331$var$SkeletonItem, {
        width: "240px",
        height: "26px",
        margin: "5px 0"
    })));
};
const $ec14ddcc702ee331$var$animationOptionStyles = null;
const $ec14ddcc702ee331$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ec14ddcc702ee331$var$SkeletonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_146ducd": (0, $9t7rW.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _j7hqw3o4 _bfhkqrzy _2rko1y44 _4t3i1474 _1bsb1rkg _18s8j3fp",
            __cmplp.className
        ])
    });
});
const $ec14ddcc702ee331$var$cardContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised'
});
const $ec14ddcc702ee331$var$titleStackStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    overflow: 'hidden'
});

});
parcelRegister("6TTwz", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $d7166072f7e8076a$export$a7395f9832c00176);

var $eUqFw = parcelRequire("eUqFw");
const $d7166072f7e8076a$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});


parcelRegister("ikX47", function(module, exports) {

$parcel$export(module.exports, "DesignCarousel", () => $1d4f18efbda18a9c$export$f1038593ff0bfc1e);

var $bdoU0 = parcelRequire("bdoU0");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iqjbc = parcelRequire("iqjbc");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5qTKr = parcelRequire("5qTKr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");


var $eeUc9 = parcelRequire("eeUc9");

var $9JBLg = parcelRequire("9JBLg");

var $1IyRF = parcelRequire("1IyRF");

var $98X92 = parcelRequire("98X92");
const $1d4f18efbda18a9c$var$getNumFullyRenderedCards = (carouselWidth)=>Math.floor(carouselWidth / (0, $39f77694d4b3405d$export$2796973bb2f51929)); // curPageNum: 0-based, returned number: 1-based(displayed to user)
const $1d4f18efbda18a9c$var$getCurPageStartEndNum = (fullyRenderedCardNum, curPageNum, totalCount)=>({
        currentStart: curPageNum * fullyRenderedCardNum + 1,
        currentEnd: totalCount >= (curPageNum + 1) * fullyRenderedCardNum ? (curPageNum + 1) * fullyRenderedCardNum : totalCount,
        lastPageNum: Math.ceil(totalCount / fullyRenderedCardNum) - 1
    });
const $1d4f18efbda18a9c$export$f1038593ff0bfc1e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [carouselWidth, setCarouselWidth] = (0, $eUqFw.useState)(0);
    const [curPageNum, setCurPageNum] = (0, $eUqFw.useState)(0);
    const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $iWLL0.usePaginationFragment)((0, $bdoU0.default), jiraVersion);
    const designEdges = data.issueAssociatedDesigns?.edges ?? [];
    const designNodes = designEdges.filter(Boolean).map((edge)=>edge.node).filter(Boolean); // We only need to use the potentially inaccurate/outdated `totalCount` value from
    // the API if we don't have all the edges loaded.
    const totalCount = hasNext ? data.issueAssociatedDesigns.totalCount : designNodes?.length ?? 0;
    const numFullyRenderedCards = $1d4f18efbda18a9c$var$getNumFullyRenderedCards(carouselWidth);
    const carouselPageInfo = $1d4f18efbda18a9c$var$getCurPageStartEndNum(numFullyRenderedCards, curPageNum, totalCount);
    (0, $eUqFw.useEffect)(()=>{
        // This is for resize event, and due to resize carousel page becomes over the last page when width grows.
        if (carouselPageInfo.lastPageNum < curPageNum) setCurPageNum(carouselPageInfo.lastPageNum);
    }, [
        carouselPageInfo.lastPageNum,
        curPageNum
    ]);
    if (totalCount === 0) return null;
    const numCardSkeleton = totalCount - designNodes.length;
    const firePaginationAnalytics = (direction)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'designsPagination', {
            direction: direction
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1d4f18efbda18a9c$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        setWidth: setCarouselWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d4f18efbda18a9c$var$CarouselWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d4f18efbda18a9c$var$CarouselSlider, {
        widthOffset: curPageNum * numFullyRenderedCards * ((0, $39f77694d4b3405d$export$2796973bb2f51929) + (0, $39f77694d4b3405d$export$c73e9b0a14b3993b))
    }, designNodes.map((designNode)=>// id shouldn't be null in real world. https://atlassian.slack.com/archives/C01E2MPPLE4/p1709250064060249
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IyRF.DesignCard), {
            key: designNode.id ?? '',
            devOpsDesign: designNode,
            jiraVersion: data
        })), hasNext && (0, (/*@__PURE__*/$parcel$interopDefault($iqjbc)))(numCardSkeleton).map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeUc9.DesignCardSkeleton), {
            key: n,
            onVisible: ()=>{
                if (!hasNext || isLoadingNext) return null;
                loadNext(6);
            }
        })))), numFullyRenderedCards < Math.max(totalCount, designNodes.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d4f18efbda18a9c$var$ArrowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JBLg.Arrow), {
        direction: "LEFT",
        onClick: ()=>{
            if (curPageNum === 0) return;
            setCurPageNum(curPageNum - 1);
            firePaginationAnalytics('left');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JBLg.Arrow), {
        direction: "RIGHT",
        onClick: ()=>{
            if (carouselPageInfo.currentEnd >= totalCount) return;
            setCurPageNum(curPageNum + 1);
            firePaginationAnalytics('right');
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }, formatMessage((0, $98X92.default).carouselPageCount, {
        ...carouselPageInfo,
        totalCount: totalCount
    })));
};
const $1d4f18efbda18a9c$var$wrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    position: 'relative',
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d4f18efbda18a9c$var$ArrowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d4f18efbda18a9c$var$CarouselWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _1reo15vq _18m915vq _4cvr1fhb _1yt41b66 _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d4f18efbda18a9c$var$CarouselSlider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthOffset: widthOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_z0ie8w": (0, $9t7rW.default)(`translateX(-${__cmplp.widthOffset}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _zulppxbi _v5641cdp _t9ec1jj4",
            __cmplp.className
        ])
    });
});
const $1d4f18efbda18a9c$var$pageCounterStyles = null;

});
parcelRegister("bdoU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf78e4bf089f8799$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<044f2a1b50736a083aa773821be0554d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $qM5nq = parcelRequire("qM5nq");
const $bf78e4bf089f8799$var$node = function() {
    var v0 = [
        "issueAssociatedDesigns"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            },
            {
                "defaultValue": 6,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $qM5nq.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "designCarousel_versionIssueAssociatedDesigns",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "designCard_versionIssueAssociatedDesigns_jiraVersion"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issueAssociatedDesigns",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "sort",
                            "value": {
                                "createdAt": {
                                    "direction": "DESC",
                                    "priority": 1
                                }
                            }
                        }
                    ],
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "__DesignSlider_issueAssociatedDesigns_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign"
                                                }
                                            ],
                                            "type": "DevOpsDesign"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "issueAssociatedDesigns.totalCount"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ],
                    "storageKey": "__DesignSlider_issueAssociatedDesigns_connection(sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                },
                "action": "THROW",
                "path": "issueAssociatedDesigns"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraVersion"
    };
}();
$bf78e4bf089f8799$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $bf78e4bf089f8799$export$2e2bcd8739ae039 = $bf78e4bf089f8799$var$node;

});
parcelRegister("qM5nq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91a8e5d03b1d7a05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cb0f9e844b8ed49be36f20a1c3e29ea>>
 * @relayHash f15bd8b5d1ef27139fdf753918230146
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672
const $91a8e5d03b1d7a05$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": 6,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "designCarousel_versionIssueAssociatedDesigns"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                    "kind": "LinkedField",
                                    "name": "issueAssociatedDesigns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "lastUpdated"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "id",
                                                                            "variableName": "cloudAri"
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "provider",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "first",
                                                                            "value": 2
                                                                        }
                                                                    ],
                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "associatedIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "key"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "webUrl"
                                                                                                },
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "idsOrAliases",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "summary"
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ignoreMissingFields",
                                                                                                            "value": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsByIdOrAlias",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v4 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "xsmall"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v5 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "text"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        v5 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssue"
                                                                                        },
                                                                                        v4 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "associatedIssues(first:2)"
                                                                }
                                                            ],
                                                            "type": "DevOpsDesign"
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "sort"
                                    ],
                                    "handle": "connection",
                                    "key": "DesignSlider_issueAssociatedDesigns",
                                    "kind": "LinkedHandle",
                                    "name": "issueAssociatedDesigns"
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672",
            "metadata": {},
            "name": "versionDetailsDesignRefetchableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$91a8e5d03b1d7a05$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $91a8e5d03b1d7a05$export$2e2bcd8739ae039 = $91a8e5d03b1d7a05$var$node;

});


parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});



// in px
const $39f77694d4b3405d$export$2796973bb2f51929 = 360;
const $39f77694d4b3405d$export$c73e9b0a14b3993b = 16;

parcelRegister("9JBLg", function(module, exports) {

$parcel$export(module.exports, "Arrow", () => $8b3b85ec252d199b$export$21b07c8f274aebd5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gpZWO = parcelRequire("gpZWO");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6IAtx = parcelRequire("6IAtx");
const $8b3b85ec252d199b$export$21b07c8f274aebd5 = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b3b85ec252d199b$var$Wrapper, {
        onClick: onClick,
        direction: direction
    }, direction === 'LEFT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
        label: formatMessage((0, $6IAtx.default).leftArrowlabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: formatMessage((0, $6IAtx.default).rightArrowlabel)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b3b85ec252d199b$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxv1rj4 _kqswstnw _154ixncg _1bsb1ejb _4t3i1ejb _2rkoutpp _11q71j9a _syaz1fxt _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _80omtlke _12ji1r31 _1qu21kw7 _12y31o36 _16qsn3ow _1du216kg _19lc7zq1",
            __cmplp.direction === 'LEFT' ? "_1ltvxmi2" : "_1ltv1wug",
            __cmplp.direction === 'RIGHT' ? "_1xi2xmi2" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bf3f089e16becc19$var$_arrowLeft = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $bf3f089e16becc19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf3f089e16becc19$var$_arrowLeft.default
    }));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = module.exports.default = $bf3f089e16becc19$var$ArrowLeftIcon;

});
parcelRegister("f4v4a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});


parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("6IAtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c136b8b5e5c3851$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c136b8b5e5c3851$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    leftArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.left-arrowlabel",
        "defaultMessage": "To next page"
    },
    rightArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.right-arrowlabel",
        "defaultMessage": "To previous page"
    }
});

});


parcelRegister("1IyRF", function(module, exports) {

$parcel$export(module.exports, "DesignCard", () => $29c9977e3397d17f$export$a0f819c247fd2165);

var $dAG8s = parcelRequire("dAG8s");

var $h6hDK = parcelRequire("h6hDK");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $6nIG2 = parcelRequire("6nIG2");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");


var $2eG9N = parcelRequire("2eG9N");

var $hP2Rw = parcelRequire("hP2Rw");

var $l3Qg0 = parcelRequire("l3Qg0");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iSZ3f = parcelRequire("iSZ3f");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $gsOUv = parcelRequire("gsOUv");

var $dWLk9 = parcelRequire("dWLk9");


var $l3ddt = parcelRequire("l3ddt");

var $1UJw7 = parcelRequire("1UJw7");

var $7uaeU = parcelRequire("7uaeU");

var $3zgLD = parcelRequire("3zgLD");
const $29c9977e3397d17f$var$DATE_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $29c9977e3397d17f$var$runtimeProps = {};
const $29c9977e3397d17f$export$a0f819c247fd2165 = ({ devOpsDesign: devOpsDesign, jiraVersion: jiraVersion })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const [designIssuesModalQueryRef, loadDesignIssuesModalQuery] = (0, $iWLL0.useQueryLoader)((0, $gsOUv.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const siteAri = (0, $hP2Rw.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    const data = (0, $iWLL0.useFragment)((0, $h6hDK.default), devOpsDesign);
    const version = (0, $iWLL0.useFragment)((0, $dAG8s.default), jiraVersion);
    const onLoadDesignIssuesModalQuery = ()=>{
        if (designIssuesModalQueryRef == null) loadDesignIssuesModalQuery({
            cloudAri: siteAri,
            designAris: [
                data.id
            ],
            versionId: version.id
        });
    };
    const associatedIssuesNodes = (data.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter((node)=>node?.__typename === 'JiraIssue').filter(Boolean);
    const issues = associatedIssuesNodes.length === 1 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3ddt.SimpleIssueCard), {
        jiraIssue: associatedIssuesNodes[0],
        openIssueInSidebar: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: onLoadDesignIssuesModalQuery,
        onFocus: onLoadDesignIssuesModalQuery,
        className: (0, $7JEyt.default)([
            "_19pku2gc _n3td1b66 _18u0xmi2"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "compact",
        appearance: "subtle",
        onClick: (_, analyticsEvent)=>{
            onLoadDesignIssuesModalQuery();
            setIsModalOpen(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'designLinkedIssuesSeeAllModal');
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            primaryColor: `var(--ds-icon-accent-blue, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
            size: "small",
            label: formatMessage((0, $7uaeU.default).issueIconLabel)
        })
    }, formatMessage((0, $7uaeU.default).manyIssues))), designIssuesModalQueryRef != null && isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-detaiols-design-issues-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UJw7.IssueModalLoading), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UJw7.IssuesModal), {
        queryRef: designIssuesModalQueryRef,
        onClose: ()=>setIsModalOpen(false)
    }))); /**
         * Implementation wise DesignModal component is issue-centric. Hence we need an issue that is linked to this design to be able to
         * open the DesignModal preview. It doens't matter which issue we pick as all of them are linked to the current deisng, hence is the
         * term `representativeIssueAri`.
         */ 
    const representativeIssueAri = associatedIssuesNodes.length > 0 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? associatedIssuesNodes[0].id : '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $iSZ3f.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: representativeIssueAri,
        designAri: data.id,
        cloudId: cloudId
    });
    const modalTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionAssociatedDesignCard",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            hasMultipleIssues: associatedIssuesNodes.length > 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $29c9977e3397d17f$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: data.provider.logoUrl,
        alt: "",
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul91tcg _19pk12x7"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $29c9977e3397d17f$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: data.url,
        target: "_blank",
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designTitleLink'),
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48pni7l _o5721q9c _1reo15vq _18m915vq _1bto1l2s _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, data.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatDate(data.lastUpdated, $29c9977e3397d17f$var$DATE_FORMAT),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
        ])
    }, (0, $3zgLD.formatRelativeDate)(new Date(data.lastUpdated)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb68cl _19pkutpp _otyrutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: modalTriggerRef,
        shouldFitContainer: true,
        spacing: "compact",
        onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openDesignPreviewButton')
    }, formatMessage((0, $7uaeU.default).openPreview))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
        ])
    }, formatMessage((0, $7uaeU.default).linkedTo)), issues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraDesignModalInVersionDetailsPage",
        packageName: "design-modal",
        entryPointActions: entryPointActions,
        runtimeProps: $29c9977e3397d17f$var$runtimeProps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $29c9977e3397d17f$var$cardContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $39f77694d4b3405d$export$2796973bb2f51929)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $39f77694d4b3405d$export$2796973bb2f51929)}px`
});
const $29c9977e3397d17f$var$iconStyles = null;
const $29c9977e3397d17f$var$titleStackStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    maxWidth: '312px' // CARD_WIDTH - paddings - icon width
});
const $29c9977e3397d17f$var$lastUpdatedStyles = null;
const $29c9977e3397d17f$var$openPreviewStyles = null;
const $29c9977e3397d17f$var$linkedToStyles = null;
const $29c9977e3397d17f$var$titleStyles = null;
const $29c9977e3397d17f$var$manyIssuesButtonStyles = null;

});
parcelRegister("dAG8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $927e411033871d39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e89d02b9a20fcaff4cda1b4ccb9afdcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $927e411033871d39$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "designCard_versionIssueAssociatedDesigns_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$927e411033871d39$var$node.hash = "574075efd4cf2b2db85cdf409e87e841";
var $927e411033871d39$export$2e2bcd8739ae039 = $927e411033871d39$var$node;

});

parcelRegister("h6hDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $17cb239ff9f6d73e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8314031cb72b2628e29a5a3038f05a2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17cb239ff9f6d73e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            }
        ],
        "kind": "Fragment",
        "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                "action": "THROW",
                "path": "displayName"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "lastUpdated"
                },
                "action": "THROW",
                "path": "lastUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "provider",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            "action": "THROW",
                            "path": "provider.logoUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "provider"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                    }
                ],
                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                "kind": "LinkedField",
                "name": "associatedIssues",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                            }
                                        ],
                                        "type": "JiraIssue"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "associatedIssues(first:2)"
            }
        ],
        "type": "DevOpsDesign"
    };
}();
$17cb239ff9f6d73e$var$node.hash = "bb9498fa38fb746e3897ed942c1b67ca";
var $17cb239ff9f6d73e$export$2e2bcd8739ae039 = $17cb239ff9f6d73e$var$node;

});

parcelRegister("hP2Rw", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $4116b9e0cf8d4078$export$6c0f81f222d09301);

var $5qxKt = parcelRequire("5qxKt");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/site/manifest.ts
var $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5qxKt.JiraSiteAriResourceOwner),
    resourceType: (0, $5qxKt.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/site/index.ts
var $4116b9e0cf8d4078$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("5qxKt", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $5e838ac9aa1e3776$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $5e838ac9aa1e3776$export$886165a991f21644);
// src/jira/site/types.ts
var $5e838ac9aa1e3776$export$b7d590981b504412 = "jira", $5e838ac9aa1e3776$export$886165a991f21644 = "site";

});


parcelRegister("gsOUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1238d1f0ab3d85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c2ad0601128319e084fe547d3d8d145>>
 * @relayHash ae335ccbbdafd28c0b60d5176236e1a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf
const $fb1238d1f0ab3d85$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "designAris"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "designAris"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudAri"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "logoUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "DevOpsDesign",
                                    "kind": "LinkedField",
                                    "name": "designEntityDetails",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.url"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.displayName"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v6 /*: any*/ ,
                                                "kind": "LinkedField",
                                                "name": "provider",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.designEntityDetails.provider.logoUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.provider"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "body_versionIssueAssociatedDesigns_IssuesModalBody"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.designEntityDetails"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "DevOpsDesign",
                            "kind": "LinkedField",
                            "name": "designEntityDetails",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                    "kind": "LinkedField",
                                    "name": "associatedIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "versionId",
                                                                            "variableName": "versionId"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasRelationshipToVersion"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUrl"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "idsOrAliases",
                                                                            "value": [
                                                                                "issuetype",
                                                                                "summary"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ignoreMissingFields",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsByIdOrAlias",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "name"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "xsmall"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v9 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "text"
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        v9 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "associatedIssues(first:100)"
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf",
            "metadata": {},
            "name": "issuesModal_designIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fb1238d1f0ab3d85$var$node.hash = "7de65187f74a740f22e361ae3bf58899";
var $fb1238d1f0ab3d85$export$2e2bcd8739ae039 = $fb1238d1f0ab3d85$var$node;

});

parcelRegister("l3ddt", function(module, exports) {

$parcel$export(module.exports, "SimpleIssueCard", () => $9fa1d088aaf6fbe6$export$a6b6cb5c242d7ead);

var $rAhs7 = parcelRequire("rAhs7");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $4kMup = parcelRequire("4kMup");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $jMP2a = parcelRequire("jMP2a");

var $a5QNi = parcelRequire("a5QNi");

var $hYpYi = parcelRequire("hYpYi");
const $9fa1d088aaf6fbe6$export$a6b6cb5c242d7ead = ({ jiraIssue: jiraIssue, openIssueInSidebar: openIssueInSidebar })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, sidebarActions] = (0, $a5QNi.useSidebarStore)();
    const data = (0, $iWLL0.useFragment)((0, $rAhs7.default), jiraIssue);
    const fieldsData = data.fieldsByIdOrAlias.filter(Boolean);
    const issueTypeFieldData = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraIssueTypeField') return {
            icon: fieldData.issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($hYpYi))),
            name: fieldData.issueType.name
        };
        return acc;
    }, {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hYpYi))),
        name: ''
    });
    const summaryText = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraSingleLineTextField') return fieldData.text;
        return acc;
    }, null);
    if (issueTypeFieldData == null) throw new Error(`issue data did not contain issuetype data(${issueTypeFieldData})`);
    if (summaryText === null) throw new Error('issue data did not contain summary data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: data.webUrl,
        target: "_blank",
        xcss: $9fa1d088aaf6fbe6$var$wrapperStyles,
        onClick: (e)=>{
            const modifiersPressed = e.shiftKey || e.metaKey || e.ctrlKey; // Open the issue in the sidebar if (a) the prop says we should and (b) the user
            // didn't *explicitly* try to open in a new tab, e.g. by control-clicking.
            if (openIssueInSidebar && !modifiersPressed) {
                e.preventDefault();
                sidebarActions.showIssue(data.key);
            }
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designLinkedIssue');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $9fa1d088aaf6fbe6$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: issueTypeFieldData.icon,
        alt: issueTypeFieldData.name,
        title: issueTypeFieldData.name,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _18s81c8u _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_1o9zidpf _syaz1wmz _u5f31ejb _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, data.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, summaryText)));
};
const $9fa1d088aaf6fbe6$var$wrapperStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    boxSizing: 'content-box',
    display: 'block',
    height: '20px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    ':hover': {
        textDecoration: 'none'
    }
});
const $9fa1d088aaf6fbe6$var$inlineStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center'
});
const $9fa1d088aaf6fbe6$var$issueTypeStyles = null;
const $9fa1d088aaf6fbe6$var$issueKeyStyles = null;
const $9fa1d088aaf6fbe6$var$issueSummaryStyles = null;

});
parcelRegister("rAhs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18d687964670bff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<548492858d45f5fbafbb71f1a08a7c7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b18d687964670bff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "simpleIssueCard_versionIssueAssociatedDesigns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "idsOrAliases",
                        "value": [
                            "issuetype",
                            "summary"
                        ]
                    },
                    {
                        "kind": "Literal",
                        "name": "ignoreMissingFields",
                        "value": true
                    }
                ],
                "kind": "LinkedField",
                "name": "fieldsByIdOrAlias",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsByIdOrAlias.issueType.name"
                                        },
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.issueType"
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.text"
                            }
                        ],
                        "type": "JiraSingleLineTextField"
                    }
                ],
                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
            },
            "action": "THROW",
            "path": "fieldsByIdOrAlias"
        }
    ],
    "type": "JiraIssue"
};
$b18d687964670bff$var$node.hash = "293ef6f7a36c1d615e6dc27559c1d40e";
var $b18d687964670bff$export$2e2bcd8739ae039 = $b18d687964670bff$var$node;

});

parcelRegister("hYpYi", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});


parcelRegister("1UJw7", function(module, exports) {

$parcel$export(module.exports, "IssueModalLoading", () => $89bb9fdb76c333e6$export$30d178fad6e7652a);
$parcel$export(module.exports, "IssuesModal", () => $89bb9fdb76c333e6$export$62000b4a046396b3);

var $gsOUv = parcelRequire("gsOUv");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $6nIG2 = parcelRequire("6nIG2");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $boSVF = parcelRequire("boSVF");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");


var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gVasy = parcelRequire("gVasy");

var $4lfxq = parcelRequire("4lfxq");
const $89bb9fdb76c333e6$export$30d178fad6e7652a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $89bb9fdb76c333e6$var$modalBodyLoadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }))));
const $89bb9fdb76c333e6$export$62000b4a046396b3 = ({ queryRef: queryRef, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const data = (0, $iWLL0.usePreloadedQuery)((0, $gsOUv.default), queryRef);
    const designEntity = data.devOps.designEntityDetails[0]; // This shouldn't happen much in real world, but can happen when the target design is deleted while the user is looking at the page.
    (0, $eUqFw.useEffect)(()=>{
        if (designEntity == null) showFlag({
            type: 'error',
            title: formatMessage((0, $4lfxq.default).errorFlagTitle),
            description: formatMessage((0, $4lfxq.default).errorFlagDescription)
        });
    }, [
        designEntity,
        formatMessage,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Why? suggested here: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3021481389/Modal+Dialog+Focus#General-Focus
        setTimeout(()=>{
            const modalElement = document.querySelector("[role='dialog']");
            modalElement?.focus();
        }, 50);
    }, []);
    if (designEntity == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: ()=>onClose(),
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150",
        xcss: $89bb9fdb76c333e6$var$modalTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: designEntity?.provider.logoUrl,
        alt: "",
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul97vkz _2hwxu2gc"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: designEntity?.url,
        target: "_blank",
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48pni7l _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, designEntity?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
        ])
    }, formatMessage((0, $4lfxq.default).linkedTo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $89bb9fdb76c333e6$var$multipleIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
        primaryColor: `var(--ds-icon-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        size: "small",
        label: ""
    }), formatMessage((0, $4lfxq.default).manyIssues))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVasy.IssuesModalBody), {
        devOpsDesign: designEntity
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: ()=>onClose()
    }, formatMessage((0, $4lfxq.default).modalCloseButtonLabel))));
};
const $89bb9fdb76c333e6$var$modalIconStyles = null;
const $89bb9fdb76c333e6$var$titleStyles = null;
const $89bb9fdb76c333e6$var$modalTitleStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $89bb9fdb76c333e6$var$modalBodyLoadingStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    height: '300px'
});
const $89bb9fdb76c333e6$var$linkedToStyles = null;
const $89bb9fdb76c333e6$var$multipleIssuesStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '14px'
});

});
parcelRegister("gVasy", function(module, exports) {

$parcel$export(module.exports, "IssuesModalBody", () => $2bcdc0d61479efd9$export$fed5c8d395452c20);

var $90H6H = parcelRequire("90H6H");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $l3ddt = parcelRequire("l3ddt");

var $6rVVb = parcelRequire("6rVVb");

var $6GHn7 = parcelRequire("6GHn7");
const $2bcdc0d61479efd9$export$fed5c8d395452c20 = ({ devOpsDesign: devOpsDesign })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const designEntity = (0, $iWLL0.useFragment)((0, $90H6H.default), devOpsDesign);
    const associatedIssuesNodes = (designEntity?.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
    const issuesAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>node.hasRelationshipToVersion);
    const issuesNotAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>!node.hasRelationshipToVersion);
    (0, $6GHn7.useFireManyIssueTrackingAnalaytics)(associatedIssuesNodes.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "versionDesignAssociatedIssues",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            issuesAssociatedTotalCount: associatedIssuesNodes.length,
            issuesAssociatedToVersionCount: issuesAssociatedToThisVersion.length,
            issuesNotAssociatedToVersionCount: issuesAssociatedToThisVersion.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.300",
        xcss: $2bcdc0d61479efd9$var$modalBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, issuesAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $2bcdc0d61479efd9$var$subTitleStyles
    }, formatMessage((0, $6rVVb.default).issuesInVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $2bcdc0d61479efd9$var$issueCountStyles
    }, "\xa0 (", issuesAssociatedToThisVersion.length, ")"))), issuesAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3ddt.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, issuesNotAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $2bcdc0d61479efd9$var$subTitleStyles
    }, formatMessage((0, $6rVVb.default).otherIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $2bcdc0d61479efd9$var$issueCountStyles
    }, "\xa0 (", issuesNotAssociatedToThisVersion.length, ")"))), issuesNotAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3ddt.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $2bcdc0d61479efd9$var$modalBodyStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
const $2bcdc0d61479efd9$var$subTitleStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $2bcdc0d61479efd9$var$issueCountStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    fontWeight: 400
});

});
parcelRegister("90H6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $2778082e11a3ec19$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e261db26d1d024b6da239237bbfbcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2778082e11a3ec19$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "versionId"
        }
    ],
    "kind": "Fragment",
    "name": "body_versionIssueAssociatedDesigns_IssuesModalBody",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                }
            ],
            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
            "kind": "LinkedField",
            "name": "associatedIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            "action": "THROW",
                                            "path": "associatedIssues.edges.node.key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "versionId",
                                                    "variableName": "versionId"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "hasRelationshipToVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                        }
                                    ],
                                    "type": "JiraIssue"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "associatedIssues(first:100)"
        }
    ],
    "type": "DevOpsDesign"
};
$2778082e11a3ec19$var$node.hash = "145e33a9a0a82742e3ace6aa6c154644";
var $2778082e11a3ec19$export$2e2bcd8739ae039 = $2778082e11a3ec19$var$node;

});

parcelRegister("6rVVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d509cfbbaa06c71$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d509cfbbaa06c71$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuesInVersion: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.issues-in-version",
        "defaultMessage": "Current version"
    },
    otherIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.other-issues",
        "defaultMessage": "Other"
    }
});

});

parcelRegister("6GHn7", function(module, exports) {

$parcel$export(module.exports, "useFireManyIssueTrackingAnalaytics", () => $303938fb4815f9b9$export$3ca4c107f1eff13e);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $303938fb4815f9b9$export$3ca4c107f1eff13e = (numIssues)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (numIssues > 100) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'designAssociatedIssues exceeded', {
            numIssues: numIssues
        });
    }, [
        createAnalyticsEvent,
        numIssues
    ]);
};

});


parcelRegister("4lfxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e097458a1a9184d9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e097458a1a9184d9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalCloseButtonLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.modal-close-button-label",
        "defaultMessage": "Close"
    },
    errorFlagTitle: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-description",
        "defaultMessage": "Please refresh the page."
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.linked-to",
        "defaultMessage": "Linked to"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues",
        "defaultMessage": "Multiple issues"
    }
});

});


parcelRegister("7uaeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e88d7f0132d5a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $18e88d7f0132d5a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openPreview: {
        "id": "version-issue-associated-designs.design-carousel.design-card.open-preview",
        "defaultMessage": "Open preview"
    },
    seeAll: {
        "id": "version-issue-associated-designs.design-carousel.design-card.see-all",
        "defaultMessage": "See all"
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.linked-to",
        "defaultMessage": "Linked to"
    },
    issueIconLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label",
        "defaultMessage": "Issue icon"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.many-issues",
        "defaultMessage": "Multiple issues"
    }
});

});

parcelRegister("3zgLD", function(module, exports) {

$parcel$export(module.exports, "formatRelativeDate", () => $a83ef95b481d7b7c$export$10da3a44394af1a6);

var $gfGP4 = parcelRequire("gfGP4");
var $EN9B6 = parcelRequire("EN9B6");
var $jtnES = parcelRequire("jtnES");
const $a83ef95b481d7b7c$var$SECONDS_IN_A_DAY = 86400;
const $a83ef95b481d7b7c$export$10da3a44394af1a6 = (lastUpdatedDate)=>{
    const currentDate = new Date();
    const isDateFormatRelative = (0, $gfGP4.default)(currentDate, lastUpdatedDate) <= $a83ef95b481d7b7c$var$SECONDS_IN_A_DAY;
    return isDateFormatRelative ? (0, $jtnES.default)(lastUpdatedDate, currentDate, {
        addSuffix: true,
        roundingMethod: 'floor'
    }) : (0, $EN9B6.default)(lastUpdatedDate, 'd MMM, HH:mm');
};

});


parcelRegister("98X92", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5a310373e9bc15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d5a310373e9bc15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    carouselPageCount: {
        "id": "version-issue-associated-designs.design-carousel.carousel-page-count",
        "defaultMessage": "{currentStart}-{currentEnd} of {totalCount}"
    }
});

});


parcelRegister("5T027", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $0e166a8f101ba1f3$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $beG97 = parcelRequire("beG97");

var $70xN8 = parcelRequire("70xN8");
const $0e166a8f101ba1f3$export$fddf379e22a74b00 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e166a8f101ba1f3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($beG97))),
        width: 80,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $70xN8.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e166a8f101ba1f3$var$Description, null, formatMessage((0, $70xN8.default).desciption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
        target: "_blank"
    }, formatMessage((0, $70xN8.default).learnMoreLabel))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e166a8f101ba1f3$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _1yt41ejb _2rkoftgi _19itzqnv",
            __cmplp.className
        ])
    });
});
const $0e166a8f101ba1f3$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("beG97", function(module, exports) {
module.exports = new URL("empty-icon.ef7b6c4a.svg", import.meta.url).toString();

});

parcelRegister("70xN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $793b270d61d99210$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $793b270d61d99210$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "version-issue-associated-designs.empty-state.title",
        "defaultMessage": "You\u2019ll see your linked designs here"
    },
    desciption: {
        "id": "version-issue-associated-designs.empty-state.desciption",
        "defaultMessage": "Get live updates and greater visibility of your team\u2019s design work."
    },
    learnMoreLabel: {
        "id": "version-issue-associated-designs.empty-state.learn-more-label",
        "defaultMessage": "Read more about linking designs to Jira issues"
    }
});

});


parcelRegister("7iK5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c563a8fae74da474$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c563a8fae74da474$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    designSectionLabel: {
        "id": "version-issue-associated-designs.design-section-label",
        "defaultMessage": "Designs"
    }
});

});


parcelRegister("eb8av", function(module, exports) {

$parcel$export(module.exports, "VersionProgress", () => $f0424b420f3ad760$export$f9ad2300f8258368);

var $imMog = parcelRequire("imMog");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $yyqSx = parcelRequire("yyqSx");

var $5Knhe = parcelRequire("5Knhe");

var $9O2N1 = parcelRequire("9O2N1");

var $01thm = parcelRequire("01thm");

var $99Lgc = parcelRequire("99Lgc");

var $eAGYL = parcelRequire("eAGYL");

var $cPHa4 = parcelRequire("cPHa4");

var $lecH2 = parcelRequire("lecH2");
const $f0424b420f3ad760$export$f9ad2300f8258368 = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $iWLL0.useFragment)((0, $imMog.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const edges = version.relatedWorkV2 ? version.relatedWorkV2.edges.filter(Boolean) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0424b420f3ad760$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0424b420f3ad760$var$MainHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage((0, $eAGYL.messages).progressHeading))), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPHa4.RelatedWorkHeading), {
        relatedWorkEdges: edges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lecH2.RelatedWorkProgressBar), {
        relatedWorkEdges: edges
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleSection), {
        jiraVersion: version,
        uiType: "PROGRESS_CARD",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99Lgc.IssuesHeading), {
                jiraVersion: version,
                isCollapsed: isCollapsed,
                onToggleClicked: onToggleClicked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9O2N1.IssuesProgressBar), {
                jiraVersion: version
            })),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01thm.IssueProgressDetails), {
                jiraVersion: version
            })
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0424b420f3ad760$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4q6zc _1e0c1txw _2lx21bp4 _zulppxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0424b420f3ad760$var$MainHeading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4wo40",
            __cmplp.className
        ])
    });
});

});
parcelRegister("imMog", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e331c88c1333c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a07bf9ea4bd202e1b85a34f170936052>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01e331c88c1333c0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "relatedWorkV2"
                ]
            }
        ]
    },
    "name": "ui_versionProgress_VersionProgress",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "relatedWorkV2",
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "__version_relatedWorkV2_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkHeading_versionProgress"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkProgressBar_versionProgress"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "relatedWorkV2.edges"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "relatedWorkV2"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesHeading_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressBar_versionProgress_IssuesProgressBar"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressDetails_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        }
    ],
    "type": "JiraVersion"
};
$01e331c88c1333c0$var$node.hash = "adad2bb30e02991a2dcfd9cb2046e4c9";
var $01e331c88c1333c0$export$2e2bcd8739ae039 = $01e331c88c1333c0$var$node;

});

parcelRegister("9O2N1", function(module, exports) {

$parcel$export(module.exports, "IssuesProgressBar", () => $0266fac3467b3fb3$export$80217ccba75d7c95);

var $23ihj = parcelRequire("23ihj");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9TlRa = parcelRequire("9TlRa");

var $i1tv1 = parcelRequire("i1tv1");

var $dbhzd = parcelRequire("dbhzd");

var $htAqx = parcelRequire("htAqx");
const $0266fac3467b3fb3$export$80217ccba75d7c95 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues } = (0, $9TlRa.useFilterSortingQueryParams)();
    const version = (0, $iWLL0.useFragment)((0, $23ihj.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    const createStatusClickHandler = (category)=>()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $8Qd0L.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    if (totalIssueCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isClickable: true,
        isLast: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.TODO_COLOR),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarContainer), null, doneIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        onClick: createStatusClickHandler((0, $8Qd0L.DONE)),
        totalCount: totalIssueCount,
        portionCount: doneIssueCount,
        isClickable: true,
        isLast: totalIssueCount === doneIssueCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: formatMessage((0, $htAqx.default).doneIssuesTooltipText, {
            completedIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.DONE_COLOR),
        isFirst: true,
        isLast: totalIssueCount === doneIssueCount
    }))), inProgressIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        totalCount: totalIssueCount,
        portionCount: inProgressIssueCount,
        onClick: createStatusClickHandler((0, $8Qd0L.IN_PROGRESS)),
        isClickable: true,
        isLast: todoIssueCount === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: formatMessage((0, $htAqx.default).inProgressIssuesTooltipText, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.IN_PROGRESS_COLOR),
        isFirst: doneIssueCount === 0,
        isLast: todoIssueCount === 0
    }))), todoIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalIssueCount,
        portionCount: todoIssueCount,
        onClick: createStatusClickHandler((0, $8Qd0L.TODO)),
        isClickable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: formatMessage((0, $htAqx.default).todoIssuesTooltipText, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.TODO_COLOR),
        isFirst: totalIssueCount === todoIssueCount,
        isLast: true
    })))));
};

});
parcelRegister("23ihj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3748dcb5a6ea1dd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<022ae572fe079cb167c3d37f775431c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3748dcb5a6ea1dd3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressBar_versionProgress_IssuesProgressBar",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$3748dcb5a6ea1dd3$var$node.hash = "9d79a458e2fb5db8bb37fec8334b2eed";
var $3748dcb5a6ea1dd3$export$2e2bcd8739ae039 = $3748dcb5a6ea1dd3$var$node;

});

parcelRegister("i1tv1", function(module, exports) {

$parcel$export(module.exports, "TODO_COLOR", () => $62f9dfa93a3697cc$export$9a2ce699a8e88c00);
$parcel$export(module.exports, "IN_PROGRESS_COLOR", () => $62f9dfa93a3697cc$export$dc4e31a90347554e);
$parcel$export(module.exports, "DONE_COLOR", () => $62f9dfa93a3697cc$export$f2a648c26a91297f);
$parcel$export(module.exports, "WARNING_COLOR", () => $62f9dfa93a3697cc$export$2d5e5bd76a1e6a66);

const $62f9dfa93a3697cc$export$9a2ce699a8e88c00 = `var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40A})`;
const $62f9dfa93a3697cc$export$dc4e31a90347554e = `var(--ds-border-information, ${(0, $73a5c9d720aa66e1$exports).B200})`;
const $62f9dfa93a3697cc$export$f2a648c26a91297f = `var(--ds-border-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $62f9dfa93a3697cc$export$2d5e5bd76a1e6a66 = `var(--ds-background-warning-bold-hovered, ${(0, $73a5c9d720aa66e1$exports).Y300})`;

});

parcelRegister("dbhzd", function(module, exports) {

$parcel$export(module.exports, "Section", () => $0e12d73d06708084$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "Summary", () => $0e12d73d06708084$export$46453a0401d6cd1a);
$parcel$export(module.exports, "Container", () => $0e12d73d06708084$export$42a852a2b6b56249);
$parcel$export(module.exports, "ProgressBarContainer", () => $0e12d73d06708084$export$91fd6e064cf0bcf3);
$parcel$export(module.exports, "ProgressBarElementContainer", () => $0e12d73d06708084$export$9148ffcd7ea9778);
$parcel$export(module.exports, "Bar", () => $0e12d73d06708084$export$bbc6c6369b38e3d1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $0e12d73d06708084$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsible: isCollapsible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.isCollapsible ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $0e12d73d06708084$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rc1",
            __cmplp.className
        ])
    });
});
const $0e12d73d06708084$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _1yt4wo40",
            __cmplp.className
        ])
    });
});
const $0e12d73d06708084$export$91fd6e064cf0bcf3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91tcg _2hwxv77o _1e0c1txw _4cvr1fhb _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $0e12d73d06708084$export$9148ffcd7ea9778 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLast: isLast, totalCount: totalCount, portionCount: portionCount, isClickable: isClickable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1wknkfl": (0, $9t7rW.default)(__cmplp.portionCount / __cmplp.totalCount * 100)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91ejb _1e0c1txw _2lx21bp4 _4cvr1fhb _7cca15wb _11q7glyw _syaz1kw7 _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _qe84exuw _x2qs15x0",
            __cmplp.isLast ? "_2hwxze3t" : "_2hwxv77o",
            __cmplp.totalCount === 0 ? "_16jlkb7n" : "_16jl1hqj",
            __cmplp.isClickable ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $0e12d73d06708084$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirst: isFirst, isLast: isLast, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color),
            "--_198gxfk": (0, $9t7rW.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                if (__cmplp.isFirst && __cmplp.isLast) return `${0, $c9TLT.gridSize}px`;
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                if (__cmplp.isFirst) return `${0, $c9TLT.gridSize}px 0 0 ${0, $c9TLT.gridSize}px`;
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                if (__cmplp.isLast) return `0 ${0, $c9TLT.gridSize}px ${0, $c9TLT.gridSize}px 0`;
                return 0;
            })())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iftgi _bfhk1cj8 _2rkocu40",
            __cmplp.className
        ])
    });
});

});

parcelRegister("htAqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87cfea27cb92f6b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d87cfea27cb92f6b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inProgressIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    doneIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.done-issues-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    todoIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("01thm", function(module, exports) {

$parcel$export(module.exports, "IssueProgressDetails", () => $8fe37ae1b1409d7f$export$d0720399ba8e473e);

var $2fmWx = parcelRequire("2fmWx");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iWLL0 = parcelRequire("iWLL0");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9TlRa = parcelRequire("9TlRa");

var $i1tv1 = parcelRequire("i1tv1");

var $2m5CQ = parcelRequire("2m5CQ");
const $8fe37ae1b1409d7f$export$d0720399ba8e473e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues, showIssuesWithWarnings: showIssuesWithWarnings } = (0, $9TlRa.useFilterSortingQueryParams)();
    const version = (0, $iWLL0.useFragment)((0, $2fmWx.default), jiraVersion);
    const { doneIssuesRedesignTemp: doneIssues, inProgressIssuesRedesignTemp: inProgressIssues, todoIssuesRedesignTemp: todoIssues } = version;
    const { warningConfig: warningConfig } = version;
    const enabledWarningCategories = [];
    if (warningConfig?.failingBuild === 'ENABLED') enabledWarningCategories.push('FAILING_BUILD');
    if (warningConfig?.openPullRequest === 'ENABLED') enabledWarningCategories.push('OPEN_PULL_REQUEST');
    if (warningConfig?.openReview === 'ENABLED') enabledWarningCategories.push('OPEN_REVIEW');
    if (warningConfig?.unreviewedCode === 'ENABLED') enabledWarningCategories.push('UNREVIEWED_CODE');
    const messageFormatter = {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$StatusCategoryName, null, chunks),
        s: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$IssueCount, null, chunks)
    };
    const createStatusClickHandler = (category)=>()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressDetailsShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $8Qd0L.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$Row, {
        onClick: createStatusClickHandler((0, $8Qd0L.DONE))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$StatusCategoryColorIndicator, {
        color: (0, $i1tv1.DONE_COLOR)
    }), formatMessage((0, $2m5CQ.messages).doneIssues, {
        ...messageFormatter,
        count: doneIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$Row, {
        onClick: createStatusClickHandler((0, $8Qd0L.IN_PROGRESS))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$StatusCategoryColorIndicator, {
        color: (0, $i1tv1.IN_PROGRESS_COLOR)
    }), formatMessage((0, $2m5CQ.messages).inProgressIssues, {
        ...messageFormatter,
        count: inProgressIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$Row, {
        onClick: createStatusClickHandler((0, $8Qd0L.TODO))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$StatusCategoryColorIndicator, {
        color: (0, $i1tv1.TODO_COLOR)
    }), formatMessage((0, $2m5CQ.messages).toDoIssues, {
        ...messageFormatter,
        count: todoIssues.totalCount
    })), enabledWarningCategories.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$Row // Warning: this test ID is used by a Pollintor check
    , {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "software-releases-version-detail-issue-list.ui.warning-filter-button",
        onClick: ()=>{
            showIssuesWithWarnings(enabledWarningCategories);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: 'warnings'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fe37ae1b1409d7f$var$StatusCategoryColorIndicator, {
        color: (0, $i1tv1.WARNING_COLOR)
    }), formatMessage((0, $2m5CQ.messages).warningIssues, {
        ...messageFormatter,
        count: version.warningsCount
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe37ae1b1409d7f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe37ae1b1409d7f$var$StatusCategoryColorIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb19bv _4t3i19bv _bfhk1cj8 _2rko19bv _2hwxv47k _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe37ae1b1409d7f$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke _2rko1l7b _1yt4u2gc _irr34mfv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe37ae1b1409d7f$var$StatusCategoryName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _o572qvpr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe37ae1b1409d7f$var$IssueCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2fmWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b17db47bd101b75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4824f62437604ac53e42b2828a4d1182>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b17db47bd101b75$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressDetails_versionProgress",
        "selections": [
            {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "warningsCount"
                },
                "action": "THROW",
                "path": "warningsCount"
            }
        ],
        "type": "JiraVersion"
    };
}();
$7b17db47bd101b75$var$node.hash = "d8f802ed4e1d73fb8f14bafb9265439b";
var $7b17db47bd101b75$export$2e2bcd8739ae039 = $7b17db47bd101b75$var$node;

});

parcelRegister("2m5CQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce0d0700d6686aba$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ce0d0700d6686aba$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    doneIssues: {
        "id": "version-progress.issue-progress-details.done-issues",
        "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    inProgressIssues: {
        "id": "version-progress.issue-progress-details.in-progress-issues",
        "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    toDoIssues: {
        "id": "version-progress.issue-progress-details.to-do-issues",
        "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    warningIssues: {
        "id": "version-progress.issue-progress-details.warning-issues",
        "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    }
});

});


parcelRegister("99Lgc", function(module, exports) {

$parcel$export(module.exports, "IssuesHeading", () => $f5fa0055f0373d26$export$d7aca75aff5e9fe3);

var $XEtCs = parcelRequire("XEtCs");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5Knhe = parcelRequire("5Knhe");

var $dbhzd = parcelRequire("dbhzd");

var $mqfI9 = parcelRequire("mqfI9");
const $f5fa0055f0373d26$export$d7aca75aff5e9fe3 = ({ jiraVersion: jiraVersion, isCollapsed: isCollapsed, onToggleClicked: onToggleClicked })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $XEtCs.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Section), {
        onClick: onToggleClicked,
        isCollapsible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h4"
    }, formatMessage((0, $mqfI9.default).issuesHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Summary), null, totalIssueCount === 0 ? formatMessage((0, $mqfI9.default).noIssues) : formatMessage((0, $mqfI9.default).doneIssues, {
        doneCount: doneIssueCount,
        totalCount: totalIssueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Knhe.CollapsibleToggleButton), {
        isCollapsed: isCollapsed
    })));
};

});
parcelRegister("XEtCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8cb0f6715e425b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a2e4b89a893c947458d602dad1156f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8cb0f6715e425b8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issuesHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$e8cb0f6715e425b8$var$node.hash = "1894f7adb956d41d80dd7d309152870c";
var $e8cb0f6715e425b8$export$2e2bcd8739ae039 = $e8cb0f6715e425b8$var$node;

});

parcelRegister("mqfI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $622124a11a2348ad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $622124a11a2348ad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuesHeading: {
        "id": "version-progress.issues-heading.issues-heading",
        "defaultMessage": "Issues"
    },
    doneIssues: {
        "id": "version-progress.issues-heading.done-issues",
        "defaultMessage": "{doneCount} of {totalCount} {totalCount, plural, one {done} other {done}}"
    },
    noIssues: {
        "id": "version-progress.issues-heading.no-issues",
        "defaultMessage": "No issues added"
    }
});

});


parcelRegister("eAGYL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $50e8e99f784bc9b1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $50e8e99f784bc9b1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    progressHeading: {
        "id": "version-progress.progress-heading",
        "defaultMessage": "Progress"
    }
});

});

parcelRegister("cPHa4", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkHeading", () => $0584c576953609c8$export$7705e89d52d14851);

var $3iVdB = parcelRequire("3iVdB");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dbhzd = parcelRequire("dbhzd");

var $hPrww = parcelRequire("hPrww");
const $0584c576953609c8$export$7705e89d52d14851 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const edges = (0, $iWLL0.useFragment)((0, $3iVdB.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Section), {
        isCollapsible: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h4"
    }, formatMessage((0, $hPrww.default).relatedWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Summary), null, totalCount === 0 ? formatMessage((0, $hPrww.default).noItems) : formatMessage((0, $hPrww.default).summaryText, {
        numNonPlaceholders: numNonPlaceholders,
        totalCount: totalCount
    })));
};

});
parcelRegister("3iVdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d301bc44b0499f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da12abafadbeeeb286bba016228ab38c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24d301bc44b0499f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$24d301bc44b0499f$var$node.hash = "211a6665d1a1915d987787889e12cca6";
var $24d301bc44b0499f$export$2e2bcd8739ae039 = $24d301bc44b0499f$var$node;

});

parcelRegister("hPrww", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecc3a14174983be$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ecc3a14174983be$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    relatedWorkHeading: {
        "id": "version-progress.related-work-heading.related-work-heading",
        "defaultMessage": "Related work"
    },
    summaryText: {
        "id": "version-progress.related-work-heading.summary-text",
        "defaultMessage": "{numNonPlaceholders} of {totalCount} added"
    },
    noItems: {
        "id": "version-progress.related-work-heading.no-items",
        "defaultMessage": "None added"
    }
});

});


parcelRegister("lecH2", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkProgressBar", () => $1329d50413948f61$export$34d7439de9413789);

var $8U47m = parcelRequire("8U47m");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $i1tv1 = parcelRequire("i1tv1");

var $dbhzd = parcelRequire("dbhzd");

var $iw48e = parcelRequire("iw48e");
const $1329d50413948f61$export$34d7439de9413789 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const edges = (0, $iWLL0.useFragment)((0, $8U47m.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    const numPlaceholders = totalCount - numNonPlaceholders;
    const fireAnalyticsEvent = (analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'relatedWorkProgressTooltip', {
            numOfItems: totalCount,
            numPlaceholders: numPlaceholders,
            numNonPlaceholders: numNonPlaceholders
        });
    };
    if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isLast: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.TODO_COLOR),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarContainer), null, numNonPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        totalCount: totalCount,
        portionCount: numNonPlaceholders
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: formatMessage((0, $iw48e.default).nonPlaceholdersSegmentTooltipText, {
            numNonPlaceholders: numNonPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.DONE_COLOR),
        isFirst: true,
        isLast: numPlaceholders === 0
    }))), numPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalCount,
        portionCount: numPlaceholders
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: formatMessage((0, $iw48e.default).placeholdersSegmentTooltipText, {
            numPlaceholders: numPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbhzd.Bar), {
        color: (0, $i1tv1.TODO_COLOR),
        isFirst: numNonPlaceholders === 0,
        isLast: true
    })))));
};

});
parcelRegister("8U47m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e05604bd4774604$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391fa37bd82e7c8c0612c5be399d9087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e05604bd4774604$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkProgressBar_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$3e05604bd4774604$var$node.hash = "c40509aabe2c6731ba0d792fff68b169";
var $3e05604bd4774604$export$2e2bcd8739ae039 = $3e05604bd4774604$var$node;

});

parcelRegister("iw48e", function(module, exports) {

$parcel$export(module.exports, "default", () => $46483a4b6a254be3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $46483a4b6a254be3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nonPlaceholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text",
        "defaultMessage": "{numNonPlaceholders} added"
    },
    placeholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.placeholders-segment-tooltip-text",
        "defaultMessage": "{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}"
    }
});

});



parcelRegister("hUb8I", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $8324eb18357f5076$export$1625b7ea4c7a5a23);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $8324eb18357f5076$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesVersionDetail",
        teamName: "fusion-solaris",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("czzq4", function(module, exports) {

$parcel$export(module.exports, "convertTabToQueryVariables", () => $5f0a2958f1bbdbde$export$4fc138bc768eeef1);
const $5f0a2958f1bbdbde$export$4fc138bc768eeef1 = (tab)=>{
    switch(tab){
        case 'release-report-warnings':
            return {
                filter: 'OPEN_PULL_REQUEST',
                isShowWarnings: true
            };
        case 'release-report-all-issues':
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
        case 'release-report-done':
            return {
                filter: 'DONE',
                isShowWarnings: false
            };
        case 'release-report-in-progress':
            return {
                filter: 'IN_PROGRESS',
                isShowWarnings: false
            };
        case 'release-report-todo':
            return {
                filter: 'TODO',
                isShowWarnings: false
            };
        default:
            // default to all issues column
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
    }
};

});

parcelRegister("h3FKF", function(module, exports) {

$parcel$export(module.exports, "useCurrentTab", () => $083ed91a742d0b15$export$49b7d3cc5222d699);

var $lB25E = parcelRequire("lB25E");

const $083ed91a742d0b15$var$toVersionTabId = (selectedTabId)=>{
    if (selectedTabId === undefined) return 0, $08f2fea3f74020e8$export$88979a530e0a9348;
    switch(selectedTabId){
        case 0, $08f2fea3f74020e8$export$53105de2008705e2:
            return 0, $08f2fea3f74020e8$export$53105de2008705e2;
        case 0, $08f2fea3f74020e8$export$88979a530e0a9348:
            return 0, $08f2fea3f74020e8$export$88979a530e0a9348;
        case 0, $08f2fea3f74020e8$export$d669607531cb7a9a:
            return 0, $08f2fea3f74020e8$export$d669607531cb7a9a;
        case 0, $08f2fea3f74020e8$export$d9e751b9469f77b3:
            return 0, $08f2fea3f74020e8$export$d9e751b9469f77b3;
        case 0, $08f2fea3f74020e8$export$5e552e58a93a50a5:
            return 0, $08f2fea3f74020e8$export$5e552e58a93a50a5;
        default:
            return 0, $08f2fea3f74020e8$export$88979a530e0a9348;
    }
};
const $083ed91a742d0b15$export$49b7d3cc5222d699 = ()=>{
    const [selectedTabId, setSelectedTab] = (0, $lB25E.usePathParam)('tab');
    const setCurrentTab = (tabId)=>{
        setSelectedTab(tabId);
    };
    return {
        currentTabId: $083ed91a742d0b15$var$toVersionTabId(selectedTabId),
        setCurrentTab: setCurrentTab
    };
};

});
const $08f2fea3f74020e8$export$53105de2008705e2 = 'release-report-warnings';
const $08f2fea3f74020e8$export$88979a530e0a9348 = 'release-report-all-issues';
const $08f2fea3f74020e8$export$d669607531cb7a9a = 'release-report-done';
const $08f2fea3f74020e8$export$d9e751b9469f77b3 = 'release-report-in-progress';
const $08f2fea3f74020e8$export$5e552e58a93a50a5 = 'release-report-todo';


parcelRegister("aFKQh", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracker", () => $46ed3f344b57110d$export$57a2c9a4973f6a35);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");

var $7vf5z = parcelRequire("7vf5z");

var $hUb8I = parcelRequire("hUb8I");
const $46ed3f344b57110d$var$versionDetailsPagePageLoad = (0, $lNfG4.metrics).pageLoad({
    key: 'software.version-details-page',
    ssr: {
        doneAsFmp: true
    },
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $46ed3f344b57110d$export$57a2c9a4973f6a35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "performanceTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "jira-software-version-details-page",
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: $46ed3f344b57110d$var$versionDetailsPagePageLoad
    }));

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("gOcNK", function(module, exports) {

$parcel$export(module.exports, "AccessCheck", () => $6372d5a25c0d3dab$export$ad057184bf4c4ff2);

var $4Nrv4 = parcelRequire("4Nrv4");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $8g5hT = parcelRequire("8g5hT");

var $lB25E = parcelRequire("lB25E");
const $6372d5a25c0d3dab$var$getVersionIssuesUrl = (versionName, projectKey)=>{
    const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND fixVersion = ${(0, $8g5hT.toQuotedString)(versionName)}`;
    return (0, $8g5hT.createIssuesUrl)(jql);
};
const $6372d5a25c0d3dab$export$ad057184bf4c4ff2 = ({ jiraVersion: jiraVersion, children: children })=>{
    const version = (0, $iWLL0.useFragment)((0, $4Nrv4.default), jiraVersion);
    if (version != null && !version.canViewVersionDetailsPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: $6372d5a25c0d3dab$var$getVersionIssuesUrl(version.name, version.project.key)
    });
    return children;
};

});
parcelRegister("4Nrv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2ac9ef61c0f068$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4a1d76106d11af339bfdb2ce2d272cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e2ac9ef61c0f068$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "accessCheck_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "NONE",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "NONE",
                        "path": "project.key"
                    }
                ]
            },
            "action": "NONE",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canViewVersionDetailsPage"
            },
            "action": "NONE",
            "path": "canViewVersionDetailsPage"
        }
    ],
    "type": "JiraVersion"
};
$6e2ac9ef61c0f068$var$node.hash = "9b2c4488974a4d13577b85807b03079a";
var $6e2ac9ef61c0f068$export$2e2bcd8739ae039 = $6e2ac9ef61c0f068$var$node;

});


parcelRegister("6nw99", function(module, exports) {

$parcel$export(module.exports, "Header", () => $51a732ec4836e272$export$8b251419efc915eb);

var $lfRks = parcelRequire("lfRks");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $bLFgh = parcelRequire("bLFgh");

var $dxopF = parcelRequire("dxopF");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $4qhD6 = parcelRequire("4qhD6");

var $g9zol = parcelRequire("g9zol");

var $yyqSx = parcelRequire("yyqSx");

var $7raLN = parcelRequire("7raLN");

var $4rHC4 = parcelRequire("4rHC4");

var $hUb8I = parcelRequire("hUb8I");

var $bQgr5 = parcelRequire("bQgr5");


var $98a56 = parcelRequire("98a56");

var $18w1f = parcelRequire("18w1f");

var $6Zjuq = parcelRequire("6Zjuq");
const $51a732ec4836e272$export$8b251419efc915eb = ({ jiraVersion: jiraVersion })=>{
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null);
    const onConnectAppExpFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $0bd71b9aecd1853d$export$af5e668651a80140)
    });
    const [warningsModalOpen, setWarningsModalOpen] = (0, $eUqFw.useState)(false);
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const version = (0, $iWLL0.useFragment)((0, $lfRks.default), jiraVersion);
    const issues = version.allIssues.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        breadcrumbs: breadcrumbs,
        truncateTitle: true,
        disableTitleStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$HeaderTitleLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$LeftContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$HeaderTitle, {
        "data-testid": "software-releases-version-detail.ui.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$PageTitleContainer, {
        isOverflowEnabled: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98a56.AsyncEditableName), {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$RightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9zol.default), {
        from: version.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "feedbackButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18w1f.FeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "releaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7raLN.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, warningsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "warningConfigModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4rHC4.ManageWarningsModal), {
        jiraVersion: version,
        setModalClosed: ()=>{
            setWarningsModalOpen(false);
        }
    }))), !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && issues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zjuq.ReleaseNotesButton), {
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "headerConnectApps",
        onError: onConnectAppExpFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51a732ec4836e272$var$MarketPlaceAddonLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQgr5.ConnectApps), {
        jiraVersion: version
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$HeaderTitleLane = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1p57pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$LeftContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _18u0x0bf _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$RightContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1e0c1txw _1bahesu3 _1ul91mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$MarketPlaceAddonLane = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvresu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$HeaderTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf _4t3ior1b",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a732ec4836e272$var$PageTitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverflowEnabled: isOverflowEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkx0bf _1ul9idpf",
            __cmplp.isOverflowEnabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lfRks", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e77ebd7eea4b1ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edd2d889f15c331ccb875f58c8834595>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e77ebd7eea4b1ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "header_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssues.totalCount"
                    }
                ],
                "storageKey": "issues(filter:\"ALL\")"
            },
            "action": "THROW",
            "path": "allIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetail_AsyncEditableName"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal"
        },
        {
            "kind": "FragmentSpread",
            "name": "connectApps_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "releaseNotesButton_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$1e77ebd7eea4b1ac$var$node.hash = "f18c07820c274d0155b6bcd5afb8be06";
var $1e77ebd7eea4b1ac$export$2e2bcd8739ae039 = $1e77ebd7eea4b1ac$var$node;

});

parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("g9zol", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0e43edf6bdb42d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $yyqSx = parcelRequire("yyqSx");

var $gd0Sp = parcelRequire("gd0Sp");


var $9OYB0 = parcelRequire("9OYB0");

var $jmsjD = parcelRequire("jmsjD");
function $0a0e43edf6bdb42d$var$Graph({ from: from }) {
    const { environment: environment } = (0, $gd0Sp.useTenantContext)();
    const graphURL = `${environment === 'staging' ? (0, $8df28cd2923155d9$export$b1c73a3711ffd2e1) : (0, $8df28cd2923155d9$export$b105bca7736ab247)}?ari=${from}`;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: graphURL,
        "aria-label": formatMessage((0, $jmsjD.default).graphButtonLabelNonFinal),
        target: "_blank",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9OYB0.GraphIcon), null)
    });
}
var $0a0e43edf6bdb42d$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>!(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $1ybV0.ff)('otc.show-me-the-graph'), $0a0e43edf6bdb42d$var$Graph, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
()=>null);

});
const $8df28cd2923155d9$export$b105bca7736ab247 = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
const $8df28cd2923155d9$export$b1c73a3711ffd2e1 = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';

parcelRegister("9OYB0", function(module, exports) {

$parcel$export(module.exports, "GraphIcon", () => $9f207142d711682c$export$717a5ffb6a14ac74);

var $eUqFw = parcelRequire("eUqFw");

const $9f207142d711682c$export$717a5ffb6a14ac74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        viewBox: "0 0 256 256"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
    }));

});

parcelRegister("jmsjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bcb16afed37fb9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a8bcb16afed37fb9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    graphButtonLabelNonFinal: {
        "id": "graph.graph-button-label-non-final",
        "defaultMessage": "Open the graph"
    }
});

});


parcelRegister("7raLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64d538555ec7ade$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $2ziLQ = parcelRequire("2ziLQ");

var $kdJSi = parcelRequire("kdJSi");

var $gGtKh = parcelRequire("gGtKh");

var $2vrdr = parcelRequire("2vrdr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b64d538555ec7ade$var$AutomationMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("9hYM0")), {
    moduleId: "./src/packages/releases/automation-menu/src/index.tsx"
});
const $b64d538555ec7ade$var$fallback = // eslint-disable-next-line jira/integration/test-id-by-folder-structure
/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2vrdr.IconWrapper), {
    "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
    glyph: (0, $kdJSi.AutomationGlyph),
    label: ""
}));
const $b64d538555ec7ade$var$AsyncReleaseAutomationMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "releases-automation-menu",
        fallback: $b64d538555ec7ade$var$fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b64d538555ec7ade$var$AutomationMenu, null));
var $b64d538555ec7ade$export$2e2bcd8739ae039 = $b64d538555ec7ade$var$AsyncReleaseAutomationMenu;

});
parcelRegister("kdJSi", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $d609bfcc752dad25$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $d609bfcc752dad25$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("2vrdr", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $857ef8c506777b2b$export$be58b4326e23250f);
$parcel$export(module.exports, "default", () => $857ef8c506777b2b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $55pTl = parcelRequire("55pTl");

var $hI5oG = parcelRequire("hI5oG");

var $2ziLQ = parcelRequire("2ziLQ");

var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $kdJSi = parcelRequire("kdJSi");

var $1iu1h = parcelRequire("1iu1h");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fwxPc = parcelRequire("fwxPc");

var $gOwVD = parcelRequire("gOwVD");

var $03Ny8 = parcelRequire("03Ny8");
const $857ef8c506777b2b$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
    glyph: (0, $kdJSi.AutomationGlyph),
    label: ""
});
const $857ef8c506777b2b$var$AutomationMenuContent = (props)=>{
    const { projectType: projectType } = props;
    const intl = (0, $5JgJ2.default)();
    return projectType === (0, $7ZZxN.SOFTWARE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$var$MenuContentWrapper, {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$var$MenuTitle, null, intl.formatMessage((0, $03Ny8.default).automationMenuTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$var$MenuSubTitle, null, intl.formatMessage((0, $03Ny8.default).automationMenuSubTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gOwVD.AutomationMenuTemplateRules), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fwxPc.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: false,
        ...props
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fwxPc.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: true,
        ...props
    });
};
const $857ef8c506777b2b$export$bf60e24e2fb3b05d = ({ isMenuEnabled: isMenuEnabled, projectProps: projectProps, isOpenByDefault: isOpenByDefault })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isOpenByDefault ?? false);
    const intl = (0, $5JgJ2.default)();
    return isMenuEnabled && projectProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "fusionReleaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$var$AutomationMenuContent, {
                projectKey: projectProps.projectKey,
                projectType: projectProps.projectType,
                isSimplifiedProject: projectProps.isSimplifiedProject
            }),
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "jira-releases-automation-menu.ui.automation-button.enabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iu1h.default), {
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen
            }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        name: "fusionReleaseAutomationMenu"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$export$be58b4326e23250f, {
        "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "top",
        content: intl.formatMessage((0, $03Ny8.default).disabledAutomationMenuButtonTooltipMessage)
    }, $857ef8c506777b2b$var$automationIcon));
};
var $857ef8c506777b2b$export$2e2bcd8739ae039 = $857ef8c506777b2b$export$bf60e24e2fb3b05d;
const $857ef8c506777b2b$var$MenuTitle = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($857ef8c506777b2b$var$MenuTitleComponent, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $857ef8c506777b2b$var$MenuContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $857ef8c506777b2b$var$MenuSubTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _1yt41rml",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $857ef8c506777b2b$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1f4h _1bsb1f4h _1bah1h6o _syaz15t7 _ca0q1b66 _d0al13gf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $857ef8c506777b2b$var$MenuTitleComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41jig",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1iu1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb3df2ea1e4b54d$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $2ziLQ = parcelRequire("2ziLQ");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $kdJSi = parcelRequire("kdJSi");

var $b8Rxm = parcelRequire("b8Rxm");
const $1bb3df2ea1e4b54d$var$MenuButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((event, analytics)=>{
        (0, $jMP2a.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $b8Rxm.default).menuButtonTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        appearance: "subtle",
        spacing: "none",
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        "data-testId": "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $b8Rxm.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb3df2ea1e4b54d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            size: "medium",
            glyph: (0, $kdJSi.AutomationGlyph),
            label: formatMessage((0, $b8Rxm.default).automationsMenuButtonIcon),
            primaryColor: isSelected ? `var(--ds-icon-selected, ${(0, $73a5c9d720aa66e1$exports).N20})` : undefined,
            secondaryColor: "none"
        }))
    }));
});
var $1bb3df2ea1e4b54d$export$2e2bcd8739ae039 = $1bb3df2ea1e4b54d$var$MenuButton;
const $1bb3df2ea1e4b54d$var$unselectedColor = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`;
const $1bb3df2ea1e4b54d$var$unselectedHoverColor = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})`;
const $1bb3df2ea1e4b54d$var$multiplier = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bb3df2ea1e4b54d$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10u62xj": (0, $9t7rW.default)($1bb3df2ea1e4b54d$var$unselectedColor),
            "--_1cs4a84": (0, $9t7rW.default)($1bb3df2ea1e4b54d$var$unselectedHoverColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz296t _30l31hcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b8Rxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $19e6b94ad660f514$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $19e6b94ad660f514$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});

});


parcelRegister("fwxPc", function(module, exports) {

$parcel$export(module.exports, "AutomationMenuDeepLinks", () => $32b55a859839d471$export$fd3c4b1ddf70f790);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $fddKl = parcelRequire("fddKl");

var $bkIGg = parcelRequire("bkIGg");

var $7XRtk = parcelRequire("7XRtk");

var $bo4OB = parcelRequire("bo4OB");
var $8PFhw = parcelRequire("8PFhw");

var $kdJSi = parcelRequire("kdJSi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cb7m7 = parcelRequire("cb7m7");

var $2u7T9 = parcelRequire("2u7T9");
const $32b55a859839d471$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
    glyph: (0, $kdJSi.AutomationGlyph),
    label: ""
});
const $32b55a859839d471$export$fd3c4b1ddf70f790 = ({ isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType, includeDiscoverAutomation: includeDiscoverAutomation })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, includeDiscoverAutomation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        href: (0, $cb7m7.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fddKl))), {
            label: ""
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $2u7T9.default).discoverAutomationMenuItemLabel)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        href: (0, $cb7m7.buildManageRulesAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: $32b55a859839d471$var$automationIcon,
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manageRulesAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $2u7T9.default).manageAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        href: (0, $cb7m7.buildNewRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: ""
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'newRuleAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $2u7T9.default).createAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        href: (0, $cb7m7.buildAuditLogAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
            label: ""
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'auditLogAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $2u7T9.default).auditLogAutomationMenuItemLabel)))));
};

});
parcelRegister("fddKl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b132bbb381384eb6$var$_react = $b132bbb381384eb6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b132bbb381384eb6$var$_compass = $b132bbb381384eb6$var$_interopRequireDefault((parcelRequire("aT0C7")));
function $b132bbb381384eb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b132bbb381384eb6$var$DiscoverIcon = (props)=>/*#__PURE__*/ $b132bbb381384eb6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/><path d="m10.86 10.186 3.896-1.948c1.11-.555 1.562-.108 1.005 1.006l-1.948 3.896c-.126.251-.426.55-.673.673l-3.897 1.948c-1.11.556-1.561.11-1.004-1.006l1.947-3.896c.126-.25.426-.55.673-.673M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g></svg>`
    }, props, {
        newIcon: $b132bbb381384eb6$var$_compass.default
    }));
$b132bbb381384eb6$var$DiscoverIcon.displayName = 'DiscoverIcon';
var $b132bbb381384eb6$var$_default = module.exports.default = $b132bbb381384eb6$var$DiscoverIcon;

});
parcelRegister("aT0C7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ecf84587571ce34$var$_react = $7ecf84587571ce34$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7ecf84587571ce34$var$_UNSAFE_baseNew = $7ecf84587571ce34$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7ecf84587571ce34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ecf84587571ce34$var$CompassIcon = (props)=>/*#__PURE__*/ $7ecf84587571ce34$var$_react.default.createElement($7ecf84587571ce34$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$7ecf84587571ce34$var$CompassIcon.displayName = 'CompassIcon';
var $7ecf84587571ce34$var$_default = module.exports.default = $7ecf84587571ce34$var$CompassIcon;

});


parcelRegister("7XRtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cc785836207fa6c$var$_react = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5cc785836207fa6c$var$_clock = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eSHsi")));
function $5cc785836207fa6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5cc785836207fa6c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $5cc785836207fa6c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $5cc785836207fa6c$var$_clock.default
    }));
$5cc785836207fa6c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $5cc785836207fa6c$var$_default = module.exports.default = $5cc785836207fa6c$var$EmojiFrequentIcon;

});

parcelRegister("cb7m7", function(module, exports) {

$parcel$export(module.exports, "buildNewRuleAutomationUrl", () => $29c7bcdc0b5587fe$export$d6be0a6034032add);
$parcel$export(module.exports, "buildManageRulesAutomationUrl", () => $29c7bcdc0b5587fe$export$fb714f787469e8b0);
$parcel$export(module.exports, "buildAuditLogAutomationUrl", () => $29c7bcdc0b5587fe$export$7d1590b2fb4dd741);
$parcel$export(module.exports, "buildDiscoverAutomationUrl", () => $29c7bcdc0b5587fe$export$51ac1eeac37070f8);
$parcel$export(module.exports, "buildTemplateRuleAutomationUrl", () => $29c7bcdc0b5587fe$export$82ce8540ef209720);

var $lwZcK = parcelRequire("lwZcK");
const $29c7bcdc0b5587fe$export$d6be0a6034032add = (projectProps)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $29c7bcdc0b5587fe$export$fb714f787469e8b0 = (projectProps)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#/rule-list`;
const $29c7bcdc0b5587fe$export$7d1590b2fb4dd741 = (projectProps)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#tab/audit-log`;
const $29c7bcdc0b5587fe$export$51ac1eeac37070f8 = (projectProps)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#/tab/rule-library`;
const $29c7bcdc0b5587fe$export$82ce8540ef209720 = (projectProps, templateId)=>`${(0, $lwZcK.getBaseAutomationUrl)(projectProps)}#/rule/template?templateId=${templateId}`;

});

parcelRegister("2u7T9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdaf507b7472b172$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdaf507b7472b172$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    discoverAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label",
        "defaultMessage": "Discover automation"
    },
    manageAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label",
        "defaultMessage": "Manage automation"
    },
    createAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label",
        "defaultMessage": "Create automation"
    },
    auditLogAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label",
        "defaultMessage": "Audit log"
    }
});

});


parcelRegister("gOwVD", function(module, exports) {

$parcel$export(module.exports, "AutomationMenuTemplateRules", () => $22fcede070f16b60$export$35643f531510af9e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $cSu9v = parcelRequire("cSu9v");

var $6nIG2 = parcelRequire("6nIG2");

var $77CtJ = parcelRequire("77CtJ");

var $bo4OB = parcelRequire("bo4OB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4qIGt = parcelRequire("4qIGt");

var $iJuaC = parcelRequire("iJuaC");

var $cb7m7 = parcelRequire("cb7m7");

var $14nKl = parcelRequire("14nKl");
const $22fcede070f16b60$var$jiraIssuesIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
    size: "medium",
    label: ""
});
const $22fcede070f16b60$var$slackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
    size: "medium",
    glyph: (0, $iJuaC.SlackGlyph),
    label: ""
});
const $22fcede070f16b60$var$launchDarklyGliph = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
    size: "medium",
    glyph: (0, $4qIGt.LaunchDarklyGlyph),
    label: ""
});
const $22fcede070f16b60$var$ActionAndTriggerIcons = ({ trigger: trigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$IconShadow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$IconShadow, null, trigger));
const $22fcede070f16b60$export$35643f531510af9e = (props)=>{
    const { isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        shouldTitleWrap: true,
        href: (0, $cb7m7.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_14'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$ActionAndTriggerIcons, {
            trigger: $22fcede070f16b60$var$jiraIssuesIcon
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'templateRuleAddVersionToInProgressIssue')
    }, formatMessage((0, $14nKl.default).templateRuleAddIssueToVersionOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        shouldTitleWrap: true,
        href: (0, $cb7m7.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'devops_template_6'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$ActionAndTriggerIcons, {
            trigger: $22fcede070f16b60$var$launchDarklyGliph
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'templateRuleCreateLaunchDarklyFlag')
    }, formatMessage((0, $14nKl.default).templateRuleCreateLaunchDarklyFlagOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        shouldTitleWrap: true,
        href: (0, $cb7m7.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_12'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$ActionAndTriggerIcons, {
            trigger: $22fcede070f16b60$var$slackIcon
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionRelease')
    }, formatMessage((0, $14nKl.default).templateRuleSendSlackMessageOnVersionRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        shouldTitleWrap: true,
        href: (0, $cb7m7.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_13'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$ActionAndTriggerIcons, {
            trigger: $22fcede070f16b60$var$slackIcon
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionUnRelease')
    }, formatMessage((0, $14nKl.default).templateRuleSendSlackMessageOnVersionUnRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22fcede070f16b60$var$DiscoverAutomationLink, {
        href: (0, $cb7m7.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink')
    }, formatMessage((0, $14nKl.default).discoverMoreAutomationMenuItemLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22fcede070f16b60$var$IconShadow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1bsbzwfg _2rko1y44 _16qszucj _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22fcede070f16b60$var$DiscoverAutomationLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41nnp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4qIGt", function(module, exports) {

$parcel$export(module.exports, "LaunchDarklyGlyph", () => $0a389f30c29abc90$export$f1f691d73572fca1);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $0a389f30c29abc90$export$f1f691d73572fca1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "matrix(0.11111112 0 0 0.11111112 -0 0.058888756)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z",
        stroke: "none",
        fill: "#282828",
        fillRule: "nonzero"
    })));

});

parcelRegister("iJuaC", function(module, exports) {

$parcel$export(module.exports, "SlackGlyph", () => $2f24e97428a7409c$export$cbfabcc4325ad3ff);
// It doesn't make sense to convert Slack icon into our token, as Slack icon is a unique brand. Confirmed that it looks great in DarkMode without tokens.
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $2f24e97428a7409c$export$cbfabcc4325ad3ff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z",
        fill: "#ECB22E"
    }));

});

parcelRegister("14nKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $31434b99f34a9178$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $31434b99f34a9178$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    discoverMoreAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label",
        "defaultMessage": "Discover more automation"
    },
    templateRuleAddIssueToVersionOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create",
        "defaultMessage": "When a version is created \u2192 then add all In Progress issues without a fix version"
    },
    templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create",
        "defaultMessage": "When a version is created \u2192 then create a LaunchDarkly flag"
    },
    templateRuleSendSlackMessageOnVersionRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release",
        "defaultMessage": "When a version is released \u2192 then send a Slack message"
    },
    templateRuleSendSlackMessageOnVersionUnRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release",
        "defaultMessage": "When a version is unreleased \u2192 then send a Slack message"
    }
});

});


parcelRegister("03Ny8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93be5b438e40688$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d93be5b438e40688$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    disabledAutomationMenuButtonTooltipMessage: {
        "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message",
        "defaultMessage": "You need to be a project admin to configure automation"
    },
    automationMenuTitle: {
        "id": "software-releases-automation-menu.automation-menu-title",
        "defaultMessage": "Automation"
    },
    automationMenuSubTitle: {
        "id": "software-releases-automation-menu.automation-menu-sub-title",
        "defaultMessage": "Setup your release automations from these templates, or create a new one of your own."
    }
});

});


parcelRegister("9hYM0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3oPbH").then(()=>parcelRequire('d1vSo'));

});


parcelRegister("4rHC4", function(module, exports) {

$parcel$export(module.exports, "ManageWarningsModal", () => $a9c185ec370ea8aa$export$6e3078b1666e4828);

var $kpbAw = parcelRequire("kpbAw");

var $gDrxi = parcelRequire("gDrxi");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $587Im = parcelRequire("587Im");

var $cKDJj = parcelRequire("cKDJj");

var $554al = parcelRequire("554al");
const $a9c185ec370ea8aa$export$6e3078b1666e4828 = ({ setModalClosed: setModalClosed, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const version = (0, $iWLL0.useFragment)((0, $gDrxi.default), jiraVersion);
    const { warningConfig: warningConfig, __id: versionRecordId } = version;
    const { openPullRequest: openPullRequest, failingBuild: failingBuild, unreviewedCode: unreviewedCode, openReview: openReview } = warningConfig;
    const [updatedVersionWarningConfig, setUpdatedVersionWarningConfig] = (0, $eUqFw.useState)((0, $554al.convertStatusToBoolean)(warningConfig));
    const removeDisabledWarningFilters = (0, $554al.useRemoveDisabledWarningFilters)(updatedVersionWarningConfig);
    const [isSaveFailed, setIsSaveFailed] = (0, $eUqFw.useState)(false);
    const [updateVersionWarningConfig, isWarningConfigUpdating] = (0, $iWLL0.useMutation)((0, $kpbAw.default));
    const jiraProjectId = version.project.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "software-releases-manage-warnings.ui.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $587Im.default).manageWarnings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9c185ec370ea8aa$var$WarningDescription, null, formatMessage((0, $587Im.default).warningDescription)), isSaveFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a9c185ec370ea8aa$var$errorSectionMessageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error"
    }, formatMessage((0, $587Im.default).updateWarningConfigFailed))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, formatMessage((0, $587Im.default).warningsSetForAllVersionsInThisProject)), openPullRequest !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKDJj.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-pull-request",
        isDisabled: isWarningConfigUpdating,
        initialValue: openPullRequest === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openPullRequest',
                    isEnabled: !prev.isOpenPullRequestEnabled
                });
                return {
                    ...prev,
                    isOpenPullRequestEnabled: !prev.isOpenPullRequestEnabled
                };
            }),
        headingTranslated: formatMessage((0, $587Im.default).openPullRequests),
        descriptionTranslated: formatMessage((0, $587Im.default).openPullRequestsDescription)
    }), openReview !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKDJj.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-review",
        isDisabled: isWarningConfigUpdating,
        initialValue: openReview === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openReview',
                    isEnabled: !prev.isOpenReviewEnabled
                });
                return {
                    ...prev,
                    isOpenReviewEnabled: !prev.isOpenReviewEnabled
                };
            }),
        headingTranslated: formatMessage((0, $587Im.default).openReviews),
        descriptionTranslated: formatMessage((0, $587Im.default).openReviewsDescription)
    }), unreviewedCode !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKDJj.Toggle), {
        testId: "software-releases-manage-warnings.ui.unreviewed-code",
        isDisabled: isWarningConfigUpdating,
        initialValue: unreviewedCode === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'unreviewedCode',
                    isEnabled: !prev.isUnreviewedCodeEnabled
                });
                return {
                    ...prev,
                    isUnreviewedCodeEnabled: !prev.isUnreviewedCodeEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $587Im.default).unreviewedCode),
        descriptionTranslated: formatMessage((0, $587Im.default).unreviewedCodeDescription)
    }), failingBuild !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKDJj.Toggle), {
        testId: "software-releases-manage-warnings.ui.failing-build",
        isDisabled: isWarningConfigUpdating,
        initialValue: failingBuild === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'failingBuild',
                    isEnabled: !prev.isFailingBuildEnabled
                });
                return {
                    ...prev,
                    isFailingBuildEnabled: !prev.isFailingBuildEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $587Im.default).failingBuilds),
        descriptionTranslated: formatMessage((0, $587Im.default).failingBuildsDescription)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        onClick: ()=>{
            updateVersionWarningConfig({
                variables: {
                    input: {
                        jiraProjectId: jiraProjectId,
                        updatedVersionWarningConfig: updatedVersionWarningConfig
                    },
                    versionId: version.id
                },
                // @ts-expect-error - TS2322 - Type '({ jira: { updateVersionWarningConfig: { success }, }, }: MutationResponse) => void' is not assignable to type '(response: {}, errors: PayloadError[] | null) => void | null'.
                onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'updateVersionWarningConfig' does not exist on type '{ readonly updateVersionWarningConfig: { readonly success: boolean; readonly version: { readonly " $fragmentSpreads": FragmentRefs<"issueProgressDetails_versionProgress">; } | null | undefined; } | null | undefined; } | null | undefined'.
                updateVersionWarningConfig: { success: success } } })=>{
                    if (success) {
                        removeDisabledWarningFilters();
                        setModalClosed();
                        return;
                    }
                    setIsSaveFailed(true);
                },
                onError: ()=>{
                    setIsSaveFailed(true);
                },
                updater: (store)=>{
                    const versionRecord = store.get(versionRecordId);
                    if (versionRecord == null) return;
                    const existingWarningConfigRecord = versionRecord.getLinkedRecord('warningConfig');
                    if (existingWarningConfigRecord == null) return;
                    const newValues = (0, $554al.getNewWarningConfigValues)(updatedVersionWarningConfig, {
                        openPullRequest: openPullRequest,
                        openReview: openReview,
                        failingBuild: failingBuild,
                        unreviewedCode: unreviewedCode
                    });
                    existingWarningConfigRecord.setValue(newValues.openPullRequest, 'openPullRequest');
                    existingWarningConfigRecord.setValue(newValues.openReview, 'openReview');
                    existingWarningConfigRecord.setValue(newValues.unreviewedCode, 'unreviewedCode');
                    existingWarningConfigRecord.setValue(newValues.failingBuild, 'failingBuild');
                    versionRecord.setLinkedRecord(existingWarningConfigRecord, 'warningConfig');
                }
            });
        },
        isLoading: isWarningConfigUpdating
    }, formatMessage((0, $587Im.default).modalSave)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-releases-manage-warnings.ui.cancel-manage-warnings",
        onClick: ()=>setModalClosed(),
        isDisabled: isWarningConfigUpdating
    }, formatMessage((0, $587Im.default).modalCancel)))));
};
const $a9c185ec370ea8aa$var$errorSectionMessageContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9c185ec370ea8aa$var$WarningDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _syazaj1x",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kpbAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a068f27845cbda$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aec7c7d15a68e9ccfb10cf6d3c93e5e1>>
 * @relayHash f80615342bea07d18fe9b588ee9c8938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce
const $c3a068f27845cbda$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "issueProgressDetails_versionProgress"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "doneIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "DONE"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                },
                                                {
                                                    "alias": "inProgressIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "IN_PROGRESS"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                },
                                                {
                                                    "alias": "todoIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "TODO"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "warningsCount"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce",
            "metadata": {},
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c3a068f27845cbda$var$node.hash = "c4e2323c95f8ee01a7aae0a690ba4f89";
var $c3a068f27845cbda$export$2e2bcd8739ae039 = $c3a068f27845cbda$var$node;

});

parcelRegister("gDrxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2296b0c6baa44e9b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db5e521c6a905015346df1d2ff4cfe7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2296b0c6baa44e9b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openPullRequest"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openPullRequest"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openReview"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openReview"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "unreviewedCode"
                            },
                            "action": "THROW",
                            "path": "warningConfig.unreviewedCode"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "failingBuild"
                            },
                            "action": "THROW",
                            "path": "warningConfig.failingBuild"
                        }
                    ]
                },
                "action": "THROW",
                "path": "warningConfig"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
}();
$2296b0c6baa44e9b$var$node.hash = "e5eb838f9801c770bc5137a984a02776";
var $2296b0c6baa44e9b$export$2e2bcd8739ae039 = $2296b0c6baa44e9b$var$node;

});

parcelRegister("587Im", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c3a48eab11bbca$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97c3a48eab11bbca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manageWarnings: {
        "id": "software-releases-manage-warnings.manage-warnings",
        "defaultMessage": "Manage warnings"
    },
    modalSave: {
        "id": "software-releases-manage-warnings.modal-save",
        "defaultMessage": "Save"
    },
    modalCancel: {
        "id": "software-releases-manage-warnings.modal-cancel",
        "defaultMessage": "Cancel"
    },
    warningsSetForAllVersionsInThisProject: {
        "id": "software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project",
        "defaultMessage": "These warning settings affect all existing and future versions in this project."
    },
    updateWarningConfigFailed: {
        "id": "software-releases-manage-warnings.update-warning-config-failed",
        "defaultMessage": "Something went wrong. Please try to save again."
    },
    openPullRequests: {
        "id": "software-releases-manage-warnings.open-pull-requests",
        "defaultMessage": "Open pull requests"
    },
    openPullRequestsDescription: {
        "id": "software-releases-manage-warnings.open-pull-requests-description",
        "defaultMessage": "These issues have been marked complete but have open pull requests."
    },
    openReviews: {
        "id": "software-releases-manage-warnings.open-reviews",
        "defaultMessage": "Open reviews"
    },
    openReviewsDescription: {
        "id": "software-releases-manage-warnings.open-reviews-description",
        "defaultMessage": "These issues have been marked complete but have open reviews."
    },
    unreviewedCode: {
        "id": "software-releases-manage-warnings.unreviewed-code",
        "defaultMessage": "Unreviewed code"
    },
    unreviewedCodeDescription: {
        "id": "software-releases-manage-warnings.unreviewed-code-description",
        "defaultMessage": "These issues have been marked complete but the commits are not part of a pull request or review."
    },
    failingBuilds: {
        "id": "software-releases-manage-warnings.failing-builds",
        "defaultMessage": "Failing builds"
    },
    failingBuildsDescription: {
        "id": "software-releases-manage-warnings.failing-builds-description",
        "defaultMessage": "These issues have been marked complete but have failing builds."
    },
    warningDescription: {
        "id": "software-releases-manage-warnings.warning-description",
        "defaultMessage": "Warnings will be displayed when the status of a Jira issue doesn't accurately reflect related development activity."
    }
});

});

parcelRegister("cKDJj", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $6704fb1bf29c8bcd$export$bea8ebba691c5813);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $e270j = parcelRequire("e270j");
const $6704fb1bf29c8bcd$export$bea8ebba691c5813 = ({ initialValue: initialValue, headingTranslated: headingTranslated, descriptionTranslated: descriptionTranslated, onChange: onChange, testId: testId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6704fb1bf29c8bcd$var$WarningCategoryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, headingTranslated), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6704fb1bf29c8bcd$var$Description, null, descriptionTranslated)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6704fb1bf29c8bcd$var$toggleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        testId: testId,
        defaultChecked: initialValue,
        onChange: onChange,
        isDisabled: isDisabled
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6704fb1bf29c8bcd$var$WarningCategoryContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _1bah1yb4 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $6704fb1bf29c8bcd$var$toggleContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6704fb1bf29c8bcd$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazaj1x",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});


parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});




parcelRegister("554al", function(module, exports) {

$parcel$export(module.exports, "convertStatusToBoolean", () => $d1722dff57a55f1e$export$6a8a12d4b311feca);
$parcel$export(module.exports, "getNewWarningConfigValues", () => $d1722dff57a55f1e$export$12511548bf3cb9c8);
$parcel$export(module.exports, "useRemoveDisabledWarningFilters", () => $d1722dff57a55f1e$export$dfbaab0bbdd97fab);


var $9TlRa = parcelRequire("9TlRa");

var $lzE4a = parcelRequire("lzE4a");
const $d1722dff57a55f1e$var$booleanToState = (value)=>value ? 'ENABLED' : 'DISABLED';
const $d1722dff57a55f1e$export$6a8a12d4b311feca = ({ openPullRequest: openPullRequest, openReview: openReview, unreviewedCode: unreviewedCode, failingBuild: failingBuild })=>({
        isOpenPullRequestEnabled: openPullRequest !== 'DISABLED',
        isOpenReviewEnabled: openReview !== 'DISABLED',
        isUnreviewedCodeEnabled: unreviewedCode !== 'DISABLED',
        isFailingBuildEnabled: failingBuild !== 'DISABLED'
    });
const $d1722dff57a55f1e$export$12511548bf3cb9c8 = (updatedBooleanValues, originalValues)=>({
        openPullRequest: originalValues.openPullRequest === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $d1722dff57a55f1e$var$booleanToState(updatedBooleanValues.isOpenPullRequestEnabled ?? true),
        openReview: originalValues.openReview === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $d1722dff57a55f1e$var$booleanToState(updatedBooleanValues.isOpenReviewEnabled ?? true),
        unreviewedCode: originalValues.unreviewedCode === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $d1722dff57a55f1e$var$booleanToState(updatedBooleanValues.isUnreviewedCodeEnabled ?? true),
        failingBuild: originalValues.failingBuild === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $d1722dff57a55f1e$var$booleanToState(updatedBooleanValues.isFailingBuildEnabled ?? true)
    });
const $d1722dff57a55f1e$export$dfbaab0bbdd97fab = ({ isFailingBuildEnabled: isFailingBuildEnabled, isOpenPullRequestEnabled: isOpenPullRequestEnabled, isOpenReviewEnabled: isOpenReviewEnabled, isUnreviewedCodeEnabled: isUnreviewedCodeEnabled })=>{
    const { parsedQueryParams: parsedQueryParams, setWarningsFilterParam: setWarningsFilterParam } = (0, $9TlRa.useFilterSortingQueryParams)();
    return ()=>{
        const currentlySelectedWarningFilters = parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] ?? [];
        const result = [];
        if (isFailingBuildEnabled && currentlySelectedWarningFilters.includes('FAILING_BUILD')) result.push('FAILING_BUILD');
        if (isOpenPullRequestEnabled && currentlySelectedWarningFilters.includes('OPEN_PULL_REQUEST')) result.push('OPEN_PULL_REQUEST');
        if (isUnreviewedCodeEnabled && currentlySelectedWarningFilters.includes('UNREVIEWED_CODE')) result.push('UNREVIEWED_CODE');
        if (isOpenReviewEnabled && currentlySelectedWarningFilters.includes('OPEN_REVIEW')) result.push('OPEN_REVIEW');
        setWarningsFilterParam(result.filter((0, $lzE4a.isWarningsFilterValue)));
    };
};

});


parcelRegister("bQgr5", function(module, exports) {

$parcel$export(module.exports, "ConnectApps", () => $528ad75cb2298651$export$4fff5b46ac23b268);

var $aqzco = parcelRequire("aqzco");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jLerq = parcelRequire("jLerq");

var $4qhD6 = parcelRequire("4qhD6");

var $fDZ6r = parcelRequire("fDZ6r");

var $izafr = parcelRequire("izafr");

var $5JgJ2 = parcelRequire("5JgJ2");


var $iLplQ = parcelRequire("iLplQ");

var $jsPSn = parcelRequire("jsPSn");
const $528ad75cb2298651$export$4fff5b46ac23b268 = ({ jiraVersion: jiraVersion })=>{
    const { connectAddonIframeData: connectAddonIframeData } = (0, $iWLL0.useFragment)((0, $aqzco.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasConnectApps = connectAddonIframeData.length > 0;
    (0, $jsPSn.useConnectAppExtensionExperienceStart)(hasConnectApps);
    const { loading: loading, error: error } = (0, $jsPSn.useLoadConnectJs)(hasConnectApps);
    const onExpFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $0bd71b9aecd1853d$export$af5e668651a80140),
        attributes: {
            errorMessage: error?.message ?? null,
            numConnectApps: connectAddonIframeData.length
        }
    });
    if (!hasConnectApps || loading) return null;
    if (error) {
        onExpFail('versionDetailsHeader', error);
        // This should be caught by the nearest NonCriticalErrorBoundary
        throw error;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: (0, $0bd71b9aecd1853d$export$af5e668651a80140)
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options === null).map((iframeData)=>{
        if (iframeData == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
            key: `error-flag-${iframeData.appName}`,
            flag: {
                type: 'error',
                title: formatMessage((0, $iLplQ.default).errorTitle, {
                    appName: iframeData.appName
                }),
                description: (0, $iLplQ.default).errorDescription
            }
        });
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options !== null).map((iframeData)=>{
        if (iframeData == null || iframeData.options == null) return null;
        const { appKey: appKey, moduleKey: moduleKey, options: options, appName: appName, location: location } = iframeData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemModuleAsync), {
            appKey: appKey,
            moduleKey: moduleKey,
            // Temp code to validate if hostOrigin is the problem. In the legacy page, hostOrigin was the public URL, but broken version had internal URL
            options: {
                ...options,
                hostOrigin: window.location.origin
            },
            appName: appName,
            key: `${appKey}-${moduleKey}`,
            location: location
        });
    }));
};

});
parcelRegister("aqzco", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2198a14b40c5787$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d2ae5269ae2695b400dba5dc9770afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2198a14b40c5787$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "connectApps_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionConnectAddonIframeData",
                "kind": "LinkedField",
                "name": "connectAddonIframeData",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.moduleKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appName"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "location"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.location"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "options"
                    }
                ]
            },
            "action": "THROW",
            "path": "connectAddonIframeData"
        }
    ],
    "type": "JiraVersion"
};
$c2198a14b40c5787$var$node.hash = "5b5aa6740e6a7342f336e876f3dce998";
var $c2198a14b40c5787$export$2e2bcd8739ae039 = $c2198a14b40c5787$var$node;

});

parcelRegister("jLerq", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleAsync", () => $ec457b27842b5036$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $ec457b27842b5036$export$c800b42cc8eabb03);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $ec457b27842b5036$var$EcosystemModule = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6C4JK")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $ec457b27842b5036$var$EcosystemTimeoutView = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lsOlj")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $ec457b27842b5036$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemModule, props));
const $ec457b27842b5036$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemTimeoutView, props));

});
parcelRegister("6C4JK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b9Lnk").then(()=>parcelRequire('7OLHR'));

});

parcelRegister("lsOlj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fJUCR").then(()=>parcelRequire('4Ep9I'));

});


parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


const $0bd71b9aecd1853d$export$af5e668651a80140 = 'viewVersionDetailsConnectAppExtension';

parcelRegister("iLplQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $28bdf3c8d77b39e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28bdf3c8d77b39e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "software-releases-version-detail.header.connect-apps.error-title",
        "defaultMessage": "We weren't able to load {appName}."
    },
    errorDescription: {
        "id": "software-releases-version-detail.header.connect-apps.error-description",
        "defaultMessage": "Please refresh the page to try again."
    }
});

});

parcelRegister("jsPSn", function(module, exports) {

$parcel$export(module.exports, "useLoadConnectJs", () => $1aea3fa6e6524b6a$export$ea4f866a08ef15ea);
$parcel$export(module.exports, "useConnectAppExtensionExperienceStart", () => $1aea3fa6e6524b6a$export$491da84e1e953d53);

var $eUqFw = parcelRequire("eUqFw");

var $4lxPQ = parcelRequire("4lxPQ");

var $bDhRl = parcelRequire("bDhRl");

var $dWLk9 = parcelRequire("dWLk9");

const $1aea3fa6e6524b6a$export$ea4f866a08ef15ea = (shouldLoad)=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldLoad) (0, $4lxPQ.withConnectHost)(()=>{
            setIsLoading(false);
        }).catch((e)=>{
            setIsLoading(false);
            setError(e);
        });
    }, [
        shouldLoad
    ]);
    return {
        loading: isLoading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
        error
    };
};
const $1aea3fa6e6524b6a$export$491da84e1e953d53 = (hasConnectApps)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $0bd71b9aecd1853d$export$af5e668651a80140),
        experienceId: cloudId,
        analyticsSource: 'versionDetails'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hasConnectApps) onStart();
    }, [
        onStart,
        hasConnectApps
    ]);
};

});
parcelRegister("4lxPQ", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $74a29a4beb89f78b$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $74a29a4beb89f78b$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $74a29a4beb89f78b$export$920fb4b46d4f2eec);

var $3X4Tl = parcelRequire("3X4Tl");
const $74a29a4beb89f78b$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $3X4Tl.setupConnectJs)();
    action(connectHost);
};
const $74a29a4beb89f78b$export$186d423c00af146c = ()=>window.connectHost;
const $74a29a4beb89f78b$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("3X4Tl", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $e1d87b293e6b1fa3$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $8nDwh = parcelRequire("8nDwh");

const $e1d87b293e6b1fa3$var$installConnectJs = async ()=>{
    await (0, $8nDwh.waitForJQuery)();
    const loader = await (parcelRequire("2Dzjt"));
    await loader.performSideEffects();
    return window.connectHost;
};
let $e1d87b293e6b1fa3$var$installConnectJsPromise = null;
const $e1d87b293e6b1fa3$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    if (window.__SPA__) {
        if ($e1d87b293e6b1fa3$var$installConnectJsPromise === null) $e1d87b293e6b1fa3$var$installConnectJsPromise = $e1d87b293e6b1fa3$var$installConnectJs();
        return $e1d87b293e6b1fa3$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $2BvS3.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    return window.connectHost;
};

});
parcelRegister("8nDwh", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $57c59c350a2284e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $57c59c350a2284e3$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $57c59c350a2284e3$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $57c59c350a2284e3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $57c59c350a2284e3$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $57c59c350a2284e3$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $57c59c350a2284e3$export$d690da9bc8146677);

var $guiFP = parcelRequire("guiFP");

const $57c59c350a2284e3$export$c47913ca32a5c6f7 = (key)=>{
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $57c59c350a2284e3$export$7232a6dc780f9887 = ()=>AJS.$;
const $57c59c350a2284e3$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    window._AP;
const $57c59c350a2284e3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $57c59c350a2284e3$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $57c59c350a2284e3$var$FIVE_MINUTES = 300000;
const $57c59c350a2284e3$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $guiFP.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $57c59c350a2284e3$var$FIVE_MINUTES);
    });
const $57c59c350a2284e3$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $57c59c350a2284e3$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $57c59c350a2284e3$export$d690da9bc8146677 = [
    $57c59c350a2284e3$export$cb954c21735b28e4,
    $57c59c350a2284e3$export$7315c38dc71bd41f
];

});

parcelRegister("2Dzjt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dJtVb").then(()=>parcelRequire('l6TcI'));

});





parcelRegister("98a56", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableName", () => $26a56eab54b99166$export$9fb8a15f1e2c2f6f);

var $hpQGI = parcelRequire("hpQGI");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $gGtKh = parcelRequire("gGtKh");

var $nlaxs = parcelRequire("nlaxs");

var $8eHfw = parcelRequire("8eHfw");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $26a56eab54b99166$var$LazyEditableName = (0, $7rh0R.lazy)(()=>(parcelRequire("27aPz")).then((module)=>module.EditableName), {
    moduleId: "./src/packages/releases/version-detail/src/ui/header/editable-name/index.tsx"
});
const $26a56eab54b99166$export$9fb8a15f1e2c2f6f = ({ jiraVersion: jiraVersion, isEditing: isEditing, setIsEditing: setIsEditing })=>{
    const version = (0, $iWLL0.useFragment)((0, $hpQGI.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "editable-name",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8eHfw.InlineEditReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nlaxs.PageTitle), {
            level: "h700",
            as: "h1"
        }, version.name))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26a56eab54b99166$var$LazyEditableName, {
        jiraVersion: version,
        isEditing: isEditing,
        setIsEditing: setIsEditing
    }));
};

});
parcelRegister("hpQGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7487d2c342497a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20a6f51f522d15758d6a81ed1c455dfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d7487d2c342497a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetail_AsyncEditableName",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableName_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$d7487d2c342497a7$var$node.hash = "72635c9ff5ceeb9dc0fc3b0d03ba28e8";
var $d7487d2c342497a7$export$2e2bcd8739ae039 = $d7487d2c342497a7$var$node;

});

parcelRegister("nlaxs", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $31dd8317384934e0$export$155581e8dc02007a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");
const $31dd8317384934e0$export$155581e8dc02007a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _19pkidpf _1yt4jjoz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8eHfw", function(module, exports) {

$parcel$export(module.exports, "InlineEditReadViewContainer", () => $0abc2cee19b2083c$export$408cb7913975dc96);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ /*
 * This component replicates margin/padding/border styles the @atlaskit/inline-edit component adds around
 * its "read view". The goal is to avoid styling inconsistencies in places where we *conditionally* render
 * an inline edit, e.g. as a suspense placeholde or a read-only mode. Example usage:
 *
 * return canEdit
 *      ? <InlineEdit readView={() => <ReadView />} {...otherProps} />
 *      : <InlineEditReadViewContainer><ReadView /></InlineEditReadViewContainer>
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $0abc2cee19b2083c$export$408cb7913975dc96 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _19itj1ic _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("27aPz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4eIrQ").then(()=>parcelRequire('5o1Bv'));

});


parcelRegister("18w1f", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $71c720ba99bc8132$export$116fedbe5e2e2bd8);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");

var $bCwLs = parcelRequire("bCwLs");

var $11icP = parcelRequire("11icP");
const $71c720ba99bc8132$var$FEEDBACK_COLLECTOR_LOCATION = 'releases.version.detail';
const $71c720ba99bc8132$export$116fedbe5e2e2bd8 = ()=>{
    const { simplified: simplified, isProjectAdmin: isProjectAdmin } = (0, $11icP.useProjectContext)();
    const additionalFeedbackEntries = [
        {
            id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $71c720ba99bc8132$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: simplified.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).IS_ADMIN,
            value: isProjectAdmin == null ? 'unknown' : isProjectAdmin.toString()
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCwLs.FeedbackCollectorButton), {
        entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};

});
parcelRegister("bCwLs", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $096795107747cbd5$export$b39479f42d974760);

var $eUqFw = parcelRequire("eUqFw");

var $c5IEJ = parcelRequire("c5IEJ");

var $2eG9N = parcelRequire("2eG9N");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $k74dc = parcelRequire("k74dc");

var $3liet = parcelRequire("3liet");
const $096795107747cbd5$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: customLabel || formatMessage((0, $k74dc.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $096795107747cbd5$export$941c5fcac2e843ea = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>openFeedbackCollector({
            ...feedbackCollectorProps,
            triggerRef: buttonRef
        }), [
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$var$FeedbackCollectorButtonNew = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $1c02D.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $1c02D.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$export$b39479f42d974760 = (0, $bAQOb.componentWithFF)('jff.magma.passing-cloudid-in-feedback-button_hif5t', $096795107747cbd5$var$FeedbackCollectorButtonNew, $096795107747cbd5$export$941c5fcac2e843ea);

});
parcelRegister("c5IEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd8976d9d4f34ae$var$_react = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8cd8976d9d4f34ae$var$_feedback = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("3kIcQ")));

var $8cd8976d9d4f34ae$var$_feedback2 = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("l2ZYW")));
function $8cd8976d9d4f34ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cd8976d9d4f34ae$var$FeedbackIcon = (props)=>/*#__PURE__*/ $8cd8976d9d4f34ae$var$_react.default.createElement($8cd8976d9d4f34ae$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $8cd8976d9d4f34ae$var$_feedback2.default
    }, props));
$8cd8976d9d4f34ae$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $8cd8976d9d4f34ae$var$_default = module.exports.default = $8cd8976d9d4f34ae$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});

parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});


parcelRegister("k74dc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a622284001ff525a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a622284001ff525a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("3liet", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $37102939becff71f$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $37102939becff71f$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
            __cmplp.className
        ])
    });
});

});



parcelRegister("6Zjuq", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesButton", () => $3385b275ef1a5865$export$760b84d5e0ebb5da);

var $hL8Qw = parcelRequire("hL8Qw");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $dxopF = parcelRequire("dxopF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");

var $cJzpl = parcelRequire("cJzpl");

var $giacT = parcelRequire("giacT");

var $hUb8I = parcelRequire("hUb8I");

var $juf5E = parcelRequire("juf5E");

var $5N4Nb = parcelRequire("5N4Nb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3385b275ef1a5865$var$LazyReleaseNotesModal = (0, $7rh0R.lazy)(()=>(parcelRequire("icAUL")).then((module)=>module.ReleaseNotesModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/index.tsx"
});
const $3385b275ef1a5865$export$760b84d5e0ebb5da = ({ jiraVersion: jiraVersion })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const version = (0, $iWLL0.useFragment)((0, $hL8Qw.default), jiraVersion);
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $iWLL0.useQueryLoader)((0, $cJzpl.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
        $3385b275ef1a5865$var$LazyReleaseNotesModal.preload();
    };
    (0, $5N4Nb.useRedirectAutoOpenReleaseModal)(()=>setIsOpen(true), loadReleaseNoteModalResource);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const experienceStart = (0, $giacT.useCreateReleaseNotesExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUb8I.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "release-note-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, releaseNotesQueryReference && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3385b275ef1a5865$var$LazyReleaseNotesModal, {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsOpen(false)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onMouseEnter: loadReleaseNoteModalResource,
        onClick: (_, analyticsEvent)=>{
            setIsOpen(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionReleaseNotesModal');
            experienceStart();
        }
    }, formatMessage((0, $juf5E.default).releaseNotesButton)));
};

});
parcelRegister("hL8Qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e660f9413afaf295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0079ec0a17b0f8593b69119b804c8bed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e660f9413afaf295$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "releaseNotesButton_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$e660f9413afaf295$var$node.hash = "05a2c1a8fb9ea7ab5acb19f863afe1aa";
var $e660f9413afaf295$export$2e2bcd8739ae039 = $e660f9413afaf295$var$node;

});

parcelRegister("giacT", function(module, exports) {

$parcel$export(module.exports, "useCreateReleaseNotesExperienceStart", () => $c3ba79cf9e236fca$export$dbc8ab93f701ba27);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceFail", () => $c3ba79cf9e236fca$export$66c9cef2c6cdd99d);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceSuccess", () => $c3ba79cf9e236fca$export$fe155a48cbacc64a);

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $c3ba79cf9e236fca$export$52919046b94109dc = 'createReleaseNotes';
const $c3ba79cf9e236fca$var$ANALYTICS_SOURCE = 'versionDetails';
const $c3ba79cf9e236fca$export$dbc8ab93f701ba27 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $c3ba79cf9e236fca$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $c3ba79cf9e236fca$var$ANALYTICS_SOURCE,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $c3ba79cf9e236fca$export$66c9cef2c6cdd99d = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $c3ba79cf9e236fca$export$52919046b94109dc
    });
const $c3ba79cf9e236fca$export$fe155a48cbacc64a = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $c3ba79cf9e236fca$export$52919046b94109dc
    });

});

parcelRegister("juf5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c55dedd37132a9d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4c55dedd37132a9d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releaseNotesButton: {
        "id": "software-releases-version-detail.header.release-notes-button.release-notes-button",
        "defaultMessage": "Release notes"
    }
});

});

parcelRegister("5N4Nb", function(module, exports) {

$parcel$export(module.exports, "useRedirectAutoOpenReleaseModal", () => $4717ecbdce5f3d41$export$83b5462c8aa5c10f);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $4717ecbdce5f3d41$export$83b5462c8aa5c10f = (openModal, loadReleaseNoteModal)=>{
    const [{ query: query }] = (0, $lB25E.useRouter)();
    const hasModalBeenOpened = (0, $eUqFw.useRef)(false);
    if (hasModalBeenOpened.current === false && query.isReleaseNoteModalOpen === 'true') {
        loadReleaseNoteModal();
        openModal();
        hasModalBeenOpened.current = true;
    }
};

});

parcelRegister("icAUL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7xZwo").then(()=>parcelRequire('lnZUp'));

});



parcelRegister("dQQNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c39a5dae0f2498d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c39a5dae0f2498d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    browserTitle: {
        "id": "software-releases-version-detail.browser-title",
        "defaultMessage": "{projectName}: {versionName}"
    },
    issues: {
        "id": "software-releases-version-detail.issues",
        "defaultMessage": "Issues"
    }
});

});

parcelRegister("bDFkL", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $d518faa0b969b01a$export$84d58c19c21f637f);

var $aGwKk = parcelRequire("aGwKk");

var $47lkD = parcelRequire("47lkD");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $247XK = parcelRequire("247XK");

var $247XK = parcelRequire("247XK");

var $9aFSa = parcelRequire("9aFSa");

var $8uD7Y = parcelRequire("8uD7Y");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a5QNi = parcelRequire("a5QNi");

var $ilAVJ = parcelRequire("ilAVJ");

var $jtcvE = parcelRequire("jtcvE");

var $1mMsc = parcelRequire("1mMsc");
const $d518faa0b969b01a$var$getNewCollapsedUis = (currentState, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== 'RIGHT_SIDEBAR') : [
        ...currentState,
        'RIGHT_SIDEBAR'
    ];
const $d518faa0b969b01a$export$84d58c19c21f637f = ({ jiraVersion: jiraVersion, children: children })=>{
    const [state] = (0, $a5QNi.useSidebarStore)();
    const sidebarActions = (0, $a5QNi.useSidebarActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const version = (0, $iWLL0.useFragment)((0, $47lkD.default), jiraVersion);
    const [updateCollapsedUis] = (0, $iWLL0.useMutation)((0, $aGwKk.default));
    const onError = ()=>{
        (0, $jMP2a.fireUIAnalytics)({
            // @ts-expect-error - Argument of type '{ meta: { id: string; packageName: string; teamName: string; }; error: Error; sendToPrivacyUnsafeSplunk: boolean; }' is not assignable to parameter of type 'UIAnalyticsEvent'.
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesVersionDetail',
                teamName: 'fusion-solaris'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const isIssueClosed = state.status === 'CLOSED';
    const isSidebarExpanded = !collapsedUis.includes('RIGHT_SIDEBAR') || !isIssueClosed;
    const keyboardShortcutPressedEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    });
    const buttonClickedEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const handleChange = (analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'versionDetailsCollapsibleRightSidebar', {
            targetState: isSidebarExpanded ? 'collapsed' : 'expanded'
        });
        if (!isIssueClosed) sidebarActions.close();
        saveUserPreference($d518faa0b969b01a$var$getNewCollapsedUis(collapsedUis, !isSidebarExpanded));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
        in: isSidebarExpanded,
        timeout: 100
    }, (transitionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d518faa0b969b01a$var$SidebarContainer, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
            keyMap: {
                ']': {
                    callback: ()=>handleChange(keyboardShortcutPressedEvent),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jtcvE.messages).resizeKeyboardShortcutLabel)
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mMsc.ResizeBoundary), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mMsc.ResizeButton), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d518faa0b969b01a$var$SidebarContent, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, children)));
};
const $d518faa0b969b01a$var$enteredTransitionContainerStyle = {
    flex: `0 0 ${(0, $ilAVJ.RIGHT_SIDEBAR_WIDTH)}px`,
    width: `${(0, $ilAVJ.RIGHT_SIDEBAR_WIDTH)}px`
};
const $d518faa0b969b01a$var$exitedTransitionContainerStyle = {
    flex: '0 0 0',
    width: `${(0, $ilAVJ.VERSION_DETAIL_PADDING)}px`
};
const $d518faa0b969b01a$var$enteredTransitionContentStyle = {
    opacity: 1
};
const $d518faa0b969b01a$var$exitedTransitionContentStyle = {
    opacity: 0
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d518faa0b969b01a$var$SidebarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl94b1 _ankwewfl _kqswh2mm _v5645o7y _1g3qkb7n",
            __cmplp.isIssueClosed ? "_1bsblti4" : "_1bsb1dft",
            __cmplp.transitionState === (0, $247XK.ENTERED) && "_16jlidpf _1o9zidpf _i0dl94b1 _1bsblti4",
            __cmplp.transitionState === (0, $247XK.EXITED) && "_16jlidpf _1o9zidpf _i0dlf1ug _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d518faa0b969b01a$var$SidebarContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulppxbi _ca0q1tcg _n3td1tcg _c71l1osq _4t3i1osq _vchhusvi _18m91wug _v564g17y",
            __cmplp.isIssueClosed ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.isIssueClosed ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.transitionState === (0, $247XK.ENTERED) && "_tzy4kb7n",
            __cmplp.transitionState === (0, $247XK.EXITED) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aGwKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $03f39c3cdc69ab25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf6797bcc455e5b9b21455cbbfbfb54c>>
 * @relayHash c2b98978082788d4d50aace3a2030149
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf
const $03f39c3cdc69ab25$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf",
            "metadata": {},
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$03f39c3cdc69ab25$var$node.hash = "eae188b16f12cd7a08081363e9d8ba79";
var $03f39c3cdc69ab25$export$2e2bcd8739ae039 = $03f39c3cdc69ab25$var$node;

});

parcelRegister("47lkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e836030a73e09847$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<060507cc19c856be16a6c851e122e50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e836030a73e09847$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rightSidebar_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$e836030a73e09847$var$node.hash = "f6b47df507b4f1c932a991a3cdcfb952";
var $e836030a73e09847$export$2e2bcd8739ae039 = $e836030a73e09847$var$node;

});

parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});

parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});


parcelRegister("ilAVJ", function(module, exports) {

$parcel$export(module.exports, "VERSION_DETAIL_PADDING", () => $6987231270202452$export$d5ba377dea81dc7b);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $6987231270202452$export$b44ab66843c05a69);
$parcel$export(module.exports, "VERSION_DESCRIPTION_MAX_NUM_BYTES", () => $6987231270202452$export$4d8870de173841bc);

var $c9TLT = parcelRequire("c9TLT");
const $6987231270202452$export$d5ba377dea81dc7b = (0, $c9TLT.gridSize) * 3;
const $6987231270202452$export$b44ab66843c05a69 = 400 + $6987231270202452$export$d5ba377dea81dc7b * 2;
const $6987231270202452$export$4d8870de173841bc = 16384;

});

parcelRegister("jtcvE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6b9a268527417e48$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6b9a268527417e48$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    resizeKeyboardShortcutLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-keyboard-shortcut-label",
        "defaultMessage": "Keyboard shortcut \"]\" which used to expand and collapse version details right sidebar"
    }
});

});

parcelRegister("1mMsc", function(module, exports) {

$parcel$export(module.exports, "ResizeButton", () => $30f0fe0f404b57b1$export$11aa56de814afc15);
$parcel$export(module.exports, "ResizeBoundary", () => $30f0fe0f404b57b1$export$e1ead9bf8a6df70f);

var $eUqFw = parcelRequire("eUqFw");

var $4GOUU = parcelRequire("4GOUU");

var $dtaN9 = parcelRequire("dtaN9");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kLOhm = parcelRequire("kLOhm");

var $lKATN = parcelRequire("lKATN");

var $a13zt = parcelRequire("a13zt");
const $30f0fe0f404b57b1$export$680dc7b2ca125eea = ({ isSidebarCollapsed: isSidebarCollapsed, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const text = isSidebarCollapsed ? formatMessage((0, $lKATN.messages).expand) : formatMessage((0, $lKATN.messages).collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a13zt.TooltipNode), {
            text: text,
            char: "]"
        }),
        hideTooltipOnClick: true,
        position: "left"
    }, children);
};
const $30f0fe0f404b57b1$export$11aa56de814afc15 = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30f0fe0f404b57b1$export$680dc7b2ca125eea, {
        isSidebarCollapsed: isSidebarCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a13zt.StyledResizeButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $lKATN.messages).resizeButtonLabel),
        "data-component-selector": (0, $kLOhm.SIDEBAR_RESIZE_BUTTON_SELECTOR),
        isSidebarCollapsed: isSidebarCollapsed,
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, isSidebarCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GOUU))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a13zt.ExpandedHitArea), null)));
};
const $30f0fe0f404b57b1$export$e1ead9bf8a6df70f = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a13zt.ResizeBoundaryButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $lKATN.messages).resizeBoundaryLabel),
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a13zt.ResizeBoundaryGrabArea), null));
};

});
parcelRegister("4GOUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36a294b3fe9eadec$var$_react = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $36a294b3fe9eadec$var$_chevronLeft = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $36a294b3fe9eadec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36a294b3fe9eadec$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $36a294b3fe9eadec$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $36a294b3fe9eadec$var$_chevronLeft.default,
        iconType: "utility"
    }));
$36a294b3fe9eadec$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $36a294b3fe9eadec$var$_default = module.exports.default = $36a294b3fe9eadec$var$ChevronLeftIcon;

});

parcelRegister("kLOhm", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_RESIZE_BUTTON_SELECTOR", () => $d93efa8e9e2b4f71$export$95fb8edad0b1f6f3);


var $c9TLT = parcelRequire("c9TLT");
const $d93efa8e9e2b4f71$export$a3e887bc10cd1d66 = 20;
const $d93efa8e9e2b4f71$export$ee82d44a2323b4c4 = 50;
const $d93efa8e9e2b4f71$export$b2bcceb1e1e560dd = 10;
const $d93efa8e9e2b4f71$export$81ca0779fec5584d = 1000;
const $d93efa8e9e2b4f71$export$d44734fdf1fc9e2d = (0, $c9TLT.gridSize) * 100;
const $d93efa8e9e2b4f71$export$9542bc50a2f9f44a = (0, $c9TLT.gridSize) * 12;
const $d93efa8e9e2b4f71$export$a3b96bc9b9fa1979 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N30})`;
const $d93efa8e9e2b4f71$export$5b063914de767703 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N30})`;
const $d93efa8e9e2b4f71$export$ffab47bcf4a11d42 = `var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N30})`;
const $d93efa8e9e2b4f71$export$c27cf3cf2ee81b07 = `var(--ds-background-information-bold, ${(0, $73a5c9d720aa66e1$exports).B400})`;
const $d93efa8e9e2b4f71$export$14dbcc9140a368ac = `var(--ds-border-information, ${(0, $73a5c9d720aa66e1$exports).B200})`;
const $d93efa8e9e2b4f71$export$53b2ee28ea173ab6 = `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $d93efa8e9e2b4f71$export$84649994e663ac1b = `var(--ds-border-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $d93efa8e9e2b4f71$export$bb29a81b503a982c = 'OPEN';
const $d93efa8e9e2b4f71$export$2fda0856fe66a3c9 = 'DECLINED';
const $d93efa8e9e2b4f71$export$26d1e2e6f089e8e4 = 'MERGED';
const $d93efa8e9e2b4f71$export$c50c7c4a5ff445b1 = 5;
const $d93efa8e9e2b4f71$export$8beb67dd759bbe2 = 5;
const $d93efa8e9e2b4f71$export$c936349447a77fe0 = 'ARCHIVED';
const $d93efa8e9e2b4f71$export$95fb8edad0b1f6f3 = 'VersionDetailsRightSidebarResizeButton';

});

parcelRegister("lKATN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4aa95bc5d6012c30$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4aa95bc5d6012c30$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    expand: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.collapse",
        "defaultMessage": "Collapse"
    },
    resizeButtonLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-button-label",
        "defaultMessage": "Button which can be clicked to expand and collapse the version details right sidebar"
    },
    resizeBoundaryLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-boundary-label",
        "defaultMessage": "Boundary line which can be clicked to expand and collapse the version details right sidebar"
    }
});

});

parcelRegister("a13zt", function(module, exports) {

$parcel$export(module.exports, "TooltipNode", () => $bdf3c70a22578fd4$export$650cc9b24ce3a5c9);
$parcel$export(module.exports, "StyledResizeButton", () => $bdf3c70a22578fd4$export$eaf8b2262a594734);
$parcel$export(module.exports, "ExpandedHitArea", () => $bdf3c70a22578fd4$export$d1ffaae3f3b6a138);
$parcel$export(module.exports, "ResizeBoundaryButton", () => $bdf3c70a22578fd4$export$9d71cd59238427a7);
$parcel$export(module.exports, "ResizeBoundaryGrabArea", () => $bdf3c70a22578fd4$export$f4eedb955e46ab7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $c9TLT = parcelRequire("c9TLT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bdf3c70a22578fd4$var$TooltipWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1q9y _1e0c1txw _vwz4nqt0 _n3td1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
});
const $bdf3c70a22578fd4$var$ShortcutWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk53wy _2rkoyh40 _vwz4cjiy _18u01b66 _1yt4rf60",
            __cmplp.className
        ])
    });
});
const $bdf3c70a22578fd4$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdf3c70a22578fd4$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdf3c70a22578fd4$var$ShortcutWrapper, null, char));
const $bdf3c70a22578fd4$var$buttonInteractionStyles = {
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        opacity: 1
    },
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        opacity: 1,
        outline: 'none'
    }
};
const $bdf3c70a22578fd4$export$eaf8b2262a594734 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarCollapsed: isSidebarCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $9t7rW.default)((0, $c9TLT.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1bhr _19itidpf _2rko1ssb _16qs16ex _syaz1thw _80omtlke _kqswstnw _1bsb1tcg _4t3i1tcg _154ioahv _1ltvxmi2 _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _t9ec1i34 _v564u1xf _1pbyader _irr315up _30l315cr _16l4kb7n _1di6qfk2 _jomrqfk2 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36",
            __cmplp.isSidebarCollapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $bdf3c70a22578fd4$export$d1ffaae3f3b6a138 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _1xi2xmi2 _94n5x0bf _1ltvxmi2",
            __cmplp.className
        ])
    });
});
const $bdf3c70a22578fd4$export$9d71cd59238427a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhloo _19itidpf _80omtlke _kqswstnw _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1osq _1bsbyh40 _v5646cel _irr315up _30l315cr _16l4kb7n _1di6qfk2 _jomrqfk2 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $bdf3c70a22578fd4$export$f4eedb955e46ab7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $9t7rW.default)((0, $c9TLT.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _1xi210v4 _94n5idpf _1ltvidpf _1pbyader",
            __cmplp.className
        ])
    });
});

});




parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("c2vP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a75018a3722a31d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a75018a3722a31d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releases: {
        "id": "spa-apps-software-releases-version-detail.releases",
        "defaultMessage": "Releases"
    }
});

});

parcelRegister("6Xjm5", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $0bd25d3d6932c75e$export$476aa014e2fd89d5);
const $0bd25d3d6932c75e$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $0bd25d3d6932c75e$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $0bd25d3d6932c75e$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $0bd25d3d6932c75e$var$NetworkErrorMessages = new Set([
    $0bd25d3d6932c75e$var$ERROR_MESSAGE_CHROME,
    $0bd25d3d6932c75e$var$ERROR_MESSAGE_FIREFOX,
    $0bd25d3d6932c75e$var$ERROR_MESSAGE_OTHER
]);
const $0bd25d3d6932c75e$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $0bd25d3d6932c75e$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});




//# sourceMappingURL=async-jira-software-version-detail.35bacc36.js.map
